import { jsx as o, Fragment as n1, jsxs as x } from "react/jsx-runtime";
import "fast-levenshtein";
import "fuzzy";
import { m as f1, i as S1, c as f5, s as f2, o as c6, b as n6, d as $2 } from "./references-BRMYEcTr.js";
import { C as U1, E as l6, l as g3, r as s6, o as a6, D as s3, u as g2, g as i6, v as T1, V as d6, j as G3, q as H2, e as u6, B as Z3, x as V3, n as h6, s as $1, w as g1, A as v5, h as f6, y as Y2, i as v6, b as m6 } from "./timing-BFaISC6B.js";
import * as s1 from "react";
import { useRef as a1, Fragment as K1, useContext as V1, useState as W, useCallback as Z, useLayoutEffect as s2, useEffect as l1, useMemo as O, createContext as F1, memo as G, forwardRef as m5, useImperativeHandle as p6 } from "react";
import { createPortal as j2, flushSync as g6 } from "react-dom";
import { Range as a3, hash as p5, Set as b6, Map as g5 } from "immutable";
import "fast-deep-equal";
import b5 from "@react-hook/resize-observer";
import M6 from "icomoon-react";
import { themeCSSVars as I } from "./legacy/themes/index.js";
import { Slot as M5 } from "@radix-ui/react-slot";
import { cva as C2 } from "class-variance-authority";
import { c as D } from "./cn-B6yFEsav.js";
import { DragDropContext as x6, Droppable as z6, Draggable as y6 } from "react-beautiful-dnd";
import { useVirtualizer as x5 } from "@tanstack/react-virtual";
import { Command as w1 } from "cmdk";
import * as v2 from "@radix-ui/react-popover";
import { Check as W2, MoreHorizontal as C6, Circle as z5, Loader2Icon as I6, ChevronLeftIcon as y5, ChevronRightIcon as C5, ChevronDownIcon as N6 } from "lucide-react";
import * as v1 from "@radix-ui/react-dropdown-menu";
import * as u1 from "@radix-ui/react-menubar";
import * as S6 from "@radix-ui/react-checkbox";
import { DateTime as y1 } from "luxon";
import { useDayPicker as w6, DateLib as B6, defaultLocale as k6, getDefaultClassNames as P6, DayPicker as L6, formatWeekdayName as T6 } from "react-day-picker";
import "clsx";
import "tailwind-merge";
import "radix-ui";
import * as I5 from "@radix-ui/react-separator";
import "@radix-ui/react-switch";
import * as m2 from "@radix-ui/react-tooltip";
import * as N5 from "@radix-ui/react-radio-group";
import { atom as E6, useAtomValue as b3 } from "jotai";
import { w as X1, c as D6, u as S5, W as w5 } from "./render-island-BMViq2-G.js";
import "jotai-effect";
function A6(e, t) {
  const r = {};
  for (let c = 0; c < e.length; c++) {
    const n = t(e[c], c, e), l = r[n] || [];
    l.push(e[c]), r[n] = l;
  }
  return r;
}
function R6(e, t) {
  const r = new Array(e.length);
  for (let c = 0; c < e.length; c++)
    r[c] = t(e[c], c);
  return r;
}
function e1(e) {
  const t = a1(e);
  return t.current = e, t;
}
function B5(e) {
  const t = V1(e);
  if (t == null)
    throw new Error("missing context");
  return t;
}
function p1({
  collection: e,
  keyProvider: t,
  children: r,
  fallback: c,
  carry: n = void 0
}) {
  return /* @__PURE__ */ o(n1, { children: e.length === 0 && c ? /* @__PURE__ */ o(c, {}) : R6(e, (l, s) => /* @__PURE__ */ o(K1, { children: r(l, s, n) }, `${t?.(l, s) ?? s}-${p5(n)}`)) });
}
function U3({
  times: e,
  keyProvider: t,
  children: r,
  carry: c = void 0
}) {
  return /* @__PURE__ */ o(n1, { children: a3(0, e).map((n) => /* @__PURE__ */ o(K1, { children: r(n, c) }, `${t?.(n) ?? n}-${p5(c)}`)).toArray() });
}
function M9() {
  const e = a1(!0);
  return l1(() => (e.current = !0, () => {
    e.current = !1;
  }), []), e;
}
function x9(e) {
  return (t) => function(c) {
    return /* @__PURE__ */ o(e.Consumer, { children: function(l) {
      return /* @__PURE__ */ o(t, { ...l, ...c });
    } });
  };
}
function k5({
  previousContextsContents: e,
  Contexts: t,
  index: r,
  Component: c
}) {
  const n = r < t.length ? t[r] : void 0;
  return n ? /* @__PURE__ */ o(n.Consumer, { children: (l) => /* @__PURE__ */ o(
    k5,
    {
      Component: c,
      index: r + 1,
      previousContextsContents: { ...e, ...l },
      Contexts: t
    }
  ) }) : /* @__PURE__ */ o(c, { ...e });
}
function z9(e) {
  return (t) => function() {
    return /* @__PURE__ */ o(
      k5,
      {
        Component: t,
        Contexts: e,
        index: 0,
        previousContextsContents: {}
      }
    );
  };
}
function G2(e, t) {
  const r = t?.debounceInterval ?? 100, [c, n] = W("idle"), l = e1({ fn: e, debounceInterval: r }), s = a1(null), a = a1(null), i = Z(
    (...u) => {
      s.current !== null && clearTimeout(s.current), a.current = () => l.current.fn(...u), s.current = setTimeout(() => {
        s.current = null, a.current?.(), n("idle");
      }, l.current.debounceInterval), n("debouncing");
    },
    [l]
  ), d = Z(() => {
    s.current !== null && (clearTimeout(s.current), s.current = null, a.current = null), n("idle");
  }, []), v = Z(() => {
    a.current?.(), d();
  }, [d]), h = e1({ cancel: d, flush: v, unmountBehavior: t?.unmountBehavior ?? "cancel" });
  return l1(() => () => h.current[h.current.unmountBehavior](), [h]), O(() => ({ cancel: d, flush: v, state: c, invoke: i }), [d, v, i, c]);
}
function T2(e, t, r) {
  const c = r?.debounceInterval ?? 100, [n, l] = W(() => e()), { invoke: s, state: a, flush: i } = G2(() => l(e()), { debounceInterval: c }), d = a1(!0);
  return l1(() => {
    if (d.current) {
      d.current = !1;
      return;
    }
    s();
  }, t), { value: n, forceUpdate: (h) => {
    i(), h !== void 0 && l(h);
  }, state: a };
}
function R(e, t) {
  return e == null ? null : typeof e == "function" ? e(t) : String(e.$$typeof) === "Symbol(react.memo)" ? /* @__PURE__ */ o(e, { ...t }) : e;
}
function z2(e, t) {
  t && (typeof t == "function" ? t(e) : t.current = e);
}
function P5(e, t) {
  return O(() => {
    const r = function(c) {
      r.current = c, z2(c, t);
    };
    return r.current = e, r;
  }, [t]);
}
function E2(e, t) {
  const [r, c] = W(e), n = e1(r), l = Z(
    (s) => {
      const a = f1(s, n.current);
      c(a), z2(a, t);
    },
    [t, n]
  );
  return [r, l];
}
function _6({
  case: e,
  match: t
}) {
  return /* @__PURE__ */ o(K1, { children: t[e]() }, e);
}
function L5(e) {
  return function() {
    const [r, c] = W(0), n = a1(null), l = Z(async (s) => {
      s?.signal?.throwIfAborted();
      let a;
      if (n.current)
        a = n.current.promise;
      else {
        let i = U1, d = U1;
        const v = () => {
          d(s?.signal?.reason);
        };
        a = new Promise((h, u) => {
          i = () => {
            s?.signal?.removeEventListener("abort", v), n.current = null, h();
          }, d = (p) => {
            n.current = null, u(p);
          };
        }), s?.signal?.addEventListener("abort", v, { once: !0 }), n.current = { resolve: i, reject: d, promise: a };
      }
      switch (c((i) => i + 1), e) {
        case "regular": {
          await a;
          break;
        }
        case "layout":
          await a, await l6(s);
      }
    }, []);
    switch (e) {
      case "regular": {
        l1(() => {
          U1(r), n.current?.resolve();
        }, [r]), l1(() => () => {
          n.current?.resolve();
        }, []);
        break;
      }
      case "layout": {
        s2(() => {
          U1(r), n.current?.resolve();
        }, [r]), s2(() => () => {
          n.current?.resolve();
        }, []);
        break;
      }
    }
    return l;
  };
}
const T5 = L5("regular"), F6 = L5("layout");
function O6({ children: e, destination: t }) {
  return /* @__PURE__ */ o(n1, { children: t ? j2(e, t) : e });
}
function J1(e, t) {
  const [r, c] = W(e), n = e1(t), l = e1(r), s = Z(
    (a) => {
      const i = f1(a, l.current);
      c(i), n.current?.onSet?.(i);
    },
    [n, l]
  );
  return l1(() => {
    c((a) => (n.current?.equalityComparator ?? S1)(a, e) ? a : e);
  }, [e, n]), [r, s];
}
function W1(e) {
  return /* @__PURE__ */ o(n1, { children: !e.children || typeof e.children == "string" || typeof e.children == "number" ? e.wrapper(e.children) : e.children });
}
function y9(e) {
  const [t, r] = W(e), c = Z((n) => {
    r((l) => {
      const s = f1(n, l);
      return S1(s, l) ? l : s;
    });
  }, []);
  return O(() => [t, c], [c, t]);
}
function $6(e, t) {
  const r = a1(t);
  return r.current.length === t.length && t.every((n, l) => S1(n, r.current[l])) || (r.current = t), O(e, r.current);
}
function C9(e, t) {
  l1(
    e,
    // biome-ignore lint/correctness/useExhaustiveDependencies: custom hook logic
    $6(() => t, t)
  );
}
class H6 extends Error {
}
function I9() {
  const [e, t] = W(() => new AbortController()), r = e1(e);
  return l1(() => {
    const c = r.current;
    return () => {
      c.abort(new H6()), t(new AbortController());
    };
  }, [r]), e.signal;
}
const K3 = F1(null);
function j6({ children: e, onCleanup: t, name: r }) {
  const c = e1(V1(K3)), n = a1({ dispose: [] }), l = e1(t), s = e1(r);
  return s2(() => {
    const a = { dispose: U1, disposed: !1 }, i = () => {
      a.disposed || (n.current.dispose.forEach((d) => d.dispose()), a.disposed = !0, l.current());
    };
    return a.dispose = i, c.current?.dispose.push(a), i;
  }, [c, n, l, s]), /* @__PURE__ */ o(K3.Provider, { value: n.current, children: R(e) });
}
function _1(e, t, r, c) {
  const n = e1(r), l = g3(e);
  s2(() => {
    if (!l.length || c?.disabled)
      return;
    const s = { capture: c?.capture, passive: c?.passive }, a = (i) => {
      n.current(i);
    };
    for (const i of l)
      i?.addEventListener(t, a, s);
    return () => {
      for (const i of l)
        i?.removeEventListener(t, a, s);
    };
  }, [n, t, c?.capture, c?.disabled, c?.passive, ...l]);
}
function q1(e, t) {
  const [r, c] = W(() => e?.getBoundingClientRect() ?? null), n = e1(t?.onChange), l = Z(
    (a) => {
      c(a), n.current?.(a);
    },
    [n]
  ), s = t?.pause ?? !1;
  return s2(() => {
    s || l(e?.getBoundingClientRect() ?? null);
  }, [s, l, e]), b5(e, (a) => {
    s || l({
      height: a.borderBoxSize[0].blockSize,
      width: a.borderBoxSize[0].inlineSize
    });
  }), r;
}
function X2(e) {
  return "scrollLeft" in e ? {
    x: e.scrollLeft,
    y: e.scrollTop,
    scrollWidth: e.scrollWidth,
    scrollHeight: e.scrollHeight,
    clientWidth: e.clientWidth,
    clientHeight: e.clientHeight,
    offsetWidth: e.offsetWidth,
    offsetHeight: e.offsetHeight
  } : {
    x: e.scrollX,
    y: e.scrollY,
    scrollWidth: e.document.scrollingElement?.scrollWidth ?? document.documentElement.scrollWidth,
    scrollHeight: e.document.scrollingElement?.scrollHeight ?? document.documentElement.scrollHeight,
    clientWidth: e.document.scrollingElement?.clientWidth ?? document.documentElement.clientWidth,
    clientHeight: e.document.scrollingElement?.clientHeight ?? document.documentElement.clientHeight,
    offsetWidth: e.document.scrollingElement?.offsetWidth ?? document.documentElement.offsetWidth,
    offsetHeight: e.document.scrollingElement?.offsetHeight ?? document.documentElement.offsetHeight
  };
}
function W6(e, t) {
  const [r, c] = W(
    () => e ? X2(e) : null
  );
  s2(() => {
    t?.disabled || c(e ? X2(e) : null);
  }, [t?.disabled, e]);
  const n = () => {
    c(e ? X2(e) : null);
  };
  return _1(e, "scroll", n, t), _1(e === window ? e : null, "resize", n, t), b5(
    t?.disabled || e === window ? null : e,
    () => {
      n();
    }
  ), r;
}
function X(e) {
  return typeof e == "string" ? e : Object.keys(Z6(e)).join(" ");
}
function I1(e, t) {
  return { ...m1(e), ...m1(t) };
}
function o1(e, t) {
  return X(I1(e, t));
}
function m1(e) {
  return e ? typeof e == "string" ? G6(e) : e : {};
}
function G6(e) {
  return e ? { [e]: !0 } : {};
}
function Z6(e) {
  if (!e)
    return {};
  const t = [...Object.entries(e)].flatMap(
    ([c, n]) => c.split(" ").map((l) => [l, n])
  ), r = /* @__PURE__ */ new Set();
  for (const [c, n] of t)
    n ? r.add(c) : r.delete(c);
  return Object.fromEntries(Array.from(r).map((c) => [c, !0]));
}
function E5(e) {
  e && e.focus({ preventScroll: !0 });
}
const J2 = {
  prefix: "use-unique-dom-id-" + Math.random().toString(36).slice(2),
  latest: 0
};
function D5() {
  return J2.latest++, J2.prefix + "-" + J2.latest;
}
function a2() {
  const [e] = W(() => D5());
  return e;
}
function N9() {
  const [e, t] = W(() => ({
    width: window.innerWidth,
    height: window.innerHeight
  }));
  return _1(
    window,
    "resize",
    () => t({
      width: window.innerWidth,
      height: window.innerHeight
    })
  ), e;
}
function S9(e) {
  return q1(document.body, e);
}
function w9({
  children: e,
  pause: t,
  onChange: r
}) {
  const [c, n] = W(null);
  q1(c, {
    pause: t,
    onChange: r
  });
  const l = O(() => ({ innerRef: n }), []);
  return /* @__PURE__ */ o(n1, { children: R(e, l) });
}
function B9(e) {
  return (t) => {
    t.preventDefault(), e?.(t);
  };
}
const p2 = E6([]);
function k9() {
  const e = b3(p2);
  return /* @__PURE__ */ o(n1, { children: e.map(({ nodeProvider: t, id: r, resolve: c, reject: n }) => /* @__PURE__ */ o(K1, { children: t({
    resolve: c,
    reject: n
  }) }, r)) });
}
function P9(e, t) {
  const r = D5(), c = {
    resolve: null,
    reject: null
  };
  return {
    id: r,
    promise: t?.signal?.aborted ? Promise.reject(t.signal.reason) : new Promise((n, l) => {
      const s = () => {
        a(), l(t?.signal?.reason);
      }, a = () => {
        X1(p2, (i) => s6(i, r, (d) => d.id)), t?.signal?.removeEventListener("abort", s);
      };
      t?.signal?.addEventListener("abort", s, { once: !0 }), c.resolve = (i) => {
        a(), n(i);
      }, c.reject = (i) => {
        a(), l(i);
      }, X1(p2, (i) => [
        ...i,
        {
          id: r,
          nodeProvider: e,
          resolve: c.resolve,
          reject: c.reject
        }
      ]);
    })
  };
}
function L9() {
  X1(p2, []);
}
function T9(e, t) {
  const r = D6(p2).find((c) => c.id === e);
  if (!r) {
    console.warn(`spawned element "${e}" not found, update skipped`);
    return;
  }
  X1(
    p2,
    (c) => a6(
      c,
      {
        ...r,
        nodeProvider: t
      },
      (n) => n.id
    )
  );
}
function V6({
  animatedNodeProvider: e,
  resolve: t,
  reject: r,
  show: c,
  onShowChange: n
}) {
  const l = e1({ onShowChange: n });
  l1(() => {
    setTimeout(() => {
      l.current.onShowChange(!0);
    }, 10);
  }, [l]);
  const s = a1(null);
  return /* @__PURE__ */ o(n1, { children: e({
    show: c,
    resolve: (a) => {
      s.current = { resolved: a }, n(!1);
    },
    reject: (a) => {
      s.current = { rejected: a }, n(!1);
    },
    onHidden: () => {
      const a = s.current;
      a && "resolved" in a ? t(a.resolved) : r(a?.rejected);
    }
  }) });
}
function E9(e) {
  return function(r) {
    return /* @__PURE__ */ o(l2, { value: !1, children: ({ value: c, onChange: n }) => /* @__PURE__ */ o(
      V6,
      {
        animatedNodeProvider: e,
        onShowChange: n,
        show: c,
        ...r
      }
    ) });
  };
}
const U6 = "selection", K6 = /* @__PURE__ */ JSON.parse('[{"icon":{"paths":["M542.659 121.697c11.997-11.997 31.441-11.997 43.438 0l275.64 275.64c11.997 11.997 11.997 31.444 0 43.441s-31.441 11.997-43.438 0l-275.64-275.641c-11.997-11.997-11.997-31.443 0-43.44z","M588.599 167.626c11.997-11.992 31.445-11.996 43.442 0 11.989 11.996 11.989 31.444 0 43.44l-270.402 270.399h280.642l130.077-130.079c11.993-11.986 31.445-11.978 43.442 0 11.997 11.997 11.997 31.483 0 43.48l-428.8 428.799c-30.126 30.151-71.017 47.079-113.64 47.079-39.958-0.004-78.373-14.889-107.84-41.599l-5.76-5.48c-30.141-30.122-47.079-70.984-47.080-113.598 0-42.623 16.928-83.513 47.080-113.639l428.839-428.801zM174.12 710.066c0.001 26.317 10.463 51.556 29.080 70.16l7.28 6.599c17.65 14.479 39.852 22.475 62.88 22.479 26.318 0 51.558-10.461 70.16-29.078h0.040l237.281-237.322h-280.642l-97 97.001c-18.618 18.6-29.080 43.844-29.080 70.16z"],"attrs":[],"grid":24,"tags":["Ptf-lab"],"isMulticolor":false,"isMulticolor2":false,"colorPermutations":{}},"attrs":[],"properties":{"order":412,"id":221,"name":"Ptf-lab","prevSize":24,"code":59882},"setIdx":0,"setId":0,"iconIdx":0},{"icon":{"paths":["M85.333 800v-682.667c0-17.673 14.327-32 32-32s32 14.327 32 32v682.667c0 29.474 23.86 53.333 53.333 53.333h682.667c17.673 0 32 14.327 32 32s-14.327 32-32 32h-682.667c-64.82 0-117.333-52.514-117.333-117.333z","M860.753 224.836c11.315-13.569 31.509-15.395 45.082-4.083 13.572 11.315 15.394 31.509 4.083 45.083l-196.207 235.416c-18.355 22.007-47.612 31.59-75.418 24.666l-0.038-0.038-118.711-29.666c-3.955-0.986-8.162 0.35-10.79 3.499l-196.167 235.456c-11.315 13.572-31.509 15.394-45.083 4.083-13.569-11.315-15.395-31.509-4.083-45.082l196.207-235.418c18.364-22.016 47.68-31.569 75.46-24.623l118.707 29.666c4.006 0.986 8.166-0.354 10.79-3.499l196.169-235.46z","M872.538 301.331c16.196-7.063 35.059 0.346 42.125 16.541s-0.346 35.057-16.542 42.125l-196.164 85.626c-14.865 6.481-34.005 8.811-51.46 8.124l-7.373-0.499-118.707-10.79c-12.489-1.135-23.398 0.841-27.418 2.581l-196.209 85.623c-16.196 7.066-35.057-0.346-42.125-16.542-7.063-16.196 0.346-35.055 16.541-42.125l196.167-85.623c16.99-7.409 39.607-9.372 58.833-7.625l118.707 10.792c12.531 1.134 23.394-0.842 27.418-2.583l196.207-85.625z"],"attrs":[],"isMulticolor":false,"isMulticolor2":false,"grid":24,"tags":["benchmark"],"colorPermutations":{"14014216812552552551293651147536515050501761761561":[]}},"attrs":[],"properties":{"order":409,"id":220,"name":"benchmark","prevSize":24,"code":59881},"setIdx":0,"setId":0,"iconIdx":1},{"icon":{"paths":["M480 853.333v-725.333c0-17.673 14.327-32 32-32s32 14.327 32 32v725.333c0 17.673-14.327 32-32 32s-32-14.327-32-32z","M864 256c0-53.026-42.974-96-96-96h-512c-53.026 0-96 42.974-96 96v512c0 53.026 42.974 96 96 96h512c53.026 0 96-42.974 96-96v-512zM928 768c0 88.371-71.629 160-160 160h-512c-88.372 0-160-71.629-160-160v-512c0-88.372 71.628-160 160-160h512c88.371 0 160 71.628 160 160v512z"],"attrs":[{},{}],"isMulticolor":false,"isMulticolor2":false,"grid":24,"tags":["screen-size1"],"colorPermutations":{"14014216812552552551293651147536515050501761761561":[{},{}]}},"attrs":[{},{}],"properties":{"order":406,"id":219,"name":"screen-size1","prevSize":24,"code":59876},"setIdx":0,"setId":0,"iconIdx":2},{"icon":{"paths":["M352 853.333v-725.333c0-17.673 14.327-32 32-32s32 14.327 32 32v725.333c0 17.673-14.327 32-32 32s-32-14.327-32-32z","M864 256c0-53.026-42.974-96-96-96h-512c-53.026 0-96 42.974-96 96v512c0 53.026 42.974 96 96 96h512c53.026 0 96-42.974 96-96v-512zM928 768c0 88.371-71.629 160-160 160h-512c-88.372 0-160-71.629-160-160v-512c0-88.372 71.628-160 160-160h512c88.371 0 160 71.628 160 160v512z"],"attrs":[{"fill":"rgb(50, 50, 50)","opacity":0.8},{"fill":"rgb(50, 50, 50)"}],"isMulticolor":true,"isMulticolor2":true,"grid":24,"tags":["screen-size2"],"colorPermutations":{"14014216812552552551293651147536515050501761761561":[{"f":1},{"f":1}]}},"attrs":[{"fill":"rgb(50, 50, 50)","opacity":0.8},{"fill":"rgb(50, 50, 50)"}],"properties":{"order":407,"id":218,"name":"screen-size2","prevSize":24,"code":59878,"codes":[59878,59879]},"setIdx":0,"setId":0,"iconIdx":3},{"icon":{"paths":["M608 853.333v-725.333c0-17.673 14.327-32 32-32s32 14.327 32 32v725.333c0 17.673-14.327 32-32 32s-32-14.327-32-32z","M864 256c0-53.026-42.974-96-96-96h-512c-53.026 0-96 42.974-96 96v512c0 53.026 42.974 96 96 96h512c53.026 0 96-42.974 96-96v-512zM928 768c0 88.371-71.629 160-160 160h-512c-88.372 0-160-71.629-160-160v-512c0-88.372 71.628-160 160-160h512c88.371 0 160 71.628 160 160v512z"],"attrs":[{},{}],"isMulticolor":false,"isMulticolor2":false,"grid":24,"tags":["screen-size3"],"colorPermutations":{"14014216812552552551293651147536515050501761761561":[{},{}]}},"attrs":[{},{}],"properties":{"order":408,"id":217,"name":"screen-size3","prevSize":24,"code":59880},"setIdx":0,"setId":0,"iconIdx":4},{"icon":{"paths":["M545.737 192c-74.509-0.008-145.964 29.586-198.647 82.271l-164.463 164.462c-12.497 12.497-32.758 12.497-45.255 0-12.497-12.495-12.497-32.757 0-45.254l164.463-164.463c64.687-64.688 152.425-101.026 243.907-101.016zM545.737 192c114.854 0.008 218.138 69.936 260.8 176.576l6.707 16.744c6.571 16.406 25.199 24.379 41.604 17.809s24.38-25.198 17.809-41.604l-6.699-16.721c-52.382-130.928-179.2-216.793-320.218-216.804z","M159.999 213.369c17.673 0 32 14.327 32 32v96.071c0 23.564 19.102 42.667 42.667 42.667h96.071c17.673 0 32 14.327 32 32s-14.327 32-32 32h-170.737c-17.673 0-32-14.327-32-32v-170.738c0-17.673 14.327-32 32-32z","M476.258 864.137c74.505 0.009 145.958-29.585 198.643-82.27l164.463-164.467c12.497-12.493 32.759-12.493 45.257 0 12.497 12.497 12.497 32.759 0 45.257l-164.463 164.463c-64.687 64.687-152.427 101.026-243.908 101.018zM476.258 864.137c-114.859-0.009-218.143-69.939-260.805-176.576l-6.706-16.747c-6.571-16.405-25.197-24.375-41.603-17.805s-24.379 25.195-17.809 41.6l6.697 16.721c52.384 130.931 179.199 216.794 320.218 216.806z","M861.99 842.765c-17.673 0-32-14.323-32-32v-138.735h-138.735c-17.673 0-32-14.327-32-32s14.327-32 32-32h170.735c17.673 0 32 14.327 32 32v170.735c0 17.677-14.327 32-32 32z"],"attrs":[],"isMulticolor":false,"isMulticolor2":false,"grid":24,"tags":["Reload"],"colorPermutations":{"10511915011401421681255255255129365114753651761761561":[],"14014216812552552551293651147536515050501761761561":[]}},"attrs":[],"properties":{"order":402,"id":216,"name":"Reload","prevSize":24,"code":59810},"setIdx":0,"setId":0,"iconIdx":5},{"icon":{"paths":["M421.333 738.133l-196.267-196.267c-4.267-4.267-7.282-8.887-9.045-13.867-1.792-4.975-2.688-10.308-2.688-16 0-5.687 0.896-11.021 2.688-16 1.763-4.975 4.779-9.6 9.045-13.867l196.267-196.265c7.821-7.822 17.779-11.733 29.867-11.733s22.046 3.911 29.867 11.733c7.821 7.822 11.733 17.778 11.733 29.867s-3.913 22.045-11.733 29.867l-166.4 166.398 166.4 166.4c7.821 7.825 11.733 17.779 11.733 29.867 0 12.092-3.913 22.046-11.733 29.867-7.821 7.825-17.779 11.733-29.867 11.733s-22.046-3.908-29.867-11.733z","M762.667 738.133l-196.267-196.267c-4.267-4.267-7.283-8.887-9.045-13.867-1.792-4.975-2.688-10.308-2.688-16 0-5.687 0.896-11.021 2.688-16 1.762-4.975 4.779-9.6 9.045-13.867l196.267-196.265c7.821-7.822 17.779-11.733 29.867-11.733s22.046 3.911 29.867 11.733c7.821 7.822 11.733 17.778 11.733 29.867s-3.913 22.045-11.733 29.867l-166.4 166.398 166.4 166.4c7.821 7.825 11.733 17.779 11.733 29.867 0 12.092-3.913 22.046-11.733 29.867-7.821 7.825-17.779 11.733-29.867 11.733s-22.046-3.908-29.867-11.733v0z"],"attrs":[],"isMulticolor":false,"isMulticolor2":false,"grid":24,"tags":["Double-left"],"colorPermutations":{"10511915011401421681255255255129365114753651761761561":[],"14014216812552552551293651147536515050501761761561":[]}},"attrs":[],"properties":{"order":395,"id":215,"name":"Double-left","prevSize":24,"code":59874},"setIdx":0,"setId":0,"iconIdx":6},{"icon":{"paths":["M225.067 738.133c-7.822-7.821-11.733-17.775-11.733-29.867 0-12.087 3.911-22.042 11.733-29.867l166.4-166.4-166.4-166.398c-7.822-7.822-11.733-17.778-11.733-29.867s3.911-22.045 11.733-29.867c7.822-7.822 17.778-11.733 29.867-11.733s22.045 3.911 29.867 11.733l196.267 196.265c4.267 4.267 7.296 8.892 9.088 13.867 1.762 4.979 2.645 10.313 2.645 16 0 5.692-0.883 11.025-2.645 16-1.792 4.979-4.821 9.6-9.088 13.867l-196.267 196.267c-7.822 7.825-17.778 11.733-29.867 11.733s-22.045-3.908-29.867-11.733v0z","M566.4 738.133c-7.821-7.821-11.733-17.775-11.733-29.867 0-12.087 3.913-22.042 11.733-29.867l166.4-166.4-166.4-166.398c-7.821-7.822-11.733-17.778-11.733-29.867s3.913-22.045 11.733-29.867c7.821-7.822 17.779-11.733 29.867-11.733s22.046 3.911 29.867 11.733l196.267 196.265c4.267 4.267 7.296 8.892 9.088 13.867 1.762 4.979 2.645 10.313 2.645 16 0 5.692-0.883 11.025-2.645 16-1.792 4.979-4.821 9.6-9.088 13.867l-196.267 196.267c-7.821 7.825-17.779 11.733-29.867 11.733s-22.046-3.908-29.867-11.733v0z"],"attrs":[],"isMulticolor":false,"isMulticolor2":false,"grid":24,"tags":["Double-right"],"colorPermutations":{"10511915011401421681255255255129365114753651761761561":[],"14014216812552552551293651147536515050501761761561":[]}},"attrs":[],"properties":{"order":394,"id":214,"name":"Double-right","prevSize":24,"code":59875},"setIdx":0,"setId":0,"iconIdx":7},{"icon":{"paths":["M184.875 744.29v-530.957c0-15.709 12.749-28.458 28.458-28.458s28.458 12.749 28.458 28.458v530.957c0 10.061 3.971 19.721 11.084 26.833s16.775 11.085 26.833 11.085h530.959c15.71 0 28.459 12.749 28.459 28.459s-12.749 28.459-28.459 28.459h-530.959c-25.146 0-49.26-10.010-67.041-27.793-17.781-17.779-27.792-41.894-27.792-67.042zM350.833 677.918v-99.541c0-15.71 12.749-28.459 28.458-28.459s28.458 12.749 28.458 28.459v99.541c0 15.71-12.749 28.459-28.458 28.459s-28.458-12.749-28.458-28.459zM516.71 677.918v-398.21c0-15.709 12.749-28.458 28.454-28.458 15.706 0.006 28.42 12.753 28.42 28.458v398.21c0 15.706-12.715 28.45-28.42 28.459-15.706 0-28.454-12.749-28.454-28.459zM682.667 677.918v-265.46c0-15.709 12.749-28.458 28.459-28.458 15.706 0.006 28.416 12.752 28.416 28.458v265.46c0 15.706-12.71 28.45-28.416 28.459-15.71 0-28.459-12.749-28.459-28.459z"],"attrs":[],"isMulticolor":false,"isMulticolor2":false,"grid":24,"tags":["Chart"],"colorPermutations":{"10511915011401421681255255255129365114753651761761561":[],"14014216812552552551293651147536515050501761761561":[]}},"attrs":[],"properties":{"order":392,"id":213,"name":"Chart","prevSize":24,"code":59767},"setIdx":0,"setId":0,"iconIdx":8},{"icon":{"paths":["M782.208 640h-241.749v142.208h203.831c20.949 0 37.918-16.969 37.918-37.918v-104.29zM540.459 583.125h241.749v-142.251h-241.749v142.251zM241.792 583.125h241.75v-142.251h-241.75v142.251zM241.792 744.29c0 20.949 16.971 37.918 37.917 37.918h203.833v-142.208h-241.75v104.29zM782.208 279.708c0-20.946-16.969-37.917-37.918-37.917h-203.831v142.208h241.749v-104.292zM241.792 384h241.75v-142.208h-203.833c-20.946 0-37.917 16.971-37.917 37.917v104.292zM839.125 744.29c0 52.365-42.47 94.835-94.835 94.835h-464.582c-52.365 0-94.833-42.47-94.833-94.835v-464.582c0-52.365 42.468-94.833 94.833-94.833h464.582c52.365 0 94.835 42.468 94.835 94.833v464.582z"],"attrs":[],"isMulticolor":false,"isMulticolor2":false,"grid":24,"tags":["Table"],"colorPermutations":{"10511915011401421681255255255129365114753651761761561":[],"14014216812552552551293651147536515050501761761561":[]}},"attrs":[],"properties":{"order":391,"id":212,"name":"Table","prevSize":24,"code":59872},"setIdx":0,"setId":0,"iconIdx":9},{"icon":{"paths":["M304.316 781.577v-454.115l-76.575 76.624c-13.053 13.053-34.243 13.053-47.296 0-13.034-13.052-13.039-34.199 0-47.248l133.713-133.713 5.239-4.259c12.968-8.566 30.585-7.148 42.009 4.259l133.713 133.713c13.052 13.050 13.043 34.194 0 47.248-13.052 13.053-34.193 13.053-47.249 0l-76.672-76.673v454.164c-0.009 18.449-14.986 33.391-33.44 33.391s-33.432-14.942-33.44-33.391zM638.622 246.774c0-18.46 14.98-33.44 33.442-33.44 18.458 0 33.438 14.981 33.438 33.44v454.018l76.574-76.578c13.052-13.035 34.202-13.039 47.249 0 13.052 13.056 13.052 34.244 0 47.296l-133.175 133.077c-4.642 4.855-10.675 8.329-17.527 9.694-2.005 0.405-4.032 0.555-6.071 0.589-0.162 0-0.324 0.098-0.486 0.098l-0.051-0.051c-4.339 0.004-8.657-0.819-12.732-2.496-0.99-0.41-1.899-0.969-2.837-1.468-2.876-1.523-5.658-3.358-8.077-5.777l-133.713-133.666c-13.056-13.052-13.056-34.24 0-47.296 13.052-13.052 34.24-13.052 47.296 0l76.672 76.672v-454.112z"],"attrs":[],"isMulticolor":false,"isMulticolor2":false,"grid":24,"tags":["sorting"],"colorPermutations":{"10511915011401421681255255255129365114753651761761561":[],"14014216812552552551293651147536515050501761761561":[]}},"attrs":[],"properties":{"order":390,"id":211,"name":"sorting","prevSize":24,"code":59873},"setIdx":0,"setId":0,"iconIdx":10},{"icon":{"paths":["M528.009 450.581c12.497-12.497 32.751-12.497 45.248 0 12.493 12.493 12.493 32.751 0 45.248l-307.333 307.332c-12.496 12.493-32.754 12.493-45.25 0s-12.494-32.751 0-45.248l307.335-307.332z","M518.626 588.446v-83.247h-83.251c-17.673 0-32-14.327-32-32s14.327-32 32-32h115.251c17.673 0 32 14.327 32 32v115.247c-0.004 17.673-14.332 32-32 32-17.673 0-32-14.327-32-32z","M864.384 511.625c0-194.508-157.658-352.163-352.166-352.166-194.51 0-352.166 157.655-352.166 352.166 0.001 50.594 10.856 98.573 30.125 142.127 7.146 16.154-0.141 35.051-16.292 42.206-16.162 7.151-35.099-0.171-42.25-16.333-22.726-51.371-35.583-108.139-35.584-168 0-229.857 186.309-416.166 416.166-416.166 229.854 0.004 416.166 186.312 416.166 416.166-0.004 229.854-186.313 416.162-416.166 416.166-59.255 0-115.535-12.604-166.499-34.876-16.181-7.078-23.566-25.937-16.5-42.125 7.076-16.192 25.932-23.569 42.125-16.499 43.197 18.876 90.775 29.5 140.874 29.5 194.509-0.004 352.162-157.662 352.166-352.166z","M710.72 511.625c0-109.61-88.892-198.497-198.502-198.499-109.611 0-198.499 88.888-198.499 198.499 0 11.076 1.065 22.033 2.959 32.917 3.030 17.408-8.636 34.005-26.042 37.043-17.407 3.029-34.004-8.64-37.042-26.044-2.459-14.127-3.875-28.791-3.875-43.917 0-144.958 117.542-262.499 262.499-262.499 144.956 0.002 262.502 117.543 262.502 262.499-0.004 144.956-117.547 262.498-262.502 262.502-15.125 0-29.79-1.459-43.917-3.917-17.404-3.038-29.069-19.593-26.039-37.001 3.034-17.412 19.631-29.073 37.039-26.044 10.884 1.894 21.841 2.961 32.917 2.961 109.611-0.004 198.498-88.892 198.502-198.502z"],"attrs":[],"isMulticolor":false,"isMulticolor2":false,"grid":24,"tags":["References"],"colorPermutations":{"10511915011401421681255255255129365114753651761761561":[],"14014216812552552551293651147536515050501761761561":[]}},"attrs":[],"properties":{"order":389,"id":210,"name":"References","prevSize":24,"code":59871},"setIdx":0,"setId":0,"iconIdx":11},{"icon":{"paths":["M665.661 402.738l-71.219 71.221c-48.246-26.65-109.817-20.217-150.711 20.677-23.894 23.892-37.219 55.601-37.219 89.142s13.325 65.705 37.219 89.139c23.893 23.895 55.598 37.217 89.143 37.217 33.541 0 65.244-13.322 89.139-37.217 23.89-23.895 37.217-55.598 37.217-89.139 0-22.057-5.975-42.732-16.543-61.112l71.219-71.221c13.327-13.325 13.327-35.38 0-48.706-13.322-13.325-35.379-13.325-48.701 0h0.456zM573.768 624.21c-21.596 21.596-59.274 21.596-81.331 0-11.028-11.028-17.001-25.272-17.001-40.433 0-15.165 5.973-29.87 17.001-40.438s25.733-16.998 40.437-16.998c14.7 0 28.943 5.514 39.972 16.543 0 0 0 0 0 0.456 0 0.461 0 0 0.461 0 10.568 11.028 16.543 24.817 16.543 39.977 0 15.165-5.975 29.865-17.004 40.433l0.922 0.461z","M832.456 296.137c-81.787-73.518-188.39-113.493-298.204-114.412h-0.922c0 0 0 0-0.456 0-16.543 0-33.085 0.919-49.627 2.757-205.391 22.515-371.266 187.471-394.699 392.404-1.838 16.082-1.838 32.164-2.298 47.785 0 1.377-0.919 2.755-0.919 4.593 0 0.922 0.459 1.838 0.459 2.76 0.459 66.627 15.163 132.332 44.111 192.067 20.217 42.271 64.787 69.381 113.034 69.381h580.791c48.246 0 92.815-27.571 113.495-69.842 29.404-61.112 44.109-126.362 44.109-194.365 0-127.276-54.216-248.581-148.874-333.585v0.459zM823.726 825.006h-580.791c-22.055 0-41.814-11.945-51.003-30.326-19.758-40.893-31.245-85.002-35.381-130.493h54.679c18.839 0 34.462-15.621 34.462-34.463 0-18.836-15.623-34.463-34.462-34.463h-54.679c0-3.215 0-6.892 0.46-10.107 19.758-173.226 160.361-312.911 333.587-332.209 2.757 0 5.514 0 8.271-0.459v55.598c0 18.839 15.624 34.462 34.46 34.462 18.842 0 34.463-15.623 34.463-34.462v-56.057c80.87 7.352 156.687 39.975 218.716 95.114 71.68 64.328 115.333 153.009 124.063 247.665h-55.598c-18.842 0-34.463 15.621-34.463 34.458 0 18.842 15.621 34.463 34.463 34.463h55.598c-4.137 45.030-15.626 88.684-35.384 130.038-9.185 18.836-28.943 30.781-51.461 30.781v0.461z"],"attrs":[],"isMulticolor":false,"isMulticolor2":false,"grid":24,"tags":["dashboard"],"colorPermutations":{"10511915011401421681255255255129365114753651761761561":[],"14014216812552552551293651147536515050501761761561":[]}},"attrs":[],"properties":{"order":375,"id":209,"name":"dashboard1","prevSize":24,"code":59858},"setIdx":0,"setId":0,"iconIdx":12},{"icon":{"paths":["M238.229 51.2c-46.063 0-84.629 37.111-84.629 82.626v757.474c0 44.498 38.675 81.5 84.629 81.5h593.443c46.065 0 84.628-37.11 84.628-82.627v-558.24l-289.72-280.733h-388.351zM221.059 133.826c0-8.509 7.707-16.419 17.17-16.419h343.393v180.745c0 43.264 36.25 78.124 80 78.124h186.066v513.897c0 8.509-7.706 16.42-17.172 16.42h-592.286c-9.464 0-17.17-7.91-17.17-16.42v-756.347zM649.078 298.152v-132.487l148.419 144.403h-135.875c-7.148 0-12.544-5.659-12.544-11.917z","M797.496 310.069l-148.419-144.403v132.487c0 6.258 5.396 11.917 12.544 11.917h135.875zM626.58 51.2l289.72 280.733v558.24c0 45.517-38.564 82.627-84.628 82.627h-593.443c-45.954 0-84.629-37.002-84.629-81.5v-757.474c0-45.515 38.566-82.626 84.629-82.626h388.351zM238.229 117.407c-9.464 0-17.17 7.91-17.17 16.419v756.347c0 8.509 7.707 16.42 17.17 16.42h592.286c9.467 0 17.172-7.91 17.172-16.42v-513.897h-186.066c-43.75 0-80-34.86-80-78.124v-180.745h-343.393z"],"attrs":[],"isMulticolor":false,"isMulticolor2":false,"grid":24,"tags":["file"],"colorPermutations":{"10511915011401421681255255255129365114753651761761561":[],"14014216812552552551293651147536515050501761761561":[]}},"attrs":[],"properties":{"order":376,"id":208,"name":"file","prevSize":24,"code":59859,"codes":[59859]},"setIdx":0,"setId":0,"iconIdx":13},{"icon":{"paths":["M128 132.25c21.202 0 38.391 17.2 38.4 38.4v674.15c0.009 7.060 5.736 12.8 12.8 12.8h674.15c21.192 0.010 38.39 17.203 38.4 38.4-0.010 21.197-17.208 38.39-38.4 38.4h-674.15c-49.479 0-89.591-40.125-89.6-89.6v-674.15c0.009-21.2 17.198-38.4 38.4-38.4zM853.35 260.25c21.192 0.009 38.39 17.205 38.4 38.4v85.35c-0.010 21.195-17.208 38.391-38.4 38.4-18.924 0-34.632-13.685-37.801-31.7l-63.048 63.1c-14.044 14.041-36.495 15.056-51.753 2.35l-96.947-80.8-70.902 94.5 148.751 138.15 123.197-123.15c14.996-14.996 39.306-14.996 54.303 0s14.996 39.305 0 54.301l-149.35 149.35c-14.607 14.587-38.124 14.996-53.253 0.947l-169.998-157.798-178.5 238.049c-12.723 16.957-36.786 20.413-53.75 7.7-16.965-12.723-20.369-36.782-7.65-53.75l183.35-244.551-40.9-37.95-102.4 136.55c-12.726 16.963-36.786 20.424-53.75 7.7s-20.37-36.782-7.65-53.75l128-170.701 2.6-3.1c6.417-6.896 15.175-11.246 24.65-12.1 10.84-0.972 21.624 2.694 29.6 10.1l66.2 61.45 90.301-120.35 2.499-3c6.19-6.698 14.607-11.032 23.752-12.1 10.445-1.214 20.966 1.916 29.051 8.65l101.048 84.15 38.2-38.25c-17.961-3.215-31.601-18.867-31.601-37.75 0.010-21.2 17.198-38.4 38.4-38.4h85.35z"],"attrs":[],"isMulticolor":false,"isMulticolor2":false,"grid":24,"tags":["Market"],"colorPermutations":{"10511915011401421681255255255129365114753651761761561":[],"14014216812552552551293651147536515050501761761561":[]}},"attrs":[],"properties":{"order":377,"id":207,"name":"Market","prevSize":24,"code":59860},"setIdx":0,"setId":0,"iconIdx":14},{"icon":{"paths":["M972.134 633.836l-104.387-402.37c-15.631-61.16-70.815-103.466-133.816-103.466-36.326 0-72.197 14.715-97.946 40.466-26.214 26.211-40.468 60.7-40.468 97.948v34.029h-124.618v-34.029c0-36.788-14.255-71.736-40.466-97.948-25.752-25.751-61.16-40.466-97.948-40.466-63 0-118.181 42.766-133.816 103.466l-107.604 413.864c0 0 0 0.916 0 1.377-9.657 39.086-7.358 80.937 8.737 120.484 29.891 72.653 99.787 119.096 178.421 119.096s148.531-46.904 178.421-119.096c10.117-24.832 14.715-50.586 14.255-76.339v-3.215c0 0 0-3.22 0-5.059v-37.709h124.618v45.983c0 0 0 0.922 0 1.382 0 49.664 18.396 99.789 56.105 137.492 37.243 37.248 86.451 56.561 136.571 56.561 24.832 0 50.125-4.598 74.035-14.715 72.658-29.891 119.101-99.784 119.101-178.417 0-20.695-3.215-40.468-9.196-59.32zM684.728 216.751c12.877-12.876 30.812-20.233 49.203-20.233 31.729 0 59.32 21.153 67.139 51.963l69.898 270.391c-3.22-1.377-5.98-3.22-8.74-4.598-67.133-27.592-143.012-15.176-197.734 31.268v-279.587c0-18.394 7.357-35.868 20.234-49.204zM264.888 248.48c7.817-30.81 35.408-51.963 67.138-51.963 18.394 0 36.328 7.357 49.204 20.233 13.336 13.336 20.233 30.35 20.233 49.204v280.508c-58.861-49.665-139.794-58.402-206.932-26.214l70.357-271.768zM277.764 817.311c-50.584 0-95.188-29.891-114.502-76.795-19.314-46.444-8.737-99.784 27.131-135.194 24.372-23.91 56.101-36.326 87.831-36.326s63.459 11.955 87.371 36.326c22.073 22.072 34.488 50.586 36.328 80.015v5.059c0 16.553-2.759 33.567-9.197 49.664-19.314 46.444-64.379 76.795-114.502 76.795l-0.46 0.456zM470.44 575.892v-206.932h124.617v206.932h-124.617zM835.558 807.654c-46.444 19.313-99.784 8.74-135.194-27.131-48.287-48.282-48.287-126.915 0-175.201 23.91-23.91 55.639-36.326 87.828-36.326 16.097 0 32.189 3.215 47.365 9.656 34.028 14.254 59.32 41.846 70.359 75.412l2.299 8.74c0 0 0 0 0 0.461 2.299 9.656 3.676 19.313 3.676 29.891 0 50.58-29.891 95.647-76.795 114.499h0.461z"],"attrs":[],"isMulticolor":false,"isMulticolor2":false,"grid":24,"tags":["Outlook"],"colorPermutations":{"10511915011401421681255255255129365114753651761761561":[],"14014216812552552551293651147536515050501761761561":[]}},"attrs":[],"properties":{"order":378,"id":206,"name":"Outlook1","prevSize":24,"code":59861},"setIdx":0,"setId":0,"iconIdx":15},{"icon":{"paths":["M906.667 512c0-217.968-176.7-394.667-394.667-394.667-217.968 0-394.667 176.698-394.667 394.667 0 217.967 176.698 394.667 394.667 394.667 217.967 0 394.667-176.7 394.667-394.667zM970.667 512c0 253.316-205.35 458.667-458.667 458.667-253.315 0-458.667-205.35-458.667-458.667 0-253.315 205.352-458.667 458.667-458.667 253.316 0 458.667 205.352 458.667 458.667z","M938.667 480c17.673 0 32 14.327 32 32s-14.327 32-32 32h-853.333c-17.673 0-32-14.327-32-32s14.327-32 32-32h853.333z","M511.996 53.333c8.99 0 17.562 3.781 23.625 10.417 111.953 122.564 175.586 281.622 179.042 447.584 0.009 0.444 0.009 0.887 0 1.331-3.456 165.965-67.089 325.022-179.042 447.586-6.063 6.635-14.635 10.415-23.625 10.415s-17.562-3.78-23.625-10.415c-111.952-122.564-175.584-281.621-179.041-447.586-0.009-0.444-0.009-0.887 0-1.331 3.457-165.963 67.089-325.021 179.041-447.584l2.377-2.333c5.828-5.178 13.376-8.083 21.248-8.083zM511.996 134.542c-86.586 106.716-135.642 239.395-138.666 377.458 3.024 138.052 52.093 270.703 138.666 377.417 86.575-106.709 135.603-239.364 138.624-377.417-3.021-138.063-52.036-270.743-138.624-377.458z"],"attrs":[],"isMulticolor":false,"isMulticolor2":false,"grid":24,"tags":["explainability"],"colorPermutations":{"10511915011401421681255255255129365114753651761761561":[],"14014216812552552551293651147536515050501761761561":[]}},"attrs":[],"properties":{"order":379,"id":205,"name":"explainability","prevSize":24,"code":59862},"setIdx":0,"setId":0,"iconIdx":16},{"icon":{"paths":["M96 768v-512c0-64.82 52.514-117.333 117.333-117.333h190.75c24.738 0 47.829 12.254 61.709 32.625l59.959 88.166c1.971 2.904 5.303 4.667 8.832 4.667h276.083c64.832 0 117.333 52.567 117.333 117.333v386.542c0 64.819-52.514 117.333-117.333 117.333h-597.333c-64.82 0-117.333-52.514-117.333-117.333zM160 768c0 29.474 23.86 53.333 53.333 53.333h597.333c29.474 0 53.333-23.859 53.333-53.333v-386.542c0-29.441-23.872-53.333-53.333-53.333h-276.083c-24.713 0-47.893-12.275-61.79-32.75v-0.041l-59.919-88c-1.993-2.921-5.286-4.667-8.792-4.667h-190.75c-29.474 0-53.333 23.86-53.333 53.333v512z"],"attrs":[],"isMulticolor":false,"isMulticolor2":false,"grid":24,"tags":["folder"],"colorPermutations":{"10511915011401421681255255255129365114753651761761561":[],"14014216812552552551293651147536515050501761761561":[]}},"attrs":[],"properties":{"order":380,"id":204,"name":"folder","prevSize":24,"code":59863},"setIdx":0,"setId":0,"iconIdx":17},{"icon":{"paths":["M96 256c0-64.82 52.514-117.333 117.333-117.333h190.5c24.975 0 48.267 12.506 62.125 33.292l59.998 90c1.937 2.908 5.291 4.708 8.879 4.708h190.498c64.819 0 117.333 52.514 117.333 117.333v12.042c68.685 10.432 114.957 79.734 94.626 148.999l-75.127 256c-14.665 49.967-60.493 84.284-112.58 84.292l-580.919-0.418c-40.833-4.139-72.666-38.609-72.666-80.542v-548.373zM404.833 458.667c-23.547 0-44.349 15.445-51.125 38.042l-97.375 324.625h493.252c23.671-0.009 44.497-15.607 51.166-38.332l75.123-256c10.022-34.159-15.561-68.331-51.166-68.335h-419.875zM160 804.373c0 9.378 7.581 16.96 16.958 16.96 7.476-0.009 14.043-4.941 16.167-12.041l99.292-330.961c14.898-49.681 60.614-83.665 112.416-83.665h373.833v-10.667c0-29.474-23.859-53.333-53.333-53.333h-190.498c-21.79 0-42.406-9.521-56.503-25.833l-5.623-7.417-60-89.958c-2.015-3.022-5.348-4.791-8.875-4.791h-190.5c-29.474 0-53.333 23.86-53.333 53.333v548.373z"],"attrs":[],"isMulticolor":false,"isMulticolor2":false,"grid":24,"tags":["folderopen"],"colorPermutations":{"10511915011401421681255255255129365114753651761761561":[],"14014216812552552551293651147536515050501761761561":[]}},"attrs":[],"properties":{"order":381,"id":203,"name":"folderopen","prevSize":24,"code":59864},"setIdx":0,"setId":0,"iconIdx":18},{"icon":{"paths":["M693.431 383.956v-53.375h-53.376c-17.673 0-32-14.327-32-32s14.327-32 32-32h85.376c17.673 0.003 32 14.329 32 32v85.375c-0.004 17.668-14.332 31.997-32 32-17.673 0-31.996-14.33-32-32z","M702.801 275.956c12.497-12.497 32.755-12.497 45.252 0 12.493 12.497 12.493 32.753 0 45.25l-128.043 128.044c-11.187 11.183-28.89 12.544-41.626 3.166l-93.751-69.085-35.375 35.459c-12.493 12.493-32.753 12.493-45.249 0-12.496-12.496-12.493-32.753 0-45.25l54.874-54.917c11.187-11.187 28.89-12.508 41.626-3.125l93.666 69.041 108.625-108.583z","M725.414 544.026c17.668 0 31.996 14.332 32 32 0 17.673-14.327 32-32 32h-128.043c-17.673-0.004-32-14.327-32-32 0.004-17.673 14.332-32 32-32h128.043z","M725.414 672.077c17.668 0 31.996 14.332 32 32 0 17.673-14.327 32-32 32h-128.043c-17.673 0-32-14.327-32-32 0.004-17.668 14.332-32 32-32h128.043z","M95.844 580.301c0-17.677 14.327-32 32-32s32 14.323 32 32v289.455c0.295 0.593 1.145 1.98 3.417 4.126 4.727 4.471 13.286 9.963 26.5 15.249 26.251 10.505 64.718 17.711 108.833 17.711 44.102-0.004 82.543-7.211 108.792-17.711 13.206-5.282 21.773-10.782 26.5-15.249 2.261-2.138 3.119-3.529 3.418-4.126v-289.455c0-17.668 14.332-31.991 32-32 17.673 0 32 14.323 32 32v290.291c-0.030 21.035-10.799 37.858-23.42 49.792-12.557 11.87-29.030 21.090-46.707 28.164-35.528 14.217-82.41 22.289-132.583 22.293-50.179 0-97.093-8.077-132.625-22.293-17.673-7.070-34.112-16.299-46.667-28.164-12.623-11.934-23.431-28.749-23.458-49.792v-290.291z","M298.594 480.004c50.152 0 97.051 8.077 132.583 22.289 17.673 7.074 34.112 16.303 46.669 28.169 12.621 11.93 23.428 28.74 23.458 49.792 0 1.485-0.141 2.944-0.333 4.373-1.361 19.046-11.383 34.394-23.125 45.5-12.561 11.878-29.030 21.094-46.711 28.169-35.53 14.212-82.416 22.289-132.582 22.293-50.178 0-97.098-8.077-132.625-22.293-17.67-7.074-34.116-16.294-46.667-28.169-12.621-11.938-23.417-28.77-23.417-49.826 0.001-21.073 10.825-37.892 23.458-49.839 12.564-11.878 29.027-21.099 46.708-28.169 35.541-14.204 82.439-22.289 132.583-22.289zM298.594 544.004c-44.093 0-82.569 7.211-108.833 17.707-13.221 5.286-21.777 10.786-26.5 15.249-1.566 1.485-2.456 2.594-2.959 3.337 0.502 0.738 1.396 1.852 2.959 3.332 4.718 4.463 13.252 9.967 26.458 15.249 26.243 10.505 64.717 17.711 108.833 17.711 44.11-0.004 82.58-7.206 108.834-17.711 13.214-5.286 21.777-10.786 26.5-15.249 1.557-1.472 2.372-2.637 2.876-3.375-0.516-0.742-1.374-1.869-2.876-3.294-4.736-4.467-13.295-9.967-26.5-15.249-26.257-10.5-64.71-17.707-108.792-17.707z","M127.868 693.427c17.408 0 31.537 13.901 31.958 31.206 0.276 0.567 1.152 1.941 3.459 4.126 4.719 4.463 13.254 9.967 26.458 15.249 26.243 10.505 64.717 17.711 108.833 17.711 44.11-0.004 82.58-7.206 108.834-17.711 13.215-5.286 21.778-10.786 26.502-15.249 4.642-4.395 3.375-5.542 3.375-3.332 0-17.673 14.332-31.996 32-32 17.673 0 32 14.327 32 32 0 21.060-10.795 37.892-23.42 49.83-12.557 11.878-29.026 21.094-46.707 28.169-35.531 14.212-82.417 22.289-132.583 22.293-50.178 0-97.098-8.077-132.625-22.293-17.67-7.074-34.116-16.294-46.667-28.169-12.621-11.938-23.417-28.774-23.417-49.83 0-17.673 14.327-32 32-32z","M864.171 768.094v-554.875c0-29.474-23.902-53.374-53.376-53.375h-512.207c-29.475 0-53.375 23.9-53.375 53.375v170.75c-0.010 17.664-14.333 32-32 32s-31.99-14.336-32-32v-170.75c0-64.821 52.554-117.375 117.375-117.375h512.207c64.823 0 117.376 52.554 117.376 117.375v554.875c0 64.819-52.553 117.376-117.376 117.376h-213.414c-17.673 0-32-14.327-32-32 0.004-17.668 14.327-32 32-32h213.414c29.474 0 53.376-23.902 53.376-53.376z"],"attrs":[],"isMulticolor":false,"isMulticolor2":false,"grid":24,"tags":["instruments-customisation"],"colorPermutations":{"10511915011401421681255255255129365114753651761761561":[],"14014216812552552551293651147536515050501761761561":[]}},"attrs":[],"properties":{"order":382,"id":202,"name":"instruments-customisation","prevSize":24,"code":59865},"setIdx":0,"setId":0,"iconIdx":19},{"icon":{"paths":["M906.667 512c0-217.968-176.7-394.667-394.667-394.667-217.968 0-394.667 176.698-394.667 394.667 0 217.967 176.698 394.667 394.667 394.667 217.967 0 394.667-176.7 394.667-394.667zM970.667 512c0 253.316-205.35 458.667-458.667 458.667-253.315 0-458.667-205.35-458.667-458.667 0-253.315 205.352-458.667 458.667-458.667 253.316 0 458.667 205.352 458.667 458.667z","M682.799 300.718c11.494-3.824 24.188-0.816 32.751 7.75 8.563 8.57 11.541 21.256 7.71 32.75l-90.458 271.373c-3.187 9.54-10.671 17.024-20.211 20.211l-271.373 90.458c-11.494 3.831-24.18 0.853-32.75-7.71-8.566-8.563-11.574-21.257-7.75-32.751l90.458-271.373c3.185-9.556 10.694-17.065 20.25-20.25l271.373-90.458zM446.801 446.801l-65.125 195.499 195.459-65.165 65.165-195.459-195.499 65.125z"],"attrs":[],"isMulticolor":false,"isMulticolor2":false,"grid":24,"tags":["market-view"],"colorPermutations":{"10511915011401421681255255255129365114753651761761561":[],"14014216812552552551293651147536515050501761761561":[]}},"attrs":[],"properties":{"order":383,"id":201,"name":"market-view","prevSize":24,"code":59866},"setIdx":0,"setId":0,"iconIdx":20},{"icon":{"paths":["M480 938.667v-213.333c0-17.673 14.327-32 32-32s32 14.327 32 32v213.333c0 17.673-14.327 32-32 32s-32-14.327-32-32z","M736 170.667c0-14.145-5.623-27.706-15.625-37.708s-23.565-15.625-37.709-15.625h-341.333c-14.145 0-27.706 5.623-37.708 15.625s-15.625 23.564-15.625 37.708l0.25 5.292c1.216 12.202 6.628 23.67 15.375 32.417 10.002 10.002 23.564 15.625 37.708 15.625h42.667c17.673 0 32 14.327 32 32v203.123c-0.015 21.824-6.124 43.204-17.625 61.751-11.469 18.496-27.863 33.408-47.333 43.127l-76.125 38.541c-8.875 4.412-16.358 11.2-21.583 19.622-5.228 8.431-7.994 18.163-8 28.083v43.085h533.333v-43.085c-0.009-9.92-2.773-19.652-8-28.083-5.227-8.422-12.71-15.211-21.585-19.622l-0.205-0.128-75.959-38.413c-19.456-9.719-35.831-24.644-47.292-43.127-11.503-18.547-17.613-39.927-17.626-61.751v-203.123c0-17.673 14.327-32 32-32h42.667l5.291-0.25c12.203-1.216 23.671-6.628 32.418-15.375 10.001-10.002 15.625-23.564 15.625-37.708zM800 170.667c0 31.119-12.369 60.954-34.377 82.959-22.003 22.004-51.84 34.375-82.957 34.375h-10.667v171.085l0.499 7.373c1.028 7.322 3.575 14.383 7.501 20.71 5.227 8.422 12.71 15.211 21.585 19.622l0.205 0.128 75.917 38.374c19.477 9.715 35.861 24.666 47.334 43.166 11.503 18.547 17.613 39.927 17.626 61.751v75.123c0 17.673-14.327 32-32 32h-597.333c-17.673 0-32-14.327-32-32v-75.123l0.292-8.166c1.335-18.965 7.272-37.359 17.333-53.585 11.465-18.492 27.829-33.451 47.291-43.166l76.167-38.502c8.875-4.412 16.358-11.2 21.583-19.622 3.923-6.327 6.473-13.389 7.5-20.71l0.5-7.373v-171.085h-10.667c-31.119 0-60.954-12.371-82.959-34.375-19.257-19.257-31.127-44.51-33.792-71.375l-0.583-11.583c0-31.119 12.371-60.954 34.375-82.959s51.84-34.375 82.959-34.375h341.333c31.117 0 60.954 12.371 82.957 34.375 22.007 22.004 34.377 51.84 34.377 82.959z"],"attrs":[],"isMulticolor":false,"isMulticolor2":false,"grid":24,"tags":["pin"],"colorPermutations":{"10511915011401421681255255255129365114753651761761561":[],"14014216812552552551293651147536515050501761761561":[]}},"attrs":[],"properties":{"order":384,"id":200,"name":"pin","prevSize":24,"code":59867},"setIdx":0,"setId":0,"iconIdx":21},{"icon":{"paths":["M587.123 554.283c0-17.685-14.319-32.034-32-32.043-17.685 0-32.038 14.353-32.038 32.043 0.009 17.681 14.357 32 32.038 32 17.677-0.009 31.996-14.327 32-32zM651.123 554.283c-0.004 53.022-42.978 95.991-96 96-53.026 0-96.030-42.974-96.038-96 0-53.035 43.008-96.043 96.038-96.043 53.030 0.009 96 43.012 96 96.043z","M752.887 388.489c0-17.683-14.323-32.033-32-32.041-17.69 0-32.043 14.354-32.043 32.041 0.009 17.681 14.357 32 32.043 32 17.673-0.008 31.991-14.324 32-32zM816.887 388.489c-0.009 53.021-42.978 95.991-96 95.999-53.030 0-96.034-42.974-96.043-95.999 0-53.034 43.008-96.041 96.043-96.041 53.026 0.008 96 43.013 96 96.041z","M309.25 554.667c0.003-135.538 109.878-245.414 245.417-245.417 17.673 0 32 14.327 32 32s-14.327 32-32 32c-100.194 0.003-181.414 81.222-181.417 181.417 0 100.194 81.222 181.414 181.417 181.419 100.198 0 181.419-81.22 181.419-181.419 0-17.668 14.332-31.996 32-32 17.668 0 31.996 14.327 32 32 0 135.543-109.875 245.419-245.419 245.419-135.54-0.004-245.417-109.879-245.417-245.419z","M928.166 554.667c0-206.278-167.219-373.5-373.5-373.5-206.278 0.001-373.499 167.222-373.5 373.5 0 206.281 167.222 373.5 373.5 373.5 206.281 0 373.5-167.219 373.5-373.5zM992.166 554.667c0 241.626-195.874 437.5-437.5 437.5s-437.5-195.874-437.5-437.5c0.001-241.624 195.876-437.499 437.5-437.5 241.626 0 437.5 195.875 437.5 437.5z"],"attrs":[],"isMulticolor":false,"isMulticolor2":false,"grid":24,"tags":["universe"],"colorPermutations":{"10511915011401421681255255255129365114753651761761561":[],"14014216812552552551293651147536515050501761761561":[]}},"attrs":[],"properties":{"order":385,"id":199,"name":"universe","prevSize":24,"code":59868},"setIdx":0,"setId":0,"iconIdx":22},{"icon":{"paths":["M500.147 948.186v-207.424c0-18.33 14.874-33.203 33.203-33.203 18.325 0 33.199 14.874 33.199 33.203v207.424c-0.009 18.321-14.878 33.152-33.199 33.152-18.325 0-33.195-14.831-33.203-33.152z","M624.631 422.988v-97.028c0-19.793 7.838-38.791 21.828-52.792 14.003-14.003 33.037-21.875 52.838-21.875 13.197-0.006 25.865-5.254 35.196-14.583 9.331-9.331 14.579-22 14.583-35.194 0-13.193-5.261-25.862-14.583-35.195-9.331-9.33-21.999-14.577-35.196-14.583h-336.438c-18.328 0-33.201-14.874-33.201-33.201s14.874-33.201 33.201-33.201h336.438c30.797 0.006 60.331 12.254 82.108 34.028 21.781 21.782 34.027 51.348 34.027 82.153-0.004 30.797-12.254 60.326-34.027 82.104-21.777 21.777-51.311 34.022-82.108 34.028-2.197 0-4.326 0.877-5.879 2.431-1.557 1.556-2.432 3.682-2.432 5.882v97.028c0 18.326-14.874 33.2-33.203 33.2-18.321-0.004-33.152-14.874-33.152-33.2z","M95.053 95.056c12.96-12.96 33.999-12.96 46.959 0l829.602 829.65c12.958 12.958 12.958 33.95 0 46.912-12.958 12.958-33.95 12.958-46.912 0l-829.649-829.604c-12.96-12.96-12.96-33.999 0-46.959z","M209.776 699.264v-31.552c0.016-21.594 6.075-42.748 17.452-61.103 11.385-18.359 27.663-33.212 47.007-42.825l73.841-37.333c8.289-4.122 15.293-10.462 20.174-18.33 4.876-7.863 7.476-16.947 7.486-26.202v-73.013c0-18.323 14.833-33.193 33.153-33.202 18.329 0 33.202 14.874 33.202 33.202v73.013l-0.294 8.073c-1.314 18.786-7.189 37.009-17.158 53.082-11.354 18.308-27.586 33.062-46.861 42.679l0.049 0.051-74.035 37.431c-8.291 4.117-15.294 10.458-20.174 18.325-4.876 7.868-7.431 16.947-7.437 26.202v31.501c0 2.197 0.875 4.326 2.43 5.879 1.551 1.549 3.643 2.428 5.833 2.432h456.314c18.33 0 33.203 14.874 33.203 33.203-0.009 18.317-14.882 33.152-33.203 33.152h-456.314c-19.797-0.004-38.793-7.876-52.792-21.875-13.993-14.003-21.875-32.998-21.875-52.791z"],"attrs":[],"isMulticolor":false,"isMulticolor2":false,"grid":24,"tags":["unpin"],"colorPermutations":{"10511915011401421681255255255129365114753651761761561":[],"14014216812552552551293651147536515050501761761561":[]}},"attrs":[],"properties":{"order":386,"id":198,"name":"unpin","prevSize":24,"code":59869},"setIdx":0,"setId":0,"iconIdx":23},{"icon":{"paths":["M480.427 895.991v-766.71c0-17.673 14.327-32 32-32s32 14.327 32 32v766.71c0 17.673-14.327 32-32 32s-32-14.327-32-32z","M896 404.052c17.673 0 32 14.327 32 32.001 0 17.673-14.327 32-32 32h-384c-17.673 0-32-14.327-32-32 0-17.674 14.327-32.001 32-32.001h384z","M512.439 596.053c17.668 0.004 32 14.327 32 32 0 17.668-14.332 31.991-32 32h-383.585c-17.673 0-32-14.327-32-32s14.327-32 32-32h383.585z","M864 213.333c0-29.474-23.859-53.333-53.333-53.333h-597.333c-29.474 0-53.333 23.86-53.333 53.333v597.333c0 29.474 23.86 53.333 53.333 53.333h597.333c29.474 0 53.333-23.859 53.333-53.333v-597.333zM928 810.667c0 64.819-52.514 117.333-117.333 117.333h-597.333c-64.82 0-117.333-52.514-117.333-117.333v-597.333c0-64.82 52.514-117.333 117.333-117.333h597.333c64.819 0 117.333 52.514 117.333 117.333v597.333z"],"attrs":[],"isMulticolor":false,"isMulticolor2":false,"grid":24,"tags":["workspace"],"colorPermutations":{"10511915011401421681255255255129365114753651761761561":[],"14014216812552552551293651147536515050501761761561":[]}},"attrs":[],"properties":{"order":387,"id":197,"name":"workspace","prevSize":24,"code":59870},"setIdx":0,"setId":0,"iconIdx":24},{"icon":{"paths":["M228.292 288c30.609 0 55.423 24.814 55.423 55.423v337.153c0 30.609-24.814 55.424-55.423 55.424v-448z","M228.292 288c30.609 0 55.423 24.814 55.423 55.423v337.153c0 30.609-24.814 55.424-55.423 55.424v-448z","M251.708 680.585l0-337.168c-0.003-12.933-10.483-23.417-23.417-23.417v-64c48.28 0 87.413 39.137 87.417 87.417l-0 337.168c-0.003 48.277-39.136 87.415-87.416 87.415v-64c12.934 0 23.413-10.483 23.416-23.415z","M283.702 512c0-17.673 14.327-32 32-32h448.002c17.673 0 32 14.327 32 32s-14.327 32-32 32h-448.002c-17.673 0-32-14.327-32-32z"],"attrs":[{"fill":"rgb(255, 255, 255)"},{"fill":"rgb(140, 142, 168)","opacity":0.5},{"fill":"rgb(140, 142, 168)"},{"fill":"rgb(140, 142, 168)"}],"isMulticolor":true,"isMulticolor2":true,"grid":24,"tags":["Property 1=Min"],"colorPermutations":{"10511915011401421681255255255129365114753651761761561":[{"f":5},{"f":4},{"f":4},{"f":4}],"14014216812552552551293651147536515050501761761561":[{"f":5},{"f":4},{"f":4},{"f":4}]}},"attrs":[{"fill":"rgb(255, 255, 255)"},{"fill":"rgb(140, 142, 168)","opacity":0.5},{"fill":"rgb(140, 142, 168)"},{"fill":"rgb(140, 142, 168)"}],"properties":{"order":373,"id":196,"name":"Property-1Min1","prevSize":24,"code":59838,"codes":[59838,59839,59840,59841]},"setIdx":0,"setId":0,"iconIdx":25},{"icon":{"paths":["M763.708 288v0c-30.609 0-55.424 24.814-55.424 55.423v337.153c0 30.609 24.815 55.424 55.424 55.424v0-448z","M763.708 288v0c-30.609 0-55.424 24.814-55.424 55.423v337.153c0 30.609 24.815 55.424 55.424 55.424v0-448z","M740.292 680.585v-337.168c0.004-12.933 10.483-23.417 23.415-23.417v-64c-48.282 0-87.411 39.137-87.415 87.417v337.168c0.004 48.277 39.134 87.415 87.415 87.415v-64c-12.932 0-23.411-10.483-23.415-23.415z","M708.271 512c0-17.673-14.327-32-32-32h-384c-17.673 0-32 14.327-32 32v0c0 17.673 14.327 32 32 32h384c17.673 0 32-14.327 32-32v0z"],"attrs":[{"fill":"rgb(255, 255, 255)"},{"fill":"rgb(140, 142, 168)","opacity":0.5},{"fill":"rgb(140, 142, 168)"},{"fill":"rgb(140, 142, 168)"}],"isMulticolor":true,"isMulticolor2":true,"grid":24,"tags":["Property 1=3quartile"],"colorPermutations":{"246155111125525525512936511761761561":[{"f":3},{"f":0},{"f":0},{"f":0}],"10511915011401421681255255255129365114753651761761561":[{"f":5},{"f":4},{"f":4},{"f":4}],"14014216812552552551293651147536515050501761761561":[{"f":5},{"f":4},{"f":4},{"f":4}]}},"attrs":[{"fill":"rgb(255, 255, 255)"},{"fill":"rgb(140, 142, 168)","opacity":0.5},{"fill":"rgb(140, 142, 168)"},{"fill":"rgb(140, 142, 168)"}],"properties":{"order":369,"id":195,"name":"Property-13quartile","prevSize":24,"code":59842,"codes":[59842,59843,59844,59845]},"setIdx":0,"setId":0,"iconIdx":26},{"icon":{"paths":["M192 288h320c35.345 0 64 28.654 64 64v320c0 35.345-28.655 64-64 64h-320v-448z","M192 288h320c35.345 0 64 28.654 64 64v320c0 35.345-28.655 64-64 64h-320v-448z","M544 672v-320c0-17.673-14.327-32-32-32h-320v-64h320c53.018 0 96 42.981 96 96v320c0 53.018-42.982 96-96 96h-320v-64h320c17.673 0 32-14.327 32-32z","M576 512c0-17.673 14.327-32 32-32h192c17.673 0 32 14.327 32 32s-14.327 32-32 32h-192c-17.673 0-32-14.327-32-32z"],"attrs":[{"fill":"rgb(255, 255, 255)"},{"fill":"rgb(140, 142, 168)","opacity":0.5},{"fill":"rgb(140, 142, 168)"},{"fill":"rgb(140, 142, 168)"}],"isMulticolor":true,"isMulticolor2":true,"grid":24,"tags":["Property 1=Max"],"colorPermutations":{"246155111125525525512936511761761561":[{"f":3},{"f":0},{"f":0},{"f":0}],"10511915011401421681255255255129365114753651761761561":[{"f":5},{"f":4},{"f":4},{"f":4}],"14014216812552552551293651147536515050501761761561":[{"f":5},{"f":4},{"f":4},{"f":4}]}},"attrs":[{"fill":"rgb(255, 255, 255)"},{"fill":"rgb(140, 142, 168)","opacity":0.5},{"fill":"rgb(140, 142, 168)"},{"fill":"rgb(140, 142, 168)"}],"properties":{"order":370,"id":194,"name":"Property-1Max","prevSize":24,"code":59846,"codes":[59846,59847,59848,59849]},"setIdx":0,"setId":0,"iconIdx":27},{"icon":{"paths":["M832 736h-640v-448h640v448z","M832 736h-640v-448h640v448z","M192 320v-64h640v64h-640zM192 768v-64h640v64h-640z","M448 288h128v448h-128v-448z"],"attrs":[{"fill":"rgb(255, 255, 255)"},{"fill":"rgb(140, 142, 168)","opacity":0.5},{"fill":"rgb(140, 142, 168)"},{"fill":"rgb(47, 53, 65)"}],"isMulticolor":true,"isMulticolor2":true,"grid":24,"tags":["Property 1=Median"],"colorPermutations":{"246155111125525525512936511761761561":[{"f":3},{"f":0},{"f":0},{"f":0}],"10511915011401421681255255255129365114753651761761561":[{"f":5},{"f":4},{"f":4},{"f":1}],"14014216812552552551293651147536515050501761761561":[{"f":5},{"f":4},{"f":4},{"f":2}]}},"attrs":[{"fill":"rgb(255, 255, 255)"},{"fill":"rgb(140, 142, 168)","opacity":0.5},{"fill":"rgb(140, 142, 168)"},{"fill":"rgb(47, 53, 65)"}],"properties":{"order":371,"id":193,"name":"Property-1Median","prevSize":24,"code":59850,"codes":[59850,59851,59852,59853]},"setIdx":0,"setId":0,"iconIdx":28},{"icon":{"paths":["M228.292 288v0c30.609 0 55.423 24.814 55.423 55.423l-0 337.153c0 30.609-24.813 55.424-55.423 55.424v0l0-448z","M228.292 288v0c30.609 0 55.423 24.814 55.423 55.423l-0 337.153c0 30.609-24.813 55.424-55.423 55.424v0l0-448z","M251.708 680.585v-337.168c-0.003-12.933-10.482-23.417-23.416-23.417v-64c48.28 0 87.413 39.137 87.416 87.417v337.168c-0.003 48.277-39.136 87.415-87.417 87.415v-64c12.934 0 23.414-10.483 23.417-23.415z","M283.688 512c0-17.673 14.327-32 32-32h447.999c17.673 0 32 14.327 32 32s-14.327 32-32 32h-447.999c-17.673 0-32-14.327-32-32z"],"attrs":[{"fill":"rgb(255, 255, 255)"},{"fill":"rgb(140, 142, 168)","opacity":0.5},{"fill":"rgb(140, 142, 168)"},{"fill":"rgb(140, 142, 168)"}],"isMulticolor":true,"isMulticolor2":true,"grid":24,"tags":["Property 1=Min"],"colorPermutations":{"246155111125525525512936511761761561":[{"f":3},{"f":0},{"f":0},{"f":0}],"10511915011401421681255255255129365114753651761761561":[{"f":5},{"f":4},{"f":4},{"f":4}],"14014216812552552551293651147536515050501761761561":[{"f":5},{"f":4},{"f":4},{"f":4}]}},"attrs":[{"fill":"rgb(255, 255, 255)"},{"fill":"rgb(140, 142, 168)","opacity":0.5},{"fill":"rgb(140, 142, 168)"},{"fill":"rgb(140, 142, 168)"}],"properties":{"order":372,"id":192,"name":"Property-1Min","prevSize":24,"code":59854,"codes":[59854,59855,59856,59857]},"setIdx":0,"setId":0,"iconIdx":29},{"icon":{"paths":["M411.004 191.788c49.467-73.181 161.258-70.748 206.583 7.292l294.127 506.124c47.036 80.964-12.949 180.126-105.583 180.126h-588.252c-92.645-0.009-152.664-99.153-105.583-180.126l294.125-506.124 4.583-7.292zM562.253 231.204c-22.114-38.062-78.387-38.068-100.497 0l-294.127 506.165c-21.328 36.676 5.056 83.951 50.25 83.959h588.252c45.146 0 71.561-47.262 50.249-83.959l-294.127-506.165zM480.004 575.996v-192c0-17.673 14.327-32 32-32s32 14.327 32 32v192c0 17.673-14.327 32-32 32s-32-14.327-32-32zM554.671 735.996c0 23.561-19.106 42.667-42.667 42.667s-42.667-19.106-42.667-42.667c-0.047-23.68 19.187-42.667 42.624-42.667l4.378 0.209c21.478 2.185 38.332 20.297 38.332 42.458z"],"attrs":[],"isMulticolor":false,"isMulticolor2":false,"grid":24,"tags":["Alert"],"colorPermutations":{"246155111125525525512936511761761561":[],"10511915011401421681255255255129365114753651761761561":[],"14014216812552552551293651147536515050501761761561":[]}},"attrs":[],"properties":{"order":359,"id":191,"name":"Alert","prevSize":24,"code":59694},"setIdx":0,"setId":0,"iconIdx":30},{"icon":{"paths":["M618.978 874.684h-256.002c-17.493 0-32 14.507-32 32s14.507 32 32 32h256.002c17.493 0 32-14.507 32-32s-14.507-32-32-32z","M715.405 177.083c-61.44-60.587-142.933-92.587-229.547-91.733-84.482 1.28-167.255 38.4-226.988 101.973-59.733 64-91.733 149.333-87.893 233.813 4.267 89.174 46.507 172.8 115.627 229.974 28.16 23.040 43.947 56.32 43.947 91.307v45.653c0 17.493 14.507 32 32 32h256.002c17.493 0 32-14.507 32-32v-45.653c0-34.987 15.787-67.84 43.093-90.453 74.24-61.013 117.333-151.040 117.333-247.040 0-86.187-33.707-167.253-95.573-227.84zM394.976 756.070v-13.653c0-14.080-1.707-27.733-4.693-40.96h201.815c-2.987 13.227-4.693 26.88-4.693 40.96v13.653h-192.428zM653.111 602.897c-12.373 10.24-22.613 22.187-32 34.987h-261.122c-9.387-12.8-19.627-25.173-32.427-35.84-55.040-45.653-88.747-112.64-92.587-183.894-3.413-67.413 22.187-135.68 70.4-186.88 47.787-51.2 113.92-81.067 181.335-81.92 68.693-1.707 134.4 25.173 183.893 73.387 49.067 48.64 76.373 113.067 76.373 182.187 0 76.8-34.133 148.907-93.867 197.547v0.427z"],"attrs":[],"isMulticolor":false,"isMulticolor2":false,"grid":24,"tags":["Suggestion"],"colorPermutations":{"246155111125525525512936511761761561":[],"10511915011401421681255255255129365114753651761761561":[],"14014216812552552551293651147536515050501761761561":[]}},"attrs":[],"properties":{"order":360,"id":190,"name":"Suggestion","prevSize":24,"code":59695},"setIdx":0,"setId":0,"iconIdx":31},{"icon":{"paths":["M778.803 512.009c0-29.474-23.902-53.372-53.376-53.372h-426.833c-29.475 0-53.375 23.898-53.375 53.372v298.795c0.004 29.47 23.903 53.376 53.375 53.376h426.833c29.474 0 53.372-23.906 53.376-53.376v-298.795zM440.137 592.218c12.501-12.48 32.759-12.454 45.248 0.043l26.624 26.667 26.667-26.624c12.501-12.493 32.759-12.497 45.252 0s12.497 32.755 0 45.248l-26.667 26.628 26.624 26.667c12.489 12.497 12.493 32.755 0 45.248-12.501 12.489-32.759 12.497-45.248 0l-26.667-26.667-26.628 26.667c-12.497 12.493-32.755 12.493-45.248 0-12.493-12.501-12.501-32.755 0-45.248l26.667-26.709-26.624-26.624c-12.493-12.506-12.501-32.802 0-45.295zM650.761 298.594c0-76.623-62.127-138.749-138.752-138.75-76.621 0-138.748 62.127-138.748 138.75v96.042h277.5v-96.042zM714.761 394.636h10.667c64.819 0 117.376 52.554 117.376 117.373v298.795c-0.004 64.815-52.557 117.376-117.376 117.376h-426.833c-64.819 0-117.371-52.561-117.375-117.376v-298.795c0-64.819 52.554-117.373 117.375-117.373h10.667v-96.042c0-111.969 90.781-202.75 202.748-202.75 111.97 0 202.752 90.781 202.752 202.75v96.042z"],"attrs":[],"isMulticolor":false,"isMulticolor2":false,"grid":24,"tags":["Locked"],"colorPermutations":{"246155111125525525512936511761761561":[],"10511915011401421681255255255129365114753651761761561":[],"14014216812552552551293651147536515050501761761561":[]}},"attrs":[],"properties":{"order":374,"id":189,"name":"Locked","prevSize":24,"code":59803},"setIdx":0,"setId":0,"iconIdx":32},{"icon":{"paths":["M480.021 810.667v-228.54l-37.833 37.833-45.293-45.252 92.457-92.459 2.462-2.206c12.565-10.244 31.117-9.506 42.833 2.206l92.459 92.459 2.163 2.419c10.261 12.565 9.545 31.113-2.163 42.833-12.497 12.497-32.798 12.497-45.295 0l-37.79-37.794v228.501c0 17.668-14.336 31.987-32 32-17.673 0-32-14.327-32-32zM909.231 661.333c0-64.585-52.749-117.329-117.333-117.333h-18.586c-17.664-0.009-32-14.332-32-32v-42.667c0-123.554-100.446-224-224-224-111.008 0.009-203.227 81.254-220.708 187.499-2.443 14.852-14.888 26.018-29.917 26.795-84.687 4.309-151.917 73.668-151.917 159.040 0 88.354 71.647 160 160 160h66.542c17.673 0 32 14.327 32 32s-14.327 32-32 32h-66.542c-123.7 0-224-100.301-224-224 0-111.45 81.476-202.962 187.709-220.292 31.639-124.545 144.355-217.033 278.833-217.041 158.899 0 288 129.1 288 288v11.209c93.7 6.899 167.919 85.372 167.919 180.791 0 99.934-81.404 181.329-181.333 181.333h-109.252c-17.664-0.009-32-14.332-32-32s14.336-31.991 32-32h109.252c64.585-0.004 117.333-52.749 117.333-117.333zM442.189 619.959c-12.497 12.497-32.796 12.497-45.293 0-12.483-12.497-12.483-32.755 0-45.252l45.293 45.252z"],"attrs":[],"grid":24,"tags":["synch-Cloud"],"isMulticolor":false,"isMulticolor2":false,"colorPermutations":{"246155111125525525512936511761761561":[],"10511915011401421681255255255129365114753651761761561":[],"14014216812552552551293651147536515050501761761561":[]}},"attrs":[],"properties":{"order":355,"id":188,"name":"synch-Cloud","prevSize":24,"code":59837},"setIdx":0,"setId":0,"iconIdx":33},{"icon":{"paths":["M819.2 243.2c0-21.208-17.19-38.4-38.4-38.4h-537.6c-21.208 0-38.4 17.192-38.4 38.4v537.6c0 21.21 17.192 38.4 38.4 38.4h537.6c21.21 0 38.4-17.19 38.4-38.4v-537.6zM896 780.8c0 63.625-51.575 115.2-115.2 115.2h-537.6c-63.623 0-115.2-51.575-115.2-115.2v-537.6c0-63.623 51.577-115.2 115.2-115.2h537.6c63.625 0 115.2 51.577 115.2 115.2v537.6z","M358.396 857.6v-691.2c0-21.208 17.193-38.4 38.4-38.4s38.4 17.192 38.4 38.4v691.2c0 21.21-17.192 38.4-38.4 38.4s-38.4-17.19-38.4-38.4z"],"attrs":[],"grid":24,"tags":["sidebar"],"isMulticolor":false,"isMulticolor2":false,"colorPermutations":{"246155111125525525512936511761761561":[],"10511915011401421681255255255129365114753651761761561":[],"14014216812552552551293651147536515050501761761561":[]}},"attrs":[],"properties":{"order":354,"id":187,"name":"sidebar","prevSize":24,"code":59836},"setIdx":0,"setId":0,"iconIdx":34},{"icon":{"paths":["M794.82 339.81v-100.876c0-5.375-4.378-9.752-9.754-9.752h-546.133c-5.375 0-9.752 4.377-9.752 9.752v100.876l0.19 1.943c0.253 1.255 0.754 2.431 1.448 3.467l1.181 1.448 205.18 205.372c9.374 11.49 8.695 28.45-2.018 39.164-10.712 10.709-27.67 11.392-39.162 2.018l-2.21-2.018-203.086-203.050c-11.291-11.231-18.149-25.999-19.695-41.6l-0.343-6.743v-100.876c0-37.692 30.575-68.267 68.267-68.267h546.133c37.692 0 68.267 30.575 68.267 68.267v100.876c0 18.094-7.177 35.444-20.002 48.267l-203.123 203.126c-11.426 11.422-29.943 11.422-41.37 0-11.426-11.426-11.426-29.948 0-41.374l203.123-203.124c1.843-1.845 2.859-4.315 2.859-6.895z","M580.275 789.909v-219.392c0-16.158 13.099-29.257 29.261-29.257 16.158 0 29.257 13.099 29.257 29.257v219.392c0 33.587-21.444 63.121-52.723 73.826l-6.366 1.869-97.562 24.38c-49.242 12.288-96.912-24.96-96.913-75.695v-243.772c0-16.158 13.099-29.257 29.257-29.257 16.157 0 29.256 13.099 29.256 29.257v243.772c0.004 12.689 11.925 21.999 24.23 18.931l97.523-24.38 3.123-1.067c6.98-3.068 11.657-10.027 11.657-17.865z"],"attrs":[],"grid":24,"tags":["Filter-no"],"isMulticolor":false,"isMulticolor2":false,"colorPermutations":{"10511915011401421681255255255129365114753651761761561":[],"14014216812552552551293651147536515050501761761561":[]}},"attrs":[],"properties":{"order":393,"id":186,"name":"Filter-no","prevSize":24,"code":59755},"setIdx":0,"setId":0,"iconIdx":35},{"icon":{"paths":["M821.333 256v-42.667c0-5.879-4.787-10.667-10.667-10.667h-597.333c-5.879 0-10.667 4.788-10.667 10.667v110.333l0.208 2.125c0.276 1.373 0.825 2.659 1.583 3.792l1.292 1.583 222.209 222.207 3.998 4.877c3.482 5.218 5.376 11.383 5.376 17.749v266.624c0 13.879 13.039 24.064 26.5 20.71l106.667-26.667 3.418-1.169c7.633-3.358 12.749-10.97 12.749-19.541v-133.291c0-17.673 14.327-32 32-32s32 14.327 32 32v133.291c0 36.74-23.454 69.043-57.668 80.751l-6.955 2.044-106.709 26.667c-53.862 13.44-106.001-27.302-106.001-82.795v-253.376l-212.75-212.706c-12.349-12.284-19.85-28.436-21.542-45.5l-0.375-7.375v-110.333c0-41.225 33.442-74.667 74.667-74.667h597.333c41.225 0 74.667 33.442 74.667 74.667v42.667c0 17.673-14.327 32-32 32s-32-14.327-32-32z","M788.045 361.373c12.497-12.497 32.755-12.497 45.252 0s12.497 32.753 0 45.25l-128 127.999c-12.497 12.497-32.755 12.497-45.252 0l-85.333-85.333-2.206-2.415c-10.253-12.57-9.51-31.118 2.206-42.834s30.268-12.462 42.833-2.208l2.419 2.208 62.707 62.708 105.374-105.375z"],"attrs":[],"isMulticolor":false,"isMulticolor2":false,"grid":24,"tags":["Filter-yes"],"colorPermutations":{"246155111125525525512936511761761561":[],"10511915011401421681255255255129365114753651761761561":[],"14014216812552552551293651147536515050501761761561":[]}},"attrs":[],"properties":{"order":350,"id":185,"name":"Filter-yes","prevSize":24,"code":59835},"setIdx":0,"setId":0,"iconIdx":36},{"icon":{"paths":["M512.004 91.563c12.215 0.001 23.364 6.956 28.736 17.926l117.815 240.572 263.441 38.804c12.019 1.771 21.999 10.195 25.762 21.747s0.661 24.239-8.009 32.751l-190.729 187.191 45.022 264.512c2.044 12.019-2.918 24.158-12.796 31.305-9.882 7.142-22.963 8.051-33.732 2.342l-235.516-124.796-235.512 124.796c-10.773 5.709-23.854 4.8-33.734-2.342-9.88-7.147-14.842-19.285-12.796-31.305l45.022-264.512-190.729-187.191c-8.671-8.512-11.774-21.199-8.012-32.751s13.743-19.977 25.763-21.748l263.401-38.804 117.859-240.576c5.376-10.97 16.525-17.923 28.74-17.922zM511.996 196.308l-96.527 197.034c-4.638 9.468-13.643 16.043-24.073 17.58l-216.351 31.872 156.705 153.801c7.479 7.343 10.89 17.877 9.132 28.207l-36.922 216.926 193.062-102.302c9.37-4.966 20.591-4.966 29.965 0l193.058 102.302-36.919-216.926c-1.762-10.33 1.651-20.864 9.131-28.207l156.702-153.801-216.393-31.872c-10.432-1.536-19.435-8.114-24.073-17.584l-96.495-197.030z"],"attrs":[],"grid":24,"tags":["Star-empty"],"isMulticolor":false,"isMulticolor2":false,"colorPermutations":{"246155111125525525512936511761761561":[],"10511915011401421681255255255129365114753651761761561":[],"14014216812552552551293651147536515050501761761561":[]}},"attrs":[],"properties":{"order":343,"id":183,"name":"Star-empty","prevSize":24,"code":59833},"setIdx":0,"setId":0,"iconIdx":37},{"icon":{"paths":["M512 123.563l125.227 255.701 280.107 41.259-202.667 198.912 47.829 281.003-250.496-132.736-250.495 132.736 47.829-281.003-202.667-198.912 280.064-41.259 125.268-255.701z","M512.004 91.563c12.215 0.001 23.364 6.956 28.736 17.926l117.815 240.572 263.441 38.804c12.019 1.771 21.999 10.195 25.762 21.747s0.661 24.239-8.009 32.751l-190.729 187.191 45.022 264.512c2.044 12.019-2.918 24.158-12.796 31.305-9.882 7.142-22.963 8.051-33.732 2.342l-235.516-124.796-235.512 124.796c-10.773 5.709-23.854 4.8-33.734-2.342-9.88-7.147-14.842-19.285-12.796-31.305l45.022-264.512-190.729-187.191c-8.671-8.512-11.774-21.199-8.012-32.751s13.743-19.977 25.763-21.748l263.401-38.804 117.859-240.576c5.376-10.97 16.525-17.923 28.74-17.922zM511.996 196.308l-96.527 197.034c-4.638 9.468-13.643 16.043-24.073 17.58l-216.351 31.872 156.705 153.801c7.479 7.343 10.89 17.877 9.132 28.207l-36.922 216.926 193.062-102.302c9.37-4.966 20.591-4.966 29.965 0l193.058 102.302-36.919-216.926c-1.762-10.33 1.651-20.864 9.131-28.207l156.702-153.801-216.393-31.872c-10.432-1.536-19.435-8.114-24.073-17.584l-96.495-197.030z"],"attrs":[],"isMulticolor":false,"isMulticolor2":false,"grid":24,"tags":["Star-Full"],"colorPermutations":{"246155111125525525512936511761761561":[],"10511915011401421681255255255129365114753651761761561":[],"14014216812552552551293651147536515050501761761561":[]}},"attrs":[],"properties":{"order":344,"id":182,"name":"Star-Full","prevSize":24,"code":59834},"setIdx":0,"setId":0,"iconIdx":38},{"icon":{"paths":[],"attrs":[],"isMulticolor":false,"isMulticolor2":false,"grid":24,"tags":["Empty"],"colorPermutations":{"246155111125525525512936511761761561":[],"2323037125525525512936511761761561":[],"10511915011401421681255255255129365114753651761761561":[],"14014216812552552551293651147536515050501761761561":[]}},"attrs":[],"properties":{"order":338,"id":181,"name":"Empty","prevSize":24,"code":59832},"setIdx":0,"setId":0,"iconIdx":39},{"icon":{"paths":["M213.337 352c-29.473 0-53.333 23.86-53.333 53.333v384c0 29.474 23.86 53.333 53.333 53.333h597.334c29.474 0 53.333-23.859 53.333-53.333v-384c0-29.474-23.859-53.333-53.333-53.333h-597.334zM96.003 405.333c0-64.82 52.514-117.333 117.333-117.333h597.334c64.819 0 117.333 52.514 117.333 117.333v384c0 64.819-52.514 117.333-117.333 117.333h-597.334c-64.82 0-117.333-52.514-117.333-117.333v-384z","M301.913 234.667c0-64.82 52.514-117.333 117.333-117.333h185.516c64.819 0 117.333 52.514 117.333 117.333v85.333c0 17.673-14.327 32-32 32s-32-14.327-32-32v-85.333c0-29.474-23.859-53.333-53.333-53.333h-185.516c-29.473 0-53.333 23.86-53.333 53.333v85.333c0 17.673-14.327 32-32 32s-32-14.327-32-32v-85.333z","M101.295 387.708c9.734-14.751 29.583-18.818 44.334-9.084l270.976 178.816c8.715 5.756 18.932 8.832 29.394 8.832h132.011c10.458 0 20.668-3.068 29.38-8.823l270.989-178.824c14.75-9.734 34.598-5.667 44.335 9.084 9.732 14.751 5.666 34.6-9.084 44.335l-270.963 178.807c-19.191 12.676-41.668 19.422-64.657 19.422h-132.011c-22.988 0-45.458-6.746-64.644-19.413l-270.976-178.816c-14.751-9.734-18.818-29.583-9.084-44.335z"],"attrs":[],"isMulticolor":false,"isMulticolor2":false,"grid":24,"tags":["portfolio-studio"],"colorPermutations":{"246155111125525525512936511761761561":[],"2323037125525525512936511761761561":[],"10511915011401421681255255255129365114753651761761561":[],"14014216812552552551293651147536515050501761761561":[]}},"attrs":[],"properties":{"order":336,"id":180,"name":"portfolio-studio","prevSize":24,"code":59831},"setIdx":0,"setId":0,"iconIdx":40},{"icon":{"paths":["M585.472 768.111c0-17.673 14.327-32 32-32h278.686c17.673 0 32 14.327 32 32s-14.327 32-32 32h-278.686c-17.673 0-32-14.327-32-32z","M585.472 640.055c0-17.673 14.327-32 32-32h278.686c17.673 0 32 14.327 32 32s-14.327 32-32 32h-278.686c-17.673 0-32-14.327-32-32z","M585.472 896.162c0-17.673 14.327-32 32-32h185.805c17.673 0 32 14.327 32 32s-14.327 32-32 32h-185.805c-17.673 0-32-14.327-32-32z","M474.679 167.492l-0.017 0.041-86.085 173.446c-4.677 9.423-13.687 15.946-24.099 17.446l-193.035 27.821c-5.058 0.692-9.277 4.21-10.864 9.063-1.587 4.851-0.265 10.182 3.404 13.728l139.749 134.967c7.632 7.373 11.115 18.048 9.297 28.501l-33.098 190.315c-0.818 5.099 1.307 10.227 5.5 13.252 4.214 3.038 9.787 3.43 14.383 1.003l0.157-0.085 147.517-76.83c15.676-8.162 34.999-2.074 43.166 13.598 8.162 15.676 2.074 34.999-13.602 43.166l-147.44 76.791c-26.092 13.734-57.713 11.511-81.629-5.743-23.94-17.276-36.018-46.626-31.169-75.746l0.038-0.226 30.217-173.743-127.546-123.183c-21.299-20.578-28.98-51.514-19.773-79.662 9.193-28.105 33.607-48.504 62.891-52.559l176.078-25.377 78.722-158.614c13.211-26.368 40.18-43.019 69.672-43.019 29.495 0 56.461 16.651 69.675 43.019l0.043 0.092 78.793 158.516 176.098 25.341c29.261 4.071 53.649 24.458 62.839 52.54 9.203 28.119 1.557 59.024-19.699 79.607l-78.767 76.164c-12.706 12.284-32.964 11.947-45.252-0.759-12.284-12.706-11.942-32.964 0.764-45.248l78.733-76.134c3.657-3.548 4.983-8.881 3.396-13.723-1.583-4.847-5.798-8.364-10.85-9.060l-0.196-0.027-192.806-27.746c-10.406-1.498-19.418-8.014-24.098-17.431l-86.217-173.463c-2.368-4.692-7.194-7.689-12.454-7.689-5.257 0-10.061 2.959-12.433 7.648z"],"attrs":[],"isMulticolor":false,"isMulticolor2":false,"grid":24,"tags":["star-favorite-menu"],"colorPermutations":{"246155111125525525512936511761761561":[],"2323037125525525512936511761761561":[],"10511915011401421681255255255129365114753651761761561":[],"14014216812552552551293651147536515050501761761561":[]}},"attrs":[],"properties":{"order":325,"id":179,"name":"star-favorite-menu","prevSize":24,"code":59824},"setIdx":0,"setId":0,"iconIdx":41},{"icon":{"paths":["M213.333 489.382c0-17.673 14.327-32 32-32h182.49c17.673 0 32 14.327 32 32s-14.327 32-32 32h-150.49v302.758h150.49c17.673 0 32 14.327 32 32s-14.327 32-32 32h-182.49c-17.673 0-32-14.327-32-32v-366.758z","M395.826 202.662c0-17.673 14.327-32 32.001-32h180.173c17.673 0 32 14.327 32 32v653.479c0 17.673 44.902 32 27.23 32h-239.407c-17.673 0-31.997-14.327-31.997-32v-653.479zM459.827 234.662v589.479h116.173v-589.479h-116.173z","M635.264 393.809c0-17.673-17.673-32 0-32h164.736c17.673 0 32 14.327 32 32v462.332c0 17.673-14.327 32-32 32h-132.77c-17.673 0-31.966-14.327-31.966-32s-34.27-32-16.597-32h149.333v-398.332h-128c-17.673 0-4.736-14.327-4.736-32z"],"attrs":[],"isMulticolor":false,"isMulticolor2":false,"grid":24,"tags":["toolchart-cart"],"colorPermutations":{"246155111125525525512936511761761561":[],"2323037125525525512936511761761561":[],"10511915011401421681255255255129365114753651761761561":[],"14014216812552552551293651147536515050501761761561":[]}},"attrs":[],"properties":{"order":326,"id":178,"name":"toolchart-cart","prevSize":24,"code":59825},"setIdx":0,"setId":0,"iconIdx":42},{"icon":{"paths":["M128 330.738c0-17.673 14.327-32 32-32h682.953c17.673 0 32 14.327 32 32s-14.327 32-32 32h-682.953c-17.673 0-32-14.327-32-32z","M128 160c0-17.673 14.327-32 32-32h682.953c17.673 0 32 14.327 32 32s-14.327 32-32 32h-682.953c-17.673 0-32-14.327-32-32z","M128 501.474c0-17.673 14.327-32 32-32h682.953c17.673 0 32 14.327 32 32s-14.327 32-32 32h-682.953c-17.673 0-32-14.327-32-32z","M128 672c0-17.673 14.327-32 32-32h682.953c17.673 0 32 14.327 32 32s-14.327 32-32 32h-682.953c-17.673 0-32-14.327-32-32z","M128 832c0-17.673 14.327-32 32-32h682.953c17.673 0 32 14.327 32 32s-14.327 32-32 32h-682.953c-17.673 0-32-14.327-32-32z"],"attrs":[],"isMulticolor":false,"isMulticolor2":false,"grid":24,"tags":["toolchart-table"],"colorPermutations":{"246155111125525525512936511761761561":[],"2323037125525525512936511761761561":[],"10511915011401421681255255255129365114753651761761561":[],"14014216812552552551293651147536515050501761761561":[]}},"attrs":[],"properties":{"order":327,"id":177,"name":"toolchart-table","prevSize":24,"code":59826},"setIdx":0,"setId":0,"iconIdx":43},{"icon":{"paths":["M85.333 725.333c0-17.673 14.327-32 32-32h768c17.673 0 32 14.327 32 32s-14.327 32-32 32h-768c-17.673 0-32-14.327-32-32z","M85.333 874.667c0-17.673 14.327-32 32-32h768c17.673 0 32 14.327 32 32s-14.327 32-32 32h-768c-17.673 0-32-14.327-32-32z","M170.667 361.387c0-17.673 14.327-32 32-32h182.49c17.673 0 32 14.327 32 32s-14.327 32-32 32h-150.49v131.23h150.49c17.673 0 32 14.327 32 32s-14.327 32-32 32h-182.49c-17.673 0-32-14.327-32-32v-195.23z","M353.16 74.667c0-17.673 14.327-32 32-32h180.174c17.673 0 32 14.327 32 32v481.95c0 17.673 44.902 32 27.23 32h-239.407c-17.673 0-31.997-14.327-31.997-32v-481.95zM417.16 106.667v417.95h116.174v-417.95h-116.174z","M592.597 265.813c0-17.673-17.673-32 0-32h164.736c17.673 0 32 14.327 32 32v290.803c0 17.673-14.327 32-32 32h-132.77c-17.673 0-31.966-14.327-31.966-32s-34.27-32-16.597-32h149.333v-226.803h-128c-17.673 0-4.736-14.327-4.736-32z"],"attrs":[],"isMulticolor":false,"isMulticolor2":false,"grid":24,"tags":["toolchart-table+graph"],"colorPermutations":{"246155111125525525512936511761761561":[],"2323037125525525512936511761761561":[],"10511915011401421681255255255129365114753651761761561":[],"14014216812552552551293651147536515050501761761561":[]}},"attrs":[],"properties":{"order":328,"id":176,"name":"toolchart-tablegraph","prevSize":24,"code":59827},"setIdx":0,"setId":0,"iconIdx":44},{"icon":{"paths":["M654.276 138.521c27.307 0.048 51.9 16.517 62.345 41.746 10.441 25.229 4.681 54.263-14.605 73.594l-142.281 142.323c-26.385 26.32-69.094 26.32-95.479 0l-142.256-142.298c-19.284-19.331-25.068-48.39-14.626-73.618s35.037-41.698 62.342-41.746h284.56zM656.713 208.654c1.024-1.029 1.327-2.571 0.772-3.911-0.555-1.339-1.856-2.214-3.307-2.223h-284.364c-1.449 0.008-2.752 0.884-3.306 2.223-0.555 1.341-0.25 2.883 0.772 3.912l142.173 142.217c1.404 1.39 3.674 1.399 5.077 0.009l142.182-142.227z","M138.521 511.996c0-17.673 14.327-32 32-32h682.949c17.677 0 32 14.327 32 32s-14.323 32-32 32h-682.949c-17.673 0-32-14.327-32-32z","M509.453 673.118l-142.167 142.212c-1.022 1.033-1.332 2.577-0.777 3.921 0.555 1.34 1.858 2.214 3.307 2.219h284.363c1.446-0.004 2.752-0.879 3.307-2.219s0.252-2.884-0.772-3.913l-142.174-142.221c-1.404-1.391-3.682-1.391-5.086 0zM464.256 627.81c26.385-26.321 69.094-26.321 95.479 0l0.034 0.030 142.225 142.268c19.281 19.332 25.067 48.388 14.626 73.617-10.445 25.229-35.038 41.698-62.345 41.745h-284.56c-27.305-0.047-51.899-16.516-62.342-41.745s-4.682-54.263 14.601-73.591l142.281-142.323z"],"attrs":[],"isMulticolor":false,"isMulticolor2":false,"grid":24,"tags":["treshold"],"colorPermutations":{"246155111125525525512936511761761561":[],"2323037125525525512936511761761561":[],"10511915011401421681255255255129365114753651761761561":[],"14014216812552552551293651147536515050501761761561":[]}},"attrs":[],"properties":{"order":329,"id":175,"name":"treshold","prevSize":24,"code":59828},"setIdx":0,"setId":0,"iconIdx":45},{"icon":{"paths":["M501.376 170.667c17.673 0 32 14.327 32 32v597.333c0 17.673-14.327 32-32 32s-32-14.327-32-32v-597.333c0-17.673 14.327-32 32-32z","M265.375 564.036c12.498-12.493 32.759-12.493 45.255 0.004l190.708 190.746 190.746-190.746c12.497-12.497 32.755-12.497 45.252 0s12.497 32.755 0 45.252l-213.376 213.376c-5.999 6.003-14.14 9.374-22.626 9.374-8.491 0-16.627-3.371-22.63-9.374l-213.332-213.376c-12.496-12.497-12.494-32.759 0.004-45.257z"],"attrs":[],"grid":24,"tags":["sort-decending"],"isMulticolor":false,"isMulticolor2":false,"colorPermutations":{"10511915011401421681255255255129365114753651761761561":[],"14014216812552552551293651147536515050501761761561":[]}},"attrs":[],"properties":{"order":335,"id":174,"name":"sort-decending","prevSize":24,"code":59829},"setIdx":0,"setId":0,"iconIdx":46},{"icon":{"paths":["M501.376 832.043c17.673 0 32-14.327 32-32v-597.334c0-17.673-14.327-32-32-32s-32 14.327-32 32v597.334c0 17.673 14.327 32 32 32z","M265.375 438.673c12.498 12.493 32.759 12.493 45.255-0.004l190.708-190.746 190.746 190.746c12.497 12.497 32.755 12.497 45.252 0s12.497-32.758 0-45.254l-213.376-213.376c-5.999-6.001-14.14-9.373-22.626-9.373-8.491 0-16.627 3.372-22.63 9.375l-213.332 213.376c-12.496 12.498-12.494 32.759 0.004 45.257z"],"attrs":[],"grid":24,"tags":["sort-ascending"],"isMulticolor":false,"isMulticolor2":false,"colorPermutations":{"10511915011401421681255255255129365114753651761761561":[],"14014216812552552551293651147536515050501761761561":[]}},"attrs":[],"properties":{"order":333,"id":173,"name":"sort-ascending","prevSize":24,"code":59830},"setIdx":0,"setId":0,"iconIdx":47},{"icon":{"paths":["M501.491 149.333c-194.49 0-352.158 157.667-352.158 352.158 0 194.496 157.667 352.162 352.158 352.162 194.496 0 352.162-157.666 352.162-352.162 0-194.49-157.666-352.158-352.162-352.158zM85.333 501.491c0-229.837 186.321-416.158 416.158-416.158 229.841 0 416.162 186.321 416.162 416.158 0 229.841-186.321 416.162-416.162 416.162-229.837 0-416.158-186.321-416.158-416.162z","M501.491 320.071c-100.195 0-181.42 81.225-181.42 181.42 0 100.198 81.225 181.423 181.42 181.423 100.198 0 181.423-81.225 181.423-181.423 0-100.195-81.225-181.42-181.423-181.42zM256.071 501.491c0-135.541 109.879-245.42 245.42-245.42 135.543 0 245.423 109.879 245.423 245.42 0 135.543-109.879 245.423-245.423 245.423-135.541 0-245.42-109.879-245.42-245.423z","M501.491 469.491c17.677 0 32 14.327 32 32v384.162c0 17.673-14.323 32-32 32-17.673 0-32-14.327-32-32v-384.162c0-17.673 14.327-32 32-32z","M531.567 490.556c6.037 16.61-2.53 34.97-19.136 41.011l-360.696 131.162c-16.609 6.037-34.97-2.53-41.009-19.14-6.039-16.606 2.529-34.97 19.138-41.007l360.693-131.162c16.61-6.037 34.97 2.53 41.011 19.136z","M227.693 188.58c13.3-11.638 33.517-10.29 45.155 3.010l252.728 288.832c11.635 13.299 10.291 33.515-3.012 45.154-13.299 11.635-33.515 10.291-45.154-3.012l-252.727-288.83c-11.638-13.3-10.29-33.517 3.010-45.155z","M471.42 490.556c6.042-16.606 24.401-25.173 41.011-19.136l360.691 131.162c16.61 6.037 25.178 24.401 19.14 41.007-6.042 16.61-24.401 25.178-41.011 19.14l-360.695-131.162c-16.606-6.042-25.173-24.401-19.136-41.011z","M775.292 188.58c13.303 11.638 14.652 31.854 3.012 45.155l-252.727 288.83c-11.639 13.303-31.855 14.647-45.154 3.012-13.303-11.639-14.647-31.855-3.012-45.154l252.727-288.832c11.639-13.3 31.855-14.648 45.154-3.010z"],"attrs":[],"isMulticolor":false,"isMulticolor2":false,"grid":24,"tags":["under-over-chart"],"colorPermutations":{"246155111125525525512936511761761561":[],"2323037125525525512936511761761561":[],"10511915011401421681255255255129365114753651761761561":[],"14014216812552552551293651147536515050501761761561":[]}},"attrs":[],"properties":{"order":320,"id":172,"name":"under-over-chart","prevSize":24,"code":59818},"setIdx":0,"setId":0,"iconIdx":48},{"icon":{"paths":["M107.051 128c0 17.673 14.327 32 32 32h739.584c17.673 0 32-14.327 32-32s-14.327-32-32-32h-739.584c-17.673 0-32 14.327-32 32z","M96 749.824c0 63.070 51.106 114.176 114.176 114.176h586.283c63.070 0 114.176-51.106 114.176-114.176v-205.397c0-63.070-51.106-114.176-114.176-114.176h-586.283c-63.060 0-114.176 51.093-114.176 114.133v205.44zM210.176 800c-27.724 0-50.176-22.451-50.176-50.176v-205.44c0-27.669 22.441-50.133 50.176-50.133h586.283c27.721 0 50.176 22.451 50.176 50.176v205.397c0 27.725-22.455 50.176-50.176 50.176h-586.283z","M107.051 298.667c0 17.673 14.327 32 32 32h739.584c17.673 0 32-14.327 32-32s-14.327-32-32-32h-739.584c-17.673 0-32 14.327-32 32z"],"attrs":[],"isMulticolor":false,"isMulticolor2":false,"grid":24,"tags":["paragraph-bottom"],"colorPermutations":{"246155111125525525512936511761761561":[],"2323037125525525512936511761761561":[],"10511915011401421681255255255129365114753651761761561":[],"14014216812552552551293651147536515050501761761561":[]}},"attrs":[],"properties":{"order":321,"id":171,"name":"paragraph-bottom","prevSize":24,"code":59819},"setIdx":0,"setId":0,"iconIdx":49},{"icon":{"paths":["M107.051 832c0-17.673 14.327-32 32-32h739.584c17.673 0 32 14.327 32 32s-14.327 32-32 32h-739.584c-17.673 0-32-14.327-32-32z","M96 210.176c0-63.070 51.106-114.176 114.176-114.176h586.283c63.070 0 114.176 51.106 114.176 114.176v205.397c0 63.070-51.106 114.176-114.176 114.176h-586.283c-63.060 0-114.176-51.093-114.176-114.133v-205.44zM210.176 160c-27.724 0-50.176 22.452-50.176 50.176v205.44c0 27.669 22.441 50.133 50.176 50.133h586.283c27.721 0 50.176-22.451 50.176-50.176v-205.397c0-27.724-22.455-50.176-50.176-50.176h-586.283z","M107.051 661.333c0-17.673 14.327-32 32-32h739.584c17.673 0 32 14.327 32 32s-14.327 32-32 32h-739.584c-17.673 0-32-14.327-32-32z"],"attrs":[],"isMulticolor":false,"isMulticolor2":false,"grid":24,"tags":["paragraph-top"],"colorPermutations":{"246155111125525525512936511761761561":[],"2323037125525525512936511761761561":[],"10511915011401421681255255255129365114753651761761561":[],"14014216812552552551293651147536515050501761761561":[]}},"attrs":[],"properties":{"order":322,"id":170,"name":"paragraph-top","prevSize":24,"code":59820},"setIdx":0,"setId":0,"iconIdx":50},{"icon":{"paths":["M128 858.667c0-17.673 14.327-32 32-32h739.584c17.673 0 32 14.327 32 32s-14.327 32-32 32h-739.584c-17.673 0-32-14.327-32-32z","M128 627.541c0-17.673 14.327-32 32-32h231.125c17.673 0 32 14.327 32 32s-14.327 32-32 32h-231.125c-17.673 0-32-14.327-32-32z","M128 396.459c0-17.673 14.327-32 32-32h231.125c17.673 0 32 14.327 32 32s-14.327 32-32 32h-231.125c-17.673 0-32-14.327-32-32z","M497.792 409.301c0-63.070 51.106-114.176 114.176-114.176h205.44c63.070 0 114.176 51.106 114.176 114.176v205.397c0 63.070-51.106 114.176-114.176 114.176h-205.44c-63.061 0-114.176-51.093-114.176-114.133v-205.44zM611.968 664.875h205.44c27.725 0 50.176-22.451 50.176-50.176v-205.397c0-27.724-22.451-50.176-50.176-50.176h-205.44c-27.725 0-50.176 22.452-50.176 50.176v205.44c0 27.669 22.443 50.133 50.176 50.133z","M128 149.333c0-17.673 14.327-32 32-32h739.584c17.673 0 32 14.327 32 32s-14.327 32-32 32h-739.584c-17.673 0-32-14.327-32-32z"],"attrs":[],"isMulticolor":false,"isMulticolor2":false,"grid":24,"tags":["paragraph-dx"],"colorPermutations":{"246155111125525525512936511761761561":[],"2323037125525525512936511761761561":[],"10511915011401421681255255255129365114753651761761561":[],"14014216812552552551293651147536515050501761761561":[]}},"attrs":[],"properties":{"order":323,"id":169,"name":"paragraph-dx","prevSize":24,"code":59821},"setIdx":0,"setId":0,"iconIdx":51},{"icon":{"paths":["M110.208 165.333c0-17.673 14.327-32 32-32h739.541c17.673 0 32 14.327 32 32s-14.327 32-32 32h-739.541c-17.673 0-32-14.327-32-32z","M618.667 396.459c0-17.673 14.327-32 32-32h231.125c17.673 0 32 14.327 32 32s-14.327 32-32 32h-231.125c-17.673 0-32-14.327-32-32z","M618.667 627.541c0-17.673 14.327-32 32-32h231.125c17.673 0 32 14.327 32 32s-14.327 32-32 32h-231.125c-17.673 0-32-14.327-32-32z","M110.208 409.301c0-63.070 51.105-114.176 114.176-114.176h205.44c63.070 0 114.176 51.106 114.176 114.176v205.44c0 63.070-51.106 114.176-114.176 114.176h-205.44c-63.071 0-114.176-51.106-114.176-114.176v-205.44zM224.384 359.125c-27.724 0-50.176 22.452-50.176 50.176v205.44c0 27.725 22.452 50.176 50.176 50.176h205.44c27.725 0 50.176-22.451 50.176-50.176v-205.44c0-27.724-22.451-50.176-50.176-50.176h-205.44z","M110.208 858.667c0-17.673 14.327-32 32-32h739.541c17.673 0 32 14.327 32 32s-14.327 32-32 32h-739.541c-17.673 0-32-14.327-32-32z"],"attrs":[],"isMulticolor":false,"isMulticolor2":false,"grid":24,"tags":["paragraph-sx"],"colorPermutations":{"246155111125525525512936511761761561":[],"2323037125525525512936511761761561":[],"10511915011401421681255255255129365114753651761761561":[],"14014216812552552551293651147536515050501761761561":[]}},"attrs":[],"properties":{"order":324,"id":168,"name":"paragraph-sx","prevSize":24,"code":59822},"setIdx":0,"setId":0,"iconIdx":52},{"icon":{"paths":["M626.645 581.333c-22.080 0-39.979 17.916-39.979 39.979v0.474c0.094 21.922 17.894 39.599 39.842 39.505h0.137c22.093 0 39.979-17.886 39.979-39.979s-17.886-39.979-39.979-39.979zM522.667 621.312c0-57.382 46.528-103.979 103.979-103.979 57.438 0 103.979 46.541 103.979 103.979 0 57.417-46.507 103.945-103.915 103.979-57.28 0.209-103.859-46.012-104.043-103.322v-0.657zM626.709 725.291h-0.064v-32l0.137 32h-0.073z","M414.914 409.581c12.495-12.497 32.757-12.497 45.254 0l138.24 138.242c12.497 12.493 12.497 32.755 0 45.252s-32.759 12.497-45.252 0l-138.242-138.24c-12.497-12.497-12.497-32.757 0-45.254z","M838.165 409.546c12.518 12.477 12.548 32.737 0.073 45.255l-137.813 138.24c-12.48 12.514-32.742 12.548-45.257 0.068-12.514-12.476-12.548-32.738-0.068-45.252l137.813-138.241c12.476-12.516 32.738-12.547 45.252-0.070z","M426.667 380.818c-0.094-21.923-17.896-39.579-39.841-39.484l-0.138 0c-22.135 0-40.021 17.886-40.021 40.021 0 22.067 17.904 39.979 40.021 39.979 22.080 0 39.979-17.917 39.979-39.979v-0.538zM386.618 277.334c57.286-0.21 103.865 46.011 104.048 103.32v0.665c0 57.383-46.528 104.014-103.979 104.014-57.414 0-104.021-46.515-104.021-103.978 0-57.458 46.503-103.984 103.952-104.021zM386.618 277.334h0.070v32l-0.138-32h0.068z","M358.166 409.546c12.516 12.477 12.547 32.737 0.070 45.255l-137.813 138.24c-12.477 12.514-32.739 12.548-45.255 0.068-12.516-12.476-12.547-32.738-0.070-45.252l137.813-138.241c12.477-12.516 32.739-12.547 45.255-0.070z","M906.624 380.903c0 0.449 0.013 0.898 0.034 1.346-0.478 21.649-18.189 39.084-39.97 39.084-22.118 0-40.021-17.911-40.021-39.979 0-22.092 17.886-39.979 39.979-39.979h0.137c21.961-0.095 39.77 17.585 39.842 39.527zM970.607 379.231c-0.964-56.63-47.236-102.063-104.030-101.856h0.068v32l-0.137-32 0.068-0c-57.408 0.038-103.91 46.563-103.91 103.979 0 57.464 46.609 103.979 104.021 103.979 57.451 0 103.979-46.596 103.979-103.979l-0.004-0.591c-0.004-0.325-0.017-0.867-0.055-1.533z","M106.676 620.416c0.020 0.448 0.031 0.9 0.033 1.348 0.071 21.943 17.882 39.62 39.841 39.526h0.138c22.092 0 39.979-17.886 39.979-39.979 0-22.067-17.904-39.979-40.021-39.979-21.78 0-39.493 17.434-39.969 39.083zM42.667 621.312c0-57.382 46.528-103.979 103.979-103.979 57.414 0 104.021 46.515 104.021 103.979 0 57.417-46.505 103.945-103.913 103.979-56.794 0.205-103.063-45.227-104.030-101.854-0.038-0.666-0.049-1.207-0.054-1.532l-0.004-0.593zM146.754 725.291h-0.066v-32l0.138 32h-0.072z","M506.667 149.333c-194.423 0-352 157.577-352 352 0 15.509 1.407 31.027 3.522 47.057 2.313 17.519-10.016 33.6-27.538 35.913-17.521 2.308-33.599-10.018-35.912-27.541-2.322-17.591-4.073-36.122-4.073-55.428 0-229.769 186.231-416 416-416 156.075 0 291.857 86.099 362.978 213.054 8.64 15.418 3.14 34.92-12.275 43.557-15.42 8.637-34.923 3.141-43.558-12.278-60.292-107.627-175.219-180.333-307.145-180.333z","M882.679 418.369c17.523-2.313 33.6 10.017 35.913 27.536 2.321 17.596 4.075 36.122 4.075 55.433 0 229.769-186.231 416-416 416-156.077 0-291.86-86.101-362.98-213.056-8.637-15.415-3.14-34.918 12.278-43.554 15.418-8.64 34.92-3.145 43.558 12.275 60.293 107.627 175.219 180.335 307.145 180.335 194.423 0 352-157.577 352-352 0-15.509-1.408-31.031-3.524-47.057-2.313-17.519 10.018-33.599 27.537-35.912z"],"attrs":[],"isMulticolor":false,"isMulticolor2":false,"grid":24,"tags":["Historic-graph"],"colorPermutations":{"246155111125525525512936511761761561":[],"2323037125525525512936511761761561":[],"10511915011401421681255255255129365114753651761761561":[],"14014216812552552551293651147536515050501761761561":[]}},"attrs":[],"properties":{"order":319,"id":167,"name":"Historic-graph","prevSize":24,"code":59823},"setIdx":0,"setId":0,"iconIdx":53},{"icon":{"paths":["M480 128c0-17.673 14.327-32 32-32 230.238 0 416 185.762 416 416s-185.762 416-416 416c-17.673 0-32-14.327-32-32s14.327-32 32-32c194.893 0 352-157.107 352-352s-157.107-352-352-352c-17.673 0-32-14.327-32-32z","M512 160c-194.892 0-352 157.108-352 352s157.108 352 352 352c17.673 0 32 14.327 32 32s-14.327 32-32 32c-230.238 0-416-185.762-416-416s185.762-416 416-416c17.673 0 32 14.327 32 32s-14.327 32-32 32z","M406.383 156.784c48.529-81.044 162.714-81.014 211.273-0.009 129.37 215.988 129.374 494.49 0.009 710.481zM617.664 867.255c-48.521 81.033-162.765 81.041-211.281 0.004-129.37-215.987-129.367-494.487 0-710.476zM562.756 189.67c-23.723-39.561-77.803-39.528-101.466-0.005-117.244 195.743-117.247 448.966-0.004 644.707 23.671 39.539 77.794 39.543 101.466 0.004 117.244-195.738 117.239-448.965 0.004-644.707z","M96 512c0-17.673 14.327-32 32-32h768c17.673 0 32 14.327 32 32s-14.327 32-32 32h-768c-17.673 0-32-14.327-32-32z"],"attrs":[],"isMulticolor":false,"isMulticolor2":false,"grid":24,"tags":["Language"],"colorPermutations":{"246155111125525525512936511761761561":[],"2323037125525525512936511761761561":[],"10511915011401421681255255255129365114753651761761561":[],"14014216812552552551293651147536515050501761761561":[]}},"attrs":[],"properties":{"order":316,"id":166,"name":"Language","prevSize":24,"code":59809},"setIdx":0,"setId":0,"iconIdx":54},{"icon":{"paths":["M224 640c0-17.673 14.327-32 32-32h128c17.673 0 32 14.327 32 32s-14.327 32-32 32h-128c-17.673 0-32-14.327-32-32z","M224 469.333c0-17.673 14.327-32 32-32h213.333c17.673 0 32 14.327 32 32s-14.327 32-32 32h-213.333c-17.673 0-32-14.327-32-32z","M224 298.667c0-17.673 14.327-32 32-32h426.667c17.673 0 32 14.327 32 32s-14.327 32-32 32h-426.667c-17.673 0-32-14.327-32-32z","M218.667 160c-32.418 0-58.667 26.249-58.667 58.667v544c0 32.418 26.249 58.667 58.667 58.667h250.667c17.673 0 32 14.327 32 32s-14.327 32-32 32h-250.667c-67.764 0-122.667-54.903-122.667-122.667v-544c0-67.764 54.903-122.667 122.667-122.667h544c67.763 0 122.667 54.903 122.667 122.667v250.667c0 17.673-14.327 32-32 32s-32-14.327-32-32v-250.667c0-32.418-26.249-58.667-58.667-58.667h-544z","M736 512c17.673 0 32 14.327 32 32 0 88.354 71.646 160 160 160 17.673 0 32 14.327 32 32s-14.327 32-32 32c-123.699 0-224-100.301-224-224 0-17.673 14.327-32 32-32z","M704 928c0-123.699 100.301-224 224-224 17.673 0 32 14.327 32 32s-14.327 32-32 32c-88.354 0-160 71.646-160 160 0 17.673-14.327 32-32 32s-32-14.327-32-32z","M512 736c0-17.673 14.327-32 32-32 123.699 0 224 100.301 224 224 0 17.673-14.327 32-32 32s-32-14.327-32-32c0-88.354-71.646-160-160-160-17.673 0-32-14.327-32-32z","M736 512c17.673 0 32 14.327 32 32 0 123.699-100.301 224-224 224-17.673 0-32-14.327-32-32s14.327-32 32-32c88.354 0 160-71.646 160-160 0-17.673 14.327-32 32-32z"],"attrs":[],"isMulticolor":false,"isMulticolor2":false,"grid":24,"tags":["Storyfolio"],"colorPermutations":{"246155111125525525512936511761761561":[],"2323037125525525512936511761761561":[],"10511915011401421681255255255129365114753651761761561":[],"14014216812552552551293651147536515050501761761561":[]}},"attrs":[],"properties":{"order":317,"id":165,"name":"Storyfolio","prevSize":24,"code":59817},"setIdx":0,"setId":0,"iconIdx":55},{"icon":{"paths":["M106.741 364.481c12.824-4.498 27.091-0.406 35.58 10.206l113.679 142.1v-122.11c0-17.673 14.327-32 32-32s32 14.327 32 32v213.331c0 13.594-8.584 25.698-21.408 30.199-12.824 4.497-27.091 0.405-35.58-10.206l-113.679-142.101v122.108c0 17.677-14.327 32-32 32s-32-14.323-32-32v-213.331c0-13.59 8.584-25.698 21.408-30.196z","M384 501.342c0-17.673 14.327-32 32-32h128c17.673 0 32 14.327 32 32 0 17.677-14.327 32-32 32h-128c-17.673 0-32-14.323-32-32z","M384 394.848c0-17.673 14.327-32 32-32h149.333c17.673 0 32 14.327 32 32s-14.327 31.998-32 31.998h-117.333v149.163h117.333c17.673 0 32 14.327 32 32 0 17.677-14.327 32-32 32h-149.333c-17.673 0-32-14.323-32-32v-213.161z","M668.817 362.836c17.583-1.758 33.267 11.072 35.025 28.657l12.983 129.838 34.347-57.69c5.769-9.694 16.213-15.633 27.494-15.633s21.726 5.939 27.494 15.633l34.347 57.69 12.983-129.838c1.758-17.585 17.442-30.415 35.025-28.657 17.587 1.759 30.417 17.44 28.659 35.025l-21.333 213.334c-1.638 16.358-15.403 28.813-31.842 28.813h-9.131c-11.281 0-21.726-5.935-27.494-15.629l-48.708-81.813-48.708 81.813c-5.769 9.694-16.213 15.629-27.494 15.629h-9.131c-16.439 0-30.204-12.454-31.842-28.813l-21.333-213.334c-1.758-17.585 11.072-33.267 28.659-35.025z","M207.175 207.186c162.47-162.47 425.844-162.47 588.315 0 12.975 12.972 24.303 26.528 34.654 39.981 10.773 14.008 8.154 34.099-5.854 44.875s-34.099 8.155-44.877-5.853c-9.276-12.061-18.769-23.338-29.175-33.747-137.476-137.477-360.331-137.477-497.808 0-10.388 10.388-19.838 21.658-29.219 33.801-10.805 13.985-30.901 16.564-44.887 5.759s-16.564-30.901-5.759-44.887c10.331-13.372 21.617-26.934 34.61-39.927z","M178.377 710.647c14.008-10.778 34.099-8.154 44.875 5.854 9.278 12.062 18.769 23.334 29.178 33.745 137.477 137.476 360.332 137.476 497.808 0 10.385-10.385 19.836-21.658 29.218-33.801 10.803-13.986 30.899-16.563 44.885-5.76 13.986 10.807 16.563 30.903 5.76 44.89-10.33 13.372-21.615 26.931-34.611 39.927-162.47 162.47-425.845 162.47-588.315 0-12.972-12.971-24.303-26.53-34.651-39.983-10.775-14.007-8.155-34.099 5.853-44.873z"],"attrs":[],"isMulticolor":false,"isMulticolor2":false,"grid":24,"tags":["Newfunction"],"colorPermutations":{"246155111125525525512936511761761561":[],"2323037125525525512936511761761561":[],"10511915011401421681255255255129365114753651761761561":[],"14014216812552552551293651147536515050501761761561":[]}},"attrs":[],"properties":{"order":309,"id":162,"name":"Newfunction","prevSize":24,"code":59811},"setIdx":0,"setId":0,"iconIdx":56},{"icon":{"paths":["M760.9 263.098c137.468 137.465 137.468 360.338 0 497.802-137.463 137.468-360.337 137.468-497.802 0-137.465-137.463-137.465-360.337 0-497.802s360.338-137.465 497.802 0zM806.157 217.844c-162.458-162.458-425.855-162.458-588.313 0s-162.458 425.856 0 588.313c162.458 162.458 425.856 162.458 588.313 0s162.458-425.855 0-588.313z","M512 352.179c17.673 0 32 14.327 32 32v255.633c0 17.673-14.327 32-32 32s-32-14.327-32-32v-255.633c0-17.673 14.327-32 32-32z","M352.179 512c0-17.673 14.327-32 32-32h255.633c17.673 0 32 14.327 32 32s-14.327 32-32 32h-255.633c-17.673 0-32-14.327-32-32z"],"attrs":[],"isMulticolor":false,"isMulticolor2":false,"grid":24,"tags":["Plus-circle"],"colorPermutations":{"246155111125525525512936511761761561":[],"2323037125525525512936511761761561":[],"10511915011401421681255255255129365114753651761761561":[],"14014216812552552551293651147536515050501761761561":[]}},"attrs":[],"properties":{"order":310,"id":161,"name":"Plus-circle","prevSize":24,"code":59812},"setIdx":0,"setId":0,"iconIdx":57},{"icon":{"paths":["M871.838 280.163c-46.426-46.426-121.655-46.426-168.081 0-12.497 12.497-32.755 12.497-45.252 0s-12.497-32.758 0-45.255c71.42-71.419 187.166-71.419 258.586 0s71.42 187.169 0 258.587l-250.837 250.837c-71.42 71.42-187.166 71.42-258.587 0-71.419-71.42-71.419-187.166 0-258.586l37.506-37.504c12.497-12.497 32.755-12.497 45.252 0s12.497 32.755 0 45.252l-37.504 37.504c-46.425 46.426-46.425 121.655 0 168.081s121.655 46.426 168.081 0l250.837-250.837c46.426-46.427 46.426-121.654 0-168.080z","M571.081 367.587c-46.426-46.426-121.655-46.426-168.080 0l-250.837 250.836c-46.426 46.426-46.426 121.655 0 168.081s121.653 46.426 168.079 0c12.497-12.497 32.758-12.497 45.255 0s12.497 32.755 0 45.252c-71.419 71.42-187.168 71.42-258.588 0s-71.419-187.166 0-258.586l250.837-250.839c71.421-71.419 187.168-71.419 258.587 0s71.42 187.168 0 258.587l-39.040 39.040c-12.497 12.497-32.755 12.497-45.252 0s-12.497-32.755 0-45.252l39.040-39.040c46.426-46.426 46.426-121.654 0-168.080z"],"attrs":[],"isMulticolor":false,"isMulticolor2":false,"grid":24,"tags":["constraint"],"colorPermutations":{"246155111125525525512936511761761561":[],"2323037125525525512936511761761561":[],"10511915011401421681255255255129365114753651761761561":[],"14014216812552552551293651147536515050501761761561":[]}},"attrs":[],"properties":{"order":304,"id":160,"name":"constraint","prevSize":24,"code":59813},"setIdx":0,"setId":0,"iconIdx":58},{"icon":{"paths":["M346.247 410.247c18.612-18.612 48.788-18.612 67.4 0 18.614 18.612 18.614 48.786 0 67.398-18.612 18.615-48.788 18.615-67.4 0-18.612-18.611-18.612-48.785 0-67.398z","M234.197 288h235.648c2.688 0 5.222 1.059 7.091 2.94l22.69-22.566-22.626 22.627 307.627 307.625c20.442 20.442 20.442 53.602 0 74.044l-175.957 175.957c-20.442 20.442-53.602 20.442-74.044 0l-307.625-307.627c-1.924-1.924-3.001-4.553-3.001-7.198v-235.605c0-5.623 4.574-10.197 10.197-10.197zM522.283 245.773c-13.914-13.971-32.781-21.773-52.437-21.773h-235.648c-40.969 0-74.197 33.228-74.197 74.197v235.605c0 19.712 7.883 38.588 21.746 52.45l307.628 307.627c45.436 45.436 119.113 45.436 164.548 0l175.957-175.957c45.436-45.436 45.436-119.113 0-164.548l-307.597-307.601z","M288 128c0-17.673 14.327-32 32-32h174.464c30.869 0 60.446 12.156 82.423 33.84l277.594 274.055c12.578 12.416 12.706 32.675 0.29 45.253s-32.674 12.706-45.252 0.29l-277.585-274.040c-10.022-9.889-23.454-15.398-37.47-15.398h-174.464c-17.673 0-32-14.327-32-32z"],"attrs":[],"isMulticolor":false,"isMulticolor2":false,"grid":24,"tags":["Tags"],"colorPermutations":{"246155111125525525512936511761761561":[],"2323037125525525512936511761761561":[],"10511915011401421681255255255129365114753651761761561":[],"14014216812552552551293651147536515050501761761561":[]}},"attrs":[],"properties":{"order":305,"id":159,"name":"Tags","prevSize":24,"code":59814},"setIdx":0,"setId":0,"iconIdx":59},{"icon":{"paths":["M122.615 255.794c-25.713-71.977 47.138-141.802 117.968-108.953l615.639 285.74c67.294 31.219 67.294 127.531 0 158.75l-615.627 285.82c-70.803 32.836-143.717-36.945-117.974-108.919l91.429-256.354-91.435-256.082zM213.648 204.897c-17.486-8.101-38.064 8.936-30.762 29.368l95.277 266.846c2.483 6.955 2.484 14.554 0.004 21.508l-95.275 267.136c-7.281 20.356 13.248 37.466 30.764 29.342l615.626-285.82c17.869-8.29 17.877-34.351 0.009-42.641l-615.643-285.74z","M215.898 512c0-17.673 14.327-32 32-32h626.772c17.673 0 32 14.327 32 32s-14.327 32-32 32h-626.772c-17.673 0-32-14.327-32-32z"],"attrs":[],"isMulticolor":false,"isMulticolor2":false,"grid":24,"tags":["Send-outline"],"colorPermutations":{"246155111125525525512936511761761561":[],"2323037125525525512936511761761561":[],"10511915011401421681255255255129365114753651761761561":[],"14014216812552552551293651147536515050501761761561":[]}},"attrs":[],"properties":{"order":306,"id":158,"name":"Send-outline","prevSize":24,"code":59815},"setIdx":0,"setId":0,"iconIdx":60},{"icon":{"paths":["M53.333 512c0-17.673 14.327-32 32-32h128c17.673 0 32 14.327 32 32v341.333c0 17.673-14.327 32-32 32h-128c-17.673 0-32-14.327-32-32v-341.333zM117.333 544v277.333h64v-277.333h-64z","M288 384c0-17.673 14.327-32 32-32h128.085c17.673 0 32 14.327 32 32v170.667c0 17.673-14.327 32-32 32h-128.085c-8.487 0-16.626-3.371-22.627-9.374-6.001-5.999-9.373-14.14-9.373-22.626v-170.667zM352 416v106.667h64.085v-106.667h-64.085z","M544 170.667c0-17.673 14.327-32 32-32h128c17.673 0 32 14.327 32 32v298.667c0 17.673-14.327 32-32 32h-128c-17.673 0-32-14.327-32-32v-298.667zM608 202.667v234.667h64v-234.667h-64z","M800 341.333c0-17.673 14.327-32 32-32h128c17.673 0 32 14.327 32 32v213.333c0 17.673-14.327 32-32 32h-128c-17.673 0-32-14.327-32-32v-213.333zM864 373.333v149.333h64v-149.333h-64z"],"attrs":[],"isMulticolor":false,"isMulticolor2":false,"grid":24,"tags":["Performance-attribution"],"colorPermutations":{"246155111125525525512936511761761561":[],"2323037125525525512936511761761561":[],"10511915011401421681255255255129365114753651761761561":[],"14014216812552552551293651147536515050501761761561":[]}},"attrs":[],"properties":{"order":301,"id":157,"name":"Performance-attribution","prevSize":24,"code":59659},"setIdx":0,"setId":0,"iconIdx":61},{"icon":{"paths":["M431.117 267.102c17.434 2.906 29.21 19.393 26.304 36.826l-13.995 83.968c-2.573 15.43-15.923 26.739-31.565 26.739h-84.395c-17.673 0-32-14.327-32-32s14.327-32 32-32h57.286l9.538-57.229c2.906-17.433 19.393-29.209 36.826-26.304z","M596.706 267.102c17.434 2.906 29.21 19.393 26.304 36.826l-7.787 46.707h48.243c17.673 0 32 14.327 32 32s-14.327 32-32 32h-86.016c-9.408 0-18.338-4.139-24.418-11.316s-8.691-16.666-7.147-25.945l13.995-83.968c2.906-17.433 19.392-29.209 36.826-26.304z","M380.296 377.379c2.569-15.433 15.921-26.745 31.566-26.745h165.589c9.404 0 18.334 4.138 24.414 11.314s8.695 16.663 7.151 25.941l-27.179 163.244c-2.569 15.433-15.919 26.743-31.565 26.743h-165.589c-9.405 0-18.335-4.139-24.415-11.315s-8.695-16.661-7.151-25.941l27.179-163.241zM438.976 414.635l-16.525 99.243h100.707l16.525-99.243h-100.706z","M266.667 545.877c0-17.673 14.327-32 32-32h86.016c9.406 0 18.336 4.139 24.416 11.315s8.695 16.666 7.148 25.946l-13.995 83.968c-2.906 17.434-19.393 29.21-36.826 26.304s-29.209-19.392-26.304-36.826l7.785-46.707h-48.241c-17.673 0-32-14.327-32-32z","M518.707 540.617c2.573-15.428 15.923-26.739 31.565-26.739h84.395c17.673 0 32 14.327 32 32s-14.327 32-32 32h-57.289l-9.536 57.229c-2.906 17.434-19.392 29.21-36.826 26.304s-29.21-19.392-26.304-36.826l13.995-83.968z","M486.417 160c-180.28 0-326.417 146.137-326.417 326.417s146.137 326.417 326.417 326.417c180.279 0 326.417-146.138 326.417-326.417s-146.138-326.417-326.417-326.417zM486.417 876.834c-215.626 0-390.417-174.793-390.417-390.417 0-215.626 174.791-390.417 390.417-390.417 215.625 0 390.417 174.791 390.417 390.417 0 215.625-174.793 390.417-390.417 390.417z","M717.372 717.372c12.497-12.497 32.759-12.497 45.257 0l155.998 156.002c12.497 12.497 12.497 32.755 0 45.252s-32.755 12.497-45.252 0l-156.002-155.998c-12.497-12.497-12.497-32.759 0-45.257z"],"attrs":[],"isMulticolor":false,"isMulticolor2":false,"grid":24,"tags":["exante-metrics"],"colorPermutations":{"246155111125525525512936511761761561":[],"2323037125525525512936511761761561":[],"10511915011401421681255255255129365114753651761761561":[],"14014216812552552551293651147536515050501761761561":[]}},"attrs":[],"properties":{"order":296,"id":156,"name":"exante-metrics1","prevSize":24,"code":59806},"setIdx":0,"setId":0,"iconIdx":62},{"icon":{"paths":["M96 213.333c0-64.82 52.514-117.333 117.333-117.333h85.333c17.673 0 32 14.327 32 32s-14.327 32-32 32h-85.333c-29.474 0-53.333 23.86-53.333 53.333v597.333c0 29.474 23.86 53.333 53.333 53.333h512c29.474 0 53.333-23.859 53.333-53.333v-42.667c0-17.673 14.327-32 32-32s32 14.327 32 32v42.667c0 64.819-52.514 117.333-117.333 117.333h-512c-64.82 0-117.333-52.514-117.333-117.333v-597.333z","M362.667 96c-17.655 0-32 14.345-32 32s14.345 32 32 32h213.333c17.655 0 32-14.345 32-32s-14.345-32-32-32h-213.333zM266.667 128c0-53.001 42.999-96 96-96h213.333c53.001 0 96 42.999 96 96s-42.999 96-96 96h-213.333c-53.001 0-96-42.999-96-96z","M266.667 341.333c0-17.673 14.327-32 32-32h256c17.673 0 32 14.327 32 32s-14.327 32-32 32h-256c-17.673 0-32-14.327-32-32z","M266.667 512c0-17.673 14.327-32 32-32h170.667c17.673 0 32 14.327 32 32s-14.327 32-32 32h-170.667c-17.673 0-32-14.327-32-32z","M608 128c0-17.673 14.327-32 32-32h85.333c64.819 0 117.333 52.514 117.333 117.333 0 17.673-14.327 32-32 32s-32-14.327-32-32c0-29.474-23.859-53.333-53.333-53.333h-85.333c-17.673 0-32-14.327-32-32z","M758.4 345.743c48.58-48.525 127.287-48.544 175.842 0.013 48.525 48.582 48.559 127.302 0 175.857l-197.658 197.662c-11.716 11.644-27.046 19.196-43.622 21.222l-134.374 16.593c-9.886 1.225-19.78-2.231-26.761-9.344-6.976-7.108-10.244-17.067-8.841-26.931l19.721-138.287c2.304-15.983 9.685-30.775 21.12-42.21l194.573-194.575zM888.99 391.011c-23.548-23.545-61.739-23.568-85.35 0l-194.56 194.559c-1.617 1.617-2.684 3.716-3.025 6.071l-13.803 96.806 92.894-11.473c2.266-0.273 4.54-1.335 6.302-3.072l197.542-197.542c23.543-23.548 23.569-61.739 0-85.35z"],"attrs":[],"isMulticolor":false,"isMulticolor2":false,"grid":24,"tags":["free-text"],"colorPermutations":{"246155111125525525512936511761761561":[],"2323037125525525512936511761761561":[],"10511915011401421681255255255129365114753651761761561":[],"14014216812552552551293651147536515050501761761561":[]}},"attrs":[],"properties":{"order":297,"id":155,"name":"free-text","prevSize":24,"code":59807},"setIdx":0,"setId":0,"iconIdx":63},{"icon":{"paths":["M273.856 138.667c11.988-25.222 37.702-42.667 67.477-42.667h85.333c29.773 0 55.488 17.444 67.477 42.667h316.523c64.819 0 117.333 52.514 117.333 117.333v554.667c0 64.819-52.514 117.333-117.333 117.333h-597.333c-64.82 0-117.333-52.514-117.333-117.333v-554.667c0-64.82 52.514-117.333 117.333-117.333h60.523zM266.667 202.667h-53.333c-29.474 0-53.333 23.86-53.333 53.333v554.667c0 29.474 23.86 53.333 53.333 53.333h597.333c29.474 0 53.333-23.859 53.333-53.333v-554.667c0-29.474-23.859-53.333-53.333-53.333h-309.333v181.333c0 11.090-5.743 21.39-15.177 27.221s-21.214 6.361-31.134 1.401l-71.023-35.511-71.023 35.511c-9.92 4.96-21.7 4.43-31.134-1.401s-15.177-16.131-15.177-27.221v-181.333zM341.333 160c-5.879 0-10.667 4.788-10.667 10.667v161.556l39.023-19.511c9.009-4.504 19.613-4.504 28.622 0l39.023 19.511v-161.556c0-5.879-4.787-10.667-10.667-10.667h-85.333zM608 384c0-17.673 14.327-32 32-32h85.333c17.673 0 32 14.327 32 32s-14.327 32-32 32h-85.333c-17.673 0-32-14.327-32-32zM266.667 554.667c0-17.673 14.327-32 32-32h85.333c17.673 0 32 14.327 32 32s-14.327 32-32 32h-85.333c-17.673 0-32-14.327-32-32zM480 554.667c0-17.673 14.327-32 32-32h213.333c17.673 0 32 14.327 32 32s-14.327 32-32 32h-213.333c-17.673 0-32-14.327-32-32zM266.667 725.333c0-17.673 14.327-32 32-32h85.333c17.673 0 32 14.327 32 32s-14.327 32-32 32h-85.333c-17.673 0-32-14.327-32-32zM480 725.333c0-17.673 14.327-32 32-32h213.333c17.673 0 32 14.327 32 32s-14.327 32-32 32h-213.333c-17.673 0-32-14.327-32-32z"],"attrs":[],"isMulticolor":false,"isMulticolor2":false,"grid":24,"tags":["summary"],"colorPermutations":{"246155111125525525512936511761761561":[],"2323037125525525512936511761761561":[],"10511915011401421681255255255129365114753651761761561":[],"14014216812552552551293651147536515050501761761561":[]}},"attrs":[],"properties":{"order":298,"id":154,"name":"summary","prevSize":24,"code":59808},"setIdx":0,"setId":0,"iconIdx":64},{"icon":{"paths":["M96 213.333v426.667c0 64.819 52.514 117.333 117.333 117.333h181.307l9.986 69.931c8.228 57.813 57.761 100.736 116.159 100.736h289.877c64.819 0 117.333-52.514 117.333-117.333v-469.333c0-64.82-52.514-117.333-117.333-117.333h-214.234l-3.9-27.276c-8.269-57.782-57.775-100.724-116.156-100.724h-263.040c-64.82 0-117.333 52.514-117.333 117.333zM422.947 693.333c-0.34-0.004-0.681-0.004-1.022 0h-208.591c-29.474 0-53.333-23.859-53.333-53.333v-426.667c0-29.474 23.86-53.333 53.333-53.333h263.040c26.526 0 49.037 19.518 52.8 45.786 0-0.002 0.004 0.003 0 0l32.107 224.644c0.064 0.542 0.141 1.075 0.23 1.604l21.069 147.422c0.081 0.747 0.188 1.485 0.316 2.214l15.142 105.95c0 0 0 0 0 0zM651.311 608h95.351c17.673 0 32-14.327 32-32s-14.327-32-32-32h-104.499l-12.194-85.333h116.693c17.673 0 32-14.327 32-32s-14.327-32-32-32h-125.841l-15.245-106.667h205.086c29.474 0 53.333 23.86 53.333 53.333v469.333c0 29.474-23.859 53.333-53.333 53.333h-268.339l85.871-85.875c10.654-10.65 19.012-23.104 24.819-36.595 1.818-3.093 3.132-6.519 3.827-10.167 5.453-16.798 7.121-34.837 4.557-52.796l-10.086-70.566zM476.053 839.757c-4.122-6.332-6.946-13.641-8.068-21.538l-8.695-60.885h99.187l-82.423 82.423zM598.545 693.333v0zM245.333 277.333c0 17.673 14.327 32 32 32h112.64c17.673 0 32-14.327 32-32s-14.327-32-32-32h-112.64c-17.673 0-32 14.327-32 32zM245.333 426.667c0 17.673 14.327 32 32 32h150.187c17.673 0 32-14.327 32-32s-14.327-32-32-32h-150.187c-17.673 0-32 14.327-32 32zM245.333 576c0 17.673 14.327 32 32 32h187.733c17.673 0 32-14.327 32-32s-14.327-32-32-32h-187.733c-17.673 0-32 14.327-32 32z"],"attrs":[],"isMulticolor":false,"isMulticolor2":false,"grid":24,"tags":["cover"],"colorPermutations":{"246155111125525525512936511761761561":[],"2323037125525525512936511761761561":[],"10511915011401421681255255255129365114753651761761561":[],"14014216812552552551293651147536515050501761761561":[]}},"attrs":[],"properties":{"order":295,"id":153,"name":"cover","prevSize":24,"code":59805},"setIdx":0,"setId":0,"iconIdx":65},{"icon":{"paths":["M307.627 568.751c-4.693 4.693-8.96 14.507-8.96 21.333 0 16.64 13.653 30.293 30.293 30.293 10.667 0 20.907-5.973 26.027-14.933 5.547-9.387 5.12-20.907 0-30.293-9.387-15.787-34.133-19.2-47.36-5.973v-0.427z","M369.924 341.332c-7.253-0.427-15.787 2.56-22.187 7.68-8.533 6.4-12.8 16.213-12.8 26.027 0 18.347 15.787 33.707 35.413 33.707 9.387 0 18.773-3.84 25.173-10.667 5.12-5.12 9.387-15.787 9.387-23.467 0-18.347-15.787-33.28-34.987-33.28z","M567.893 647.684c-7.253-7.253-17.067-11.093-27.307-11.093-10.667-0.853-20.48 3.84-27.733 11.52-7.253 7.253-11.093 17.493-11.093 27.733 0 21.333 17.493 38.827 38.827 38.827 10.667 0 20.48-4.267 27.733-11.52s11.52-17.493 11.093-27.307c0-10.667-4.267-20.48-11.52-27.733v-0.427z","M531.627 523.942c6.827-11.947 6.827-26.88 0-39.253-6.827-11.947-19.627-19.2-33.707-19.2-10.24 0-20.053 4.267-27.733 11.52-7.253 7.253-11.52 17.493-11.093 27.307 0 21.333 17.493 38.827 39.253 38.827 13.653 0 26.453-7.68 33.28-19.627v0.427z","M885.76 469.333c-194.56 0-352-157.867-352-352 0-17.493-14.507-32-32-32-229.973 0-416.427 186.453-416.427 416s186.453 416 416 416c229.547 0 416-186.453 416-416 0-17.493-14.507-32-32-32h0.427zM501.76 853.333c-194.56 0-352-157.867-352-352-0.427-183.893 140.8-334.933 320.853-350.72 16.213 203.093 178.347 365.227 381.44 381.44-15.36 180.053-166.827 321.28-350.72 321.28h0.427z"],"attrs":[],"isMulticolor":false,"isMulticolor2":false,"grid":24,"tags":["cookies"],"colorPermutations":{"246155111125525525512936511761761561":[],"2323037125525525512936511761761561":[],"10511915011401421681255255255129365114753651761761561":[],"14014216812552552551293651147536515050501761761561":[]}},"attrs":[],"properties":{"order":285,"id":151,"name":"cookies","prevSize":24,"code":59804},"setIdx":0,"setId":0,"iconIdx":66},{"icon":{"paths":["M349.18 159.997l96.986 60.616c34.347 21.431 55.168 59.053 55.168 99.512v458.538h138.667c29.474 0 53.333-23.859 53.333-53.333v-42.667c0-17.673 14.327-32 32-32s32 14.327 32 32v42.667c0 64.819-52.514 117.333-117.333 117.333h-139.618c-10.441 82.867-104.85 130.278-178.576 84.177 0.003 0-0.003 0 0 0l-170.659-106.662c-34.335-21.431-55.147-59.046-55.147-99.499v-507.22c0-70.050 58.547-119.276 120.943-117.461h423.057c64.819 0 117.333 52.513 117.333 117.333v42.667c0 17.673-14.327 32-32 32s-32-14.327-32-32v-42.667c0-29.474-23.859-53.333-53.333-53.333h-290.82zM241.6 168.231c-35.536-22.189-81.6 3.352-81.6 45.227v507.22c0 18.423 9.474 35.499 25.046 45.214l170.688 106.679c35.517 22.212 81.6-3.332 81.6-45.184v-507.263c0-18.421-9.472-35.498-25.046-45.214l-170.688-106.679c-0.003-0.002 0.003 0.001 0 0zM788.041 361.369c12.497-12.497 32.755-12.497 45.252 0l85.333 85.334c12.497 12.497 12.497 32.759 0 45.252l-85.333 85.333c-12.497 12.497-32.755 12.497-45.252 0-12.497-12.493-12.497-32.755 0-45.252l30.703-30.707h-178.743c-17.673 0-32-14.327-32-32s14.327-32 32-32h178.743l-30.703-30.705c-12.497-12.497-12.497-32.758 0-45.255z"],"attrs":[],"tags":["Exit"],"grid":24,"isMulticolor":false,"isMulticolor2":false,"colorPermutations":{"246155111125525525512936511761761561":[],"2323037125525525512936511761761561":[],"10511915011401421681255255255129365114753651761761561":[],"14014216812552552551293651147536515050501761761561":[]}},"attrs":[],"properties":{"order":281,"id":1,"name":"Exit","prevSize":24,"code":59801},"setIdx":0,"setId":0,"iconIdx":67},{"icon":{"paths":["M579.9 444.164c37.453 37.449 37.495 98.308 0.013 135.876-37.453 37.449-98.304 37.483-135.872-0.009-37.447-37.453-37.475-98.304 0.017-135.868 37.555-37.547 98.347-37.53 135.842 0zM625.131 398.883c-62.515-62.516-163.814-62.487-226.339 0.037-62.423 62.529-62.47 163.905 0 226.374 62.529 62.426 163.905 62.473 226.374 0 62.421-62.524 62.473-163.891 0.013-226.364z","M512 245.333c-146.354 0-277.42 78.937-336.226 199.151-10.434 21.329-15.774 44.343-15.774 67.516s5.34 46.187 15.774 67.516c58.806 120.213 189.872 199.151 336.226 199.151 146.355 0 277.419-78.938 336.226-199.151 10.432-21.329 15.774-44.343 15.774-67.516s-5.342-46.187-15.774-67.516c-58.807-120.214-189.871-199.151-336.226-199.151zM118.284 416.36c70.474-144.064 225.104-235.026 393.716-235.026 168.61 0 323.243 90.962 393.715 235.026 14.656 29.955 22.285 62.578 22.285 95.64s-7.629 65.685-22.285 95.642c-70.473 144.064-225.105 235.025-393.715 235.025-168.611 0-323.242-90.961-393.716-235.025-14.654-29.956-22.284-62.579-22.284-95.642s7.631-65.685 22.284-95.64z"],"attrs":[],"tags":["show"],"grid":24,"isMulticolor":false,"isMulticolor2":false,"colorPermutations":{"246155111125525525512936511761761561":[],"2323037125525525512936511761761561":[],"10511915011401421681255255255129365114753651761761561":[],"14014216812552552551293651147536515050501761761561":[]}},"attrs":[],"properties":{"order":312,"id":2,"name":"show","prevSize":24,"code":59677},"setIdx":0,"setId":0,"iconIdx":68},{"icon":{"paths":["M375.322 777.997c6.379-16.482 24.912-24.674 41.393-18.291 31.839 12.322 63.886 18.961 95.289 18.961 17.673 0 32 14.327 32 32s-14.327 32-32 32c-40.452 0-80.341-8.55-118.39-23.279-16.482-6.379-24.671-24.909-18.292-41.391z","M906.189 503.821c15.543 8.405 21.333 27.823 12.928 43.366-42.308 78.242-102.583 151.467-172.416 205.436-69.658 53.828-150.929 90.044-234.697 90.044-17.677 0-32-14.327-32-32s14.323-32 32-32c65.348 0 133.197-28.489 195.563-76.685 62.187-48.060 116.834-114.185 155.251-185.233 8.405-15.548 27.823-21.333 43.371-12.928z","M793.254 356.297c13.44-11.478 33.638-9.889 45.116 3.549 30.839 36.103 58.347 75.584 80.747 117.009 11.814 21.897 11.814 48.435 0 70.332-8.393 15.556-27.789 21.333-43.345 12.945-15.552-8.393-21.346-27.831-12.954-43.383 1.583-2.931 1.57-6.541-0.009-9.472-20.096-37.163-44.979-72.939-73.101-105.864-11.482-13.438-9.89-33.638 3.546-45.116z","M833.297 190.706c12.497 12.497 12.497 32.758 0 45.255l-597.334 597.332c-12.497 12.497-32.758 12.497-45.255 0s-12.497-32.755 0-45.252l597.332-597.335c12.497-12.497 32.759-12.497 45.257 0z","M584.435 439.565c-39.983-39.982-104.841-39.982-144.823 0-39.984 39.983-39.984 104.845 0 144.828 12.497 12.497 12.497 32.755 0 45.252s-32.759 12.497-45.256 0c-64.977-64.977-64.977-170.355 0-235.334 64.976-64.977 170.359-64.977 235.336 0 12.497 12.497 12.497 32.756 0 45.254s-32.759 12.497-45.257 0z","M277.303 271.385c69.658-53.838 150.93-90.051 234.702-90.051 83.793 0 165.133 36.248 234.79 90.147 13.978 10.815 16.542 30.914 5.726 44.891s-30.912 16.541-44.89 5.726c-62.353-48.244-130.261-76.765-195.627-76.765-65.353 0-133.201 28.49-195.564 76.69-62.188 48.064-116.834 114.196-155.253 185.271-1.58 2.927-1.57 6.537 0.006 9.468 38.418 71.023 93.033 137.105 155.178 185.182 13.978 10.812 16.544 30.912 5.73 44.89s-30.912 16.546-44.89 5.73c-69.774-53.978-130.015-127.155-172.321-205.372-11.815-21.901-11.831-48.41-0.016-70.31 42.306-78.263 102.595-151.523 172.428-205.496z"],"attrs":[],"tags":["Hide"],"grid":24,"isMulticolor":false,"isMulticolor2":false,"colorPermutations":{"246155111125525525512936511761761561":[],"2323037125525525512936511761761561":[],"10511915011401421681255255255129365114753651761761561":[],"14014216812552552551293651147536515050501761761561":[]}},"attrs":[],"properties":{"order":283,"id":3,"name":"Hide","prevSize":24,"code":59693},"setIdx":0,"setId":0,"iconIdx":69},{"icon":{"paths":["M96 512c0-17.673 14.327-32 32-32h597.333c17.673 0 32 14.327 32 32s-14.327 32-32 32h-597.333c-17.673 0-32-14.327-32-32z","M896 885.333c-17.673 0-32-14.327-32-32v-682.667c0-17.673 14.327-32 32-32s32 14.327 32 32v682.667c0 17.673-14.327 32-32 32z","M489.37 748.002c-12.493-12.497-12.493-32.759 0.004-45.257l190.746-190.707-190.746-190.744c-12.497-12.497-12.497-32.758 0-45.255s32.755-12.497 45.252 0l213.376 213.377c6.003 5.999 9.374 14.14 9.374 22.626 0 8.491-3.371 16.627-9.374 22.63l-213.376 213.333c-12.497 12.493-32.759 12.493-45.257-0.004z"],"attrs":[],"isMulticolor":false,"isMulticolor2":false,"grid":24,"tags":["import"],"colorPermutations":{"246155111125525525512936511761761561":[],"2323037125525525512936511761761561":[],"10511915011401421681255255255129365114753651761761561":[],"14014216812552552551293651147536515050501761761561":[]}},"attrs":[],"properties":{"order":280,"id":150,"name":"import","prevSize":24,"code":59802},"setIdx":0,"setId":0,"iconIdx":70},{"icon":{"paths":["M512 949.333c17.673 0 32-14.327 32-32v-597.333c0-17.673-14.327-32-32-32s-32 14.327-32 32v597.333c0 17.673 14.327 32 32 32z","M138.667 149.333c0 17.673 14.327 32 32 32h682.667c17.673 0 32-14.327 32-32s-14.327-32-32-32h-682.667c-17.673 0-32 14.327-32 32z","M275.999 555.964c12.498 12.493 32.759 12.493 45.255-0.004l190.708-190.745 190.746 190.745c12.497 12.497 32.755 12.497 45.252 0s12.497-32.755 0-45.252l-213.376-213.377c-5.999-6.001-14.14-9.373-22.626-9.373-8.491 0-16.627 3.373-22.63 9.375l-213.332 213.375c-12.496 12.497-12.494 32.759 0.004 45.257z"],"attrs":[],"tags":["Upload"],"grid":24,"isMulticolor":false,"isMulticolor2":false,"colorPermutations":{"246155111125525525512936511761761561":[],"2323037125525525512936511761761561":[],"10511915011401421681255255255129365114753651761761561":[],"14014216812552552551293651147536515050501761761561":[]}},"attrs":[],"properties":{"order":237,"id":4,"name":"Upload","prevSize":24,"code":59687},"setIdx":0,"setId":0,"iconIdx":71},{"icon":{"paths":["M512 96c17.673 0 32 14.327 32 32v597.333c0 17.673-14.327 32-32 32s-32-14.327-32-32v-597.333c0-17.673 14.327-32 32-32z","M138.667 896c0-17.673 14.327-32 32-32h682.667c17.673 0 32 14.327 32 32s-14.327 32-32 32h-682.667c-17.673 0-32-14.327-32-32z","M275.999 489.37c12.498-12.493 32.759-12.493 45.255 0.004l190.708 190.746 190.746-190.746c12.497-12.497 32.755-12.497 45.252 0s12.497 32.755 0 45.252l-213.376 213.376c-5.999 6.003-14.14 9.374-22.626 9.374-8.491 0-16.627-3.371-22.63-9.374l-213.332-213.376c-12.496-12.497-12.494-32.759 0.004-45.257z"],"attrs":[],"tags":["Dowload"],"grid":24,"isMulticolor":false,"isMulticolor2":false,"colorPermutations":{"246155111125525525512936511761761561":[],"2323037125525525512936511761761561":[],"10511915011401421681255255255129365114753651761761561":[],"14014216812552552551293651147536515050501761761561":[]}},"attrs":[],"properties":{"order":238,"id":5,"name":"Dowload","prevSize":24,"code":59668},"setIdx":0,"setId":0,"iconIdx":72},{"icon":{"paths":["M138.521 853.47c0-17.673 14.327-32 32-32h682.949c17.677 0 32 14.327 32 32 0 17.677-14.323 32-32 32h-682.949c-17.673 0-32-14.323-32-32z","M138.521 682.735c0-17.673 14.327-32 32-32h682.949c17.677 0 32 14.327 32 32s-14.323 32-32 32h-682.949c-17.673 0-32-14.327-32-32z","M138.521 511.996c0-17.673 14.327-32 32-32h682.949c17.677 0 32 14.327 32 32s-14.323 32-32 32h-682.949c-17.673 0-32-14.327-32-32z","M479.996 341.259c0-17.673 14.327-32 32-32h341.478c17.673 0 32 14.327 32 32s-14.327 32-32 32h-341.478c-17.673 0-32-14.327-32-32z","M479.996 170.521c0-17.673 14.327-32 32-32h341.478c17.673 0 32 14.327 32 32s-14.327 32-32 32h-341.478c-17.673 0-32-14.327-32-32z","M138.656 255.89c0-17.673 14.327-32 32-32h213.422c17.673 0 32 14.327 32 32s-14.327 32-32 32h-213.422c-17.673 0-32-14.327-32-32z","M278.623 147.893c-12.497-12.497-32.758-12.497-45.255 0l-85.369 85.369c-12.497 12.497-12.497 32.758 0 45.255l85.369 85.369c12.497 12.497 32.758 12.497 45.255 0s12.497-32.758 0-45.255l-62.742-62.741 62.742-62.742c12.497-12.497 12.497-32.758 0-45.255z"],"attrs":[],"tags":["outdent"],"grid":24,"isMulticolor":false,"isMulticolor2":false,"colorPermutations":{"246155111125525525512936511761761561":[],"2323037125525525512936511761761561":[],"10511915011401421681255255255129365114753651761761561":[],"14014216812552552551293651147536515050501761761561":[]}},"attrs":[],"properties":{"order":239,"id":6,"name":"outdent","prevSize":24,"code":59686},"setIdx":0,"setId":0,"iconIdx":73},{"icon":{"paths":["M138.521 853.47c0-17.673 14.327-32 32-32h682.949c17.677 0 32 14.327 32 32 0 17.677-14.323 32-32 32h-682.949c-17.673 0-32-14.323-32-32z","M138.521 682.735c0-17.673 14.327-32 32-32h682.949c17.677 0 32 14.327 32 32s-14.323 32-32 32h-682.949c-17.673 0-32-14.327-32-32z","M138.521 511.996c0-17.673 14.327-32 32-32h682.949c17.677 0 32 14.327 32 32s-14.323 32-32 32h-682.949c-17.673 0-32-14.327-32-32z","M479.996 341.259c0-17.673 14.327-32 32-32h341.478c17.673 0 32 14.327 32 32s-14.327 32-32 32h-341.478c-17.673 0-32-14.327-32-32z","M479.996 170.521c0-17.673 14.327-32 32-32h341.478c17.673 0 32 14.327 32 32s-14.327 32-32 32h-341.478c-17.673 0-32-14.327-32-32z","M138.521 255.89c0-17.673 14.327-32 32-32h213.423c17.673 0 32 14.327 32 32s-14.327 32-32 32h-213.423c-17.673 0-32-14.327-32-32z","M275.947 147.893c12.497-12.497 32.758-12.497 45.255 0l85.369 85.369c12.497 12.497 12.497 32.758 0 45.255l-85.369 85.369c-12.497 12.497-32.758 12.497-45.255 0s-12.497-32.758 0-45.255l62.742-62.741-62.742-62.742c-12.497-12.497-12.497-32.758 0-45.255z"],"attrs":[],"tags":["indent"],"grid":24,"isMulticolor":false,"isMulticolor2":false,"colorPermutations":{"246155111125525525512936511761761561":[],"2323037125525525512936511761761561":[],"10511915011401421681255255255129365114753651761761561":[],"14014216812552552551293651147536515050501761761561":[]}},"attrs":[],"properties":{"order":240,"id":7,"name":"indent","prevSize":24,"code":59743},"setIdx":0,"setId":0,"iconIdx":74},{"icon":{"paths":["M437.333 170.668c0-17.673 14.327-32 32-32h384c17.673 0 32 14.327 32 32s-14.327 32-32 32h-384c-17.673 0-32-14.327-32-32z","M443.733 384.001c0-17.673 14.327-32 32-32h377.6c17.673 0 32 14.327 32 32s-14.327 32-32 32h-377.6c-17.673 0-32-14.327-32-32z","M236.246 141.103c11.958 4.953 19.754 16.622 19.754 29.564v181.333h21.333c17.673 0 32 14.327 32 32s-14.327 32-32 32h-106.667c-17.673 0-32-14.327-32-32s14.327-32 32-32h21.333v-104.147c-12.564 11.257-31.887 10.849-43.961-1.225-12.497-12.497-12.497-32.758 0-45.255l53.333-53.333c9.152-9.152 22.916-11.889 34.873-6.937z","M437.333 640c0-17.673 14.327-32 32-32h384c17.673 0 32 14.327 32 32s-14.327 32-32 32h-384c-17.673 0-32-14.327-32-32z","M443.733 853.333c0-17.673 14.327-32 32-32h377.6c17.673 0 32 14.327 32 32s-14.327 32-32 32h-377.6c-17.673 0-32-14.327-32-32z","M138.667 640c0-17.673 14.327-32 32-32h106.667c17.673 0 32 14.327 32 32v85.333c0 11.243-5.897 21.658-15.536 27.439l-91.13 54.682v13.879h85.333c17.673 0 32 14.327 32 32s-14.327 32-32 32h-117.333c-17.673 0-32-14.327-32-32v-64c0-11.238 5.897-21.658 15.536-27.439l91.13-54.677v-35.217h-74.667c-17.673 0-32-14.327-32-32z"],"attrs":[],"tags":["List-Numbers"],"grid":24,"isMulticolor":false,"isMulticolor2":false,"colorPermutations":{"246155111125525525512936511761761561":[],"2323037125525525512936511761761561":[],"10511915011401421681255255255129365114753651761761561":[],"14014216812552552551293651147536515050501761761561":[]}},"attrs":[],"properties":{"order":284,"id":8,"name":"List-Numbers","prevSize":24,"code":59775},"setIdx":0,"setId":0,"iconIdx":75},{"icon":{"paths":["M330.667 256c0-17.673 14.327-32 32-32h512c17.673 0 32 14.327 32 32s-14.327 32-32 32h-512c-17.673 0-32-14.327-32-32z","M117.333 256c0-17.673 14.327-32 32-32h42.667c17.673 0 32 14.327 32 32s-14.327 32-32 32h-42.667c-17.673 0-32-14.327-32-32z","M117.333 512c0-17.673 14.327-32 32-32h42.667c17.673 0 32 14.327 32 32s-14.327 32-32 32h-42.667c-17.673 0-32-14.327-32-32z","M117.333 768c0-17.673 14.327-32 32-32h42.667c17.673 0 32 14.327 32 32s-14.327 32-32 32h-42.667c-17.673 0-32-14.327-32-32z","M330.667 512c0-17.673 14.327-32 32-32h512c17.673 0 32 14.327 32 32s-14.327 32-32 32h-512c-17.673 0-32-14.327-32-32z","M330.667 768c0-17.673 14.327-32 32-32h512c17.673 0 32 14.327 32 32s-14.327 32-32 32h-512c-17.673 0-32-14.327-32-32z"],"attrs":[],"tags":["commentary-bulletpoint"],"grid":24,"isMulticolor":false,"isMulticolor2":false,"colorPermutations":{"246155111125525525512936511761761561":[],"2323037125525525512936511761761561":[],"10511915011401421681255255255129365114753651761761561":[],"14014216812552552551293651147536515050501761761561":[]}},"attrs":[],"properties":{"order":242,"id":9,"name":"commentary-bulletpoint","prevSize":24,"code":59760},"setIdx":0,"setId":0,"iconIdx":76},{"icon":{"paths":["M319.967 95.844c12.12 0.001 23.2 6.85 28.619 17.692l192.039 384.158c7.902 15.808 1.493 35.029-14.315 42.931s-35.029 1.493-42.931-14.315l-163.424-326.916-163.495 326.882c-7.906 15.804-27.128 22.212-42.934 14.306s-22.211-27.132-14.305-42.935l192.123-384.118c5.422-10.84 16.503-17.687 28.623-17.685z","M134.26 435.123c0-17.671 14.327-31.998 32-31.998h307.241c17.673 0 32 14.327 32 31.998 0 17.677-14.327 32-32 32h-307.241c-17.673 0-32-14.323-32-32z","M718.878 460.489c30.827-30.882 80.806-30.839 111.637-0.009l74.458 74.458c30.903 30.827 30.865 80.819 0.030 111.654l-258.458 258.453c-14.848 14.848-34.897 23.117-55.791 23.117h-121.438c-17.673 0-32-14.323-32-32v-121.434c0-20.894 8.269-40.947 23.117-55.795l258.445-258.445zM785.263 505.732c-5.875-5.871-15.3-5.833-21.094-0.026l-258.479 258.483c-2.825 2.82-4.373 6.588-4.373 10.539v89.434h89.438c3.947 0 7.714-1.545 10.539-4.369l258.453-258.453c5.871-5.875 5.833-15.3 0.026-21.094l-74.509-74.513z"],"attrs":[],"tags":["Style"],"grid":24,"isMulticolor":false,"isMulticolor2":false,"colorPermutations":{"246155111125525525512936511761761561":[],"2323037125525525512936511761761561":[],"10511915011401421681255255255129365114753651761761561":[],"14014216812552552551293651147536515050501761761561":[]}},"attrs":[],"properties":{"order":220,"id":10,"name":"Style","prevSize":24,"code":59776},"setIdx":0,"setId":0,"iconIdx":77},{"icon":{"paths":["M95.844 234.546c0-64.839 52.529-117.369 117.369-117.369h213.422c64.83 0 117.37 52.519 117.37 117.326v213.467c0 64.836-52.531 117.367-117.37 117.367h-213.422c-64.839 0-117.369-52.531-117.369-117.367v-213.424zM213.213 181.177c-29.493 0-53.369 23.875-53.369 53.369v213.424c0 29.491 23.875 53.367 53.369 53.367h213.422c29.493 0 53.37-23.876 53.37-53.367v-213.467c0-29.44-23.868-53.326-53.37-53.326h-213.422z","M220.491 241.602c16.631-16.461 43.408-16.483 60.065-0.067 0.023 0.022 0.045 0.044 0.067 0.067 0.039 0.038 0.078 0.077 0.116 0.116zM280.806 241.784c16.613 16.685 16.591 43.641-0.067 60.298-16.68 16.68-43.685 16.68-60.365 0s-16.68-43.685 0-60.365l0.116-0.116zM280.806 241.784c-0.022-0.022-0.044-0.044-0.067-0.067z","M245.239 503.97c0-131.081 106.265-237.397 237.397-237.397 12.087 0 23.445 1.183 33.873 2.667 17.498 2.488 29.662 18.69 27.174 36.187s-18.688 29.664-36.186 27.175c-8.781-1.248-16.887-2.029-24.862-2.029-95.777 0-173.397 77.654-173.397 173.397 0 7.991 0.751 16.111 2.012 24.742 2.553 17.489-9.553 33.737-27.041 36.288-17.488 2.556-33.734-9.553-36.288-27.038-1.556-10.662-2.684-22.007-2.684-33.993z","M608.055 511.996c0-17.673 14.327-32 32-32h256.107c17.677 0 32 14.327 32 32s-14.323 32-32 32h-256.107c-17.673 0-32-14.327-32-32z","M608.055 341.257c0-17.673 14.327-32 32-32h256.107c17.677 0 32 14.327 32 32s-14.323 32-32 32h-256.107c-17.673 0-32-14.327-32-32z","M608.055 170.519c0-17.673 14.327-32 32-32h256.107c17.677 0 32 14.327 32 32s-14.323 32-32 32h-256.107c-17.673 0-32-14.327-32-32z","M95.844 853.47c0-17.673 14.327-32 32-32h768.318c17.677 0 32 14.327 32 32s-14.323 32-32 32h-768.318c-17.673 0-32-14.327-32-32z","M95.844 682.731c0-17.673 14.327-32 32-32h768.318c17.677 0 32 14.327 32 32 0 17.677-14.323 32-32 32h-768.318c-17.673 0-32-14.323-32-32z"],"attrs":[],"tags":["Graph"],"grid":24,"isMulticolor":false,"isMulticolor2":false,"colorPermutations":{"246155111125525525512936511761761561":[],"2323037125525525512936511761761561":[],"10511915011401421681255255255129365114753651761761561":[],"14014216812552552551293651147536515050501761761561":[]}},"attrs":[],"properties":{"order":221,"id":11,"name":"Graph","prevSize":24,"code":59777},"setIdx":0,"setId":0,"iconIdx":78},{"icon":{"paths":["M256 160c-53.026 0-96 42.974-96 96v512c0 53.026 42.974 96 96 96h512c53.026 0 96-42.974 96-96v-512c0-53.026-42.974-96-96-96h-512zM96 256c0-88.372 71.628-160 160-160h512c88.371 0 160 71.628 160 160v512c0 88.371-71.629 160-160 160h-512c-88.372 0-160-71.629-160-160v-512zM316.75 363.514c11.314-13.577 31.492-15.411 45.069-4.097l127.998 106.665c7.296 6.080 11.516 15.087 11.516 24.585s-4.22 18.505-11.516 24.585l-127.998 106.667c-13.577 11.311-33.755 9.476-45.069-4.1s-9.48-33.754 4.097-45.069l98.5-82.082-98.5-82.083c-13.577-11.314-15.411-31.492-4.097-45.069zM522.667 640c0-17.673 14.327-32 32-32h128c17.673 0 32 14.327 32 32s-14.327 32-32 32h-128c-17.673 0-32-14.327-32-32z"],"attrs":[],"tags":["Terminal"],"grid":24,"isMulticolor":false,"isMulticolor2":false,"colorPermutations":{"246155111125525525512936511761761561":[],"2323037125525525512936511761761561":[],"10511915011401421681255255255129365114753651761761561":[],"14014216812552552551293651147536515050501761761561":[]}},"attrs":[],"properties":{"order":222,"id":12,"name":"Terminal","prevSize":24,"code":59778},"setIdx":0,"setId":0,"iconIdx":79},{"icon":{"paths":["M345.216 334.549c-5.879 0-10.667 4.788-10.667 10.667v166.784c0 17.673-14.327 32-32 32s-32-14.327-32-32v-166.784c0-41.225 33.442-74.667 74.667-74.667h124.117c41.225 0 74.667 33.442 74.667 74.667v166.784c0 17.673-14.327 32-32 32s-32-14.327-32-32v-166.784c0-5.879-4.787-10.667-10.667-10.667h-124.117z","M279.922 489.374c6.001-6.003 14.141-9.374 22.627-9.374h209.451c17.673 0 32 14.327 32 32v209.451c0 17.673-14.327 32-32 32h-166.784c-41.225 0-74.667-33.442-74.667-74.667v-166.784c0-8.486 3.372-16.627 9.373-22.626zM334.549 544v134.784c0 5.879 4.788 10.667 10.667 10.667h134.784v-145.451h-145.451z","M480 512c0-17.673 14.327-32 32-32h166.784c41.225 0 74.667 33.442 74.667 74.667v124.117c0 41.225-33.442 74.667-74.667 74.667h-166.784c-17.673 0-32-14.327-32-32s14.327-32 32-32h166.784c5.879 0 10.667-4.787 10.667-10.667v-124.117c0-5.879-4.787-10.667-10.667-10.667h-166.784c-17.673 0-32-14.327-32-32z","M654.549 170.667c0-41.225 33.442-74.667 74.667-74.667h124.117c41.225 0 74.667 33.442 74.667 74.667v124.117c0 41.225-33.442 74.667-74.667 74.667h-124.117c-41.225 0-74.667-33.442-74.667-74.667v-124.117zM729.216 160c-5.879 0-10.667 4.788-10.667 10.667v124.117c0 5.879 4.787 10.667 10.667 10.667h124.117c5.879 0 10.667-4.788 10.667-10.667v-124.117c0-5.879-4.787-10.667-10.667-10.667h-124.117z","M197.803 160c-20.855 0-37.803 16.948-37.803 37.803v628.395c0 20.855 16.948 37.803 37.803 37.803h628.395c20.855 0 37.803-16.947 37.803-37.803v-314.197c0-17.673 14.327-32 32-32s32 14.327 32 32v314.197c0 56.201-45.602 101.803-101.803 101.803h-628.395c-56.201 0-101.803-45.602-101.803-101.803v-628.395c0-56.201 45.602-101.803 101.803-101.803h314.197c17.673 0 32 14.327 32 32s-14.327 32-32 32h-314.197z"],"attrs":[],"tags":["blocks"],"grid":24,"isMulticolor":false,"isMulticolor2":false,"colorPermutations":{"246155111125525525512936511761761561":[],"2323037125525525512936511761761561":[],"10511915011401421681255255255129365114753651761761561":[],"14014216812552552551293651147536515050501761761561":[]}},"attrs":[],"properties":{"order":223,"id":13,"name":"blocks","prevSize":24,"code":59779},"setIdx":0,"setId":0,"iconIdx":80},{"icon":{"paths":["M702.929 776.96l-82.773-483.84 49.92-99.84c11.52-23.467 10.24-50.347-3.413-72.533s-37.547-35.413-63.573-35.413h-203.52c-25.6 0-49.92 13.653-63.573 35.413-13.653 22.187-14.933 49.493-3.413 72.533l49.92 99.413-82.773 484.267c-4.693 27.733 6.4 55.467 28.587 72.533l128 96c13.227 9.813 29.013 14.933 44.8 14.933s31.573-5.12 44.8-14.933l128-96c22.613-17.067 33.707-44.8 29.013-72.533zM390.609 154.453c1.707-2.987 5.547-5.12 8.96-5.12h203.52c3.84 0 7.253 2.133 8.96 5.12 2.133 2.987 2.133 7.253 0.427 10.24l-45.653 91.307h-131.413l-45.227-91.307c-1.707-3.413-1.28-7.253 0.427-10.24zM635.942 798.293l-128 96c-3.84 2.987-8.96 2.987-12.8 0l-128-96c-2.987-2.56-4.693-6.4-4.267-10.24l79.787-468.053h116.907l80.213 467.627c0.853 3.84-0.853 8.107-4.267 10.24l0.427 0.427z"],"attrs":[],"tags":["Tone-of-voice"],"grid":24,"isMulticolor":false,"isMulticolor2":false,"colorPermutations":{"246155111125525525512936511761761561":[],"2323037125525525512936511761761561":[],"10511915011401421681255255255129365114753651761761561":[],"14014216812552552551293651147536515050501761761561":[]}},"attrs":[],"properties":{"order":224,"id":14,"name":"Tone-of-voice","prevSize":24,"code":59780},"setIdx":0,"setId":0,"iconIdx":81},{"icon":{"paths":["M256 213.333c0-17.673 14.327-32 32-32h248.875c100.147 0 181.333 81.186 181.333 181.333 0 52.492-22.302 99.776-57.95 132.885 63.475 28.224 107.742 91.831 107.742 165.781 0 100.147-81.186 181.333-181.333 181.333h-298.667c-17.673 0-32-14.327-32-32v-597.333zM320 544v234.667h266.667c64.802 0 117.333-52.531 117.333-117.333s-52.531-117.333-117.333-117.333h-266.667zM536.875 480c64.802 0 117.333-52.531 117.333-117.333s-52.531-117.333-117.333-117.333h-216.875v234.667h216.875z"],"attrs":[],"tags":["Bold"],"grid":24,"isMulticolor":false,"isMulticolor2":false,"colorPermutations":{"246155111125525525512936511761761561":[],"2323037125525525512936511761761561":[],"10511915011401421681255255255129365114753651761761561":[],"14014216812552552551293651147536515050501761761561":[]}},"attrs":[],"properties":{"order":226,"id":15,"name":"Bold","prevSize":24,"code":59781},"setIdx":0,"setId":0,"iconIdx":82},{"icon":{"paths":["M298.667 138.667c17.673 0 32 14.327 32 32v298.667c0 100.13 81.204 181.333 181.333 181.333s181.333-81.203 181.333-181.333v-298.667c0-17.673 14.327-32 32-32s32 14.327 32 32v298.667c0 135.475-109.858 245.333-245.333 245.333s-245.333-109.858-245.333-245.333v-298.667c0-17.673 14.327-32 32-32zM224 853.333c0-17.673 14.327-32 32-32h512c17.673 0 32 14.327 32 32s-14.327 32-32 32h-512c-17.673 0-32-14.327-32-32z"],"attrs":[],"tags":["Underline"],"grid":24,"isMulticolor":false,"isMulticolor2":false,"colorPermutations":{"246155111125525525512936511761761561":[],"2323037125525525512936511761761561":[],"10511915011401421681255255255129365114753651761761561":[],"14014216812552552551293651147536515050501761761561":[]}},"attrs":[],"properties":{"order":227,"id":16,"name":"Underline","prevSize":24,"code":59782},"setIdx":0,"setId":0,"iconIdx":83},{"icon":{"paths":["M224 192c0-17.673 14.327-32 32-32h512c17.673 0 32 14.327 32 32s-14.327 32-32 32h-512c-17.673 0-32-14.327-32-32z","M224 874.667c0-17.673 14.327-32 32-32h512c17.673 0 32 14.327 32 32s-14.327 32-32 32h-512c-17.673 0-32-14.327-32-32z","M341.333 160c17.673 0 32 14.327 32 32v170.667c0 16.808 7.887 32.582 21.333 42.667l117.333 88 117.333-88c13.444-10.085 21.333-25.859 21.333-42.667v-170.667c0-17.673 14.327-32 32-32s32 14.327 32 32v170.667c0 36.952-17.37 71.697-46.933 93.867l-136.533 102.4c-11.379 8.533-27.021 8.533-38.4 0l-136.533-102.4c-29.562-22.17-46.933-56.914-46.933-93.867v-170.667c0-17.673 14.327-32 32-32z","M492.8 507.733c11.379-8.533 27.021-8.533 38.4 0l136.533 102.4c29.564 22.17 46.933 56.913 46.933 93.867v170.667c0 17.673-14.327 32-32 32s-32-14.327-32-32v-170.667c0-16.806-7.889-32.58-21.333-42.667l-117.333-88-117.333 88c-13.446 10.086-21.333 25.86-21.333 42.667v170.667c0 17.673-14.327 32-32 32s-32-14.327-32-32v-170.667c0-36.954 17.372-71.697 46.933-93.867l136.533-102.4z"],"attrs":[],"tags":["Loading"],"grid":24,"isMulticolor":false,"isMulticolor2":false,"colorPermutations":{"246155111125525525512936511761761561":[],"2323037125525525512936511761761561":[],"10511915011401421681255255255129365114753651761761561":[],"14014216812552552551293651147536515050501761761561":[]}},"attrs":[],"properties":{"order":243,"id":17,"name":"Loading","prevSize":24,"code":59783},"setIdx":0,"setId":0,"iconIdx":84},{"icon":{"paths":["M93.652 192.081c-5.543-5.543-8.315-12.598-8.315-21.165s2.772-15.622 8.315-21.165l98.77-98.77c3.024-3.024 6.299-5.17 9.827-6.44 3.528-1.25 7.307-1.875 11.339-1.875s7.811 0.625 11.338 1.875c3.528 1.27 6.803 3.416 9.827 6.44l98.266 97.51c5.543 5.543 8.315 12.346 8.315 20.409s-3.024 15.118-9.071 21.165c-5.543 5.543-12.598 8.314-21.165 8.314s-15.622-2.772-21.165-8.314l-76.345-75.59-78.362 78.361c-5.543 5.543-12.346 8.315-20.409 8.315s-15.118-3.023-21.165-9.071z","M930.347 842.231c5.542 5.542 8.316 12.599 8.316 21.163 0 8.567-2.773 15.625-8.316 21.167l-98.769 98.769c-3.025 3.025-6.298 5.171-9.826 6.443-3.529 1.25-7.309 1.873-11.341 1.873-4.028 0-7.808-0.623-11.337-1.873-3.529-1.271-6.801-3.418-9.826-6.443l-98.266-97.51c-5.542-5.542-8.316-12.343-8.316-20.407s3.025-15.117 9.071-21.167c5.542-5.542 12.599-8.311 21.163-8.311 8.567 0 15.625 2.769 21.167 8.311l76.343 75.593 78.362-78.362c5.547-5.542 12.348-8.316 20.412-8.316 8.060 0 15.117 3.025 21.163 9.071z","M610.56 704c-28.587 0-55.040-11.093-75.52-31.147-41.387-41.387-41.387-109.227 0-151.040 40.533-40.107 110.507-40.107 151.040 0 41.387 41.813 41.387 109.227 0 151.040-20.053 20.053-46.933 31.147-75.52 31.147zM610.56 554.667c-11.52 0-22.187 4.267-30.293 12.373-16.64 16.64-16.64 43.52 0 60.16 16.213 16.213 44.373 16.213 60.16 0 16.64-16.64 16.64-43.52 0-60.587-8.107-8.107-18.773-12.373-30.293-12.373l0.427 0.427z","M840.96 512c-27.307 0-54.613-10.24-75.52-31.147-41.387-41.387-41.387-109.225 0-151.039s109.227-41.387 151.040 0c41.387 41.387 41.387 109.225 0 151.039-20.907 20.907-48.213 31.147-75.52 31.147zM840.96 362.668c-11.093 0-21.76 4.267-30.293 12.373-16.64 16.64-16.64 43.52 0 60.159 16.64 16.64 43.52 16.64 60.16 0 16.64-16.639 16.64-43.519 0-60.159-8.533-8.107-19.2-12.373-30.293-12.373h0.427z","M149.333 742.4c-28.587 0-55.467-11.093-75.52-31.147s-31.147-46.933-31.147-75.52c0-28.587 11.093-55.467 31.147-75.52 41.387-41.387 109.227-41.387 151.040 0 20.053 20.053 31.147 46.933 31.147 75.52s-11.093 55.467-31.147 75.52c-20.053 20.053-46.933 31.147-75.52 31.147zM149.333 593.067c-11.093 0-21.76 4.267-30.293 12.373s-12.373 18.773-12.373 30.293c0 11.52 4.267 22.187 12.373 30.293 16.213 16.213 44.373 16.213 60.16 0 8.107-8.107 12.373-18.773 12.373-30.293s-4.267-22.187-12.373-30.293c-8.107-8.107-19.2-12.373-30.293-12.373h0.427z","M379.733 597.333c-27.307 0-54.613-10.24-75.52-31.147-41.387-41.387-41.387-109.227 0-151.039 41.387-41.387 109.227-41.813 151.040 0 41.387 41.385 41.387 109.225 0 151.039-20.907 20.907-48.213 31.147-75.52 31.147zM349.44 460.373c-16.64 16.64-16.64 43.52 0 60.16s43.52 16.64 60.16 0c16.64-16.64 16.64-43.52 0-60.16s-43.52-16.64-60.16 0z","M667.307 581.973c-8.96 0-18.347-3.84-24.747-11.52-11.093-13.653-9.387-33.707 4.267-45.227l116.48-96.853c13.653-11.092 33.707-9.385 45.227 4.267 11.093 13.653 9.387 33.707-4.267 45.227l-116.48 96.853c-5.973 5.12-13.227 7.253-20.48 7.253z","M544 576c-4.693 0-9.813-1.28-14.080-3.413l-85.333-42.667c-15.787-8.107-22.187-27.307-14.507-43.093 8.107-15.787 27.307-22.187 43.093-14.507l85.333 42.667c15.787 8.107 22.187 27.307 14.507 43.093-5.547 11.093-17.067 17.493-28.587 17.493l-0.427 0.427z","M202.667 618.667c-11.52 0-23.040-6.4-28.587-17.493-8.107-15.787-1.707-34.987 14.507-43.093l85.333-42.667c15.787-7.68 34.987-1.28 43.093 14.507s1.707 34.987-14.507 43.093l-85.333 42.667c-4.693 2.133-9.387 3.413-14.080 3.413l-0.427-0.427z"],"attrs":[],"tags":["volatility"],"grid":24,"isMulticolor":false,"isMulticolor2":false,"colorPermutations":{"246155111125525525512936511761761561":[],"2323037125525525512936511761761561":[],"10511915011401421681255255255129365114753651761761561":[],"14014216812552552551293651147536515050501761761561":[]}},"attrs":[],"properties":{"order":244,"id":18,"name":"volatility","prevSize":24,"code":59784},"setIdx":0,"setId":0,"iconIdx":85},{"icon":{"paths":["M737.399 164.149c-5.534-5.532-14.455-5.532-19.985 0l-119.287 119.284c-5.53 5.532-5.53 14.453 0 19.985l119.287 119.284c5.53 5.53 14.451 5.53 19.985 0l119.258-119.258c-0.009 0.006 0.004-0.006 0 0 5.5-5.533 5.517-14.487 0.017-20.019-0.004-0.006 0.004 0.006 0 0l-119.275-119.276zM672.158 118.894c30.524-30.525 79.97-30.525 110.494 0l119.283 119.284c30.451 30.519 30.477 79.95 0.030 110.469l-119.313 119.308c-30.524 30.528-79.97 30.528-110.494 0l-119.283-119.282c-30.528-30.525-30.528-79.969 0-110.495l119.283-119.284zM341.607 221.145c-41.546-41.545-108.904-41.545-150.449 0s-41.545 108.903 0 150.448c41.545 41.545 108.903 41.545 150.448 0s41.545-108.903 0-150.448zM386.862 175.89c66.54 66.538 66.54 174.419 0 240.958s-174.419 66.54-240.958 0c-66.538-66.539-66.538-174.419 0-240.958s174.419-66.539 240.958 0zM802.854 682.394c-41.545-41.545-108.902-41.545-150.447 0s-41.545 108.902 0 150.447c41.545 41.545 108.902 41.545 150.447 0 41.549-41.545 41.549-108.902 0-150.447zM607.155 637.137c66.534-66.539 174.417-66.539 240.956 0s66.539 174.421 0 240.96c-66.539 66.539-174.417 66.539-240.956 0s-66.539-174.421 0-240.96zM182.25 662.144c-7.824 0-14.141 6.31-14.141 14.14v168.678c0 7.804 6.336 14.14 14.141 14.14h168.677c7.805 0 14.141-6.336 14.141-14.14v-168.678c0-7.804-6.336-14.14-14.141-14.14h-168.677zM104.109 676.284c0-43.213 35.008-78.14 78.141-78.14h168.677c43.152 0 78.141 34.987 78.141 78.14v168.678c0 43.149-34.99 78.14-78.141 78.14h-168.677c-43.152 0-78.141-34.991-78.141-78.14v-168.678z"],"attrs":[],"tags":["composition"],"grid":24,"isMulticolor":false,"isMulticolor2":false,"colorPermutations":{"246155111125525525512936511761761561":[],"2323037125525525512936511761761561":[],"10511915011401421681255255255129365114753651761761561":[],"14014216812552552551293651147536515050501761761561":[]}},"attrs":[],"properties":{"order":245,"id":19,"name":"composition","prevSize":24,"code":59785},"setIdx":0,"setId":0,"iconIdx":86},{"icon":{"paths":["M298.667 96c17.673 0 32 14.327 32 32v10.667h234.667v-10.667c0-17.673 14.327-32 32-32s32 14.327 32 32v10.667h53.333c64.819 0 117.333 52.514 117.333 117.333v323.669c0 19.729-7.808 38.788-21.909 52.83-0.009 0.009 0.009-0.009 0 0l-145.63 145.626c-14.025 14.025-32.998 21.875-52.791 21.875h-366.336c-64.82 0-117.333-52.514-117.333-117.333v-426.667c0-64.82 52.514-117.333 117.333-117.333h53.333v-10.667c0-17.673 14.327-32 32-32zM266.667 202.667h-53.333c-29.474 0-53.333 23.86-53.333 53.333v96h576v-96c0-29.474-23.859-53.333-53.333-53.333h-53.333v10.667c0 17.673-14.327 32-32 32s-32-14.327-32-32v-10.667h-234.667v10.667c0 17.673-14.327 32-32 32s-32-14.327-32-32v-10.667zM736 416h-576v266.667c0 29.474 23.86 53.333 53.333 53.333h309.333v-138.667c0-41.225 33.442-74.667 74.667-74.667h138.667v-106.667zM733.385 586.667h-136.051c-5.879 0-10.667 4.787-10.667 10.667v136.043c0.183-0.162 0.367-0.329 0.542-0.503l145.724-145.724c0.154-0.158 0.307-0.316 0.452-0.482zM896 352c17.673 0 32 14.327 32 32v426.667c0 64.819-52.514 117.333-117.333 117.333h-469.333c-17.673 0-32-14.327-32-32s14.327-32 32-32h469.333c29.474 0 53.333-23.859 53.333-53.333v-426.667c0-17.673 14.327-32 32-32z"],"attrs":[],"tags":["calendar-exante"],"grid":24,"isMulticolor":false,"isMulticolor2":false,"colorPermutations":{"246155111125525525512936511761761561":[],"2323037125525525512936511761761561":[],"10511915011401421681255255255129365114753651761761561":[],"14014216812552552551293651147536515050501761761561":[]}},"attrs":[],"properties":{"order":246,"id":20,"name":"calendar-exante","prevSize":24,"code":59786},"setIdx":0,"setId":0,"iconIdx":87},{"icon":{"paths":["M96 256c0-88.372 71.628-160 160-160h512c88.371 0 160 71.628 160 160v128c0 17.673-14.327 32-32 32s-32-14.327-32-32v-128c0-53.026-42.974-96-96-96h-512c-53.026 0-96 42.974-96 96v469.333c0 53.026 42.974 96 96 96h85.333c17.673 0 32 14.327 32 32s-14.327 32-32 32h-85.333c-88.372 0-160-71.629-160-160v-469.333z","M771.089 556.919c-20.122-35.75-71.471-35.691-91.49 0.004l-128.742 228.813c-19.703 35.034 5.594 78.263 45.751 78.263h257.408c40.162 0 65.476-43.234 45.794-78.306l-128.721-228.774zM623.791 525.598c44.501-79.313 158.511-79.249 203.072-0.064l128.725 228.779c43.618 77.653-12.378 173.687-101.572 173.687h-257.408c-89.122 0-145.229-95.949-101.534-173.641l128.717-228.762z","M725.333 592.981c17.673 0 32 14.327 32 32v77.525c0 17.673-14.327 32-32 32s-32-14.327-32-32v-77.525c0-17.673 14.327-32 32-32z","M689.493 792.175c-0.226-20.019 15.996-36.164 35.797-36.164 20.036 0 35.84 16.307 35.84 35.84 0 19.298-15.573 35.84-35.797 35.84-19.426 0-35.665-15.633-35.84-35.516zM693.517 791.851h-4.023c0 0.107 0 0.218 0 0.324zM753.489 791.258l0.004 0.533c0-0.085 0-0.175 0-0.265-0.004-0.090-0.004-0.179-0.004-0.269z","M266.667 320c0-17.673 14.327-32 32-32h426.667c17.673 0 32 14.327 32 32s-14.327 32-32 32h-426.667c-17.673 0-32-14.327-32-32z","M266.667 512c0-17.673 14.327-32 32-32h170.667c17.673 0 32 14.327 32 32s-14.327 32-32 32h-170.667c-17.673 0-32-14.327-32-32z"],"attrs":[],"tags":["disclaimer"],"grid":24,"isMulticolor":false,"isMulticolor2":false,"colorPermutations":{"246155111125525525512936511761761561":[],"2323037125525525512936511761761561":[],"10511915011401421681255255255129365114753651761761561":[],"14014216812552552551293651147536515050501761761561":[]}},"attrs":[],"properties":{"order":247,"id":21,"name":"disclaimer","prevSize":24,"code":59787},"setIdx":0,"setId":0,"iconIdx":88},{"icon":{"paths":["M96 512c0-229.75 186.25-416 416-416 229.751 0 416 186.25 416 416 0 229.751-186.249 416-416 416-229.75 0-416-186.249-416-416zM512 160c-194.404 0-352 157.596-352 352 0 194.402 157.596 352 352 352 194.402 0 352-157.598 352-352 0-194.404-157.598-352-352-352z","M597.333 105.585c17.673 0 32 14.327 32 32v225.081c0 17.673-14.327 32-32 32s-32-14.327-32-32v-225.081c0-17.673 14.327-32 32-32z","M597.333 501.333c17.673 0 32 14.327 32 32v353.109c0 17.673-14.327 32-32 32s-32-14.327-32-32v-353.109c0-17.673 14.327-32 32-32z","M657.86 444.527c12.497-12.497 32.759-12.497 45.257 0l187.947 187.947c12.493 12.497 12.493 32.759 0 45.257-12.497 12.493-32.759 12.493-45.257 0l-187.947-187.947c-12.497-12.497-12.497-32.759 0-45.257z","M597.333 394.667c-29.457 0-53.333 23.878-53.333 53.333 0 29.457 23.876 53.333 53.333 53.333s53.333-23.876 53.333-53.333c0-29.455-23.876-53.333-53.333-53.333zM480 448c0-64.801 52.531-117.333 117.333-117.333s117.333 52.532 117.333 117.333c0 64.802-52.531 117.333-117.333 117.333s-117.333-52.531-117.333-117.333z","M536.747 444.356c12.506 12.489 12.518 32.751 0.026 45.257l-130.158 130.308c-12.49 12.506-32.751 12.518-45.255 0.026-12.504-12.489-12.516-32.751-0.026-45.252l130.161-130.313c12.489-12.501 32.747-12.514 45.252-0.026z","M276.039 489.374c12.497-12.497 32.758-12.497 45.255 0l85.307 85.308c12.497 12.497 12.51 32.742 0.013 45.239-12.49 12.506-32.751 12.518-45.255 0.026l-85.321-85.321c-12.497-12.497-12.497-32.755 0-45.252z","M321.294 489.374c12.497 12.497 12.497 32.755 0 45.252l-143.101 143.104c-12.497 12.497-32.758 12.497-45.255 0s-12.497-32.759 0-45.257l143.101-143.1c12.497-12.497 32.758-12.497 45.255 0z"],"attrs":[],"tags":["market-insight"],"grid":24,"isMulticolor":false,"isMulticolor2":false,"colorPermutations":{"246155111125525525512936511761761561":[],"2323037125525525512936511761761561":[],"10511915011401421681255255255129365114753651761761561":[],"14014216812552552551293651147536515050501761761561":[]}},"attrs":[],"properties":{"order":248,"id":22,"name":"market-insight","prevSize":24,"code":59788},"setIdx":0,"setId":0,"iconIdx":89},{"icon":{"paths":["M431.117 267.102c17.434 2.906 29.21 19.393 26.304 36.826l-13.995 83.968c-2.573 15.43-15.923 26.739-31.565 26.739h-84.395c-17.673 0-32-14.327-32-32s14.327-32 32-32h57.286l9.538-57.229c2.906-17.433 19.393-29.209 36.826-26.304z","M596.706 267.102c17.434 2.906 29.21 19.393 26.304 36.826l-7.787 46.707h48.243c17.673 0 32 14.327 32 32s-14.327 32-32 32h-86.016c-9.408 0-18.338-4.139-24.418-11.316s-8.691-16.666-7.147-25.945l13.995-83.968c2.906-17.433 19.392-29.209 36.826-26.304z","M380.296 377.379c2.569-15.433 15.921-26.745 31.566-26.745h165.589c9.404 0 18.334 4.138 24.414 11.314s8.695 16.663 7.151 25.941l-27.179 163.244c-2.569 15.433-15.919 26.743-31.565 26.743h-165.589c-9.405 0-18.335-4.139-24.415-11.315s-8.695-16.661-7.151-25.941l27.179-163.241zM438.976 414.635l-16.525 99.243h100.707l16.525-99.243h-100.706z","M266.667 545.877c0-17.673 14.327-32 32-32h86.016c9.406 0 18.336 4.139 24.416 11.315s8.695 16.666 7.148 25.946l-13.995 83.968c-2.906 17.434-19.393 29.21-36.826 26.304s-29.209-19.392-26.304-36.826l7.785-46.707h-48.241c-17.673 0-32-14.327-32-32z","M518.707 540.617c2.573-15.428 15.923-26.739 31.565-26.739h84.395c17.673 0 32 14.327 32 32s-14.327 32-32 32h-57.289l-9.536 57.229c-2.906 17.434-19.392 29.21-36.826 26.304s-29.21-19.392-26.304-36.826l13.995-83.968z","M486.417 160c-180.28 0-326.417 146.137-326.417 326.417s146.137 326.417 326.417 326.417c180.279 0 326.417-146.138 326.417-326.417s-146.138-326.417-326.417-326.417zM486.417 876.834c-215.626 0-390.417-174.793-390.417-390.417 0-215.626 174.791-390.417 390.417-390.417 215.625 0 390.417 174.791 390.417 390.417 0 215.625-174.793 390.417-390.417 390.417z","M717.372 717.372c12.497-12.497 32.759-12.497 45.257 0l155.998 156.002c12.497 12.497 12.497 32.755 0 45.252s-32.755 12.497-45.252 0l-156.002-155.998c-12.497-12.497-12.497-32.759 0-45.257z"],"attrs":[],"tags":["exante-metrics"],"grid":24,"isMulticolor":false,"isMulticolor2":false,"colorPermutations":{"246155111125525525512936511761761561":[],"2323037125525525512936511761761561":[],"10511915011401421681255255255129365114753651761761561":[],"14014216812552552551293651147536515050501761761561":[]}},"attrs":[],"properties":{"order":249,"id":23,"name":"exante-metrics","prevSize":24,"code":59789},"setIdx":0,"setId":0,"iconIdx":90},{"icon":{"paths":["M173.215 160.841c12.497-12.497 32.758-12.497 45.255 0l51.2 51.2c12.497 12.497 12.497 32.758 0 45.255s-32.758 12.497-45.255 0l-51.2-51.2c-12.497-12.497-12.497-32.758 0-45.255zM863.923 174.4c12.548 12.445 12.634 32.706 0.188 45.255l-50.773 51.2c-12.446 12.549-32.704 12.634-45.252 0.189-12.553-12.444-12.634-32.705-0.192-45.254l50.773-51.2c12.446-12.549 32.708-12.634 45.257-0.189zM462.054 314.848c17.429 2.906 29.21 19.393 26.304 36.826l-7.787 46.707h100.706l9.54-57.229c2.906-17.433 19.392-29.209 36.826-26.304 17.429 2.906 29.205 19.393 26.304 36.826l-7.787 46.707h48.243c17.673 0 32 14.327 32 31.998 0 17.677-14.327 32-32 32h-58.906l-16.521 99.243h46.626c17.673 0 32 14.327 32 32 0 17.677-14.327 32-32 32h-57.289l-9.536 57.229c-2.906 17.434-19.396 29.21-36.826 26.304-17.434-2.906-29.21-19.392-26.304-36.826l7.782-46.707h-100.706l-9.536 57.229c-2.906 17.434-19.395 29.21-36.827 26.304s-29.209-19.392-26.304-36.826l7.785-46.707h-48.241c-17.673 0-32-14.323-32-32 0-17.673 14.327-32 32-32h58.903l16.523-99.243h-46.626c-17.673 0-32-14.323-32-32 0-17.671 14.327-31.998 32-31.998h57.286l9.538-57.229c2.907-17.433 19.394-29.209 36.827-26.304zM469.909 462.379l-16.521 99.243h100.706l16.525-99.243h-100.71zM23.896 512c0-17.673 14.327-32 32-32h72.107c17.673 0 32 14.327 32 32 0 17.677-14.327 32-32 32h-72.107c-17.673 0-32-14.323-32-32zM864.004 512c0-17.673 14.323-32 32-32h72.107c17.673 0 32 14.327 32 32 0 17.677-14.327 32-32 32h-72.107c-17.677 0-32-14.323-32-32zM255.922 752.96c12.549 12.446 12.634 32.704 0.189 45.257l-50.773 51.2c-12.444 12.548-32.705 12.634-45.254 0.188s-12.634-32.704-0.189-45.257l50.773-51.2c12.445-12.548 32.706-12.634 45.255-0.188zM754.334 766.707c12.497-12.497 32.759-12.497 45.257 0l51.2 51.2c12.497 12.497 12.497 32.759 0 45.257s-32.759 12.497-45.257 0l-51.2-51.2c-12.497-12.497-12.497-32.759 0-45.257z"],"attrs":[],"tags":["metrics"],"grid":24,"isMulticolor":false,"isMulticolor2":false,"colorPermutations":{"246155111125525525512936511761761561":[],"2323037125525525512936511761761561":[],"10511915011401421681255255255129365114753651761761561":[],"14014216812552552551293651147536515050501761761561":[]}},"attrs":[],"properties":{"order":250,"id":24,"name":"metrics","prevSize":24,"code":59790},"setIdx":0,"setId":0,"iconIdx":91},{"icon":{"paths":["M773.239 53.581c10.155 1.648 18.897 8.078 23.497 17.28l52.126 104.294 104.294 52.127c9.203 4.599 15.633 13.341 17.28 23.496s-1.685 20.481-8.96 27.756l-170.735 170.739c-6.003 5.999-14.144 9.37-22.63 9.37h-157.483l-96.055 96.060c-12.497 12.497-32.759 12.497-45.257 0s-12.497-32.759 0-45.257l96.060-96.056v-157.483c0-8.487 3.371-16.626 9.37-22.627l170.739-170.738c7.275-7.274 17.6-10.607 27.755-8.959zM629.376 394.643h125.483l129.967-129.967-74.121-37.046c-6.195-3.097-11.221-8.121-14.319-14.317l-37.043-74.12-129.967 129.967v125.483zM501.261 167.508c1.084 17.64-12.339 32.817-29.978 33.9-177.578 10.899-314.927 159.964-311.285 337.838 3.642 177.873 146.976 321.19 324.849 324.813s326.925-133.743 337.805-311.322c1.079-17.638 16.256-31.061 33.894-29.982 17.643 1.079 31.066 16.256 29.986 33.894-12.979 211.844-190.793 375.718-402.987 371.396-212.197-4.322-383.19-175.296-387.534-387.49-4.344-212.197 159.507-390.026 371.351-403.028 17.638-1.082 32.815 12.34 33.899 29.98zM501.133 328.836c1.916 17.569-10.769 33.366-28.339 35.284-88.417 9.655-154.375 85.949-151.151 174.832 3.224 88.887 74.536 160.196 163.422 163.422 88.883 3.226 165.175-62.733 174.831-151.151 1.92-17.57 17.715-30.255 35.285-28.339 17.57 1.92 30.255 17.715 28.339 35.285-13.299 121.766-118.366 212.604-240.777 208.162-122.41-4.437-220.619-102.647-225.059-225.058s86.395-227.477 208.163-240.774c17.57-1.919 33.365 10.768 35.285 28.337z"],"attrs":[],"tags":["target"],"grid":24,"isMulticolor":false,"isMulticolor2":false,"colorPermutations":{"246155111125525525512936511761761561":[],"2323037125525525512936511761761561":[],"10511915011401421681255255255129365114753651761761561":[],"14014216812552552551293651147536515050501761761561":[]}},"attrs":[],"properties":{"order":200,"id":25,"name":"target","prevSize":24,"code":59791},"setIdx":0,"setId":0,"iconIdx":92},{"icon":{"paths":["M95.99 127.99c0-17.673 14.327-32 32-32h282.965c8.487 0 16.625 3.371 22.628 9.373 5.999 6.001 9.374 14.14 9.374 22.627v170.667c0 17.673-14.327 32-32.002 32h-282.965c-17.673 0-32-14.327-32-32v-170.667zM159.99 159.99v106.667h218.965v-106.667h-218.965zM105.367 404.033c6.001-6.001 14.14-9.373 22.627-9.373h525.484c17.673 0 32 14.327 32 32v170.668c0 17.673-14.327 32-32 32h-525.484c-17.673 0-32-14.327-32-32v-170.668c0-8.487 3.371-16.626 9.373-22.627zM159.994 458.662v106.667h461.484v-106.667h-461.484zM105.371 702.703c6.001-5.999 14.14-9.37 22.627-9.37h768.002c17.673 0 32 14.323 32 32v170.667c0 17.673-14.327 32-32 32h-768.002c-17.673 0-32-14.327-32-32v-170.667c0-8.491 3.371-16.627 9.373-22.63zM159.998 757.333v106.667h704.002v-106.667h-704.002z"],"attrs":[],"tags":["Factors-exposure"],"grid":24,"isMulticolor":false,"isMulticolor2":false,"colorPermutations":{"246155111125525525512936511761761561":[],"2323037125525525512936511761761561":[],"10511915011401421681255255255129365114753651761761561":[],"14014216812552552551293651147536515050501761761561":[]}},"attrs":[],"properties":{"order":201,"id":26,"name":"Factors-exposure","prevSize":24,"code":59792},"setIdx":0,"setId":0,"iconIdx":93},{"icon":{"paths":["M477.44 832c-104.96 0-203.947-45.653-271.787-125.44-11.52-13.653-9.813-33.707 3.84-45.227s33.707-9.813 45.227 3.84c55.467 65.28 136.533 102.827 222.72 102.827 154.88 0 282.453-119.893 290.133-273.067 0-5.12 0-9.813 0-14.933 0-17.493 14.507-32 32-32s32 14.507 32 32c0 5.973 0 11.947-0.427 18.347-9.387 187.307-165.12 333.653-354.133 333.653h0.427zM166.4 426.667c-2.987 0-5.547 0-8.533-1.28-17.067-4.693-26.88-22.187-22.187-39.253 41.813-151.893 182.613-258.133 341.76-258.133 93.44 0 181.333 35.84 248.32 100.693 12.8 12.373 12.8 32.427 0.853 45.227-12.373 12.8-32.427 12.8-45.227 0.427-54.613-53.333-127.147-82.347-203.52-82.347-130.56 0-245.76 87.040-280.32 211.2-3.84 14.080-16.64 23.467-30.72 23.467h-0.427z","M885.333 917.333c-8.107 0-16.213-2.987-22.613-9.387l-170.667-170.667c-12.373-12.373-12.373-32.853 0-45.227s32.853-12.373 45.227 0l170.667 170.667c12.373 12.373 12.373 32.853 0 45.227-6.4 6.4-14.507 9.387-22.613 9.387z","M610.56 618.667c-28.587 0-55.040-11.093-75.52-31.147-41.387-41.387-41.387-109.227 0-151.040 40.533-40.107 110.507-40.107 151.040 0 41.387 41.813 41.387 109.227 0 151.040-20.053 20.053-46.933 31.147-75.52 31.147zM610.56 469.333c-11.52 0-22.187 4.267-30.293 12.373-16.64 16.64-16.64 43.52 0 60.16 16.213 16.213 44.373 16.213 60.16 0 16.64-16.64 16.64-43.52 0-60.587-8.107-8.107-18.773-12.373-30.293-12.373l0.427 0.427z","M840.96 426.667c-27.307 0-54.613-10.24-75.52-31.147-41.387-41.387-41.387-109.227 0-151.040s109.227-41.387 151.040 0c41.387 41.387 41.387 109.227 0 151.040-20.907 20.907-48.213 31.147-75.52 31.147zM840.96 277.333c-11.093 0-21.76 4.267-30.293 12.373-16.64 16.64-16.64 43.52 0 60.16s43.52 16.64 60.16 0c16.64-16.64 16.64-43.52 0-60.16-8.533-8.107-19.2-12.373-30.293-12.373h0.427z","M149.333 657.067c-28.587 0-55.467-11.093-75.52-31.147s-31.147-46.933-31.147-75.52c0-28.587 11.093-55.467 31.147-75.52 41.387-41.387 109.227-41.387 151.040 0 20.053 20.053 31.147 46.933 31.147 75.52s-11.093 55.467-31.147 75.52c-20.053 20.053-46.933 31.147-75.52 31.147zM149.333 507.733c-11.093 0-21.76 4.267-30.293 12.373s-12.373 18.773-12.373 30.293c0 11.52 4.267 22.187 12.373 30.293 16.213 16.213 44.373 16.213 60.16 0 8.107-8.107 12.373-18.773 12.373-30.293s-4.267-22.187-12.373-30.293c-8.107-8.107-19.2-12.373-30.293-12.373h0.427z","M379.733 512c-27.307 0-54.613-10.24-75.52-31.147-41.387-41.387-41.387-109.227 0-151.040 41.387-41.387 109.227-41.813 151.040 0 41.387 41.387 41.387 109.227 0 151.040-20.907 20.907-48.213 31.147-75.52 31.147zM349.44 375.040c-16.64 16.64-16.64 43.52 0 60.16s43.52 16.64 60.16 0c16.64-16.64 16.64-43.52 0-60.16s-43.52-16.64-60.16 0z","M667.307 496.64c-8.96 0-18.347-3.84-24.747-11.52-11.093-13.653-9.387-33.707 4.267-45.227l116.48-96.853c13.653-11.093 33.707-9.387 45.227 4.267 11.093 13.653 9.387 33.707-4.267 45.227l-116.48 96.853c-5.973 5.12-13.227 7.253-20.48 7.253z","M544 490.667c-4.693 0-9.813-1.28-14.080-3.413l-85.333-42.667c-15.787-8.107-22.187-27.307-14.507-43.093 8.107-15.787 27.307-22.187 43.093-14.507l85.333 42.667c15.787 8.107 22.187 27.307 14.507 43.093-5.547 11.093-17.067 17.493-28.587 17.493l-0.427 0.427z","M202.667 533.333c-11.52 0-23.040-6.4-28.587-17.493-8.107-15.787-1.707-34.987 14.507-43.093l85.333-42.667c15.787-7.68 34.987-1.28 43.093 14.507s1.707 34.987-14.507 43.093l-85.333 42.667c-4.693 2.133-9.387 3.413-14.080 3.413l-0.427-0.427z"],"attrs":[],"tags":["Ex-antevolatilitycontribution"],"grid":24,"isMulticolor":false,"isMulticolor2":false,"colorPermutations":{"246155111125525525512936511761761561":[],"2323037125525525512936511761761561":[],"10511915011401421681255255255129365114753651761761561":[],"14014216812552552551293651147536515050501761761561":[]}},"attrs":[],"properties":{"order":202,"id":27,"name":"Ex-antevolatilitycontribution","prevSize":24,"code":59793},"setIdx":0,"setId":0,"iconIdx":94},{"icon":{"paths":["M836.267 452.267h-234.667c-42.667 0-76.8-34.133-76.8-76.8v-234.667c0-21.333 8.533-42.667 25.6-55.467s38.4-21.333 59.733-17.067v0c153.6 21.333 277.333 145.067 298.667 298.667 4.267 21.333-4.267 42.667-17.067 59.733s-34.133 25.6-55.467 25.6zM601.6 132.267c-4.267 0-4.267 0-4.267 4.267 0 0-4.267 4.267-4.267 8.533v234.667c0 4.267 4.267 8.533 8.533 8.533h234.667c4.267 0 8.533-4.267 8.533-4.267s4.267-4.267 4.267-8.533c-21.333-123.733-123.733-226.133-247.467-243.2v0c0 0 0 0 0 0z","M785.067 797.867c-21.333 0-38.4-8.533-51.2-21.333l-123.733-123.733c-21.333-21.333-29.867-55.467-17.067-81.067 12.8-29.867 38.4-46.933 68.267-46.933h174.933c21.333 0 42.667 8.533 55.467 25.6s21.333 38.4 17.067 59.733c-8.533 55.467-29.867 110.933-64 157.867v0c-12.8 17.067-34.133 25.6-55.467 29.867 0 0-4.267 0-4.267 0zM819.2 750.933v0 0zM661.333 588.8c-4.267 0-8.533 4.267-8.533 8.533s0 8.533 4.267 12.8l123.733 123.733c4.267 4.267 8.533 4.267 8.533 4.267s4.267 0 8.533-4.267c29.867-38.4 46.933-81.067 55.467-128 0-4.267 0-4.267-4.267-8.533 0 0-4.267-4.267-8.533-4.267h-179.2z","M418.133 960c-21.333 0-46.933-4.267-68.267-8.533-140.8-25.6-251.733-136.533-277.333-277.333-17.067-98.133 0-196.267 59.733-277.333 55.467-81.067 140.8-132.267 238.933-145.067 0 0 0 0 0 0 17.067 0 38.4 4.267 55.467 17.067s25.6 34.133 25.6 55.467v260.267c0 4.267 0 4.267 4.267 8.533l183.467 183.467c17.067 17.067 21.333 38.4 21.333 59.733s-12.8 42.667-29.867 55.467c-64 42.667-136.533 68.267-213.333 68.267zM375.467 315.733c-76.8 12.8-149.333 55.467-196.267 119.467s-64 145.067-46.933 226.133c21.333 115.2 115.2 204.8 226.133 226.133 81.067 17.067 166.4-4.267 230.4-51.2 4.267 0 4.267-4.267 4.267-8.533 0 0 0-4.267-4.267-8.533l-179.2-179.2c-12.8-12.8-21.333-34.133-21.333-51.2v-260.267c0-4.267-4.267-8.533-4.267-8.533 0-4.267-4.267-4.267-8.533-4.267v0z"],"attrs":[],"tags":["piechart"],"grid":24,"isMulticolor":false,"isMulticolor2":false,"colorPermutations":{"246155111125525525512936511761761561":[],"2323037125525525512936511761761561":[],"10511915011401421681255255255129365114753651761761561":[],"14014216812552552551293651147536515050501761761561":[]}},"attrs":[],"properties":{"order":203,"id":28,"name":"piechart","prevSize":24,"code":59794},"setIdx":0,"setId":0,"iconIdx":95},{"icon":{"paths":["M853.333 480c17.673 0 32 14.327 32 32v341.333c0 17.673-14.327 32-32 32s-32-14.327-32-32v-341.333c0-17.673 14.327-32 32-32z","M627.2 593.92c17.673 0 32 14.327 32 32v227.413c0 17.673-14.327 32-32 32s-32-14.327-32-32v-227.413c0-17.673 14.327-32 32-32z","M170.667 693.333c17.673 0 32 14.327 32 32v128c0 17.673-14.327 32-32 32s-32-14.327-32-32v-128c0-17.673 14.327-32 32-32z","M396.8 548.267c17.673 0 32 14.327 32 32v273.067c0 17.673-14.327 32-32 32s-32-14.327-32-32v-273.067c0-17.673 14.327-32 32-32z","M653.227 490.722c-28.587 0-55.040-11.093-75.52-31.147-41.387-41.388-41.387-109.228 0-151.042 40.533-40.107 110.507-40.107 151.040 0 41.387 41.813 41.387 109.227 0 151.042-20.053 20.053-46.933 31.147-75.52 31.147zM653.227 341.387c-11.52 0-22.187 4.266-30.293 12.373-16.64 16.64-16.64 43.52 0 60.16 16.213 16.215 44.373 16.215 60.16 0 16.64-16.64 16.64-43.52 0-60.587-8.107-8.107-18.773-12.373-30.293-12.373l0.427 0.427z","M883.627 298.72c-27.307 0-54.613-10.24-75.52-31.147-41.387-41.387-41.387-109.227 0-151.040s109.227-41.387 151.040 0c41.387 41.387 41.387 109.227 0 151.040-20.907 20.907-48.213 31.147-75.52 31.147zM883.627 149.387c-11.093 0-21.76 4.267-30.293 12.373-16.64 16.64-16.64 43.52 0 60.16s43.52 16.64 60.16 0c16.64-16.64 16.64-43.52 0-60.16-8.533-8.107-19.2-12.373-30.293-12.373h0.427z","M192 529.122c-28.587 0-55.467-11.093-75.52-31.147s-31.147-46.933-31.147-75.522c0-28.587 11.093-55.467 31.147-75.52 41.387-41.387 109.227-41.387 151.040 0 20.053 20.053 31.147 46.933 31.147 75.52 0 28.589-11.093 55.469-31.147 75.522s-46.933 31.147-75.52 31.147zM192 379.787c-11.093 0-21.76 4.267-30.293 12.373s-12.373 18.773-12.373 30.293c0 11.522 4.267 22.189 12.373 30.295 16.213 16.213 44.373 16.213 60.16 0 8.107-8.107 12.373-18.773 12.373-30.295 0-11.52-4.267-22.187-12.373-30.293s-19.2-12.373-30.293-12.373h0.427z","M422.4 384.054c-27.307 0-54.613-10.24-75.52-31.147-41.387-41.387-41.387-109.227 0-151.040 41.387-41.387 109.227-41.813 151.040 0 41.387 41.387 41.387 109.227 0 151.040-20.907 20.907-48.213 31.147-75.52 31.147zM392.107 247.093c-16.64 16.64-16.64 43.52 0 60.16s43.52 16.64 60.16 0c16.64-16.64 16.64-43.52 0-60.16s-43.52-16.64-60.16 0z","M709.973 368.694c-8.96 0-18.347-3.84-24.747-11.52-11.093-13.653-9.387-33.707 4.267-45.227l116.48-96.853c13.653-11.093 33.707-9.387 45.227 4.267 11.093 13.653 9.387 33.707-4.267 45.227l-116.48 96.854c-5.973 5.12-13.227 7.253-20.48 7.253z","M586.667 362.72c-4.693 0-9.813-1.28-14.080-3.413l-85.333-42.667c-15.787-8.107-22.187-27.307-14.507-43.094 8.107-15.787 27.307-22.187 43.093-14.507l85.333 42.667c15.787 8.107 22.187 27.307 14.507 43.093-5.547 11.094-17.067 17.493-28.587 17.493l-0.427 0.427z","M245.333 405.387c-11.52 0-23.040-6.4-28.587-17.493-8.107-15.787-1.707-34.987 14.507-43.093l85.333-42.667c15.787-7.68 34.987-1.28 43.093 14.507s1.707 34.987-14.507 43.093l-85.333 42.667c-4.693 2.134-9.387 3.413-14.080 3.413l-0.427-0.427z"],"attrs":[],"tags":["performance"],"grid":24,"isMulticolor":false,"isMulticolor2":false,"colorPermutations":{"246155111125525525512936511761761561":[],"2323037125525525512936511761761561":[],"10511915011401421681255255255129365114753651761761561":[],"14014216812552552551293651147536515050501761761561":[]}},"attrs":[],"properties":{"order":204,"id":29,"name":"performance","prevSize":24,"code":59795},"setIdx":0,"setId":0,"iconIdx":96},{"icon":{"paths":["M381.439 677.547c17.493 0 32-14.507 32-32s-14.507-32-32-32h-144.213c-17.493 0-32 14.507-32 32s14.507 32 32 32h144.213z","M237.225 533.333h144.213c17.493 0 32-14.507 32-32s-14.507-32-32-32h-144.213c-17.493 0-32 14.507-32 32s14.507 32 32 32z","M928.427 853.76h-10.667v-681.815c0-28.587-14.080-55.040-37.547-71.253s-53.333-20.053-79.787-9.813l-274.347 102.827c-33.707 12.8-56.32 45.227-56.32 81.493v51.627c-5.12-0.853-10.667-1.707-16.213-1.707h-16.213v-64c0-44.373-35.841-80.213-80.215-80.213h-16.213v-63.573c0-17.493-14.507-32-32-32s-32 14.507-32 32v64h-16.213c-44.373 0-80.213 35.84-80.213 80.213v64h-16.213c-44.373 0-80.213 35.84-80.213 80.213v448.001h-10.667c-17.493 0-32 14.507-32 32s14.507 32 32 32h854.615c17.493 0 32-14.507 32-32s-14.507-32-32-32h0.427zM533.333 275.199c0-9.387 5.973-17.92 14.933-21.333l274.347-102.827c6.827-2.56 14.933-1.707 20.907 2.56s9.813 11.093 9.813 18.773v681.388h-320v-578.561zM245.332 261.545c0-8.96 7.253-16.213 16.213-16.213h96c8.96 0 16.213 7.253 16.213 16.213v64h-128v-64h-0.427zM149.332 405.759c0-8.96 7.253-16.213 16.213-16.213h288.001c8.96 0 16.213 7.253 16.213 16.213v448.001h-128.001v-40.107c0-17.493-14.507-32-32-32s-32 14.507-32 32v40.107h-128.427v-448.001z","M629.76 747.093c17.493 0 32-14.507 32-32v-339.201c0-17.493-14.507-32-32-32s-32 14.507-32 32v339.201c0 17.493 14.507 32 32 32z","M757.76 747.093c17.493 0 32-14.507 32-32v-339.201c0-17.493-14.507-32-32-32s-32 14.507-32 32v339.201c0 17.493 14.507 32 32 32z"],"attrs":[],"tags":["institutional"],"grid":24,"isMulticolor":false,"isMulticolor2":false,"colorPermutations":{"246155111125525525512936511761761561":[],"2323037125525525512936511761761561":[],"10511915011401421681255255255129365114753651761761561":[],"14014216812552552551293651147536515050501761761561":[]}},"attrs":[],"properties":{"order":205,"id":30,"name":"institutional","prevSize":24,"code":59796},"setIdx":0,"setId":0,"iconIdx":97},{"icon":{"paths":["M802.133 128h-93.867v-51.2c0-17.067-12.8-34.133-34.133-34.133s-34.133 12.8-34.133 34.133v51.2h-277.333v-51.2c0-21.333-12.8-34.133-29.867-34.133s-34.133 12.8-34.133 34.133v51.2h-93.867c-68.267 0-119.467 51.2-119.467 119.467v554.667c0 64 51.2 119.467 119.467 119.467h597.333c64 0 119.467-51.2 119.467-119.467v-554.667c-4.267-68.267-55.467-119.467-119.467-119.467zM853.333 802.133c0 29.867-25.6 51.2-51.2 51.2h-597.333c-29.867 0-51.2-25.6-51.2-51.2v-396.8h699.733v396.8zM853.333 341.333h-704v-93.867c0-29.867 25.6-51.2 51.2-51.2h98.133v51.2c0 17.067 12.8 34.133 34.133 34.133s34.133-12.8 34.133-34.133v-55.467h273.067v51.2c0 17.067 12.8 34.133 34.133 34.133s34.133-12.8 34.133-34.133v-51.2h93.867c29.867 0 51.2 25.6 51.2 51.2v98.133z","M503.467 584.533c21.333 0 42.667-17.067 42.667-42.667 0-21.333-21.333-42.667-42.667-42.667-12.8 0-21.333 4.267-29.867 12.8s-12.8 17.067-12.8 29.867c0 25.6 17.067 42.667 42.667 42.667z","M716.8 584.533c21.333 0 42.667-17.067 42.667-42.667 0-21.333-21.333-42.667-42.667-42.667-12.8 0-21.333 4.267-29.867 12.8s-12.8 17.067-12.8 29.867c0 25.6 17.067 42.667 42.667 42.667z","M290.133 755.2c21.333 0 42.667-17.067 42.667-42.667 0-21.333-21.333-42.667-42.667-42.667-12.8 0-21.333 4.267-29.867 12.8s-12.8 17.067-12.8 29.867c0 25.6 17.067 42.667 42.667 42.667z","M503.467 755.2c21.333 0 42.667-17.067 42.667-42.667 0-21.333-21.333-42.667-42.667-42.667-12.8 0-21.333 4.267-29.867 12.8s-12.8 17.067-12.8 29.867c0 25.6 17.067 42.667 42.667 42.667z"],"attrs":[],"tags":["Calendar-Schedule"],"grid":24,"isMulticolor":false,"isMulticolor2":false,"colorPermutations":{"246155111125525525512936511761761561":[],"2323037125525525512936511761761561":[],"10511915011401421681255255255129365114753651761761561":[],"14014216812552552551293651147536515050501761761561":[]}},"attrs":[],"properties":{"order":206,"id":31,"name":"Calendar-Schedule","prevSize":24,"code":59797},"setIdx":0,"setId":0,"iconIdx":98},{"icon":{"paths":["M499.2 567.467v0c-4.267 0-4.267 0 0 0l-102.4-234.667c0 0 0-4.267-4.267-4.267 0 0 0-4.267-4.267-4.267 0 0-4.267-4.267-8.533-4.267 0 0 0 0-4.267-4.267-4.267 0-4.267 0-8.533 0 0 0-4.267 0-4.267 0s0 0-4.267 0-8.533 0-8.533 0c0 0 0 0-4.267 0s-4.267 4.267-8.533 4.267c0 0-4.267 4.267-4.267 4.267s0 4.267-4.267 4.267l-98.133 230.4c0 0 0 0 0 0l-21.333 51.2c-8.533 17.067 0 34.133 17.067 42.667 4.267 0 8.533 4.267 12.8 4.267 12.8 0 25.6-8.533 29.867-21.333l12.8-29.867h157.867l12.8 29.867c4.267 12.8 17.067 21.333 29.867 21.333 4.267 0 8.533 0 12.8-4.267 17.067-8.533 25.6-25.6 17.067-42.667l-12.8-42.667zM315.733 546.133l51.2-119.467 51.2 119.467h-102.4z","M716.8 85.333h-426.667c-115.2 0-204.8 89.6-204.8 204.8v426.667c0 110.933 89.6 204.8 204.8 204.8h426.667c110.933 0 204.8-89.6 204.8-204.8v-426.667c-4.267-115.2-93.867-204.8-204.8-204.8zM853.333 716.8c0 76.8-64 136.533-136.533 136.533h-426.667c-76.8 0-136.533-64-136.533-136.533v-426.667c-4.267-76.8 59.733-140.8 136.533-140.8h426.667c72.533 0 136.533 64 136.533 140.8v426.667z","M746.667 426.667c-12.8 0-21.333 8.533-25.6 17.067-46.933-25.6-102.4-21.333-140.8 17.067-21.333 21.333-34.133 51.2-34.133 85.333s12.8 59.733 34.133 85.333c21.333 21.333 51.2 34.133 85.333 34.133 21.333 0 42.667-4.267 59.733-17.067 4.267 8.533 17.067 17.067 25.6 17.067 17.067 0 34.133-12.8 34.133-34.133v-170.667c-8.533-21.333-21.333-34.133-38.4-34.133zM699.733 580.267c-21.333 21.333-55.467 21.333-76.8 0-8.533-8.533-17.067-21.333-17.067-38.4s4.267-29.867 17.067-38.4c8.533-8.533 25.6-17.067 38.4-17.067s29.867 4.267 38.4 17.067c21.333 21.333 21.333 59.733 0 76.8z"],"attrs":[],"tags":["Commentary-template"],"grid":24,"isMulticolor":false,"isMulticolor2":false,"colorPermutations":{"246155111125525525512936511761761561":[],"2323037125525525512936511761761561":[],"10511915011401421681255255255129365114753651761761561":[],"14014216812552552551293651147536515050501761761561":[]}},"attrs":[],"properties":{"order":251,"id":32,"name":"Commentary-template","prevSize":24,"code":59798},"setIdx":0,"setId":0,"iconIdx":99},{"icon":{"paths":["M138.521 213.213c0-64.821 52.548-117.369 117.369-117.369h391.5c31.134 0 60.983 12.379 82.987 34.385zM730.377 130.229l120.708 120.708c-0.004-0.001 0 0.001 0 0 22.003 22.002 34.385 51.853 34.385 82.987v178.080c0 17.673-14.323 32-32 32-17.673 0-32-14.327-32-32v-178.080c0-14.144-5.623-27.715-15.633-37.725l-120.717-120.715c-10.010-10.013-23.586-15.64-37.73-15.64h-391.5c-29.475 0-53.369 23.894-53.369 53.369v597.582c0 29.474 23.894 53.367 53.369 53.367h85.369c17.673 0 32 14.327 32 32 0 17.677-14.327 32-32 32h-85.369c-64.821 0-117.369-52.548-117.369-117.367v-597.582z","M437.312 736.098c0-17.673 14.327-32 32-32h128.051c17.677 0 32 14.327 32 32v160.064c0 17.677-14.323 32-32 32h-128.051c-17.673 0-32-14.323-32-32v-160.064zM501.312 768.098v96.064h64.051v-96.064h-64.051z","M565.363 554.688c0-17.673 14.327-32 32-32h128.055c17.673 0 32 14.327 32 32v341.474c0 17.677-14.327 32-32 32h-128.055c-17.673 0-32-14.323-32-32v-341.474zM629.363 586.688v277.474h64.055v-277.474h-64.055z","M693.419 650.726c0-17.673 14.327-32 32-32h128.051c17.677 0 32.004 14.327 32.004 32v245.436c0 17.677-14.327 32-32.004 32h-128.051c-17.673 0-32-14.323-32-32v-245.436zM757.419 682.726v181.436h64.051v-181.436h-64.051z","M309.259 341.266c0-17.673 14.327-32 32-32h298.793c17.673 0 32 14.327 32 32s-14.327 32-32 32h-298.793c-17.673 0-32-14.327-32-32z","M309.259 490.662c0-17.673 14.327-32 32-32h106.711c17.673 0 32 14.327 32 32s-14.327 32-32 32h-106.711c-17.673 0-32-14.327-32-32z"],"attrs":[],"tags":["Report-with-chart"],"grid":24,"isMulticolor":false,"isMulticolor2":false,"colorPermutations":{"246155111125525525512936511761761561":[],"2323037125525525512936511761761561":[],"10511915011401421681255255255129365114753651761761561":[],"14014216812552552551293651147536515050501761761561":[]}},"attrs":[],"properties":{"order":277,"id":33,"name":"Report-with-chart","prevSize":24,"code":59799},"setIdx":0,"setId":0,"iconIdx":100},{"icon":{"paths":["M806.4 251.733l-119.467-119.467c-21.333-21.333-51.2-34.133-81.067-34.133h-307.2c-64-4.267-119.467 51.2-119.467 115.2v597.333c0 64 51.2 119.467 119.467 119.467h426.667c64 0 119.467-51.2 119.467-119.467v-477.867c0-29.867-12.8-59.733-38.4-81.067zM631.467 166.4c4.267 4.267 8.533 4.267 12.8 8.533l119.467 119.467c4.267 4.267 4.267 8.533 8.533 12.8h-132.267c-4.267 0-8.533-4.267-8.533-8.533v-132.267zM776.533 810.667c0 29.867-25.6 51.2-51.2 51.2h-426.667c-29.867 0-51.2-25.6-51.2-51.2v-597.333c0-29.867 25.6-51.2 51.2-51.2h264.533v136.533c0 42.667 34.133 76.8 76.8 76.8h136.533v435.2z","M384 435.2c-42.667 0-76.8 34.133-76.8 76.8v200.533c0 0 0 0 0 0v12.8c0 42.667 34.133 76.8 76.8 76.8h256c42.667 0 76.8-34.133 76.8-76.8v-64c0 0 0 0 0 0v-149.333c0-42.667-34.133-76.8-76.8-76.8h-256zM648.533 725.333c0 4.267-4.267 8.533-8.533 8.533h-256c-4.267 0-8.533-4.267-8.533-8.533l59.733-51.2 29.867 21.333c12.8 8.533 29.867 8.533 42.667-4.267l72.533-72.533 72.533 59.733v46.933zM648.533 512v81.067l-55.467-46.933c-12.8-8.533-29.867-8.533-42.667 4.267l-72.533 76.8-29.867-17.067c-12.8-8.533-25.6-8.533-38.4 4.267l-38.4 34.133v-136.533c0-4.267 4.267-8.533 8.533-8.533h256c8.533 0 12.8 4.267 12.8 8.533z"],"attrs":[],"tags":["image"],"grid":24,"isMulticolor":false,"isMulticolor2":false,"colorPermutations":{"246155111125525525512936511761761561":[],"2323037125525525512936511761761561":[],"10511915011401421681255255255129365114753651761761561":[],"14014216812552552551293651147536515050501761761561":[]}},"attrs":[],"properties":{"order":278,"id":34,"name":"image","prevSize":24,"code":59770},"setIdx":0,"setId":0,"iconIdx":101},{"icon":{"paths":["M810.667 93.867h-426.667c-64 0-119.467 55.467-119.467 119.467v55.467h-51.2c-64-4.267-119.467 51.2-119.467 115.2v256c0 64 51.2 119.467 119.467 119.467h55.467v51.2c0 64 51.2 119.467 119.467 119.467h426.667c64 0 119.467-51.2 119.467-119.467v-597.333c-4.267-64-59.733-119.467-123.733-119.467zM213.333 695.467c-29.867 0-51.2-25.6-51.2-51.2v-260.267c0-29.867 25.6-51.2 51.2-51.2h256c29.867 0 51.2 25.6 51.2 51.2v256c0 29.867-25.6 51.2-51.2 51.2h-256zM866.133 810.667c0 29.867-25.6 55.467-55.467 55.467h-426.667c-29.867 0-55.467-25.6-55.467-55.467v-55.467h140.8c55.467 0 98.133-34.133 110.933-85.333h281.6v140.8zM866.133 610.133h-277.333v-192h277.333v192zM866.133 354.133h-281.6c-12.8-51.2-59.733-89.6-115.2-89.6h-140.8v-51.2c0-29.867 25.6-55.467 55.467-55.467h426.667c29.867 0 55.467 25.6 55.467 55.467v140.8z","M379.733 392.533h-106.667c-17.067 0-29.867 17.067-29.867 34.133v170.667c0 17.067 12.8 34.133 34.133 34.133 17.067 0 34.133-12.8 34.133-34.133v-34.133h76.8c42.667 0 76.8-34.133 76.8-76.8v-17.067c-8.533-42.667-42.667-76.8-85.333-76.8zM392.533 490.667c0 4.267-4.267 12.8-12.8 12.8h-72.533v-42.667h76.8c4.267 0 12.8 4.267 12.8 12.8v17.067z"],"attrs":[],"tags":["ppt"],"grid":24,"isMulticolor":false,"isMulticolor2":false,"colorPermutations":{"246155111125525525512936511761761561":[],"2323037125525525512936511761761561":[],"10511915011401421681255255255129365114753651761761561":[],"14014216812552552551293651147536515050501761761561":[]}},"attrs":[],"properties":{"order":274,"id":35,"name":"ppt","prevSize":24,"code":59771},"setIdx":0,"setId":0,"iconIdx":102},{"icon":{"paths":["M383.942 159.844c-29.475 0-53.369 23.894-53.369 53.369v85.369c0 17.673-14.327 32-32 32s-32-14.327-32-32v-85.369c0-64.821 52.548-117.369 117.369-117.369h426.844c64.819 0 117.367 52.548 117.367 117.369v597.582c0 64.819-52.548 117.367-117.367 117.367h-426.844c-64.821 0-117.369-52.548-117.369-117.367v-85.367c0-17.673 14.327-32 32-32s32 14.327 32 32v85.367c0 29.474 23.894 53.367 53.369 53.367h426.844c29.474 0 53.367-23.893 53.367-53.367v-597.582c0-29.475-23.893-53.369-53.367-53.369h-426.844z","M138.521 383.916c0-64.801 52.532-117.333 117.333-117.333h256.18c64.798 0 117.329 52.532 117.329 117.333v256.177c0 64.802-52.531 117.333-117.333 117.333h-256.176c-64.802 0-117.333-52.531-117.333-117.333v-256.177zM255.854 330.583c-29.455 0-53.333 23.878-53.333 53.333v256.177c0 29.457 23.878 53.333 53.333 53.333h256.176c29.457 0 53.333-23.876 53.333-53.333v-256.177c0-29.455-23.876-53.333-53.329-53.333h-256.18z","M565.363 387.365c0-17.673 14.327-32 32-32h298.79c17.677 0 32 14.327 32 32s-14.323 32-32 32h-298.79c-17.673 0-32-14.327-32-32z","M565.363 640.051c0-17.673 14.327-32 32-32h298.79c17.677 0 32 14.327 32 32s-14.323 32-32 32h-298.79c-17.673 0-32-14.327-32-32z","M597.363 95.844c17.673 0 32 14.327 32 32v768.318c0 17.677-14.327 32-32 32s-32-14.323-32-32v-768.318c0-17.673 14.327-32 32-32z","M301.946 413.007c13.419-11.502 33.62-9.948 45.122 3.471l128.051 149.393c11.503 13.419 9.95 33.621-3.469 45.124-13.419 11.499-33.621 9.946-45.122-3.473l-128.053-149.393c-11.501-13.419-9.947-33.621 3.471-45.123z","M471.65 413.007c13.419 11.502 14.972 31.704 3.469 45.123l-128.051 149.393c-11.502 13.419-31.703 14.972-45.122 3.473-13.418-11.503-14.972-31.706-3.471-45.124l128.053-149.393c11.5-13.419 31.703-14.973 45.122-3.471z"],"attrs":[],"tags":["xls"],"grid":24,"isMulticolor":false,"isMulticolor2":false,"colorPermutations":{"246155111125525525512936511761761561":[],"2323037125525525512936511761761561":[],"10511915011401421681255255255129365114753651761761561":[],"14014216812552552551293651147536515050501761761561":[]}},"attrs":[],"properties":{"order":255,"id":36,"name":"xls","prevSize":24,"code":59772},"setIdx":0,"setId":0,"iconIdx":103},{"icon":{"paths":["M806.4 251.733l-119.467-119.467c-21.333-21.333-51.2-34.133-81.067-34.133h-307.2c-64-4.267-119.467 51.2-119.467 115.2v597.333c0 64 51.2 119.467 119.467 119.467h426.667c64 0 119.467-51.2 119.467-119.467v-477.867c0-29.867-12.8-59.733-38.4-81.067zM631.467 166.4c4.267 4.267 8.533 4.267 12.8 8.533l119.467 119.467c4.267 4.267 4.267 8.533 8.533 12.8h-132.267c-4.267 0-8.533-4.267-8.533-8.533v-132.267zM776.533 810.667c0 29.867-25.6 51.2-51.2 51.2h-426.667c-29.867 0-51.2-25.6-51.2-51.2v-597.333c0-29.867 25.6-51.2 51.2-51.2h264.533v136.533c0 42.667 34.133 76.8 76.8 76.8h136.533v435.2z","M584.533 576c4.267-8.533 8.533-17.067 8.533-29.867v-51.2c0-29.867-25.6-55.467-55.467-55.467h-51.2c-29.867 0-55.467 25.6-55.467 55.467v51.2c0 12.8 4.267 21.333 8.533 29.867l-38.4 64h-34.133c-29.867 0-55.467 25.6-55.467 55.467v51.2c0 29.867 25.6 55.467 55.467 55.467h51.2c29.867 0 55.467-25.6 55.467-55.467v-4.267h76.8v4.267c0 29.867 25.6 55.467 55.467 55.467h51.2c29.867 0 55.467-25.6 55.467-55.467v0-51.2c0-29.867-25.6-55.467-55.467-55.467h-34.133l-38.4-64zM409.6 733.867h-34.133v-34.133h34.133v34.133zM494.933 503.467h34.133v34.133h-34.133v-34.133zM554.667 674.133h-85.333c0-4.267-4.267-12.8-8.533-17.067l38.4-55.467h29.867l38.4 55.467c-8.533 4.267-12.8 12.8-12.8 17.067zM652.8 733.867h-34.133v-34.133h34.133v34.133z"],"attrs":[],"tags":["pdf"],"grid":24,"isMulticolor":false,"isMulticolor2":false,"colorPermutations":{"246155111125525525512936511761761561":[],"2323037125525525512936511761761561":[],"10511915011401421681255255255129365114753651761761561":[],"14014216812552552551293651147536515050501761761561":[]}},"attrs":[],"properties":{"order":276,"id":37,"name":"pdf","prevSize":24,"code":59773},"setIdx":0,"setId":0,"iconIdx":104},{"icon":{"paths":["M213.333 160c-29.474 0-53.333 23.86-53.333 53.333v597.333c0 29.474 23.86 53.333 53.333 53.333h597.333c29.474 0 53.333-23.859 53.333-53.333v-597.333c0-29.474-23.859-53.333-53.333-53.333h-597.333zM96 213.333c0-64.82 52.514-117.333 117.333-117.333h597.333c64.819 0 117.333 52.514 117.333 117.333v597.333c0 64.819-52.514 117.333-117.333 117.333h-597.333c-64.82 0-117.333-52.514-117.333-117.333v-597.333z","M394.667 419.542c0-64.82 52.514-117.333 117.333-117.333s117.333 52.513 117.333 117.333c0 50.952-33.207 77.819-56.311 93.393l-0.038 0.026c-19.524 13.12-28.983 23.671-28.983 41.707v10.667c0 17.673-14.327 32-32 32s-32-14.327-32-32v-10.667c0-51.665 33.617-78.916 57.267-94.814 19.038-12.834 28.066-23.002 28.066-40.311 0-29.474-23.859-53.333-53.333-53.333s-53.333 23.86-53.333 53.333c0 17.672-14.327 32-32 32s-32-14.327-32-32z","M469.333 693.449c-0.107-23.731 19.145-42.782 42.624-42.782 23.522 0 42.709 19.021 42.709 42.667 0 23.561-19.106 42.667-42.667 42.667-23.522 0-42.603-19.042-42.667-42.551z"],"attrs":[],"tags":["Tooltip-questionmark"],"grid":24,"isMulticolor":false,"isMulticolor2":false,"colorPermutations":{"246155111125525525512936511761761561":[],"2323037125525525512936511761761561":[],"10511915011401421681255255255129365114753651761761561":[],"14014216812552552551293651147536515050501761761561":[]}},"attrs":[],"properties":{"order":36,"id":38,"name":"Tooltip-questionmark","prevSize":24,"code":59665},"setIdx":0,"setId":0,"iconIdx":105},{"icon":{"paths":["M512 480c17.673 0 32 14.327 32 32v213.333c0 17.673-14.327 32-32 32s-32-14.327-32-32v-213.333c0-17.673 14.327-32 32-32z","M469.333 352.116c-0.111-23.733 19.145-42.783 42.624-42.783 23.522 0 42.709 19.023 42.709 42.667 0 23.561-19.106 42.667-42.667 42.667-23.522 0-42.603-19.043-42.667-42.551zM481.83 352.141l-12.497 0.090c0-0.038 0-0.077 0-0.116s0-0.077 0-0.116h12.446c0.017 0.047 0.034 0.094 0.051 0.141zM490.667 352.077l-8.836 0.064c4.429 12.355 16.247 21.192 30.127 21.192-11.635 0-21.248-9.424-21.291-21.256zM490.667 352h10.667l-10.667 0.077c0-0.026 0-0.052 0-0.077zM490.667 352c0-11.771 9.523-21.31 21.291-21.333-0.013 0 0.013 0 0 0 11.708 0 21.252 9.423 21.376 21.102 0 0.077 0 0.154 0 0.232-0.038 11.887-9.732 21.31-21.376 21.333zM490.667 352h-8.887z","M213.333 160c-29.474 0-53.333 23.86-53.333 53.333v597.333c0 29.474 23.86 53.333 53.333 53.333h597.333c29.474 0 53.333-23.859 53.333-53.333v-597.333c0-29.474-23.859-53.333-53.333-53.333h-597.333zM96 213.333c0-64.82 52.514-117.333 117.333-117.333h597.333c64.819 0 117.333 52.514 117.333 117.333v597.333c0 64.819-52.514 117.333-117.333 117.333h-597.333c-64.82 0-117.333-52.514-117.333-117.333v-597.333z"],"attrs":[],"tags":["Information"],"grid":24,"isMulticolor":false,"isMulticolor2":false,"colorPermutations":{"246155111125525525512936511761761561":[],"2323037125525525512936511761761561":[],"10511915011401421681255255255129365114753651761761561":[],"14014216812552552551293651147536515050501761761561":[]}},"attrs":[],"properties":{"order":269,"id":39,"name":"Information","prevSize":24,"code":59735},"setIdx":0,"setId":0,"iconIdx":106},{"icon":{"paths":["M567.663 120.688c-45.487-18.695-96.623-18.704-142.226 0.007l-237.053 97.050c-23.585 9.641-39.050 32.605-39.050 58.135v186.64c0 197.623 147.588 384.226 347.247 432.619 199.095-48.256 346.411-233.933 347.247-430.929-0.030-0.563-0.043-1.126-0.043-1.69v-186.64c0-25.52-15.351-48.409-39.074-58.144l-237.047-97.047zM907.785 460.762c0.030 0.58 0.047 1.165 0.047 1.758 0 230.609-172.54 444.621-404.233 496.7-4.621 1.037-9.412 1.037-14.033 0-231.694-52.079-404.233-266.091-404.233-496.7v-186.64c0-51.547 31.192-97.893 78.801-117.363l237.008-97.031c61.142-25.084 129.75-25.099 190.823-0.003v0l237.018 97.034c47.667 19.561 78.801 65.801 78.801 117.363v184.882z","M536.589 416c0-17.673-14.323-32-32-32-17.673 0-32 14.327-32 32v56.58h-56.589c-17.673 0-32 14.327-32 32s14.327 32 32 32h56.589v56.593c0 17.673 14.327 32 32 32 17.677 0 32-14.327 32-32v-56.593h56.585c17.673 0 32-14.327 32-32s-14.327-32-32-32h-56.585v-56.58z"],"attrs":[],"tags":["score"],"grid":24,"isMulticolor":false,"isMulticolor2":false,"colorPermutations":{"246155111125525525512936511761761561":[],"2323037125525525512936511761761561":[],"10511915011401421681255255255129365114753651761761561":[],"14014216812552552551293651147536515050501761761561":[]}},"attrs":[],"properties":{"order":257,"id":40,"name":"score","prevSize":24,"code":59774},"setIdx":0,"setId":0,"iconIdx":107},{"icon":{"paths":["M170.667 373.333c-5.879 0-10.667 4.788-10.667 10.667v469.333c0 5.879 4.788 10.667 10.667 10.667h469.333c5.879 0 10.667-4.787 10.667-10.667v-469.333c0-5.879-4.787-10.667-10.667-10.667h-469.333zM96 384c0-41.225 33.442-74.667 74.667-74.667h469.333c41.225 0 74.667 33.442 74.667 74.667v469.333c0 41.225-33.442 74.667-74.667 74.667h-469.333c-41.225 0-74.667-33.442-74.667-74.667v-469.333z","M778.667 128c0-17.673 14.327-32 32-32h42.667c41.225 0 74.667 33.442 74.667 74.667v42.667c0 17.673-14.327 32-32 32s-32-14.327-32-32v-42.667c0-5.879-4.787-10.667-10.667-10.667h-42.667c-17.673 0-32-14.327-32-32z","M896 608c17.673 0 32 14.327 32 32v42.667c0 41.225-33.442 74.667-74.667 74.667h-42.667c-17.673 0-32-14.327-32-32s14.327-32 32-32h42.667c5.879 0 10.667-4.787 10.667-10.667v-42.667c0-17.673 14.327-32 32-32z","M341.333 160c-5.879 0-10.667 4.788-10.667 10.667v42.667c0 17.673-14.327 32-32 32s-32-14.327-32-32v-42.667c0-41.225 33.442-74.667 74.667-74.667h42.667c17.673 0 32 14.327 32 32s-14.327 32-32 32h-42.667z","M522.667 128c0-17.673 14.327-32 32-32h85.333c17.673 0 32 14.327 32 32s-14.327 32-32 32h-85.333c-17.673 0-32-14.327-32-32z","M896 352c17.673 0 32 14.327 32 32v85.333c0 17.673-14.327 32-32 32s-32-14.327-32-32v-85.333c0-17.673 14.327-32 32-32z"],"attrs":[],"tags":["Content Copy"],"grid":24,"isMulticolor":false,"isMulticolor2":false,"colorPermutations":{"246155111125525525512936511761761561":[],"2323037125525525512936511761761561":[],"10511915011401421681255255255129365114753651761761561":[],"14014216812552552551293651147536515050501761761561":[]}},"attrs":[],"properties":{"order":137,"id":41,"name":"Content-Copy","prevSize":24,"code":59733},"setIdx":0,"setId":0,"iconIdx":108},{"icon":{"paths":["M210.536 117.333v115.649h-93.198v-104.983c0-5.891 4.776-10.667 10.667-10.667h82.531zM274.536 117.333h93.187v115.649h-93.187v-115.649zM431.723 117.333h138.103v115.649h-138.103v-115.649zM633.826 117.333h115.657v115.649h-115.657v-115.649zM813.483 117.333h82.522c5.892 0 10.667 4.776 10.667 10.667v107.695c-3.951-1.744-8.316-2.712-12.911-2.712h-80.277v-115.649zM906.671 294.27v165.984c-3.951-1.741-8.316-2.709-12.911-2.709h-80.277v-160.562h80.277c4.595 0 8.96-0.969 12.911-2.712zM906.671 518.831v165.986c-3.951-1.745-8.32-2.714-12.915-2.714h-80.273v-160.559h80.277c4.595 0 8.96-0.969 12.911-2.714zM906.671 743.39v152.61c0 5.892-4.774 10.667-10.667 10.667h-84.343c1.178-3.337 1.822-6.925 1.822-10.667v-149.897h80.273c4.595 0 8.964-0.969 12.915-2.714zM751.3 906.667h-119.296c1.178-3.337 1.822-6.925 1.822-10.667v-149.897h115.657v149.897c0 3.742 0.64 7.33 1.818 10.667zM571.648 906.667h-141.747c1.182-3.337 1.822-6.925 1.822-10.667v-149.897h138.103v149.897c0 3.742 0.64 7.33 1.822 10.667zM369.544 906.667h-96.829c1.179-3.337 1.821-6.925 1.821-10.667v-149.897h93.187v149.897c0 3.742 0.642 7.33 1.821 10.667zM212.357 906.667h-84.352c-5.891 0-10.667-4.774-10.667-10.667v-149.897h93.198v149.897c0 3.742 0.642 7.33 1.821 10.667zM53.338 714.641v181.359c0 41.237 33.43 74.667 74.667 74.667h768c41.237 0 74.667-33.429 74.667-74.667v-768c0-41.237-33.429-74.667-74.667-74.667h-768c-41.237 0-74.667 33.429-74.667 74.667v585.57c-0.003 0.175-0.004 0.354-0.004 0.533s0.001 0.358 0.004 0.538zM117.338 682.103v-160.559h93.198v160.559h-93.198zM117.338 457.545v-160.562h93.198v160.562h-93.198zM274.536 296.983h93.187v160.562h-93.187v-160.562zM431.723 296.983h138.103v160.562h-138.103v-160.562zM633.826 296.983h115.657v160.562h-115.657v-160.562zM749.483 521.545v160.559h-115.657v-160.559h115.657zM569.826 682.103h-138.103v-160.559h138.103v160.559zM367.723 682.103h-93.187v-160.559h93.187v160.559z"],"attrs":[],"tags":["regime-breakdown"],"grid":24,"isMulticolor":false,"isMulticolor2":false,"colorPermutations":{"246155111125525525512936511761761561":[],"2323037125525525512936511761761561":[],"10511915011401421681255255255129365114753651761761561":[],"14014216812552552551293651147536515050501761761561":[]}},"attrs":[],"properties":{"order":258,"id":42,"name":"regime-breakdown","prevSize":24,"code":59763},"setIdx":0,"setId":0,"iconIdx":109},{"icon":{"paths":["M853.333 371.2c17.067 0 29.867-12.8 29.867-29.867v-213.333c0-17.067-12.8-29.867-29.867-29.867h-554.667c-17.067 0-29.867 12.8-29.867 29.867v183.467h-140.8c-17.067 0-29.867 12.8-29.867 29.867v213.333c0 17.067 12.8 29.867 29.867 29.867h140.8v311.467c0 17.067 12.8 29.867 29.867 29.867h554.667c17.067 0 29.867-12.8 29.867-29.867v-341.333c0-17.067-12.8-29.867-29.867-29.867h-55.467v-153.6h55.467zM328.533 157.867h217.6v153.6h-217.6v-153.6zM738.133 371.2v153.6h-260.267v-153.6h260.267zM157.867 524.8v-153.6h260.267v153.6h-260.267zM546.133 866.133h-217.6v-89.6h217.6v89.6zM546.133 716.8h-217.6v-132.267h217.6v132.267zM823.467 866.133h-217.6v-89.6h217.6v89.6zM823.467 584.533v132.267h-217.6v-132.267h217.6zM605.867 311.467v-153.6h217.6v153.6h-217.6z"],"attrs":[],"tags":["table"],"grid":24,"isMulticolor":false,"isMulticolor2":false,"colorPermutations":{"246155111125525525512936511761761561":[],"2323037125525525512936511761761561":[],"10511915011401421681255255255129365114753651761761561":[],"14014216812552552551293651147536515050501761761561":[]}},"attrs":[],"properties":{"order":210,"id":43,"name":"table","prevSize":24,"code":59764},"setIdx":0,"setId":0,"iconIdx":110},{"icon":{"paths":["M831.573 366.421h-157.952v-157.952c-0.021-21.333-8.508-41.789-23.595-56.875s-35.537-23.572-56.875-23.595h-384.683c-21.333 0.022-41.789 8.509-56.875 23.595s-23.572 35.541-23.595 56.875v384.512c-0.022 21.363 8.445 41.86 23.534 56.986 15.092 15.121 35.572 23.633 56.936 23.654h157.952v157.952c0.022 21.333 8.509 41.788 23.595 56.875s35.539 23.573 56.875 23.595h384.683c21.333-0.021 41.788-8.508 56.875-23.595s23.573-35.541 23.595-56.875v-384.512c0.021-21.364-8.444-41.862-23.535-56.984-15.091-15.125-35.571-23.633-56.934-23.656zM208.64 605.355c-3.236 0-6.342-1.284-8.631-3.575-2.286-2.287-3.572-5.393-3.572-8.627v-384.683c0-3.236 1.286-6.339 3.572-8.628 2.289-2.289 5.394-3.575 8.631-3.575h384.341c3.264-0.044 6.413 1.219 8.738 3.514s3.635 5.422 3.635 8.689v157.952h-158.293c-21.393-0.022-41.917 8.466-57.046 23.595s-23.617 35.653-23.595 57.045v158.293h-157.781zM605.355 434.688v158.293c0.047 3.294-1.242 6.468-3.571 8.802-2.33 2.33-5.508 3.618-8.802 3.571h-158.293v-158.293c-0.047-3.294 1.242-6.473 3.575-8.802 2.33-2.33 5.504-3.618 8.798-3.571h158.293zM844.288 831.403c0 3.234-1.284 6.34-3.575 8.631-2.287 2.287-5.393 3.571-8.627 3.571h-385.024c-3.238 0.047-6.357-1.199-8.678-3.452-2.317-2.257-3.648-5.342-3.695-8.58v-157.952h158.293c21.393 0.026 41.916-8.465 57.045-23.595 15.13-15.125 23.616-35.652 23.595-57.041v-158.293h157.952c3.238 0 6.34 1.284 8.627 3.575 2.291 2.287 3.575 5.389 3.575 8.627l0.512 384.508z"],"attrs":[],"isMulticolor":false,"isMulticolor2":false,"colorPermutations":{"761761561771761561":[],"2552552551761761561":[],"246155111125525525512936511761761561":[],"2323037125525525512936511761761561":[],"10511915011401421681255255255129365114753651761761561":[],"14014216812552552551293651147536515050501761761561":[]},"tags":["merge"],"grid":24},"attrs":[],"properties":{"order":182,"id":44,"name":"merge","prevSize":24,"code":59765},"setIdx":0,"setId":0,"iconIdx":111},{"icon":{"paths":["M848 272.001v479.999c0 25.459-10.112 49.882-28.117 67.883-18.001 18.005-42.423 28.117-67.883 28.117h-112c-11.435 0-21.995-6.097-27.712-16-5.717-9.899-5.717-22.097 0-32 5.713-9.899 16.277-16 27.712-16h112c8.486 0 16.627-3.371 22.626-9.374 6.003-5.999 9.374-14.14 9.374-22.626v-479.999c0-8.487-3.371-16.626-9.374-22.627-5.999-6.004-14.14-9.373-22.626-9.373h-112c-11.435 0-21.995-6.1-27.712-16s-5.717-22.1 0-32c5.713-9.9 16.277-16 27.712-16h112c25.459 0 49.882 10.114 67.883 28.116 18.005 18.004 28.117 42.423 28.117 67.884zM544 128.001v767.999c0 11.435-6.101 21.999-16 27.716s-22.101 5.717-32 0c-9.899-5.717-16-16.282-16-27.716v-48h-208c-25.46 0-49.88-10.112-67.884-28.117-18.004-18.001-28.116-42.423-28.116-67.883v-479.999c0-25.46 10.114-49.88 28.116-67.884s42.423-28.116 67.884-28.116h208v-48c0-11.433 6.101-21.996 16-27.714s22.101-5.717 32 0c9.899 5.716 16 16.28 16 27.714zM480 784v-543.999h-208c-8.487 0-16.626 3.37-22.627 9.373-6.003 6-9.373 14.14-9.373 22.627v479.999c0 8.486 3.37 16.627 9.373 22.626 6 6.007 14.14 9.374 22.627 9.374h208z"],"attrs":[],"isMulticolor":false,"isMulticolor2":false,"colorPermutations":{"761761561771761561":[],"2552552551761761561":[],"246155111125525525512936511761761561":[],"2323037125525525512936511761761561":[],"10511915011401421681255255255129365114753651761761561":[],"14014216812552552551293651147536515050501761761561":[]},"tags":["compare"],"grid":24},"attrs":[],"properties":{"order":183,"id":45,"name":"compare","prevSize":24,"code":59766},"setIdx":0,"setId":0,"iconIdx":112},{"icon":{"paths":["M734.033 321.709l-552.788 293.548M734.033 702.302l-552.788-293.551M647.454 512.004h86.579M852.092 512h86.575M309.492 631.778c41.519 40.922 41.519 107.273 0 148.194-41.519 40.926-108.834 40.926-150.353 0-41.519-40.922-41.519-107.273 0-148.194s108.834-40.922 150.353 0zM309.492 244.026c41.519 40.923 41.519 107.273 0 148.196-41.519 40.922-108.834 40.922-150.353 0-41.519-40.923-41.519-107.273 0-148.196s108.834-40.923 150.353 0z"],"attrs":[{"fill":"none","strokeLinejoin":"round","strokeLinecap":"round","strokeMiterlimit":"4","strokeWidth":61.44}],"isMulticolor":false,"isMulticolor2":false,"colorPermutations":{"761761561771761561":[{}],"2552552551761761561":[{}],"246155111125525525512936511761761561":[{"s":0}],"2323037125525525512936511761761561":[{}],"10511915011401421681255255255129365114753651761761561":[{"s":0}],"14014216812552552551293651147536515050501761761561":[{}]},"tags":["separate"],"grid":24},"attrs":[{"fill":"none","strokeLinejoin":"round","strokeLinecap":"round","strokeMiterlimit":"4","strokeWidth":61.44}],"properties":{"order":401,"id":46,"name":"separate","prevSize":24,"code":59877},"setIdx":0,"setId":0,"iconIdx":113},{"icon":{"paths":["M96.295 214.204v0.007l4.437 597.33v0.004c0.472 64.478 52.872 116.454 117.332 116.454h592.256c64.819 0 117.333-52.514 117.333-117.333v-476.672c0-31.11-12.382-60.964-34.377-82.958l-120.661-120.661c-21.986-21.988-51.797-34.375-82.957-34.375h-476.032c-65.124 0-117.802 53.039-117.332 118.204zM330.667 864v-297.131c0-12.621 10.249-22.869 22.869-22.869h316.971c12.561 0 22.827 10.231 22.827 22.869v297.131h-362.667zM757.333 864v-297.131c0-47.949-38.886-86.869-86.827-86.869h-316.971c-47.966 0-86.869 38.903-86.869 86.869v297.131h-48.602c-29.319 0-53.121-23.629-53.334-52.928v-0.004l-4.437-597.325v-0.007c-0.212-29.639 23.739-53.736 53.334-53.736h95.404v134.784c0 41.225 33.442 74.667 74.667 74.667h255.999c41.225 0 74.667-33.442 74.667-74.667v-128.71c4.749 2.484 9.135 5.693 13.001 9.556l120.661 120.661c10.005 10.006 15.629 23.587 15.629 37.703v476.672c0 29.474-23.859 53.333-53.333 53.333h-52.988zM650.364 294.784c0 5.879-4.787 10.667-10.667 10.667h-255.999c-5.879 0-10.667-4.788-10.667-10.667v-134.784h277.332v134.784z"],"attrs":[],"isMulticolor":false,"isMulticolor2":false,"colorPermutations":{"761761561771761561":[],"2552552551761761561":[],"246155111125525525512936511761761561":[],"2323037125525525512936511761761561":[],"10511915011401421681255255255129365114753651761761561":[],"14014216812552552551293651147536515050501761761561":[]},"tags":["save"],"grid":24},"attrs":[],"properties":{"order":185,"id":47,"name":"save","prevSize":24,"code":59768},"setIdx":0,"setId":0,"iconIdx":114},{"icon":{"paths":["M297.362 297.373c-12.497 12.497-12.497 32.758 0 45.255l169.373 169.373-169.373 169.374c-12.497 12.497-12.497 32.755 0 45.252s32.758 12.497 45.255 0l192-192c12.497-12.497 12.497-32.755 0-45.252l-192-192.001c-12.497-12.497-32.758-12.497-45.255 0z","M96 511.991c0 17.673 14.327 32 32 32h384c17.673 0 32-14.327 32-32 0-17.677-14.327-32-32-32h-384c-17.673 0-32 14.323-32 32z","M746.615 96c-41.237 0-74.667 33.429-74.667 74.667v682.667c0 41.237 33.429 74.667 74.667 74.667h106.667c41.237 0 74.667-33.429 74.667-74.667v-682.667c0-41.237-33.429-74.667-74.667-74.667h-106.667zM735.949 170.667c0-5.891 4.774-10.667 10.667-10.667h106.667c5.892 0 10.667 4.776 10.667 10.667v682.667c0 5.892-4.774 10.667-10.667 10.667h-106.667c-5.892 0-10.667-4.774-10.667-10.667v-682.667z"],"attrs":[],"tags":["ask-position-rightsmall"],"grid":24,"isMulticolor":false,"isMulticolor2":false,"colorPermutations":{"246155111125525525512936511761761561":[],"2323037125525525512936511761761561":[],"10511915011401421681255255255129365114753651761761561":[],"14014216812552552551293651147536515050501761761561":[]}},"attrs":[],"properties":{"order":146,"id":48,"name":"ask-position-rightsmall","prevSize":24,"code":59739},"setIdx":0,"setId":0,"iconIdx":115},{"icon":{"paths":["M297.373 726.639c12.497 12.497 32.758 12.497 45.255 0l169.373-169.374 169.374 169.374c12.497 12.497 32.755 12.497 45.252 0s12.497-32.759 0-45.257l-192-192c-12.497-12.497-32.755-12.497-45.252 0l-192.001 192c-12.497 12.497-12.497 32.759 0 45.257z","M511.991 928c17.673 0 32-14.327 32-32v-384c0-17.673-14.327-32-32-32-17.677 0-32 14.327-32 32v384c0 17.673 14.323 32 32 32z","M96 277.385c0 41.237 33.429 74.667 74.667 74.667h682.667c41.237 0 74.667-33.429 74.667-74.667v-106.667c0-41.237-33.429-74.667-74.667-74.667h-682.667c-41.237 0-74.667 33.429-74.667 74.667v106.667zM170.667 288.052c-5.891 0-10.667-4.776-10.667-10.667v-106.667c0-5.891 4.776-10.667 10.667-10.667h682.667c5.892 0 10.667 4.776 10.667 10.667v106.667c0 5.891-4.774 10.667-10.667 10.667h-682.667z"],"attrs":[],"tags":["expand-ver"],"grid":24,"isMulticolor":false,"isMulticolor2":false,"colorPermutations":{"246155111125525525512936511761761561":[],"2323037125525525512936511761761561":[],"10511915011401421681255255255129365114753651761761561":[],"14014216812552552551293651147536515050501761761561":[]}},"attrs":[],"properties":{"order":154,"id":49,"name":"expand-ver","prevSize":24,"code":59747},"setIdx":0,"setId":0,"iconIdx":116},{"icon":{"paths":["M726.588 297.373c12.493 12.497 12.493 32.758 0 45.255l-169.374 169.373 169.374 169.374c12.493 12.497 12.493 32.755 0 45.252-12.497 12.497-32.759 12.497-45.257 0l-192-192c-12.497-12.497-12.497-32.755 0-45.252l192-192.001c12.497-12.497 32.759-12.497 45.257 0z","M927.949 511.991c0 17.673-14.327 32-32 32h-384c-17.673 0-32-14.327-32-32 0-17.677 14.327-32 32-32h384c17.673 0 32 14.323 32 32z","M277.333 96c41.237 0 74.667 33.429 74.667 74.667v682.667c0 41.237-33.429 74.667-74.667 74.667h-106.667c-41.237 0-74.667-33.429-74.667-74.667v-682.667c0-41.237 33.429-74.667 74.667-74.667h106.667zM288 170.667c0-5.891-4.776-10.667-10.667-10.667h-106.667c-5.891 0-10.667 4.776-10.667 10.667v682.667c0 5.892 4.776 10.667 10.667 10.667h106.667c5.891 0 10.667-4.774 10.667-10.667v-682.667z"],"attrs":[],"tags":["ask-positionleftsmall"],"grid":24,"isMulticolor":false,"isMulticolor2":false,"colorPermutations":{"246155111125525525512936511761761561":[],"2323037125525525512936511761761561":[],"10511915011401421681255255255129365114753651761761561":[],"14014216812552552551293651147536515050501761761561":[]}},"attrs":[],"properties":{"order":145,"id":50,"name":"ask-positionleftsmall","prevSize":24,"code":59738},"setIdx":0,"setId":0,"iconIdx":117},{"icon":{"paths":["M297.373 297.414c12.497-12.497 32.758-12.497 45.255 0l169.373 169.372 169.374-169.372c12.497-12.497 32.755-12.497 45.252 0s12.497 32.758 0 45.255l-192 192c-12.497 12.497-32.755 12.497-45.252 0l-192.001-192c-12.497-12.497-12.497-32.758 0-45.255z","M511.991 96.052c17.673 0 32 14.327 32 32v383.999c0 17.673-14.327 32-32 32-17.677 0-32-14.327-32-32v-383.999c0-17.673 14.323-32 32-32z","M96 746.667c0-41.237 33.429-74.667 74.667-74.667h682.667c41.237 0 74.667 33.429 74.667 74.667v106.667c0 41.237-33.429 74.667-74.667 74.667h-682.667c-41.237 0-74.667-33.429-74.667-74.667v-106.667zM170.667 736c-5.891 0-10.667 4.774-10.667 10.667v106.667c0 5.892 4.776 10.667 10.667 10.667h682.667c5.892 0 10.667-4.774 10.667-10.667v-106.667c0-5.892-4.774-10.667-10.667-10.667h-682.667z"],"attrs":[],"tags":["contract-ver"],"grid":24,"isMulticolor":false,"isMulticolor2":false,"colorPermutations":{"246155111125525525512936511761761561":[],"2323037125525525512936511761761561":[],"10511915011401421681255255255129365114753651761761561":[],"14014216812552552551293651147536515050501761761561":[]}},"attrs":[],"properties":{"order":153,"id":51,"name":"contract-ver","prevSize":24,"code":59746},"setIdx":0,"setId":0,"iconIdx":118},{"icon":{"paths":["M885.999 113.491c-23.040-23.040-55.893-32.853-87.467-26.027l-165.973 34.56c-28.16 5.973-55.040 15.787-80.213 29.867-23.467 12.8-45.653 29.013-64.853 48.64l-98.131 98.133-119.467 0.853c-19.627 0-38.4 8.107-52.053 21.76l-116.907 117.332c-13.653 13.653-18.773 33.707-13.653 52.053 5.12 18.773 20.053 32.853 39.253 37.547l119.040 28.16c-4.693 43.093 6.827 86.187 31.147 121.6l-50.347 50.347c-12.373 12.373-12.373 32.853 0 45.227 6.4 6.4 14.507 9.387 22.613 9.387s16.213-2.987 22.613-9.387l50.347-50.347c29.867 20.48 65.707 32 103.68 32 5.971 0 11.945-0.853 17.918-1.28l28.16 119.467c4.267 18.773 18.773 33.707 37.12 38.827 4.693 1.28 9.813 2.133 14.507 2.133 14.080 0 27.733-5.547 37.547-15.787l117.333-117.333c14.080-14.080 21.76-32.427 21.76-52.053l0.853-119.467 98.133-98.133c19.2-19.2 35.413-40.96 48.64-64.853 13.653-24.745 23.893-51.625 29.867-79.785l34.56-165.973c6.4-32-2.987-64.427-26.027-87.467zM811.759 150.184c2.133-0.427 4.693-0.853 6.827-0.853 8.533 0 16.213 3.413 22.613 9.387 7.68 7.68 11.093 18.347 8.533 29.013l-34.56 165.973c-0.853 3.84-2.133 7.253-2.987 10.667-51.2-66.56-110.507-125.44-177.067-177.067 3.413-0.853 6.827-2.133 10.667-2.987l165.973-34.56v0.427zM263.494 366.504c0 0 4.693-2.987 7.253-2.987h58.453c-31.573 37.973-55.893 81.918-70.827 130.558l-98.987-23.467 104.107-104.105zM633.412 735.996l-104.107 104.107-23.467-98.56c47.787-14.507 92.587-37.973 130.987-69.973v57.173c-0.427 2.56-1.707 5.547-3.84 7.253h0.427zM618.479 602.449c-46.933 46.933-108.373 77.653-177.067 87.893-25.171 3.84-50.771-1.707-72.958-13.653l204.798-204.8c12.373-12.373 12.373-32.853 0-45.225-12.373-12.373-32.853-12.373-45.227 0l-204.798 204.798c-11.947-22.187-17.493-48.64-13.227-75.947 9.813-65.28 40.533-127.147 87.467-174.078l136.105-136.107c10.667-10.667 22.613-20.053 35.413-28.16 82.773 59.307 154.88 130.987 213.76 213.758-8.107 12.373-17.493 24.747-28.16 35.413l-136.107 136.107z"],"attrs":[],"tags":["Rocket"],"grid":24,"isMulticolor":false,"isMulticolor2":false,"colorPermutations":{"246155111125525525512936511761761561":[],"2323037125525525512936511761761561":[],"10511915011401421681255255255129365114753651761761561":[],"14014216812552552551293651147536515050501761761561":[]}},"attrs":[],"properties":{"order":147,"id":52,"name":"Rocket","prevSize":24,"code":59740},"setIdx":0,"setId":0,"iconIdx":119},{"icon":{"paths":["M256 224c17.673 0 32 14.327 32 32v544c0 35.716 28.181 64 63.189 64h320c35.678 0 64.811-28.996 64.811-64v-544c0-17.673 14.327-32 32-32s32 14.327 32 32v544c0 71.066-58.505 128-128.811 128h-320c-71.061 0-127.189-57.647-127.189-128v-544c0-17.673 14.327-32 32-32z","M160 256c0-17.673 14.327-32 32-32h640c17.673 0 32 14.327 32 32s-14.327 32-32 32h-640c-17.673 0-32-14.327-32-32z","M394.667 128c0-17.673 14.327-32 32-32h170.667c17.673 0 32 14.327 32 32s-14.327 32-32 32h-170.667c-17.673 0-32-14.327-32-32z","M597.333 394.667c17.673 0 32 14.327 32 32v298.667c0 17.673-14.327 32-32 32s-32-14.327-32-32v-298.667c0-17.673 14.327-32 32-32z","M426.667 394.667c17.673 0 32 14.327 32 32v298.667c0 17.673-14.327 32-32 32s-32-14.327-32-32v-298.667c0-17.673 14.327-32 32-32z"],"attrs":[],"tags":["Delete"],"grid":24,"isMulticolor":false,"isMulticolor2":false,"colorPermutations":{"246155111125525525512936511761761561":[],"2323037125525525512936511761761561":[],"10511915011401421681255255255129365114753651761761561":[],"14014216812552552551293651147536515050501761761561":[]}},"attrs":[],"properties":{"order":38,"id":53,"name":"Delete","prevSize":24,"code":59667},"setIdx":0,"setId":0,"iconIdx":120},{"icon":{"paths":["M704.073 248.462c-4.143-4.143-10.893-4.143-15.036 0l-440.635 440.635c-1.95 1.941-3.068 4.599-3.068 7.437v82.133h82.133c2.837 0 5.495-1.118 7.435-3.068l0.062-0.064 440.618-440.531c0-0.001 0 0.001 0 0 4.139-4.143 4.143-10.891 0-15.033l-71.509-71.509zM643.785 203.207c29.137-29.137 76.403-29.137 105.54 0l71.509 71.509c29.137 29.137 29.137 76.406 0 105.543l-440.557 440.473c-0.009 0.009 0.010-0.009 0 0-14.015 14.076-33.048 21.935-52.81 21.935h-114.133c-17.673 0-32-14.327-32-32v-114.133c0-19.759 7.829-38.763 21.901-52.779 0.012-0.009 0.023-0.021 0.034-0.034l440.517-440.514z","M564.041 282.865c12.497-12.497 32.755-12.497 45.252 0l131.84 131.84c12.497 12.499 12.497 32.757 0 45.254s-32.755 12.497-45.252 0l-131.84-131.839c-12.497-12.497-12.497-32.758 0-45.255z"],"attrs":[],"tags":["Edit"],"grid":24,"isMulticolor":false,"isMulticolor2":false,"colorPermutations":{"246155111125525525512936511761761561":[],"2323037125525525512936511761761561":[],"10511915011401421681255255255129365114753651761761561":[],"14014216812552552551293651147536515050501761761561":[]}},"attrs":[],"properties":{"order":114,"id":54,"name":"Edit","prevSize":24,"code":59718},"setIdx":0,"setId":0,"iconIdx":121},{"icon":{"paths":["M298.667 629.333c-76.578 0-138.667 62.089-138.667 138.667 0 17.673-14.327 32-32 32s-32-14.327-32-32c0-111.923 90.743-202.667 202.667-202.667h170.667c111.923 0 202.667 90.743 202.667 202.667 0 17.673-14.327 32-32 32s-32-14.327-32-32c0-76.578-62.089-138.667-138.667-138.667h-170.667z","M650.667 198.443c0-17.673 14.327-32 32-32 76.595 0 138.667 62.071 138.667 138.667s-62.071 138.667-138.667 138.667c-17.673 0-32-14.327-32-32s14.327-32 32-32c41.25 0 74.667-33.417 74.667-74.667s-33.417-74.667-74.667-74.667c-17.673 0-32-14.327-32-32z","M463.983 235.796c44.169 44.172 44.169 115.789 0 159.961-44.173 44.171-115.79 44.171-159.962 0s-44.172-115.789 0-159.961c44.172-44.172 115.789-44.172 159.962 0zM509.235 190.541c-69.163-69.166-181.304-69.166-250.469 0s-69.165 181.305 0 250.47c69.165 69.167 181.306 69.167 250.469 0 69.167-69.166 69.167-181.305 0-250.47z","M693.333 554.667c0-17.673 14.327-32 32-32 111.923 0 202.667 90.743 202.667 202.667 0 17.673-14.327 32-32 32s-32-14.327-32-32c0-76.578-62.089-138.667-138.667-138.667-17.673 0-32-14.327-32-32z"],"attrs":[],"tags":["share"],"grid":24,"isMulticolor":false,"isMulticolor2":false,"colorPermutations":{"246155111125525525512936511761761561":[],"2323037125525525512936511761761561":[],"10511915011401421681255255255129365114753651761761561":[],"14014216812552552551293651147536515050501761761561":[]}},"attrs":[],"properties":{"order":270,"id":55,"name":"share","prevSize":24,"code":59759},"setIdx":0,"setId":0,"iconIdx":122},{"icon":{"paths":["M469.333 53.333c17.673 0 32 14.327 32 32v64.204c24.755 2.159 48.823 6.801 71.945 13.681 16.939 5.041 26.581 22.859 21.542 39.798-5.043 16.939-22.861 26.584-39.799 21.543-17.28-5.142-35.226-8.771-53.687-10.728v61.13c0 17.673-14.327 32-32 32s-32-14.327-32-32v-61.127c-140.042 14.859-251.304 126.121-266.161 266.164h61.123c17.673 0 32 14.327 32 32s-14.327 32-32 32h-61.123c14.857 140.041 126.118 251.307 266.161 266.163v-61.124c0-17.677 14.327-32 32-32s32 14.323 32 32v61.129c18.462-1.958 36.407-5.585 53.687-10.726 16.939-5.043 34.756 4.604 39.799 21.542 5.039 16.939-4.604 34.756-21.542 39.799-23.121 6.878-47.189 11.52-71.945 13.679v64.205c0 17.673-14.327 32-32 32s-32-14.327-32-32v-64.205c-175.417-15.283-315.175-155.046-330.46-330.462h-64.207c-17.673 0-32-14.327-32-32s14.327-32 32-32h64.207c15.285-175.418 155.043-315.177 330.46-330.464v-64.203c0-17.673 14.327-32 32-32zM831.727 434.048c-43.025-43.026-112.802-43.045-155.908 0.009 0 0 0 0.004 0 0.004zM675.819 434.061c-43.021 43.034-43.017 112.853 0.013 155.883 43.034 43.034 112.862 43.034 155.895 0s43.034-112.862 0-155.895zM630.588 388.78c68.079-68.003 178.359-68.021 246.391 0.012 64.397 64.396 67.836 166.719 10.313 235.165l78.746 78.741c12.493 12.497 12.493 32.759 0 45.257-12.497 12.497-32.759 12.497-45.257 0l-83.17-83.17c-66.176 36.335-150.976 26.47-207.036-29.589-68.023-68.023-68.023-178.377 0-246.403l0.013-0.012z"],"attrs":[],"isMulticolor":false,"isMulticolor2":false,"colorPermutations":{"761761561771761561":[],"2552552551761761561":[],"246155111125525525512936511761761561":[],"2323037125525525512936511761761561":[],"10511915011401421681255255255129365114753651761761561":[],"14014216812552552551293651147536515050501761761561":[]},"tags":["focus-detail"],"grid":24},"attrs":[],"properties":{"order":271,"id":56,"name":"focus-detail","prevSize":24,"code":59769},"setIdx":0,"setId":0,"iconIdx":123},{"icon":{"paths":["M182.045 170.667c-29.848 0-54.045 19.103-54.045 42.667s24.197 42.667 54.045 42.667h415.289c29.85 0 54.046-19.103 54.046-42.667s-24.196-42.667-54.046-42.667h-415.289zM182.045 810.667c-29.848 0-54.045 19.102-54.045 42.667s24.197 42.667 54.045 42.667h543.289c29.85 0 54.046-19.102 54.046-42.667s-24.196-42.667-54.046-42.667h-543.289zM128 426.667c0-23.564 24.197-42.667 54.045-42.667h329.955c29.85 0 54.046 19.103 54.046 42.667s-24.196 42.667-54.046 42.667h-329.955c-29.848 0-54.045-19.102-54.045-42.667zM182.045 597.333c-29.848 0-54.045 19.102-54.045 42.667s24.197 42.667 54.045 42.667h702.576c29.85 0 54.046-19.102 54.046-42.667s-24.196-42.667-54.046-42.667h-702.576z"],"attrs":[],"isMulticolor":false,"isMulticolor2":false,"colorPermutations":{"761761561771761561":[],"2552552551761761561":[],"246155111125525525512936511761761561":[],"2323037125525525512936511761761561":[],"10511915011401421681255255255129365114753651761761561":[],"14014216812552552551293651147536515050501761761561":[]},"tags":["commentary-full"],"grid":24},"attrs":[],"properties":{"order":272,"id":57,"name":"commentary-full","prevSize":24,"code":59800},"setIdx":0,"setId":0,"iconIdx":124},{"icon":{"paths":["M183.811 85.333c-53.988 0-98.478 44.49-98.478 98.478v437.65c0 53.99 44.49 98.479 98.478 98.479h62.226l-18.807 182.579c-0.912 9.020 1.94 18.027 7.89 24.858 5.95 6.848 14.478 10.918 23.526 11.264 9.063 0.35 17.866-3.068 24.308-9.451l209.929-209.25h325.491c53.986 0 98.479-44.489 98.479-98.479v-437.65c0-53.988-44.493-98.478-98.479-98.478h-634.565zM183.811 150.991h634.578c18.748 0 32.823 14.072 32.823 32.821v437.65c0 18.748-14.076 32.823-32.823 32.823h-339.17c-8.717-0.030-17.084 3.413-23.253 9.57l-154.203 153.523 12.986-127.189c0.869-9.165-2.157-18.27-8.339-25.105-6.182-6.818-14.941-10.743-24.149-10.799h-98.464c-18.749 0-32.821-14.076-32.821-32.823v-437.65c0-18.749 14.072-32.821 32.821-32.821h0.015zM260.399 227.578c-18.126 0-32.821 14.695-32.821 32.821s14.695 32.821 32.821 32.821h481.403c18.125 0 32.819-14.695 32.819-32.821s-14.694-32.821-32.819-32.821h-481.403zM260.399 369.808c-18.126 0-32.821 14.695-32.821 32.821s14.695 32.822 32.821 32.822h481.403c18.125 0 32.819-14.696 32.819-32.822s-14.694-32.821-32.819-32.821h-481.403zM260.399 512.038c-18.126 0-32.821 14.694-32.821 32.823 0 18.125 14.695 32.819 32.821 32.819h481.403c18.125 0 32.819-14.694 32.819-32.819 0-18.129-14.694-32.823-32.819-32.823h-481.403z"],"attrs":[],"isMulticolor":false,"isMulticolor2":false,"colorPermutations":{"761761561771761561":[],"2552552551761761561":[],"246155111125525525512936511761761561":[],"2323037125525525512936511761761561":[],"10511915011401421681255255255129365114753651761761561":[],"14014216812552552551293651147536515050501761761561":[]},"tags":["commentary-text"],"grid":24},"attrs":[],"properties":{"order":260,"id":58,"name":"commentary-text","prevSize":24,"code":59756},"setIdx":0,"setId":0,"iconIdx":125},{"icon":{"paths":["M141.145 85.333c-53.988 0-98.478 44.49-98.478 98.478v437.65c0 53.99 44.49 98.479 98.478 98.479h62.226l-18.807 182.579c-0.912 9.020 1.94 18.027 7.89 24.858 5.95 6.848 14.478 10.918 23.526 11.264 9.063 0.35 17.866-3.068 24.308-9.451l209.929-209.25h71.62c18.129 0 32.828-14.699 32.828-32.828 0-18.133-14.699-32.828-32.828-32.828h-85.286c-8.717-0.030-17.086 3.413-23.253 9.57l-154.203 153.523 12.986-127.189c0.869-9.165-2.157-18.27-8.339-25.105-6.182-6.818-14.941-10.743-24.149-10.799h-98.464c-18.749 0-32.821-14.076-32.821-32.823v-437.65c0-18.749 14.087-32.821 32.835-32.821h634.578c18.748 0 32.823 14.072 32.823 32.821v124.701c0 18.127 14.694 32.821 32.819 32.821s32.823-14.694 32.823-32.821v-124.701c0-53.988-44.493-98.478-98.479-98.478h-634.565zM810.667 545.067v94.933h-94.929c-18.274 0-33.067 15.433-33.067 34.133s14.793 34.133 33.067 34.133h94.929v112c0 18.274 15.433 33.067 34.133 33.067 18.697 0 34.133-14.793 34.133-33.067v-112h92.228c18.854 0 33.647-15.138 33.647-34.133s-14.793-34.133-33.067-34.133h-92.809v-94.353c0-18.854-15.138-33.647-34.133-33.647-18.999 0-34.133 14.793-34.133 33.067z"],"attrs":[],"isMulticolor":false,"isMulticolor2":false,"colorPermutations":{"761761561771761561":[],"2552552551761761561":[],"246155111125525525512936511761761561":[],"2323037125525525512936511761761561":[],"10511915011401421681255255255129365114753651761761561":[],"14014216812552552551293651147536515050501761761561":[]},"tags":["commentary-add"],"grid":24},"attrs":[],"properties":{"order":261,"id":59,"name":"commentary-add","prevSize":24,"code":59757},"setIdx":0,"setId":0,"iconIdx":126},{"icon":{"paths":["M923.307 424.533c-23.893-32-61.44-49.92-101.12-48.64h-173.653c-3.413 0-6.4-1.28-8.533-3.84-2.133-2.987-3.413-6.827-2.56-10.667l21.333-136.96c5.12-27.733 0-56.32-13.653-80.64-14.080-24.32-36.267-43.093-63.147-52.48-12.373-3.84-24.747-5.973-37.12-5.973-38.4 0-74.667 17.92-97.28 49.067l-129.28 192.427c-14.080-45.227-51.2-67.84-112.64-67.84h-43.52c-80.213 0-119.467 37.547-119.467 115.2v425.387c0 77.227 39.253 115.2 119.467 115.2l43.52-0.427c22.187 3.413 45.227-0.853 64.853-11.52s35.413-27.733 44.8-48.213l93.013 71.68c29.867 23.467 67.413 36.267 105.387 35.413h165.12c34.133 0 67.413-11.52 94.72-32s47.787-49.067 57.6-81.493l104.107-316.16c14.080-35.84 9.387-75.947-11.947-107.52z","M162.133 914.347h43.52c22.187 3.413 45.227-0.853 64.853-11.52s35.413-27.733 44.8-48.213l93.013 71.68c29.867 23.467 67.413 36.267 105.387 35.413h165.12c34.133 0 67.413-11.52 94.72-32s47.787-49.067 57.6-81.493l104.107-316.16c14.080-35.84 9.387-75.947-11.947-107.52-23.893-32-61.44-49.92-101.12-48.64h-173.653c-3.413 0-6.4-1.28-8.533-3.84-2.133-2.987-3.413-6.827-2.56-10.667l21.333-136.96c5.12-27.733 0-56.32-13.653-80.64-14.080-24.32-36.267-43.093-63.147-52.48-12.373-3.84-24.747-5.973-37.12-5.973-38.4 0-74.667 17.92-97.28 49.067l-129.28 192.427c-14.080-45.227-51.2-67.84-112.64-67.84h-43.52c-80.213 0-119.467 37.547-119.467 115.2v425.387c0 77.227 39.253 115.2 119.467 115.2v-0.427zM325.12 433.493l176.64-262.827c6.827-8.533 16.213-14.507 26.453-17.493s21.333-2.987 31.573 0c11.947 4.267 21.76 12.8 28.16 23.467s8.533 23.467 6.4 35.84l-21.76 139.52c-3.84 22.613 2.987 45.653 17.92 63.147 14.507 16.64 35.84 26.453 58.027 26.027h173.653c18.347-1.28 36.267 6.827 48.213 20.907 9.387 14.933 10.667 33.28 3.413 49.067l-104.96 319.147c-6.4 18.773-18.773 35.413-34.56 47.36-16.213 11.947-35.413 18.773-55.467 19.2h-165.12c-22.187 0.427-44.373-6.4-62.72-19.2l-126.293-97.707v-346.027l0.427-0.427zM107.947 374.187c0-38.827 7.253-49.92 54.187-49.92h43.52c46.933 0 54.187 11.093 54.187 49.92v425.387c0 38.827-7.253 49.92-54.187 49.92h-43.52c-46.933 0-54.187-11.093-54.187-49.92v-425.387z"],"attrs":[{"fill":"rgb(76, 176, 156)","opacity":0.5},{"fill":"rgb(76, 176, 156)"}],"isMulticolor":true,"isMulticolor2":true,"colorPermutations":{"761761561771761561":[{"f":0},{"f":0}],"2552552551761761561":[{"f":0},{"f":0}],"246155111125525525512936511761761561":[{"f":1},{"f":1}],"2323037125525525512936511761761561":[{"f":1},{"f":1}],"10511915011401421681255255255129365114753651761761561":[{"f":2},{"f":2}],"14014216812552552551293651147536515050501761761561":[{"f":3},{"f":3}]},"tags":["Thumb-Up-done"],"grid":24},"attrs":[{"fill":"rgb(76, 176, 156)","opacity":0.5},{"fill":"rgb(76, 176, 156)"}],"properties":{"order":264,"id":62,"name":"Thumb-Up-done","prevSize":24,"code":59751,"codes":[59751,59752]},"setIdx":0,"setId":0,"iconIdx":127},{"icon":{"paths":["M62.652 622.545c23.893 32 61.44 49.92 101.12 48.64h173.653c3.413 0 6.4 1.28 8.533 3.84 2.133 2.987 3.413 6.827 2.56 10.667l-21.333 136.96c-5.12 27.733 0 56.32 13.653 80.64 14.080 24.32 36.267 43.093 63.147 52.48 12.373 3.84 24.747 5.973 37.12 5.973 38.4 0 74.667-17.92 97.28-49.067l129.28-192.427c14.080 45.227 51.2 67.84 112.64 67.84h43.52c80.213 0 119.467-37.547 119.467-115.2v-425.387c0-77.227-39.253-115.2-119.467-115.2l-43.52 0.427c-22.187-3.413-45.227 0.853-64.853 11.52s-35.413 27.733-44.8 48.213l-93.013-71.68c-29.867-23.466-67.413-36.267-105.387-35.413h-165.12c-34.133 0-67.413 11.52-94.72 32s-47.787 49.067-57.6 81.493l-104.107 316.16c-14.080 35.84-9.387 75.947 11.947 107.52z","M823.825 132.731h-43.52c-22.187-3.413-45.227 0.853-64.853 11.52s-35.413 27.733-44.8 48.213l-93.013-71.68c-29.867-23.466-67.413-36.267-105.387-35.413h-165.12c-34.133 0-67.413 11.52-94.72 32s-47.787 49.067-57.6 81.493l-104.107 316.16c-14.080 35.84-9.387 75.947 11.947 107.52 23.893 32 61.44 49.92 101.12 48.64h173.653c3.413 0 6.4 1.28 8.533 3.84 2.133 2.987 3.413 6.827 2.56 10.667l-21.333 136.96c-5.12 27.733 0 56.32 13.653 80.64 14.080 24.32 36.267 43.093 63.147 52.48 12.373 3.84 24.747 5.973 37.12 5.973 38.4 0 74.667-17.92 97.28-49.067l129.28-192.427c14.080 45.227 51.2 67.84 112.64 67.84h43.52c80.213 0 119.467-37.547 119.467-115.2v-425.387c0-77.227-39.253-115.2-119.467-115.2v0.427zM660.838 613.585l-176.64 262.827c-6.827 8.533-16.213 14.507-26.453 17.493s-21.333 2.987-31.573 0c-11.947-4.267-21.76-12.8-28.16-23.467s-8.533-23.467-6.4-35.84l21.76-139.52c3.84-22.613-2.987-45.653-17.92-63.147-14.507-16.64-35.84-26.453-58.027-26.027h-173.653c-18.347 1.28-36.267-6.827-48.213-20.907-9.387-14.933-10.667-33.28-3.413-49.067l104.96-319.147c6.4-18.773 18.773-35.413 34.56-47.36 16.213-11.947 35.413-18.773 55.467-19.2h165.12c22.187-0.427 44.373 6.4 62.72 19.2l126.293 97.707v346.027l-0.427 0.427zM878.012 672.892c0 38.827-7.253 49.92-54.187 49.92h-43.52c-46.933 0-54.187-11.093-54.187-49.92v-425.387c0-38.827 7.253-49.92 54.187-49.92h43.52c46.933 0 54.187 11.093 54.187 49.92v425.387z"],"attrs":[{"fill":"rgb(76, 176, 156)","opacity":0.5},{"fill":"rgb(76, 176, 156)"}],"isMulticolor":true,"isMulticolor2":true,"colorPermutations":{"761761561771761561":[{"f":0},{"f":0}],"2552552551761761561":[{"f":0},{"f":0}],"246155111125525525512936511761761561":[{"f":1},{"f":1}],"2323037125525525512936511761761561":[{"f":1},{"f":1}],"10511915011401421681255255255129365114753651761761561":[{"f":2},{"f":2}],"14014216812552552551293651147536515050501761761561":[{"f":3},{"f":3}]},"tags":["Thumb-Down-done"],"grid":24},"attrs":[{"fill":"rgb(76, 176, 156)","opacity":0.5},{"fill":"rgb(76, 176, 156)"}],"properties":{"order":265,"id":63,"name":"Thumb-Down-done","prevSize":24,"code":59753,"codes":[59753,59754]},"setIdx":0,"setId":0,"iconIdx":128},{"icon":{"paths":["M823.906 133.12h-43.52c-22.187-3.413-45.227 0.853-64.853 11.52s-35.413 27.733-44.8 48.213l-93.013-71.68c-30.293-23.893-67.413-36.267-105.813-35.84h-165.12c-34.133 0-67.413 11.52-94.72 32s-47.787 49.067-57.6 81.493l-103.68 316.16c-14.080 35.84-9.387 75.947 11.947 107.52 23.893 32 61.44 49.92 101.12 48.64h173.653c3.413 0 6.4 1.28 8.533 3.84 2.133 2.987 3.413 6.827 2.56 10.667l-21.333 136.96c-5.12 27.733 0 56.32 13.653 80.64 14.080 24.32 36.267 43.093 63.147 52.48 11.947 4.267 24.32 6.4 36.693 6.4 38.4 0 74.667-17.92 97.28-49.067l129.28-192.427c14.080 45.227 51.2 67.84 112.64 67.84h43.52c80.213 0 119.467-37.547 119.467-115.2v-424.96c0-77.227-39.253-115.2-119.467-115.2h0.427zM660.919 613.973l-176.64 262.827c-6.827 8.533-16.213 14.507-26.453 17.493s-21.333 2.987-31.573 0c-11.947-4.267-21.76-12.8-28.16-23.467s-8.533-23.467-6.4-35.84l21.76-139.52c3.84-22.613-2.987-45.653-17.92-63.147-14.507-16.64-35.84-26.453-58.027-26.027h-173.653c-18.347 1.28-36.267-6.827-48.213-20.907-9.387-14.933-10.667-33.28-3.413-49.067l104.96-319.573c6.4-18.773 18.773-35.413 34.56-47.36 16.213-11.947 35.413-18.773 55.467-19.2h165.12c22.187-0.427 44.373 6.4 62.72 19.2l126.293 97.707v346.88h-0.427zM878.093 673.707c0 38.827-7.253 49.92-54.187 49.92h-43.52c-46.933 0-54.187-11.093-54.187-49.92v-425.386c0-38.827 7.253-49.92 54.187-49.92h43.52c46.933 0 54.187 11.093 54.187 49.92v425.386z"],"attrs":[],"isMulticolor":false,"isMulticolor2":false,"colorPermutations":{"761761561771761561":[],"2552552551761761561":[],"246155111125525525512936511761761561":[],"2323037125525525512936511761761561":[],"10511915011401421681255255255129365114753651761761561":[],"14014216812552552551293651147536515050501761761561":[]},"tags":["Thumb-Down"],"grid":24},"attrs":[],"properties":{"order":267,"id":64,"name":"Thumb-Down","prevSize":24,"code":59758},"setIdx":0,"setId":0,"iconIdx":129},{"icon":{"paths":["M162.133 914.347h43.52c22.187 3.413 45.227-0.853 64.853-11.52s35.413-27.733 44.8-48.213l93.013 71.68c29.867 23.467 67.413 36.267 105.387 35.413h165.12c34.133 0 67.413-11.52 94.72-32s47.787-49.067 57.6-81.493l104.107-316.16c14.080-35.84 9.387-75.947-11.947-107.52-23.893-32-61.44-49.92-101.12-48.64h-173.653c-3.413 0-6.4-1.28-8.533-3.84-2.133-2.987-3.413-6.827-2.56-10.667l21.333-136.96c5.12-27.733 0-56.32-13.653-80.64-14.080-24.32-36.267-43.093-63.147-52.48-12.373-3.84-24.747-5.973-37.12-5.973-38.4 0-74.667 17.92-97.28 49.067l-129.28 192.427c-14.080-45.227-51.2-67.84-112.64-67.84h-43.52c-80.213 0-119.467 37.547-119.467 115.2v425.387c0 77.227 39.253 115.2 119.467 115.2v-0.427zM325.12 433.493l176.64-262.827c6.827-8.533 16.213-14.507 26.453-17.493s21.333-2.987 31.573 0c11.947 4.267 21.76 12.8 28.16 23.467s8.533 23.467 6.4 35.84l-21.76 139.52c-3.84 22.613 2.987 45.653 17.92 63.147 14.507 16.64 35.84 26.453 58.027 26.027h173.653c18.347-1.28 36.267 6.827 48.213 20.907 9.387 14.933 10.667 33.28 3.413 49.067l-104.96 319.147c-6.4 18.773-18.773 35.413-34.56 47.36-16.213 11.947-35.413 18.773-55.467 19.2h-165.12c-22.187 0.427-44.373-6.4-62.72-19.2l-126.293-97.707v-346.027l0.427-0.427zM107.947 374.187c0-38.827 7.253-49.92 54.187-49.92h43.52c46.933 0 54.187 11.093 54.187 49.92v425.387c0 38.827-7.253 49.92-54.187 49.92h-43.52c-46.933 0-54.187-11.093-54.187-49.92v-425.387z"],"attrs":[],"isMulticolor":false,"isMulticolor2":false,"colorPermutations":{"761761561771761561":[],"2552552551761761561":[],"246155111125525525512936511761761561":[],"2323037125525525512936511761761561":[],"10511915011401421681255255255129365114753651761761561":[],"14014216812552552551293651147536515050501761761561":[]},"tags":["Thumb-Up"],"grid":24},"attrs":[],"properties":{"order":160,"id":65,"name":"Thumb-Up","prevSize":24,"code":59741},"setIdx":0,"setId":0,"iconIdx":130},{"icon":{"paths":["M507.302 608.427h-83.2l9.813-64c3.413-17.493 0-35.84-8.533-51.2-8.96-15.36-23.040-27.307-39.68-33.28-15.36-5.12-32-5.12-47.36 0-15.36 4.693-28.587 14.507-38.4 27.733l-55.893 83.2c-15.36-17.067-37.973-25.6-60.587-23.467h-22.613c-20.48-2.987-40.96 3.84-55.467 17.92-14.933 14.507-22.187 34.56-19.627 55.040v223.147c-2.133 20.48 5.12 40.533 19.627 55.040 14.933 14.507 35.413 20.907 55.467 17.92h22.613c23.467 2.133 46.507-6.827 61.44-24.747l35.84 27.307c17.92 14.933 40.96 22.613 64.427 22.187h86.613c20.48 0 40.533-6.827 57.173-19.2s28.587-29.44 34.987-49.067l54.187-165.547c8.96-22.613 5.973-48.213-7.68-68.267-14.933-20.053-38.4-31.573-63.573-31.147l0.427 0.427zM199.676 843.093c0 3.84 0 7.68-1.28 11.52-4.693 1.707-9.813 2.133-14.507 1.707h-22.613c-4.693 0-9.387 0-14.080-1.28-1.28-3.84-1.707-7.68-1.707-11.947v-223.147c0-3.84 0-7.68 1.28-11.52 4.693-1.707 9.813-2.133 14.507-1.707h22.613c10.24 0 14.080 2.133 14.080 1.28 1.28 3.84 1.707 8.107 1.707 11.947v223.147zM522.236 687.787l-55.040 168.107c-2.56 7.253-7.253 13.227-13.653 17.92-5.973 4.693-13.653 7.253-21.333 7.253h-86.613c-8.96 0-17.493-2.56-25.173-7.253l-61.44-47.36v-171.52l90.453-134.827c4.267-3.84 10.24-5.547 15.787-4.267 3.413 1.28 5.973 3.84 7.68 6.827s2.56 6.827 1.707 10.24l-11.52 73.387c-2.56 15.36 1.707 31.147 11.947 42.667 10.24 11.947 24.747 18.773 40.533 18.347h90.88c5.547-0.427 11.093 1.707 14.933 5.547 2.133 4.693 2.133 9.813 0 14.507l0.853 0.427zM866.556 110.507h-22.613c-23.467-2.133-46.507 6.827-61.44 24.747l-35.84-27.307c-18.347-14.933-40.96-22.613-64.427-22.613h-86.613c-20.48 0-40.533 6.827-57.173 19.2s-28.587 29.44-34.987 49.067l-54.187 165.547c-8.96 22.613-5.973 48.213 7.68 68.267 14.933 20.053 38.4 31.573 63.573 31.147h83.2l-9.813 64c-3.413 17.493 0 35.84 8.533 51.2 8.96 15.36 23.040 27.307 39.68 33.28 7.68 2.987 15.36 4.267 23.467 4.267 24.32 0 47.36-11.52 61.867-31.573l55.893-83.2c15.36 17.067 37.973 25.6 60.587 23.467h22.613c20.48 2.987 40.96-3.84 55.467-17.92 14.933-14.507 22.187-34.56 19.627-55.040v-223.573c2.133-20.48-5.12-40.533-19.627-55.040-14.933-14.507-35.413-20.907-55.467-17.92zM768.422 371.627l-90.453 134.827c-4.267 3.84-10.24 5.547-15.787 4.267-3.413-1.28-5.973-3.84-7.68-6.827s-2.56-6.827-1.707-10.24l11.52-73.387c2.56-15.36-1.707-31.147-11.947-42.667-10.24-11.947-24.747-18.773-40.533-18.347h-90.88c-5.547 0.427-11.093-1.707-14.933-5.547-2.133-4.693-2.133-9.813 0-14.507l55.040-168.107c2.56-7.253 7.253-13.227 13.653-17.92 5.973-4.693 13.653-7.253 21.333-7.253h86.613c8.96 0 17.493 2.56 25.173 7.253l61.44 47.36v171.093h-0.853zM882.342 407.040c0 3.84 0 7.68-1.28 11.52-4.693 1.707-9.813 2.133-14.507 1.707h-22.613c-4.693 0-9.387 0-14.080-1.28-1.28-3.84-1.707-8.107-1.707-11.947v-223.573c0-3.84 0-7.68 1.28-11.52 4.693-1.707 9.813-2.133 14.507-1.707h22.613c10.24 0 14.507 2.987 14.080 1.28 1.28 3.84 1.707 8.107 1.707 11.947v223.573z"],"attrs":[],"isMulticolor":false,"isMulticolor2":false,"colorPermutations":{"761761561771761561":[],"2552552551761761561":[],"246155111125525525512936511761761561":[],"2323037125525525512936511761761561":[],"10511915011401421681255255255129365114753651761761561":[],"14014216812552552551293651147536515050501761761561":[]},"tags":["Evaluate"],"grid":24},"attrs":[],"properties":{"order":161,"id":66,"name":"Evaluate","prevSize":24,"code":59742},"setIdx":0,"setId":0,"iconIdx":131},{"icon":{"paths":["M629.333 234.667h53.333v53.333c0 17.493 14.507 32 32 32s32-14.507 32-32v-53.333h53.333c17.493 0 32-14.507 32-32s-14.507-32-32-32h-53.333v-53.333c0-17.493-14.507-32-32-32s-32 14.507-32 32v53.333h-53.333c-17.493 0-32 14.507-32 32s14.507 32 32 32zM416 320c-64.853 0-117.333-52.48-117.333-117.333 0-17.493-14.507-32-32-32s-32 14.507-32 32c0 64.853-52.48 117.333-117.333 117.333-17.493 0-32 14.507-32 32s14.507 32 32 32c64.853 0 117.333 52.48 117.333 117.333 0 17.493 14.507 32 32 32s32-14.507 32-32c0-64.853 52.48-117.333 117.333-117.333 17.493 0 32-14.507 32-32s-14.507-32-32-32zM266.667 398.933c-12.8-18.347-28.587-34.133-46.933-46.933 18.347-12.8 34.133-28.587 46.933-46.933 12.8 18.347 28.587 34.133 46.933 46.933-18.347 12.8-34.133 28.587-46.933 46.933zM716.783 462.080c0 93.013 75.52 168.533 168.533 168.533h-0.853c17.493 0 32 14.507 32 32s-14.507 32-32 32c-92.587 0-168.107 75.52-168.107 168.107 0 17.493-14.507 32-32 32s-32-14.507-32-32c0-92.587-75.52-168.107-168.107-168.107-17.493 0-32-14.507-32-32s14.507-32 32-32c93.013 0 168.533-75.52 168.533-168.533 0-17.493 14.507-32 32-32s32 14.507 32 32zM602.010 662.613c34.133 20.053 63.147 48.64 83.2 83.2 20.053-34.56 48.64-63.147 83.2-83.2-34.133-20.053-63.147-48.64-83.2-83.2-20.053 34.56-48.64 63.147-83.2 83.2z"],"attrs":[],"isMulticolor":false,"isMulticolor2":false,"colorPermutations":{"761761561771761561":[],"2552552551761761561":[],"246155111125525525512936511761761561":[],"2323037125525525512936511761761561":[],"10511915011401421681255255255129365114753651761761561":[],"14014216812552552551293651147536515050501761761561":[]},"tags":["sphere-ai"],"grid":24},"attrs":[],"properties":{"order":172,"id":67,"name":"sphere-ai","prevSize":24,"code":59736},"setIdx":0,"setId":0,"iconIdx":132},{"icon":{"paths":["M632.051 409.335c33.118-35.325 51.887-82.794 51.887-131.367 0-105.977-86.11-192.635-192.636-192.635h-20.975c-94.386 0-171.661 76.723-171.661 171.66v637.517c0 24.286 19.871 44.156 44.157 44.156s44.157-19.87 44.157-44.156v-107.081c39.189 30.357 87.208 46.362 137.44 46.362 124.74 0 225.749-101.559 225.749-225.749 0-83.9-45.261-158.967-118.669-198.708h0.55zM524.42 745.481c-75.618 0-137.44-61.82-137.44-137.438v-141.303c5.519 2.206 11.591 3.311 17.111 3.311h120.329c75.618 0 137.438 61.82 137.438 137.438s-61.82 137.438-137.438 137.438v0.555zM491.853 382.289h-87.761c-6.071 0-11.591 1.104-17.111 3.312v-128.607c0-45.813 36.981-82.795 82.792-82.795h20.975c57.404 0 104.324 46.917 104.324 104.321s-46.366 103.769-103.219 104.321v-0.552z"],"attrs":[],"isMulticolor":false,"isMulticolor2":false,"colorPermutations":{"761761561771761561":[],"2552552551761761561":[],"246155111125525525512936511761761561":[],"2323037125525525512936511761761561":[],"10511915011401421681255255255129365114753651761761561":[],"14014216812552552551293651147536515050501761761561":[]},"tags":["beta"],"grid":24},"attrs":[],"properties":{"order":144,"id":68,"name":"beta","prevSize":24,"code":59737},"setIdx":0,"setId":0,"iconIdx":133},{"icon":{"paths":["M546.15 497.067l122.667 120.533c6.4 6.4 9.6 14.046 9.6 22.933s-3.2 16.533-9.6 22.933c-6.4 6.4-13.867 9.6-22.4 9.6s-16-3.2-22.4-9.6l-132.267-130.133c-3.554-3.554-6.046-7.287-7.467-11.2s-2.133-8-2.133-12.267v-182.4c0-9.245 3.021-16.889 9.067-22.933s13.687-9.067 22.933-9.067c9.246 0 16.887 3.022 22.933 9.067s9.067 13.689 9.067 22.933v169.6zM516.284 896c-53.333 0-103.467-10.133-150.4-30.4s-88-47.821-123.2-82.667c-35.2-34.846-62.933-75.733-83.2-122.667s-30.4-97.067-30.4-150.4c0-53.333 10.133-103.111 30.4-149.333s48-86.578 83.2-121.067c35.2-34.489 76.267-61.689 123.2-81.6s97.067-29.867 150.4-29.867c56.887 0 110.754 12.445 161.6 37.333s94.754 59.022 131.733 102.4v-81.067c0-9.245 3.021-16.889 9.067-22.933s13.687-9.067 22.933-9.067c9.246 0 16.887 3.022 22.933 9.067s9.067 13.689 9.067 22.933v157.867c0 9.245-3.021 16.889-9.067 22.933s-13.687 9.067-22.933 9.067h-158.933c-9.246 0-16.887-3.022-22.933-9.067s-9.067-13.689-9.067-22.933c0-9.245 3.021-16.889 9.067-22.933s13.687-9.067 22.933-9.067h80c-31.287-36.267-68.087-65.422-110.4-87.467s-87.646-33.067-136-33.067c-88.887 0-164.978 30.4-228.267 91.2s-94.933 135.289-94.933 223.467c0 90.313 31.289 167.113 93.867 230.4s139.022 94.933 229.334 94.933c82.487 0 152.533-26.667 210.133-80s92.446-119.821 104.533-199.467c1.421-8.533 5.333-15.821 11.733-21.867s13.867-8.713 22.4-8c9.954 0.713 17.6 4.621 22.933 11.733s7.287 15.646 5.867 25.6c-13.513 96-54.933 176-124.267 240s-153.779 96-253.333 96z"],"attrs":[],"isMulticolor":false,"isMulticolor2":false,"colorPermutations":{"761761561771761561":[],"2552552551761761561":[],"246155111125525525512936511761761561":[],"2323037125525525512936511761761561":[],"10511915011401421681255255255129365114753651761761561":[],"14014216812552552551293651147536515050501761761561":[]},"tags":["chathistory"],"grid":24},"attrs":[],"properties":{"order":151,"id":69,"name":"chathistory","prevSize":24,"code":59744},"setIdx":0,"setId":0,"iconIdx":134},{"icon":{"paths":["M877.658 279.893h-132.053v-129.707c0-17.2-6.955-33.696-19.337-45.858-12.386-12.163-29.18-18.995-46.69-18.995h-528.217c-17.511 0-34.306 6.833-46.688 18.995s-19.339 28.658-19.339 45.858v518.827c0.019 6.101 1.79 12.070 5.11 17.229 3.319 5.154 8.052 9.289 13.655 11.921s11.848 3.661 18.018 2.965c6.17-0.7 12.016-3.089 16.864-6.903l144.434-114.385v121.6c0 17.199 6.957 33.694 19.339 45.858s29.177 18.995 46.688 18.995h386.217l154.381 122.492c5.841 4.642 13.12 7.185 20.634 7.215 8.755 0 17.152-3.418 23.343-9.498s9.668-14.327 9.668-22.929v-518.827c0-17.2-6.955-33.696-19.337-45.858s-29.175-18.995-46.69-18.995zM260.924 514.095l-109.564 87.023v-450.931h528.217v356.693h-397.896c-7.556 0-14.883 2.547-20.757 7.215zM877.658 795.682l-109.564-87.027c-5.841-4.642-13.12-7.185-20.634-7.215h-398.018v-129.707h330.135c17.51 0 34.304-6.831 46.69-18.995 12.382-12.164 19.337-28.659 19.337-45.858v-162.133h132.053v450.935z"],"attrs":[],"isMulticolor":false,"isMulticolor2":false,"colorPermutations":{"761761561771761561":[],"2552552551761761561":[],"246155111125525525512936511761761561":[],"2323037125525525512936511761761561":[],"10511915011401421681255255255129365114753651761761561":[],"14014216812552552551293651147536515050501761761561":[]},"tags":["chat"],"grid":24},"attrs":[],"properties":{"order":152,"id":70,"name":"chat","prevSize":24,"code":59745},"setIdx":0,"setId":0,"iconIdx":135},{"icon":{"paths":["M400.688 165.056c7.25-7.253 17.486-11.519 27.724-11.519v0.427c11.085 0 21.747 4.693 29.427 12.799 7.676 8.106 11.511 19.198 10.236 30.291v231.235c0 10.24-4.267 20.48-11.516 27.733-7.253 7.253-17.489 11.52-27.725 11.52h-236.272c-14.074 0-27.295-7.253-34.119-19.627-6.824-11.947-6.824-26.878 0-39.25 7.25-11.946 20.045-19.625 34.119-19.625h140.741l-236.274-235.929c-10.236-10.239-14.074-24.745-10.236-38.397s14.501-24.318 28.148-28.158c13.648-3.413 28.148 0.427 37.958 10.239l236.274 236.355v-140.363c0-10.239 4.265-20.478 11.515-27.731zM689.843 633.929h141.589c14.076 0 26.871-7.68 34.121-19.622 6.822-12.373 6.822-27.307 0-39.253-6.822-12.373-20.045-19.622-34.121-19.622h-236.271c-10.236 0-20.471 4.267-27.725 11.516-7.249 7.253-11.511 17.493-11.511 27.733v236.356c0 14.080 7.676 26.876 19.618 34.129 12.365 6.827 27.294 6.827 39.236 0 12.369-6.827 19.618-20.049 19.618-34.129v-140.365l236.275 236.356c9.809 9.813 24.734 14.080 38.383 10.24 13.645-3.84 24.307-14.507 28.147-28.16 3.84-13.649 0-28.156-10.236-38.396l-237.124-236.783z"],"attrs":[],"isMulticolor":false,"isMulticolor2":false,"colorPermutations":{"761761561771761561":[],"2552552551761761561":[],"246155111125525525512936511761761561":[],"2323037125525525512936511761761561":[],"10511915011401421681255255255129365114753651761761561":[],"14014216812552552551293651147536515050501761761561":[]},"tags":["contract-ori"],"grid":24},"attrs":[],"properties":{"order":155,"id":71,"name":"contract-ori","prevSize":24,"code":59748},"setIdx":0,"setId":0,"iconIdx":136},{"icon":{"paths":["M360.023 163.879h-142.036l236.303 236.064c10.236 9.818 14.076 24.332 10.236 37.992-3.413 13.662-14.076 23.906-27.725 27.746-13.65 3.418-28.152-0.427-37.963-10.244l-235.021-235.21v139.59c0 14.087-7.678 27.32-19.621 34.15-12.369 6.83-27.299 6.83-39.241 0-11.943-7.257-19.621-20.063-19.621-34.15v-235.21c0-10.245 4.265-20.49 11.517-27.747s17.488-11.526 27.725-11.526h235.448c14.076 0 27.299 7.684 34.123 19.636 6.825 12.379 6.825 27.32 0 39.273-7.251 11.953-20.047 19.636-34.123 19.636zM871.45 638.144c7.249-7.253 17.489-11.524 27.725-11.524h0.427c11.089 0 21.325 4.698 29.005 12.809 7.249 8.107 11.089 19.209 9.809 30.306v229.662c0 10.244-4.267 20.489-11.516 27.746-7.253 7.258-17.489 11.524-27.725 11.524h-235.021c-14.076 0-27.298-7.68-34.125-19.635-6.822-12.378-6.822-27.319 0-39.27 7.253-11.955 20.049-19.639 34.125-19.639h140.331l-235.025-235.209c-10.236-9.818-14.076-24.333-10.236-37.995 3.413-13.658 14.076-23.902 27.725-27.746 13.649-3.413 28.151 0.427 37.961 10.244l235.025 235.213v-138.735c0-10.249 4.262-20.493 11.516-27.75z"],"attrs":[],"isMulticolor":false,"isMulticolor2":false,"colorPermutations":{"761761561771761561":[],"2552552551761761561":[],"246155111125525525512936511761761561":[],"2323037125525525512936511761761561":[],"10511915011401421681255255255129365114753651761761561":[],"14014216812552552551293651147536515050501761761561":[]},"tags":["expand-ori"],"grid":24},"attrs":[],"properties":{"order":156,"id":72,"name":"expand-ori","prevSize":24,"code":59749},"setIdx":0,"setId":0,"iconIdx":137},{"icon":{"paths":["M388.267 388.267c-30.293 30.293-46.933 70.4-46.933 113.067s16.64 82.773 46.933 113.067c30.293 30.293 70.4 46.933 113.067 46.933s82.773-16.64 113.067-46.933c30.293-30.293 46.933-70.4 46.933-113.067s-16.64-82.773-46.933-113.067c-62.293-62.293-163.84-62.293-226.133 0zM569.173 569.173c-36.267 36.267-99.413 36.267-135.68 0-18.347-17.92-28.16-42.24-28.16-67.84s9.813-49.92 28.16-67.84c18.773-18.773 43.093-28.16 67.84-28.16s49.067 9.387 67.84 28.16c18.773 18.773 28.16 42.24 28.16 67.84s-9.813 49.92-28.16 67.84z","M827.307 392.533c-8.107 0-15.787-5.12-18.773-11.947l-2.987-8.107c-3.84-9.387-1.707-20.053 5.12-26.88 33.707-33.707 33.707-89.173 0-122.88l-30.72-30.72c-33.707-33.707-89.173-34.133-122.88 0-7.253 7.253-17.92 8.96-28.587 4.693l-5.973-2.56c-7.68-2.987-12.373-10.667-12.373-21.76 0-47.787-38.827-87.040-87.040-87.040h-43.52c-47.787 0-87.040 38.827-87.040 90.027 0 8.107-5.12 15.787-14.080 19.2l-5.973 2.56c-9.387 3.84-20.053 1.707-26.88-5.12-33.707-33.707-89.173-34.133-122.88 0l-30.72 30.72c-33.707 34.133-33.707 89.173 0 122.88 7.253 7.253 8.96 17.493 5.12 26.88l-2.987 7.68c-2.987 7.253-10.667 12.373-21.76 12.373-47.787 0-87.040 38.827-87.040 87.040v43.52c0 47.787 38.827 87.040 90.027 87.040 8.107 0 15.787 5.12 18.773 11.947l2.987 7.68c3.84 9.387 1.707 19.627-5.12 26.88-33.707 33.707-33.707 89.173 0 122.88l30.72 30.72c33.707 33.707 89.173 33.707 122.88 0 7.253-7.253 17.493-9.387 26.88-5.12l7.68 2.987c7.253 2.987 12.373 10.24 12.373 21.76 0 47.787 38.827 87.040 87.040 87.040h43.52c47.787 0 87.040-39.253 87.040-90.027 0-8.107 5.12-15.787 12.373-18.773l7.253-2.987c9.387-3.84 20.053-1.707 27.307 5.12 34.133 33.707 89.173 33.707 122.88 0l30.72-30.72c33.707-33.707 33.707-89.173 0-122.88-7.253-7.253-8.96-17.493-4.267-29.013l2.133-5.547c2.987-7.68 10.24-12.373 21.76-12.373 47.787 0 87.040-39.253 87.040-87.040v-43.52c0-47.787-39.253-87.040-90.027-87.040v0.427zM853.333 523.093c0 12.8-10.24 23.040-26.027 23.040-34.987 0-65.707 20.907-78.507 53.333l-2.133 5.547c-14.080 33.28-6.827 71.253 18.773 96.853 8.96 8.96 8.96 23.467 0 32.427l-30.72 30.72c-8.96 8.96-23.467 8.96-32.427 0-25.6-25.6-63.573-32.853-97.28-18.773l-5.973 2.56c-32 12.8-52.907 43.52-52.907 81.067 0 12.8-10.24 23.040-23.040 23.040h-43.52c-12.8 0-23.040-10.24-23.040-26.027 0-34.987-20.907-65.707-52.907-78.080l-6.4-2.56c-11.093-4.693-23.040-6.827-34.56-6.827-23.040 0-45.653 8.96-62.72 26.027-8.96 8.96-23.467 8.96-32.427 0l-30.72-30.72c-8.96-8.96-8.96-23.467 0-32.427 25.6-25.6 32.853-63.573 19.2-96.853l-2.56-6.4c-12.8-32-43.52-52.907-81.067-52.907-12.8 0-23.040-10.24-23.040-23.040v-43.52c0-12.8 10.24-23.040 26.027-23.040 34.987 0 65.707-20.907 78.507-52.907l2.56-5.973c14.080-33.28 6.827-71.68-18.773-96.853-8.96-8.96-8.96-23.467 0-32.427l30.72-30.72c8.533-8.533 23.893-8.533 32.427 0 25.6 25.6 63.573 32.853 97.28 18.773l5.973-2.56c32-12.8 52.907-43.52 52.907-81.067 0-12.8 10.24-23.040 23.040-23.040h43.52c12.8 0 23.040 10.24 23.040 26.027 0 34.987 20.907 65.707 52.907 78.507l5.973 2.56c33.28 14.080 71.253 6.827 96.853-18.773 8.96-8.96 23.467-8.96 32.427 0l30.72 30.72c8.96 8.96 8.96 23.467 0 32.427-25.6 25.6-32.853 63.573-18.347 98.56l1.707 4.693c12.8 32 43.52 52.907 81.067 52.907 12.8 0 23.040 10.24 23.040 23.040v43.52l0.427-0.853z"],"attrs":[],"tags":["Settings"],"grid":24,"isMulticolor":false,"isMulticolor2":false,"colorPermutations":{"246155111125525525512936511761761561":[],"2323037125525525512936511761761561":[],"10511915011401421681255255255129365114753651761761561":[],"14014216812552552551293651147536515050501761761561":[]}},"attrs":[],"properties":{"order":138,"id":73,"name":"Settings","prevSize":24,"code":59731},"setIdx":0,"setId":0,"iconIdx":138},{"icon":{"paths":["M512 853.333c-23.467 0-43.55-8.35-60.245-25.045-16.725-16.725-25.088-36.821-25.088-60.288s8.363-43.563 25.088-60.288c16.695-16.695 36.779-25.045 60.245-25.045s43.563 8.35 60.288 25.045c16.695 16.725 25.045 36.821 25.045 60.288s-8.35 43.563-25.045 60.288c-16.725 16.695-36.821 25.045-60.288 25.045zM512 597.333c-23.467 0-43.55-8.363-60.245-25.088-16.725-16.695-25.088-36.779-25.088-60.245s8.363-43.563 25.088-60.288c16.695-16.695 36.779-25.045 60.245-25.045s43.563 8.35 60.288 25.045c16.695 16.725 25.045 36.821 25.045 60.288s-8.35 43.55-25.045 60.245c-16.725 16.725-36.821 25.088-60.288 25.088zM512 341.333c-23.467 0-43.55-8.363-60.245-25.088-16.725-16.697-25.088-36.779-25.088-60.245s8.363-43.549 25.088-60.245c16.695-16.725 36.779-25.088 60.245-25.088s43.563 8.363 60.288 25.088c16.695 16.697 25.045 36.779 25.045 60.245s-8.35 43.549-25.045 60.245c-16.725 16.725-36.821 25.088-60.288 25.088z"],"attrs":[],"isMulticolor":false,"isMulticolor2":false,"colorPermutations":{"761761561771761561":[],"2552552551761761561":[],"246155111125525525512936511761761561":[],"2323037125525525512936511761761561":[],"10511915011401421681255255255129365114753651761761561":[],"14014216812552552551293651147536515050501761761561":[]},"tags":["Vertical"],"grid":24},"attrs":[],"properties":{"order":136,"id":74,"name":"Vertical","prevSize":24,"code":59732},"setIdx":0,"setId":0,"iconIdx":139},{"icon":{"paths":["M874.667 690.428v-146.347c0-17.493-14.507-32-32-32s-32 14.507-32 32v138.667h-116.053c-25.173 0-48.213 12.373-62.293 33.28l-17.493 26.027c-2.133 2.987-5.12 4.693-8.96 4.693h-209.92c-3.413 0-6.827-1.707-8.96-4.693l-17.493-26.027c-14.080-20.907-37.12-33.28-62.293-33.28h-115.627v-394.668c0-14.080 5.547-27.733 15.787-37.547 10.24-10.24 23.467-15.787 37.547-15.787h170.667c17.493 0 32-14.507 32-32s-14.507-32-32-32h-170.667c-31.147 0-60.587 12.373-82.773 34.56s-34.56 51.627-34.133 82.773v402.348c-25.173 11.947-42.667 37.547-42.667 66.987v42.667c0 31.147 12.373 60.587 34.56 82.773s51.627 34.56 82.773 34.56h597.76c31.147 0 60.587-12.373 82.773-34.133 22.187-22.187 34.56-51.627 34.56-82.773v-42.667c0-29.867-17.493-55.040-42.667-66.987l-0.427-0.427zM853.333 800.508c0 14.080-5.547 27.733-15.787 37.547-10.24 10.24-23.467 15.787-37.547 15.787h-597.76c-14.080 0-27.733-5.547-37.547-15.787-10.24-10.24-15.787-23.467-15.787-37.547v-42.667c0-5.973 4.693-10.667 10.667-10.667h148.053c3.413 0 6.827 1.707 8.96 4.693l17.493 26.027c14.080 20.907 37.12 33.28 62.293 33.28h210.347c25.173 0 48.213-12.373 62.293-33.28l17.493-26.027c2.133-2.987 5.12-4.693 8.96-4.693h148.053c5.973 0 10.667 4.693 10.667 10.667v42.667h-0.853z","M897.707 102.48c-12.373-11.947-29.013-17.493-46.080-16.64-47.787 1.707-94.72 14.080-137.387 35.413-42.24-21.76-89.173-34.133-136.107-35.84-17.493-0.853-34.133 5.12-46.933 16.64-12.8 11.947-19.627 28.587-19.627 45.653v209.067c0 32.853 26.453 60.16 60.587 61.867 44.373 0.427 87.467 12.801 125.44 35.841 0.427 0 1.28 0 1.707 0.427 4.693 2.56 9.387 4.267 14.933 4.267s10.24-1.707 14.933-4.267c0.427 0 1.28 0 1.707-0.427 37.973-23.040 81.067-35.414 126.72-35.841 32.853-1.707 58.88-28.587 59.307-62.293v-208.213c0-17.067-7.253-33.707-19.627-45.653h0.427zM576 356.774l-0.853-206.933c37.547 1.28 74.24 11.093 107.52 27.733v198.4c-32.853-12.8-67.413-19.627-101.547-19.627-1.707 0-3.413 0-5.12 0v0.427zM746.667 376.4v-199.253c33.707-16.64 69.973-26.453 106.667-29.013l2.56 206.933c-37.547 0.427-74.667 7.68-109.227 21.333z"],"attrs":[],"tags":["Help-center"],"grid":24,"isMulticolor":false,"isMulticolor2":false,"colorPermutations":{"246155111125525525512936511761761561":[],"2323037125525525512936511761761561":[],"10511915011401421681255255255129365114753651761761561":[],"14014216812552552551293651147536515050501761761561":[]}},"attrs":[],"properties":{"order":135,"id":75,"name":"Help-center","prevSize":24,"code":59734},"setIdx":0,"setId":0,"iconIdx":140},{"icon":{"paths":["M266.667 469.333c0-135.476 109.858-245.333 245.333-245.333h5.675c17.673 0 32 14.327 32 32s-14.327 32-32 32h-5.675c-100.13 0-181.333 81.204-181.333 181.333v106.837c0 25.98-14.685 49.609-37.788 61.201l-0.062 0.030-21.402 10.679c-15.983 8.030-26.080 24.375-26.080 42.18 0 26.018 21.086 47.104 47.104 47.104h439.125c26.018 0 47.104-21.086 47.104-47.104 0-17.813-10.074-34.125-26.022-42.108zM752.644 648.154l-21.602-10.782c-23.019-11.627-37.709-35.204-37.709-61.201v-112.341c0-17.673 14.327-32 32-32s32 14.327 32 32v112.341c0 1.638 0.909 3.221 2.53 4.058v0l21.359 10.658c37.628 18.816 61.444 57.293 61.444 99.375 0 61.363-49.741 111.104-111.104 111.104h-439.125c-61.364 0-111.104-49.741-111.104-111.104 0-42.086 23.797-80.533 61.386-99.388l21.458-10.709c1.548-0.781 2.489-2.334 2.489-3.994v-106.837z","M394.667 853.333c0-17.673 14.327-32 32-32h136.533c17.673 0 32 14.327 32 32s-14.327 32-32 32h-136.533c-17.673 0-32-14.327-32-32z","M706.658 96c17.673 0 32 14.327 32 32v40.96c0 17.673-14.327 32-32 32s-32-14.327-32-32v-40.96c0-17.673 14.327-32 32-32z","M706.658 300.802c17.673 0 32 14.327 32 32v40.96c0 17.673-14.327 32-32 32s-32-14.327-32-32v-40.96c0-17.673 14.327-32 32-32z","M572.48 173.385c8.87-15.287 28.45-20.492 43.738-11.625l35.307 20.48c15.287 8.867 20.493 28.449 11.627 43.736-8.87 15.287-28.45 20.492-43.738 11.625l-35.307-20.48c-15.287-8.867-20.493-28.449-11.627-43.736z","M750.165 275.786c8.866-15.287 28.45-20.492 43.738-11.625l35.307 20.48c15.287 8.867 20.493 28.449 11.622 43.736-8.866 15.287-28.446 20.492-43.733 11.625l-35.311-20.48c-15.287-8.867-20.489-28.449-11.622-43.736z","M663.151 275.786c8.866 15.287 3.661 34.869-11.627 43.736l-35.307 20.48c-15.287 8.867-34.867 3.663-43.738-11.625-8.866-15.287-3.661-34.869 11.627-43.736l35.307-20.48c15.287-8.867 34.867-3.663 43.738 11.625z","M840.832 173.385c8.87 15.287 3.665 34.869-11.622 43.736l-35.307 20.48c-15.287 8.867-34.871 3.663-43.738-11.625s-3.665-34.869 11.622-43.736l35.311-20.48c15.287-8.867 34.867-3.663 43.733 11.625z","M741.948 215.591c19.49 19.493 19.49 51.087 0 70.58-19.494 19.493-51.089 19.493-70.579 0-19.494-19.493-19.494-51.087 0-70.58 19.49-19.493 51.085-19.493 70.579 0zM787.2 170.336c-44.484-44.487-116.604-44.487-161.088 0-44.489 44.486-44.489 116.603 0 161.090 44.484 44.486 116.604 44.486 161.088 0 44.489-44.487 44.489-116.603 0-161.090z"],"attrs":[],"tags":["Notification-settings"],"grid":24,"isMulticolor":false,"isMulticolor2":false,"colorPermutations":{"246155111125525525512936511761761561":[],"2323037125525525512936511761761561":[],"10511915011401421681255255255129365114753651761761561":[],"14014216812552552551293651147536515050501761761561":[]}},"attrs":[],"properties":{"order":130,"id":76,"name":"Notification-settings","prevSize":24,"code":59723},"setIdx":0,"setId":0,"iconIdx":141},{"icon":{"paths":["M568.747 287.575h-270.507l52.053-52.907c7.253-7.253 11.52-17.493 11.093-28.16 0-10.24-5.12-20.053-13.227-27.307-8.107-6.4-18.347-9.387-29.013-8.533-8.96 1.28-16.213 5.12-21.76 11.093l-116.053 116.48c-6.827 6.827-10.667 16.213-10.667 26.027 0 9.387 3.84 18.773 10.667 26.027l115.2 115.202c6.827 7.68 16.64 12.373 26.88 12.373 10.667 0 20.48-3.84 27.307-10.667 7.68-7.68 11.52-17.493 11.093-27.307 0-9.813-4.693-20.055-11.947-26.455l-52.053-52.053h265.813c126.72 0 225.707 98.989 225.707 225.282v7.68c0 122.88-101.12 224-224.427 225.707-10.24-1.28-20.907 2.133-29.013 9.813-7.68 7.253-12.373 17.493-11.947 28.16 0 10.667 4.693 20.48 12.8 27.307 6.827 5.973 15.36 9.387 24.747 9.387h2.987c165.547-2.133 299.947-136.533 299.947-299.947v-7.68c0-163.842-131.84-297.389-295.253-299.949l-0.427 0.427z"],"attrs":[],"isMulticolor":false,"isMulticolor2":false,"colorPermutations":{"761761561771761561":[],"2552552551761761561":[],"246155111125525525512936511761761561":[],"2323037125525525512936511761761561":[],"10511915011401421681255255255129365114753651761761561":[],"14014216812552552551293651147536515050501761761561":[]},"tags":["restore"],"grid":24},"attrs":[],"properties":{"order":134,"id":77,"name":"restore","prevSize":24,"code":59729},"setIdx":0,"setId":0,"iconIdx":142},{"icon":{"paths":["M653.286 192h-0.862c-12.254 0-23.556 6.636-29.491 17.367l-317.794 572.534c-12.479 22.477 3.776 50.099 29.491 50.099 12.223 0 23.525-6.635 29.462-17.335l318.65-572.534c12.51-22.479-3.746-50.13-29.461-50.13h0.004zM441.114 284.541c0-51.114-41.429-92.541-92.541-92.541-51.114 0-92.573 41.43-92.573 92.541 0 51.146 41.461 92.573 92.573 92.573 51.114 0 92.541-41.43 92.541-92.573zM666.044 646.874c-51.11 0-92.57 41.434-92.57 92.578 0 51.115 41.463 92.544 92.57 92.544 51.115 0 92.544-41.434 92.544-92.544 0-51.145-41.429-92.578-92.544-92.578z"],"attrs":[{}],"isMulticolor":false,"isMulticolor2":false,"colorPermutations":{"761761561771761561":[{}],"2552552551761761561":[{}],"246155111125525525512936511761761561":[{}],"2323037125525525512936511761761561":[{}],"10511915011401421681255255255129365114753651761761561":[{}],"14014216812552552551293651147536515050501761761561":[{}]},"tags":["Percentile"],"grid":24},"attrs":[{}],"properties":{"order":131,"id":78,"name":"Percentile","prevSize":24,"code":59730},"setIdx":0,"setId":0,"iconIdx":143},{"icon":{"paths":["M806.4 866.133l-238.933-238.933c-21.333 17.067-45.867 30.579-73.6 40.533s-57.246 14.933-88.533 14.933c-77.511 0-143.104-26.837-196.779-80.512-53.703-53.705-80.555-119.309-80.555-196.821 0-77.511 26.851-143.118 80.555-196.821 53.675-53.675 119.267-80.512 196.779-80.512 77.513 0 143.117 26.837 196.821 80.512 53.675 53.703 80.512 119.31 80.512 196.821 0 31.287-4.979 60.8-14.933 88.533s-23.467 52.267-40.533 73.6l240 240c7.821 7.821 11.733 17.421 11.733 28.8s-4.267 21.333-12.8 29.867c-7.821 7.821-17.779 11.733-29.867 11.733s-22.046-3.913-29.867-11.733v0zM405.333 597.333c53.333 0 98.675-18.658 136.021-55.979 37.321-37.346 55.979-82.688 55.979-136.021s-18.658-98.674-55.979-136.021c-37.346-37.319-82.688-55.979-136.021-55.979s-98.674 18.659-136.021 55.979c-37.319 37.347-55.979 82.688-55.979 136.021s18.659 98.675 55.979 136.021c37.347 37.321 82.688 55.979 136.021 55.979z"],"attrs":[],"isMulticolor":false,"isMulticolor2":false,"colorPermutations":{"1911962061761761561":[],"761761561771761561":[],"2552552551761761561":[],"246155111125525525512936511761761561":[],"2323037125525525512936511761761561":[],"10511915011401421681255255255129365114753651761761561":[],"14014216812552552551293651147536515050501761761561":[]},"tags":["Search"],"grid":24},"attrs":[],"properties":{"order":122,"id":80,"name":"Search","prevSize":24,"code":59724},"setIdx":0,"setId":0,"iconIdx":144},{"icon":{"paths":["M838.276 213.333h-652.551c-31.624 0-57.725 26.102-57.725 57.725s26.102 57.725 57.725 57.725h652.551c32.124 0 57.724-26.102 57.724-57.725s-26.103-57.725-57.724-57.725zM693.21 466.825h-507.484c-32.125 0-57.725 26.099-57.725 57.724s26.102 57.724 57.725 57.724h507.484c32.124 0 57.724-26.099 57.724-57.724s-26.103-57.724-57.724-57.724zM185.725 720.311h290.132c31.625 0 57.728 26.103 57.728 57.728 0 31.62-25.6 57.724-57.728 57.724h-290.132c-31.624 0-57.725-26.103-57.725-57.724 0-31.625 25.6-57.728 57.725-57.728z"],"attrs":[],"isMulticolor":false,"isMulticolor2":false,"colorPermutations":{"1911962061761761561":[],"761761561771761561":[],"2552552551761761561":[],"246155111125525525512936511761761561":[],"2323037125525525512936511761761561":[],"10511915011401421681255255255129365114753651761761561":[],"14014216812552552551293651147536515050501761761561":[]},"tags":["Sort-Up"],"grid":24},"attrs":[],"properties":{"order":121,"id":81,"name":"Sort-Up","prevSize":24,"code":59719},"setIdx":0,"setId":0,"iconIdx":145},{"icon":{"paths":["M53.333 426.667c0-17.673 14.327-32 32-32h298.667c17.673 0 32 14.327 32 32s-14.327 32-32 32h-298.667c-17.673 0-32-14.327-32-32z","M276.039 318.706c12.497-12.497 32.758-12.497 45.255 0l85.333 85.333c12.497 12.497 12.497 32.756 0 45.254l-85.333 85.333c-12.497 12.497-32.758 12.497-45.255 0s-12.497-32.755 0-45.252l62.706-62.707-62.706-62.706c-12.497-12.497-12.497-32.758 0-45.255z","M608 576c0-17.673 14.327-32 32-32h298.667c17.673 0 32 14.327 32 32s-14.327 32-32 32h-298.667c-17.673 0-32-14.327-32-32z","M747.959 468.041c12.497 12.497 12.497 32.755 0 45.252l-62.703 62.707 62.703 62.707c12.497 12.497 12.497 32.755 0 45.252s-32.755 12.497-45.252 0l-85.333-85.333c-12.497-12.497-12.497-32.755 0-45.252l85.333-85.333c12.497-12.497 32.755-12.497 45.252 0z","M53.333 213.333c0-64.82 52.514-117.333 117.333-117.333h256c64.819 0 117.333 52.514 117.333 117.333v10.667h309.333c64.819 0 117.333 52.514 117.333 117.333v469.333c0 64.819-52.514 117.333-117.333 117.333h-256c-64.819 0-117.333-52.514-117.333-117.333v-53.333h-309.333c-64.82 0-117.333-52.514-117.333-117.333v-426.667zM544 810.667c0 29.474 23.859 53.333 53.333 53.333h256c29.474 0 53.333-23.859 53.333-53.333v-469.333c0-29.474-23.859-53.333-53.333-53.333h-309.333v522.667zM480 693.333v-480c0-29.474-23.859-53.333-53.333-53.333h-256c-29.474 0-53.333 23.86-53.333 53.333v426.667c0 29.474 23.86 53.333 53.333 53.333h309.333z"],"attrs":[{},{},{},{},{}],"isMulticolor":false,"isMulticolor2":false,"colorPermutations":{"1911962061761761561":[],"761761561771761561":[],"2552552551761761561":[],"246155111125525525512936511761761561":[{},{},{},{},{}],"2323037125525525512936511761761561":[{},{},{},{},{}],"10511915011401421681255255255129365114753651761761561":[{},{},{},{},{}],"14014216812552552551293651147536515050501761761561":[{},{},{},{},{}]},"tags":["Sync"],"grid":24},"attrs":[{},{},{},{},{}],"properties":{"order":116,"id":82,"name":"Sync","prevSize":24,"code":59720},"setIdx":0,"setId":0,"iconIdx":146},{"icon":{"paths":["M138.681 512.009c0-17.673 14.327-32 32-32h682.665c17.677 0 32 14.327 32 32s-14.323 32-32 32h-682.665c-17.673 0-32-14.327-32-32z","M138.681 682.748c0-17.673 14.327-32 32-32h682.665c17.677 0 32 14.327 32 32s-14.323 32-32 32h-682.665c-17.673 0-32-14.327-32-32z","M138.667 341.271c0-17.673 14.327-32 32-32h682.667c17.673 0 32 14.327 32 32s-14.327 32-32 32h-682.667c-17.673 0-32-14.327-32-32z"],"attrs":[],"isMulticolor":false,"isMulticolor2":false,"colorPermutations":{"246155111125525525512936511761761561":[],"2323037125525525512936511761761561":[],"10511915011401421681255255255129365114753651761761561":[],"14014216812552552551293651147536515050501761761561":[]},"tags":["menu"],"grid":24},"attrs":[],"properties":{"order":133,"id":83,"name":"menu","prevSize":24,"code":59711},"setIdx":0,"setId":0,"iconIdx":147},{"icon":{"paths":["M328.533 695.467c7.822 7.821 17.778 11.733 29.867 11.733s22.045-3.913 29.867-11.733l123.733-123.733 124.8 124.8c7.821 7.821 17.609 11.55 29.355 11.179 11.721-0.341 21.491-4.425 29.312-12.245s11.733-17.779 11.733-29.867c0-12.087-3.913-22.046-11.733-29.867l-123.733-123.733 124.8-124.8c7.821-7.822 11.55-17.607 11.179-29.355-0.341-11.719-4.425-21.49-12.245-29.312s-17.779-11.733-29.867-11.733c-12.087 0-22.046 3.911-29.867 11.733l-123.733 123.733-124.8-124.8c-7.822-7.822-17.593-11.563-29.312-11.221-11.747 0.37-21.533 4.466-29.355 12.288s-11.733 17.778-11.733 29.867c0 12.089 3.911 22.045 11.733 29.867l123.733 123.733-124.8 124.8c-7.822 7.821-11.549 17.591-11.179 29.312 0.341 11.746 4.423 21.534 12.245 29.355zM512 938.667c-59.021 0-114.489-11.209-166.4-33.621-51.911-22.387-97.067-52.779-135.467-91.179s-68.793-83.554-91.179-135.467c-22.414-51.913-33.621-107.379-33.621-166.4s11.207-114.489 33.621-166.4c22.386-51.911 52.779-97.067 91.179-135.467s83.555-68.807 135.467-91.221c51.911-22.386 107.379-33.579 166.4-33.579s114.487 11.193 166.4 33.579c51.913 22.414 97.067 52.821 135.467 91.221s68.791 83.555 91.179 135.467c22.413 51.911 33.621 107.379 33.621 166.4s-11.209 114.487-33.621 166.4c-22.387 51.913-52.779 97.067-91.179 135.467s-83.554 68.791-135.467 91.179c-51.913 22.413-107.379 33.621-166.4 33.621zM512 853.333c94.579 0 175.117-33.237 241.621-99.712 66.475-66.505 99.712-147.042 99.712-241.621 0-94.578-33.237-175.118-99.712-241.621-66.505-66.475-147.042-99.712-241.621-99.712-94.578 0-175.104 33.237-241.579 99.712-66.503 66.503-99.755 147.043-99.755 241.621 0 94.579 33.251 175.117 99.755 241.621 66.475 66.475 147.001 99.712 241.579 99.712z"],"attrs":[],"isMulticolor":false,"isMulticolor2":false,"colorPermutations":{"1911962061761761561":[],"761761561771761561":[],"2552552551761761561":[],"246155111125525525512936511761761561":[],"2323037125525525512936511761761561":[],"10511915011401421681255255255129365114753651761761561":[],"14014216812552552551293651147536515050501761761561":[]},"tags":["Cancel"],"grid":24},"attrs":[],"properties":{"order":100,"id":84,"name":"Cancel","prevSize":24,"code":59664},"setIdx":0,"setId":0,"iconIdx":148},{"icon":{"paths":["M407.451 749.867c-5.689 0-11.022-0.896-16-2.688-4.977-1.762-9.6-4.779-13.867-9.045l-183.467-183.467c-7.822-7.821-11.563-17.963-11.221-30.421 0.37-12.429 4.466-22.554 12.288-30.379 7.823-7.821 17.778-11.733 29.867-11.733s22.045 3.913 29.867 11.733l152.533 152.533 361.599-361.599c7.825-7.822 17.963-11.733 30.421-11.733 12.433 0 22.558 3.911 30.379 11.733 7.825 7.823 11.733 17.949 11.733 30.379 0 12.459-3.908 22.599-11.733 30.421l-392.533 392.532c-4.267 4.267-8.887 7.283-13.865 9.045-4.977 1.792-10.311 2.688-16 2.688z"],"attrs":[],"isMulticolor":false,"isMulticolor2":false,"colorPermutations":{"1911962061761761561":[],"761761561771761561":[],"2552552551761761561":[],"246155111125525525512936511761761561":[],"2323037125525525512936511761761561":[],"10511915011401421681255255255129365114753651761761561":[],"14014216812552552551293651147536515050501761761561":[]},"tags":["Outline"],"grid":24},"attrs":[],"properties":{"order":96,"id":85,"name":"Outline","prevSize":24,"code":59696},"setIdx":0,"setId":0,"iconIdx":149},{"icon":{"paths":["M512 810.667c-12.087 0-22.217-4.096-30.379-12.288-8.192-8.162-12.288-18.291-12.288-30.379v-213.333h-213.333c-12.089 0-22.229-4.096-30.421-12.288-8.163-8.162-12.245-18.291-12.245-30.379s4.082-22.229 12.245-30.421c8.192-8.162 18.333-12.245 30.421-12.245h213.333v-213.333c0-12.089 4.096-22.229 12.288-30.421 8.162-8.163 18.291-12.245 30.379-12.245s22.229 4.082 30.421 12.245c8.162 8.192 12.245 18.333 12.245 30.421v213.333h213.333c12.087 0 22.217 4.083 30.379 12.245 8.192 8.192 12.288 18.334 12.288 30.421s-4.096 22.217-12.288 30.379c-8.162 8.192-18.291 12.288-30.379 12.288h-213.333v213.333c0 12.087-4.083 22.217-12.245 30.379-8.192 8.192-18.334 12.288-30.421 12.288z"],"attrs":[],"isMulticolor":false,"isMulticolor2":false,"colorPermutations":{"1911962061761761561":[],"761761561771761561":[],"2552552551761761561":[],"246155111125525525512936511761761561":[],"2323037125525525512936511761761561":[],"10511915011401421681255255255129365114753651761761561":[],"14014216812552552551293651147536515050501761761561":[]},"tags":["Outline"],"grid":24},"attrs":[],"properties":{"order":97,"id":86,"name":"Outline1","prevSize":24,"code":59697},"setIdx":0,"setId":0,"iconIdx":150},{"icon":{"paths":["M854.059 469.333h-684.788c-22.807 0-41.27 18.825-41.27 41.634 0 22.805 18.463 41.63 41.27 41.63h684.063c23.531 0 41.993-18.462 41.993-41.63 0-23.172-18.462-41.634-41.267-41.634z"],"attrs":[],"isMulticolor":false,"isMulticolor2":false,"colorPermutations":{"1911962061761761561":[],"761761561771761561":[],"2552552551761761561":[],"246155111125525525512936511761761561":[],"2323037125525525512936511761761561":[],"10511915011401421681255255255129365114753651761761561":[],"14014216812552552551293651147536515050501761761561":[]},"tags":["Minus"],"grid":24},"attrs":[],"properties":{"order":99,"id":87,"name":"Minus","prevSize":24,"code":59698},"setIdx":0,"setId":0,"iconIdx":151},{"icon":{"paths":["M511.991 571.733l-209.067 209.067c-7.822 7.825-17.777 11.733-29.867 11.733s-22.044-3.908-29.867-11.733c-7.822-7.821-11.733-17.775-11.733-29.867 0-12.087 3.911-22.042 11.733-29.867l209.067-209.067-209.067-209.065c-7.822-7.822-11.733-17.778-11.733-29.867s3.911-22.045 11.733-29.867c7.823-7.822 17.778-11.733 29.867-11.733s22.045 3.911 29.867 11.733l209.067 209.065 209.067-209.065c7.821-7.822 17.779-11.733 29.867-11.733s22.046 3.911 29.867 11.733c7.821 7.822 11.733 17.778 11.733 29.867s-3.913 22.045-11.733 29.867l-209.067 209.065 209.067 209.067c7.821 7.825 11.733 17.779 11.733 29.867 0 12.092-3.913 22.046-11.733 29.867-7.821 7.825-17.779 11.733-29.867 11.733s-22.046-3.908-29.867-11.733l-209.067-209.067z"],"attrs":[],"isMulticolor":false,"isMulticolor2":false,"colorPermutations":{"1911962061761761561":[],"761761561771761561":[],"2552552551761761561":[],"246155111125525525512936511761761561":[],"2323037125525525512936511761761561":[],"10511915011401421681255255255129365114753651761761561":[],"14014216812552552551293651147536515050501761761561":[]},"tags":["Close"],"grid":24},"attrs":[],"properties":{"order":101,"id":88,"name":"Close","prevSize":24,"code":59699},"setIdx":0,"setId":0,"iconIdx":152},{"icon":{"paths":["M256 938.667c-23.467 0-43.549-8.35-60.245-25.045-16.725-16.725-25.088-36.821-25.088-60.288v-426.667c0-23.467 8.363-43.563 25.088-60.288 16.697-16.697 36.779-25.045 60.245-25.045h384v-85.333c0-35.555-12.446-65.778-37.333-90.667s-55.113-37.333-90.667-37.333c-29.154 0-54.925 8.704-77.312 26.112-22.414 17.437-37.533 39.31-45.355 65.621-3.555 10.667-9.059 19.371-16.512 26.112-7.481 6.77-16.199 10.155-26.155 10.155-14.222 0-25.6-4.807-34.133-14.421-8.533-9.586-11.378-20.423-8.533-32.512 10.667-47.645 35.2-87.296 73.6-118.955 38.4-31.63 83.2-47.445 134.4-47.445 59.021 0 109.342 20.793 150.955 62.379 41.587 41.614 62.379 91.933 62.379 150.955v85.333h42.667c23.467 0 43.563 8.349 60.288 25.045 16.695 16.725 25.045 36.821 25.045 60.288v426.667c0 23.467-8.35 43.563-25.045 60.288-16.725 16.695-36.821 25.045-60.288 25.045h-512zM256 853.333h512v-426.667h-512v426.667zM512 725.333c23.467 0 43.563-8.35 60.288-25.045 16.695-16.725 25.045-36.821 25.045-60.288s-8.35-43.563-25.045-60.288c-16.725-16.695-36.821-25.045-60.288-25.045s-43.55 8.35-60.245 25.045c-16.725 16.725-25.088 36.821-25.088 60.288s8.363 43.563 25.088 60.288c16.695 16.695 36.779 25.045 60.245 25.045zM256 426.667v0z"],"attrs":[],"isMulticolor":false,"isMulticolor2":false,"colorPermutations":{"1911962061761761561":[],"761761561771761561":[],"2552552551761761561":[],"246155111125525525512936511761761561":[],"2323037125525525512936511761761561":[],"10511915011401421681255255255129365114753651761761561":[],"14014216812552552551293651147536515050501761761561":[]},"tags":["Locker-open"],"grid":24},"attrs":[],"properties":{"order":358,"id":89,"name":"Locker-open","prevSize":24,"code":59700},"setIdx":0,"setId":0,"iconIdx":153},{"icon":{"paths":["M256 938.667c-23.467 0-43.549-8.35-60.245-25.045-16.725-16.725-25.088-36.821-25.088-60.288v-426.667c0-23.467 8.363-43.563 25.088-60.288 16.697-16.697 36.779-25.045 60.245-25.045h42.667v-85.333c0-59.022 20.807-109.341 62.421-150.955 41.586-41.586 91.891-62.379 150.912-62.379s109.342 20.793 150.955 62.379c41.587 41.614 62.379 91.933 62.379 150.955v85.333h42.667c23.467 0 43.563 8.349 60.288 25.045 16.695 16.725 25.045 36.821 25.045 60.288v426.667c0 23.467-8.35 43.563-25.045 60.288-16.725 16.695-36.821 25.045-60.288 25.045h-512zM384 341.333h256v-85.333c0-35.555-12.446-65.778-37.333-90.667s-55.113-37.333-90.667-37.333c-35.554 0-65.779 12.445-90.667 37.333-24.889 24.889-37.333 55.111-37.333 90.667v85.333zM256 853.333h512v-426.667h-512v426.667zM512 725.333c23.467 0 43.563-8.35 60.288-25.045 16.695-16.725 25.045-36.821 25.045-60.288s-8.35-43.563-25.045-60.288c-16.725-16.695-36.821-25.045-60.288-25.045s-43.55 8.35-60.245 25.045c-16.725 16.725-25.088 36.821-25.088 60.288s8.363 43.563 25.088 60.288c16.695 16.695 36.779 25.045 60.245 25.045z"],"attrs":[],"isMulticolor":false,"isMulticolor2":false,"colorPermutations":{"1911962061761761561":[],"761761561771761561":[],"2552552551761761561":[],"246155111125525525512936511761761561":[],"2323037125525525512936511761761561":[],"10511915011401421681255255255129365114753651761761561":[],"14014216812552552551293651147536515050501761761561":[]},"tags":["Locker-close"],"grid":24},"attrs":[],"properties":{"order":93,"id":90,"name":"Locker-close","prevSize":24,"code":59701},"setIdx":0,"setId":0,"iconIdx":154},{"icon":{"paths":["M512.017 835.2c-5.687 0-11.021-0.896-16-2.688-4.979-1.762-9.6-4.779-13.867-9.045l-281.6-281.6c-8.533-8.533-12.8-18.675-12.8-30.421 0-11.721 4.267-21.845 12.8-30.379s18.489-12.8 29.867-12.8c11.378 0 21.333 4.267 29.867 12.8l209.067 209.067v-477.867c0-12.089 4.096-22.045 12.288-29.867 8.162-7.822 18.291-11.733 30.379-11.733s22.229 4.082 30.421 12.245c8.162 8.192 12.245 18.333 12.245 30.421v476.8l209.067-209.067c8.533-8.533 18.487-12.8 29.867-12.8s21.333 4.267 29.867 12.8c8.533 8.533 12.8 18.658 12.8 30.379 0 11.746-4.267 21.888-12.8 30.421l-281.6 281.6c-4.267 4.267-8.887 7.283-13.867 9.045-4.979 1.792-10.313 2.688-16 2.688z"],"attrs":[],"isMulticolor":false,"isMulticolor2":false,"colorPermutations":{"1911962061761761561":[],"761761561771761561":[],"2552552551761761561":[],"246155111125525525512936511761761561":[],"2323037125525525512936511761761561":[],"10511915011401421681255255255129365114753651761761561":[],"14014216812552552551293651147536515050501761761561":[]},"tags":["Down"],"grid":24},"attrs":[],"properties":{"order":396,"id":92,"name":"Down1","prevSize":24,"code":59703},"setIdx":0,"setId":0,"iconIdx":155},{"icon":{"paths":["M512.017 853.333c-12.087 0-22.217-4.096-30.379-12.288-8.192-8.162-12.288-18.291-12.288-30.379v-476.8l-208 208c-8.533 8.533-18.674 12.8-30.421 12.8-11.719 0-21.845-4.267-30.379-12.8s-12.8-18.487-12.8-29.867c0-11.379 4.267-21.333 12.8-29.867l281.6-281.6c4.267-4.267 8.887-7.296 13.867-9.088 4.979-1.764 10.313-2.645 16-2.645s11.209 0.881 16.555 2.645c5.321 1.792 9.758 4.821 13.312 9.088l281.6 281.6c8.533 8.533 12.8 18.487 12.8 29.867s-4.267 21.333-12.8 29.867c-8.533 8.533-18.675 12.8-30.421 12.8-11.721 0-21.845-4.267-30.379-12.8l-208-208v476.8c0 12.087-4.083 22.217-12.245 30.379-8.192 8.192-18.334 12.288-30.421 12.288z"],"attrs":[],"isMulticolor":false,"isMulticolor2":false,"colorPermutations":{"1911962061761761561":[],"761761561771761561":[],"2552552551761761561":[],"246155111125525525512936511761761561":[],"2323037125525525512936511761761561":[],"10511915011401421681255255255129365114753651761761561":[],"14014216812552552551293651147536515050501761761561":[]},"tags":["Up"],"grid":24},"attrs":[],"properties":{"order":90,"id":93,"name":"Up1","prevSize":24,"code":59704},"setIdx":0,"setId":0,"iconIdx":156},{"icon":{"paths":["M482.133 823.467c-7.821-7.821-11.917-17.779-12.288-29.867-0.341-12.087 3.401-22.046 11.221-29.867l209.067-209.067h-476.8c-12.089 0-22.229-4.096-30.421-12.288-8.163-8.162-12.245-18.291-12.245-30.379s4.082-22.229 12.245-30.421c8.192-8.162 18.333-12.245 30.421-12.245h476.8l-209.067-209.067c-7.821-7.823-11.563-17.778-11.221-29.867 0.371-12.089 4.467-22.045 12.288-29.867s17.779-11.733 29.867-11.733c12.087 0 22.046 3.911 29.867 11.733l281.6 281.6c4.267 3.554 7.296 7.991 9.088 13.312 1.762 5.346 2.645 10.867 2.645 16.555s-0.883 11.021-2.645 16c-1.792 4.979-4.821 9.6-9.088 13.867l-281.6 281.6c-7.821 7.821-17.779 11.733-29.867 11.733s-22.046-3.913-29.867-11.733z"],"attrs":[],"isMulticolor":false,"isMulticolor2":false,"colorPermutations":{"1911962061761761561":[],"761761561771761561":[],"2552552551761761561":[],"246155111125525525512936511761761561":[],"2323037125525525512936511761761561":[],"10511915011401421681255255255129365114753651761761561":[],"14014216812552552551293651147536515050501761761561":[]},"tags":["Right"],"grid":24},"attrs":[],"properties":{"order":88,"id":91,"name":"Right1","prevSize":24,"code":59702},"setIdx":0,"setId":0,"iconIdx":157},{"icon":{"paths":["M464 823.467l-281.6-281.6c-4.267-4.267-7.296-8.887-9.088-13.867-1.763-4.975-2.645-10.308-2.645-16 0-5.687 0.882-11.021 2.645-16 1.792-4.975 4.821-9.6 9.088-13.867l281.6-281.599c7.821-7.822 17.591-11.918 29.312-12.288 11.746-0.341 21.888 3.755 30.421 12.288 8.533 7.822 12.983 17.593 13.355 29.312 0.341 11.747-3.755 21.888-12.288 30.421l-209.067 209.066h476.8c12.087 0 22.229 4.083 30.421 12.245 8.162 8.192 12.245 18.334 12.245 30.421 0 12.092-4.083 22.217-12.245 30.379-8.192 8.192-18.334 12.288-30.421 12.288h-476.8l209.067 209.067c7.821 7.825 11.917 17.779 12.288 29.867 0.341 12.092-3.755 22.046-12.288 29.867-7.821 8.533-17.779 12.8-29.867 12.8s-22.4-4.267-30.933-12.8z"],"attrs":[],"isMulticolor":false,"isMulticolor2":false,"colorPermutations":{"1911962061761761561":[],"761761561771761561":[],"2552552551761761561":[],"246155111125525525512936511761761561":[],"2323037125525525512936511761761561":[],"10511915011401421681255255255129365114753651761761561":[],"14014216812552552551293651147536515050501761761561":[]},"tags":["Left"],"grid":24},"attrs":[],"properties":{"order":91,"id":94,"name":"Left1","prevSize":24,"code":59705},"setIdx":0,"setId":0,"iconIdx":158},{"icon":{"paths":["M624.213 375.893l-66.133 66.133c-44.8-24.747-101.973-18.773-139.947 19.2-22.187 22.187-34.56 51.627-34.56 82.773s12.373 61.013 34.56 82.773c22.187 22.187 51.627 34.56 82.773 34.56s60.587-12.373 82.773-34.56c22.187-22.187 34.56-51.627 34.56-82.773 0-20.48-5.547-39.68-15.36-56.747l66.133-66.133c12.373-12.373 12.373-32.853 0-45.227s-32.853-12.373-45.227 0h0.427zM538.88 581.547c-20.053 20.053-55.040 20.053-75.52 0-10.24-10.24-15.787-23.467-15.787-37.547s5.547-27.733 15.787-37.547c10.24-9.813 23.893-15.787 37.547-15.787s26.88 5.12 37.12 15.36c0 0 0 0 0 0.427s0 0 0.427 0c9.813 10.24 15.36 23.040 15.36 37.12s-5.547 27.733-15.787 37.547l0.853 0.427z","M779.093 276.907c-75.947-68.267-174.933-105.387-276.907-106.24h-0.853c0 0 0 0-0.427 0-15.36 0-30.72 0.853-46.080 2.56-190.72 20.907-344.747 174.080-366.507 364.373-1.707 14.933-1.707 29.867-2.133 44.373 0 1.28-0.853 2.56-0.853 4.267 0 0.853 0.427 1.707 0.427 2.56 0.427 61.867 14.080 122.88 40.96 178.347 18.773 39.253 60.16 64.427 104.96 64.427h539.307c44.8 0 86.187-25.6 105.387-64.853 27.307-56.747 40.96-117.333 40.96-180.48 0-118.187-50.347-230.827-138.24-309.76v0.427zM770.987 768h-539.307c-20.48 0-38.827-11.093-47.36-28.16-18.347-37.973-29.013-78.933-32.853-121.173h50.773c17.493 0 32-14.507 32-32s-14.507-32-32-32h-50.773c0-2.987 0-6.4 0.427-9.387 18.347-160.853 148.907-290.56 309.76-308.48 2.56 0 5.12 0 7.68-0.427v51.627c0 17.493 14.507 32 32 32s32-14.507 32-32v-52.053c75.093 6.827 145.493 37.12 203.093 88.32 66.56 59.733 107.093 142.080 115.2 229.973h-51.627c-17.493 0-32 14.507-32 32s14.507 32 32 32h51.627c-3.84 41.813-14.507 82.347-32.853 120.747-8.533 17.493-26.88 28.587-47.787 28.587v0.427z"],"attrs":[],"tags":["dashboard"],"grid":24,"isMulticolor":false,"isMulticolor2":false,"colorPermutations":{"246155111125525525512936511761761561":[],"2323037125525525512936511761761561":[],"10511915011401421681255255255129365114753651761761561":[],"14014216812552552551293651147536515050501761761561":[]}},"attrs":[],"properties":{"order":87,"id":95,"name":"dashboard","prevSize":24,"code":59656},"setIdx":0,"setId":0,"iconIdx":159},{"icon":{"paths":["M694.259 694.263c12.497-12.497 32.755-12.497 45.252 0l136.593 136.589c12.497 12.497 12.497 32.759 0 45.257s-32.759 12.497-45.257 0l-136.589-136.593c-12.497-12.497-12.497-32.755 0-45.252z","M409.016 401.798c12.684-8.363 29.499-6.655 40.242 4.088l128.051 128.053c12.497 12.497 12.497 32.759 0 45.257-12.493 12.497-32.755 12.497-45.252 0l-109.6-109.602-234.319 154.496c-14.755 9.728-34.602 5.653-44.33-9.101s-5.654-34.603 9.101-44.331l256.107-168.86z","M837.508 370.093c9.728 14.755 5.653 34.602-9.101 44.33l-256.107 168.86c-14.758 9.728-34.603 5.653-44.331-9.101s-5.653-34.603 9.101-44.331l256.107-168.86c14.754-9.728 34.603-5.654 44.331 9.101z","M720.721 317.758c-72.149-96.387-196.706-137.627-312.119-103.341s-197.254 136.838-205.078 256.982c-1.149 17.638-16.376 31.002-34.012 29.854s-31.002-16.375-29.853-34.014c9.566-146.881 109.618-272.256 250.717-314.172 141.101-41.916 293.374 8.502 381.579 126.34 10.59 14.149 7.706 34.203-6.443 44.794s-34.202 7.706-44.791-6.442z","M811.802 480.073c17.638 1.148 31.002 16.375 29.854 34.010-9.566 146.884-109.615 272.26-250.718 314.176-141.099 41.916-293.373-8.503-381.578-126.34-10.59-14.148-7.706-34.202 6.442-44.796 14.148-10.59 34.203-7.706 44.794 6.443 72.148 96.388 196.705 137.63 312.119 103.343s197.252-136.836 205.077-256.981c1.148-17.638 16.375-31.002 34.010-29.854z"],"attrs":[],"tags":["hmm"],"grid":24,"isMulticolor":false,"isMulticolor2":false,"colorPermutations":{"246155111125525525512936511761761561":[],"2323037125525525512936511761761561":[],"10511915011401421681255255255129365114753651761761561":[],"14014216812552552551293651147536515050501761761561":[]}},"attrs":[],"properties":{"order":292,"id":96,"name":"hmm","prevSize":24,"code":59657},"setIdx":0,"setId":0,"iconIdx":160},{"icon":{"paths":["M689.894 312.771c104.137 104.14 104.137 272.982 0 377.123-104.141 104.141-272.985 104.141-377.125 0s-104.14-272.983 0-377.123c104.14-104.14 272.984-104.14 377.125 0zM735.147 267.517c-129.131-129.133-338.499-129.133-467.632 0s-129.133 338.499 0 467.634c129.133 129.131 338.501 129.131 467.632 0 129.135-129.135 129.135-338.501 0-467.634z","M501.333 682.667c17.673 0 32 14.327 32 32v170.667c0 17.673-14.327 32-32 32s-32-14.327-32-32v-170.667c0-17.673 14.327-32 32-32z","M501.333 85.333c17.673 0 32 14.327 32 32v170.667c0 17.673-14.327 32-32 32s-32-14.327-32-32v-170.667c0-17.673 14.327-32 32-32z","M85.333 501.333c0-17.673 14.327-32 32-32h170.667c17.673 0 32 14.327 32 32s-14.327 32-32 32h-170.667c-17.673 0-32-14.327-32-32z","M682.667 501.333c0-17.673 14.327-32 32-32h170.667c17.673 0 32 14.327 32 32s-14.327 32-32 32h-170.667c-17.673 0-32-14.327-32-32z"],"attrs":[],"tags":["assetfocus"],"grid":24,"isMulticolor":false,"isMulticolor2":false,"colorPermutations":{"246155111125525525512936511761761561":[],"2323037125525525512936511761761561":[],"10511915011401421681255255255129365114753651761761561":[],"14014216812552552551293651147536515050501761761561":[]}},"attrs":[],"properties":{"order":85,"id":97,"name":"assetfocus","prevSize":24,"code":59658},"setIdx":0,"setId":0,"iconIdx":161},{"icon":{"paths":["M908.147 640l-96.853-373.333c-14.507-56.747-65.707-96-124.16-96-33.707 0-66.987 13.653-90.88 37.547-24.32 24.32-37.547 56.32-37.547 90.88v31.573h-115.627v-31.573c0-34.133-13.227-66.56-37.547-90.88-23.893-23.893-56.747-37.547-90.88-37.547-58.453 0-109.653 39.68-124.16 96l-99.84 384c0 0 0 0.853 0 1.28-8.96 36.267-6.827 75.093 8.107 111.787 27.733 67.413 92.587 110.507 165.547 110.507s137.813-43.52 165.547-110.507c9.387-23.040 13.653-46.933 13.227-70.827v-2.987c0 0 0-2.987 0-4.693v-34.987h115.627v42.667c0 0 0 0.853 0 1.28 0 46.080 17.067 92.587 52.053 127.573 34.56 34.56 80.213 52.48 126.72 52.48 23.040 0 46.507-4.267 68.693-13.653 67.413-27.733 110.507-92.587 110.507-165.547 0-19.2-2.987-37.547-8.533-55.040zM641.481 253.013c11.947-11.947 28.587-18.773 45.653-18.773 29.44 0 55.040 19.627 62.293 48.213l64.853 250.88c-2.987-1.28-5.547-2.987-8.107-4.267-62.293-25.6-132.693-14.080-183.467 29.013v-259.413c0-17.067 6.827-33.28 18.773-45.653zM251.933 282.453c7.253-28.587 32.853-48.213 62.293-48.213 17.067 0 33.707 6.827 45.653 18.773 12.373 12.373 18.773 28.16 18.773 45.653v260.267c-54.613-46.080-129.707-54.187-192-24.32l65.28-252.16zM263.88 810.24c-46.933 0-88.32-27.733-106.24-71.253-17.92-43.093-8.107-92.587 25.173-125.44 22.613-22.187 52.053-33.707 81.493-33.707s58.88 11.093 81.067 33.707c20.48 20.48 32 46.933 33.707 74.24v4.693c0 15.36-2.56 31.147-8.533 46.080-17.92 43.093-59.733 71.253-106.24 71.253l-0.427 0.427zM442.654 586.24v-192h115.627v192h-115.627zM781.427 801.28c-43.093 17.92-92.587 8.107-125.44-25.173-44.8-44.8-44.8-117.76 0-162.56 22.187-22.187 51.627-33.707 81.493-33.707 14.933 0 29.867 2.987 43.947 8.96 31.573 13.227 55.040 38.827 65.28 69.973l2.133 8.107c0 0 0 0 0 0.427 2.133 8.96 3.413 17.92 3.413 27.733 0 46.933-27.733 88.747-71.253 106.24h0.427z"],"attrs":[],"grid":24,"tags":["Outlook"],"isMulticolor":false,"isMulticolor2":false,"colorPermutations":{"246155111125525525512936511761761561":[],"2323037125525525512936511761761561":[],"10511915011401421681255255255129365114753651761761561":[],"14014216812552552551293651147536515050501761761561":[]}},"attrs":[],"properties":{"order":314,"id":164,"name":"Outlook","prevSize":24,"code":59816},"setIdx":0,"setId":0,"iconIdx":162},{"icon":{"paths":["M95.845 277.232c0-76.608 62.103-138.711 138.711-138.711h554.897c76.608 0 138.714 62.103 138.714 138.711v128.053c0 17.673-14.327 32.001-32 32.001s-32-14.328-32-32.001v-128.053c0-41.262-33.451-74.711-74.714-74.711h-554.897c-41.262 0-74.711 33.449-74.711 74.711v149.396c0 17.673-14.327 32.001-32 32.001s-32-14.327-32-32.001v-149.396z","M896.166 586.709c17.673 0 32 14.323 32 32v128.051c0 76.608-62.106 138.714-138.714 138.714h-234.765c-17.673 0-32-14.327-32-32 0-17.677 14.327-32 32-32h234.765c41.263 0 74.714-33.451 74.714-74.714v-128.051c0-17.677 14.327-32 32-32z","M789.453 437.286h106.714c5.901 0 10.684 4.783 10.684 10.684v128.051c0 5.901-4.783 10.688-10.684 10.688h-106.714c-41.259 0-74.709-33.451-74.709-74.714s33.451-74.709 74.709-74.709zM789.453 373.285c-76.608 0-138.709 62.103-138.709 138.711s62.101 138.714 138.709 138.714h106.714c41.246 0 74.684-33.438 74.684-74.688v-128.051c0-41.248-33.438-74.685-74.684-74.685h-106.714z","M200.683 780.86c-12.493-12.501-32.755-12.506-45.255-0.013l-92.716 92.668c-12.5 12.493-12.506 32.755-0.012 45.257 12.494 12.497 32.755 12.506 45.255 0.013l92.717-92.668c12.5-12.497 12.505-32.755 0.012-45.257z","M298.75 543.991c76.623 0 138.737 62.114 138.737 138.739 0 76.621-62.115 138.735-138.737 138.735s-138.738-62.114-138.738-138.735c0-76.625 62.115-138.739 138.738-138.739zM501.487 682.731c0-111.97-90.768-202.739-202.737-202.739s-202.738 90.769-202.738 202.739c0 111.966 90.769 202.735 202.738 202.735s202.737-90.769 202.737-202.735z"],"attrs":[],"isMulticolor":false,"isMulticolor2":false,"colorPermutations":{"246155111125525525512936511761761561":[],"2323037125525525512936511761761561":[],"10511915011401421681255255255129365114753651761761561":[],"14014216812552552551293651147536515050501761761561":[]},"tags":["Detailportfolios"],"grid":24},"attrs":[],"properties":{"order":307,"id":99,"name":"Detailportfolios","prevSize":24,"code":59675},"setIdx":0,"setId":0,"iconIdx":163},{"icon":{"paths":["M213.333 160c-29.474 0-53.333 23.86-53.333 53.333v597.333c0 29.474 23.86 53.333 53.333 53.333h597.333c29.474 0 53.333-23.859 53.333-53.333v-597.333c0-29.474-23.859-53.333-53.333-53.333h-597.333zM96 213.333c0-64.82 52.514-117.333 117.333-117.333h597.333c64.819 0 117.333 52.514 117.333 117.333v597.333c0 64.819-52.514 117.333-117.333 117.333h-597.333c-64.82 0-117.333-52.514-117.333-117.333v-597.333z","M790.81 406.953c12.395 12.597 12.233 32.859-0.367 45.254l-170.667 167.936c-11.281 11.102-28.979 12.288-41.643 2.79l-148.642-111.484-151.047 148.629c-12.597 12.395-32.858 12.233-45.254-0.367-12.396-12.595-12.232-32.858 0.365-45.252l170.667-167.936c11.281-11.102 28.981-12.288 41.644-2.79l148.642 111.484 151.049-148.629c12.595-12.396 32.858-12.232 45.252 0.365z"],"attrs":[],"tags":["Positioning-indicator"],"grid":24,"isMulticolor":false,"isMulticolor2":false,"colorPermutations":{"246155111125525525512936511761761561":[],"2323037125525525512936511761761561":[],"10511915011401421681255255255129365114753651761761561":[],"14014216812552552551293651147536515050501761761561":[]}},"attrs":[],"properties":{"order":291,"id":79,"name":"Positioning-indicator","prevSize":24,"code":59725},"setIdx":0,"setId":0,"iconIdx":164},{"icon":{"paths":["M512.361 696.314c-7.645 0-14.812-1.203-21.501-3.61-6.689-2.374-12.9-6.426-18.634-12.154l-265.171-265.174c-10.511-10.511-15.519-23.66-15.021-39.446 0.458-15.748 5.944-28.877 16.454-39.389s23.89-15.766 40.134-15.766c16.244 0 29.623 5.256 40.134 15.766l223.604 223.604 225.034-225.037c10.515-10.511 23.661-15.538 39.45-15.079 15.75 0.497 28.877 6.001 39.386 16.512 10.515 10.511 15.77 23.889 15.77 40.134s-5.254 29.622-15.77 40.134l-263.736 263.741c-5.733 5.728-11.944 9.779-18.634 12.154-6.689 2.406-13.856 3.61-21.5 3.61v0z"],"attrs":[],"isMulticolor":false,"isMulticolor2":false,"colorPermutations":{"1911962061761761561":[],"761761561771761561":[],"2552552551761761561":[],"246155111125525525512936511761761561":[],"2323037125525525512936511761761561":[],"10511915011401421681255255255129365114753651761761561":[],"14014216812552552551293651147536515050501761761561":[]},"tags":["Chevron/Down"],"grid":24},"attrs":[],"properties":{"order":74,"id":100,"name":"Down","prevSize":24,"code":59648},"setIdx":0,"setId":0,"iconIdx":165},{"icon":{"paths":["M599.821 816.218l-264.036-264.038c-5.74-5.74-9.796-11.958-12.169-18.655-2.411-6.696-3.616-13.871-3.616-21.524s1.205-14.828 3.616-21.524c2.372-6.697 6.429-12.915 12.169-18.655l264.036-264.036c10.523-10.524 23.916-15.785 40.179-15.785s29.658 5.261 40.179 15.785c10.522 10.523 15.782 23.916 15.782 40.179s-5.261 29.656-15.782 40.179l-223.857 223.857 223.857 223.859c10.522 10.522 15.782 23.91 15.782 40.179 0 16.262-5.261 29.651-15.782 40.179-10.522 10.522-23.917 15.782-40.179 15.782s-29.656-5.261-40.179-15.782v0z"],"attrs":[],"isMulticolor":false,"isMulticolor2":false,"colorPermutations":{"1911962061761761561":[],"761761561771761561":[],"2552552551761761561":[],"246155111125525525512936511761761561":[],"2323037125525525512936511761761561":[],"10511915011401421681255255255129365114753651761761561":[],"14014216812552552551293651147536515050501761761561":[]},"tags":["Chevron/Left"],"grid":24},"attrs":[],"properties":{"order":75,"id":101,"name":"Left","prevSize":24,"code":59653},"setIdx":0,"setId":0,"iconIdx":166},{"icon":{"paths":["M335.785 898.349c-10.524-10.522-15.785-23.917-15.785-40.179s5.261-29.658 15.785-40.179l223.856-223.858-223.856-223.856c-10.524-10.524-15.785-23.916-15.785-40.18s5.261-29.656 15.785-40.179c10.523-10.523 23.916-15.784 40.179-15.784s29.656 5.261 40.179 15.784l264.036 264.036c5.741 5.74 9.818 11.958 12.224 18.655 2.374 6.697 3.558 13.871 3.558 21.524s-1.184 14.828-3.558 21.525c-2.406 6.696-6.483 12.915-12.224 18.655l-264.036 264.036c-10.523 10.522-23.916 15.782-40.179 15.782s-29.656-5.261-40.179-15.782v0z"],"attrs":[],"isMulticolor":false,"isMulticolor2":false,"colorPermutations":{"1911962061761761561":[],"761761561771761561":[],"2552552551761761561":[],"246155111125525525512936511761761561":[],"2323037125525525512936511761761561":[],"10511915011401421681255255255129365114753651761761561":[],"14014216812552552551293651147536515050501761761561":[]},"tags":["Chevron/Right"],"grid":24},"attrs":[],"properties":{"order":76,"id":102,"name":"Right","prevSize":24,"code":59654},"setIdx":0,"setId":0,"iconIdx":167},{"icon":{"paths":["M207.749 679.373c-10.499-10.496-15.749-23.859-15.749-40.089 0-16.227 5.25-29.59 15.749-40.089l263.446-263.445c5.727-5.727 11.931-9.793 18.612-12.199 6.682-2.367 13.841-3.551 21.476-3.551s14.795 1.183 21.476 3.551c6.682 2.406 12.886 6.472 18.613 12.199l264.876 264.877c10.502 10.499 15.75 23.386 15.75 38.657 0 15.27-5.728 28.633-17.184 40.089-10.496 10.502-23.859 15.75-40.090 15.75-16.224 0-29.587-5.248-40.090-15.75l-223.353-223.355-224.787 224.788c-10.5 10.496-23.386 15.75-38.658 15.75s-28.635-5.728-40.090-17.184z"],"attrs":[],"isMulticolor":false,"isMulticolor2":false,"colorPermutations":{"1911962061761761561":[],"761761561771761561":[],"2552552551761761561":[],"246155111125525525512936511761761561":[],"2323037125525525512936511761761561":[],"10511915011401421681255255255129365114753651761761561":[],"14014216812552552551293651147536515050501761761561":[]},"tags":["Chevron/Up"],"grid":24},"attrs":[],"properties":{"order":77,"id":103,"name":"Up","prevSize":24,"code":59655},"setIdx":0,"setId":0,"iconIdx":168},{"icon":{"paths":["M801.707 188.8l-207.36-84.907c-59.733-24.747-125.867-24.747-185.6 0l-207.787 84.907c-44.373 17.92-72.96 60.587-72.96 108.8v171.947c0 201.387 144.213 387.84 342.613 444.16 10.24 2.987 20.48 4.267 30.72 4.267s20.907-1.28 30.72-4.267c198.4-56.32 342.613-242.773 342.613-444.16v-171.947c0-47.787-28.587-90.453-72.96-108.8zM810.667 469.12c0 173.227-124.587 334.080-295.68 382.293-8.533 2.56-18.347 2.56-26.88 0-171.52-48.64-295.68-209.493-295.68-382.293v-171.52c0-21.76 12.8-40.96 33.28-49.493l206.933-84.907c22.187-8.96 45.227-13.653 68.693-13.653s46.507 4.693 68.693 13.653l207.36 84.907c20.053 8.107 33.28 27.733 33.28 49.493v171.52z","M590.933 519.893c26.88-30.293 36.693-71.68 26.027-111.787-10.667-40.533-43.52-73.387-84.053-83.627-37.12-9.813-75.093-2.133-104.96 20.907-29.44 23.040-46.507 57.6-46.507 94.72 0 29.44 10.667 57.6 30.293 79.787 2.987 2.987 3.84 6.827 2.987 10.24l-16.64 57.6c-6.4 22.613-2.133 46.507 12.373 65.707 14.080 18.773 35.84 29.867 59.733 29.867h62.72c23.467 0 45.227-10.667 59.733-29.867 14.080-18.773 18.773-42.667 12.373-65.707l-16.64-58.027c-0.853-3.413 0-7.253 2.987-10.24l-0.427 0.427zM543.147 477.227c-17.493 19.627-23.893 46.080-16.64 70.4l16.64 57.6c1.28 4.267-0.427 7.68-1.707 9.387s-3.84 4.267-8.533 4.267h-62.72c-4.693 0-7.253-2.56-8.533-4.267s-2.987-5.12-1.707-9.387l16.64-57.6c6.827-24.747 0.853-50.773-16.64-70.4-8.96-10.24-14.080-23.467-14.080-37.12 0-17.493 8.107-33.707 21.76-44.373 9.813-7.68 21.76-11.52 34.133-11.52 5.12 0 10.24 0.853 15.787 2.133 17.92 4.693 33.707 20.053 38.4 37.973 5.12 19.2 0.853 38.4-11.947 52.907h-0.853z"],"attrs":[],"tags":["Property 1=Privacy"],"grid":24,"isMulticolor":false,"isMulticolor2":false,"colorPermutations":{"246155111125525525512936511761761561":[],"2323037125525525512936511761761561":[],"10511915011401421681255255255129365114753651761761561":[],"14014216812552552551293651147536515050501761761561":[]}},"attrs":[],"properties":{"order":31,"id":104,"name":"Property-1Privacy","prevSize":24,"code":59660},"setIdx":0,"setId":0,"iconIdx":169},{"icon":{"paths":["M288.035 448.124c-29.475 0-53.369 23.893-53.369 53.367v298.795c0 29.474 23.894 53.367 53.369 53.367h426.845c29.474 0 53.367-23.893 53.367-53.367v-298.795c0-29.474-23.893-53.367-53.367-53.367h-426.845zM170.667 501.491c0-64.819 52.548-117.367 117.369-117.367h426.845c64.819 0 117.367 52.547 117.367 117.367v298.795c0 64.819-52.548 117.367-117.367 117.367h-426.845c-64.821 0-117.369-52.548-117.369-117.367v-298.795z","M501.457 149.333c-76.622 0-138.737 62.115-138.737 138.738v128.053c0 17.672-14.327 31.999-32 31.999s-32-14.327-32-31.999v-128.053c0-111.969 90.769-202.738 202.737-202.738 111.97 0 202.739 90.769 202.739 202.738v128.053c0 17.672-14.327 31.999-32 31.999s-32-14.327-32-31.999v-128.053c0-76.623-62.114-138.738-138.739-138.738z"],"attrs":[],"tags":["Top-menu-password"],"grid":24,"isMulticolor":false,"isMulticolor2":false,"colorPermutations":{"246155111125525525512936511761761561":[],"2323037125525525512936511761761561":[],"10511915011401421681255255255129365114753651761761561":[],"14014216812552552551293651147536515050501761761561":[]}},"attrs":[],"properties":{"order":32,"id":105,"name":"Top-menu-password","prevSize":24,"code":59661},"setIdx":0,"setId":0,"iconIdx":170},{"icon":{"paths":["M760.9 263.098c-137.463-137.465-360.337-137.465-497.802 0s-137.465 360.338 0 497.802c137.464 137.463 360.338 137.463 497.802 0 137.459-137.459 137.451-360.336 0-497.802-0.004-0.005 0.004 0.005 0 0zM806.157 217.844c162.458 162.458 162.458 425.856 0 588.313s-425.856 162.458-588.313 0c-162.458-162.458-162.458-425.856 0-588.313s425.856-162.458 588.313 0z","M574.238 377.781c34.377 34.374 34.377 90.106 0 124.483-34.372 34.372-90.108 34.372-124.48 0-34.375-34.377-34.375-90.108 0-124.483 34.372-34.374 90.108-34.374 124.48 0zM619.494 332.526c-59.371-59.368-155.622-59.368-214.992 0-59.368 59.368-59.368 155.623 0 214.99 59.369 59.371 155.621 59.371 214.992 0 59.366-59.366 59.366-155.622 0-214.99z","M245.288 786.889c66.971-70.562 161.594-114.889 266.708-114.889 105.118 0 199.735 44.322 266.705 114.837 12.169 12.817 11.648 33.071-1.169 45.239-12.813 12.173-33.067 11.648-45.239-1.165-55.484-58.423-133.581-94.912-220.297-94.912-86.712 0-164.804 36.489-220.286 94.946-12.166 12.817-32.42 13.346-45.239 1.182s-13.348-32.422-1.182-45.239z"],"attrs":[],"tags":["Top-menu-user"],"grid":24,"isMulticolor":false,"isMulticolor2":false,"colorPermutations":{"246155111125525525512936511761761561":[],"2323037125525525512936511761761561":[],"10511915011401421681255255255129365114753651761761561":[],"14014216812552552551293651147536515050501761761561":[]}},"attrs":[],"properties":{"order":33,"id":106,"name":"Top-menu-user","prevSize":24,"code":59662},"setIdx":0,"setId":0,"iconIdx":171},{"icon":{"paths":["M609.792 750.635c17.673 0 32 14.327 32 32v15.573c0 71.689-58.103 129.792-129.792 129.792-71.68 0-129.792-58.095-129.792-129.749v-15.573c0-17.673 14.327-32 32-32s32 14.327 32 32v15.573c0 36.292 29.44 65.749 65.792 65.749 36.343 0 65.792-29.449 65.792-65.792v-15.573c0-17.673 14.327-32 32-32z","M401.792 206.208c0-60.841 49.301-110.208 110.208-110.208s110.208 49.367 110.208 110.208v39.168c0 17.673-14.327 32-32 32s-32-14.327-32-32v-39.168c0-25.517-20.672-46.208-46.208-46.208s-46.208 20.691-46.208 46.208v39.168c0 17.673-14.327 32-32 32s-32-14.327-32-32v-39.168z","M473.344 273.365c-89.083 0-161.323 72.206-161.323 161.323v119.339c0 31.108-12.381 60.962-34.375 82.957l-27.349 27.349c-10.006 10.005-15.63 23.586-15.63 37.705 0 26.871 21.769 48.64 48.64 48.64h457.429c26.871 0 48.64-21.769 48.64-48.64 0-14.118-5.623-27.699-15.629-37.705l-27.349-27.349c-21.995-21.995-34.377-51.849-34.377-82.957v-119.339c0-89.083-72.205-161.323-161.323-161.323h-77.355zM248.021 434.688c0-124.472 100.902-225.323 225.323-225.323h77.355c124.471 0 225.323 100.902 225.323 225.323v119.339c0 14.118 5.623 27.699 15.629 37.705l27.349 27.349c21.995 21.995 34.377 51.849 34.377 82.957 0 62.217-50.423 112.64-112.64 112.64h-457.429c-62.217 0-112.64-50.423-112.64-112.64 0-31.108 12.381-60.962 34.375-82.957l27.349-27.349c10.006-10.005 15.63-23.586 15.63-37.705v-119.339z"],"attrs":[],"tags":["Property 1=Notifications"],"grid":24,"isMulticolor":false,"isMulticolor2":false,"colorPermutations":{"246155111125525525512936511761761561":[],"2323037125525525512936511761761561":[],"10511915011401421681255255255129365114753651761761561":[],"14014216812552552551293651147536515050501761761561":[]}},"attrs":[],"properties":{"order":34,"id":107,"name":"Property-1Notifications","prevSize":24,"code":59663},"setIdx":0,"setId":0,"iconIdx":172},{"icon":{"paths":["M501.338 917.76c-53.76 0-107.948-10.667-159.148-32-102.827-42.667-182.613-122.453-225.28-225.28-87.467-211.627 13.227-455.68 225.28-543.147 102.401-42.667 215.468-42.667 318.295 0s182.613 122.453 225.28 225.28c42.667 102.827 42.667 215.893 0 318.293s-122.453 182.613-225.28 225.28c-51.2 21.333-105.387 32-159.147 32v-0.427zM501.338 149.333c-45.653 0-91.308 8.96-134.828 26.88-179.2 74.24-264.533 280.747-190.293 459.947 35.84 87.040 103.68 154.453 190.293 190.293 87.041 35.84 182.615 35.84 269.228 0 87.040-35.84 154.453-103.68 190.293-190.293s35.84-182.613 0-269.227c-35.84-87.040-103.68-154.453-190.293-190.293-43.52-17.92-89.173-26.88-134.827-26.88l0.427-0.427z","M645.124 655.787c-5.547 0-11.52-1.707-16.64-4.693l-156.16-95.147c-9.387-5.973-15.36-16.213-15.36-27.307v-198.4c0-17.493 14.507-32 32-32s32 14.507 32 32v180.48l140.8 85.76c14.933 9.387 20.053 29.013 10.667 43.947-5.973 9.813-16.64 15.36-27.307 15.36z"],"attrs":[],"tags":["Clock"],"grid":24,"isMulticolor":false,"isMulticolor2":false,"colorPermutations":{"246155111125525525512936511761761561":[],"2323037125525525512936511761761561":[],"10511915011401421681255255255129365114753651761761561":[],"14014216812552552551293651147536515050501761761561":[]}},"attrs":[],"properties":{"order":37,"id":108,"name":"Clock","prevSize":24,"code":59666},"setIdx":0,"setId":0,"iconIdx":173},{"icon":{"paths":["M920.107 464.533l-74.031-81.1c-7.070-7.486-16.222-12.061-26.202-12.061s-19.546 3.328-27.034 10.398c-14.972 14.557-16.222 39.511-2.078 54.898l26.202 29.53c0 0 3.324 4.16 5.82 7.070h-271.168v-272.416c2.91 2.496 5.406 4.575 7.070 5.823l27.866 25.786c15.804 14.141 40.341 13.725 54.899-1.664 7.070-7.486 10.812-17.052 10.812-27.034s-4.574-19.548-12.476-26.618l-81.933-74.031c-26.202-23.707-66.961-23.707-93.163 0l-81.102 74.031c-7.486 7.070-12.061 16.22-12.061 26.618 0 9.982 3.327 19.547 10.397 27.034 14.557 15.389 39.511 16.221 54.9 2.080l29.53-26.202c0 0 4.16-3.327 7.070-5.823v272.416h-272.834c2.496-2.91 4.575-5.406 5.823-7.070l26.202-29.53c14.141-15.803 13.309-40.341-2.080-54.898-7.486-7.070-16.22-10.398-27.034-10.398-9.981 0-19.547 4.575-26.202 12.061l-74.031 81.1c-23.706 26.202-24.122 66.961 0 93.163l74.031 81.933c7.071 7.488 16.221 12.062 26.618 12.48 10.813 0 19.964-3.328 27.034-10.816 14.973-14.554 15.804-39.509 1.664-54.899l-25.786-27.866c0 0-3.328-4.156-5.823-7.070h272.004v271.586c-2.914-2.496-5.41-4.574-7.074-5.82l-29.53-26.206c-15.802-14.14-40.34-13.308-54.897 2.082-7.070 7.484-10.813 17.050-10.397 27.034 0 9.98 4.575 19.546 12.061 26.615l81.1 74.031c12.894 12.062 29.948 17.886 46.583 17.886s33.271-5.824 46.583-17.886l81.933-74.031c7.484-7.070 12.062-16.218 12.476-26.615 0-9.984-3.328-19.964-10.812-27.034-14.558-14.972-39.514-15.804-54.903-1.664l-27.866 25.788c0 0-4.156 3.324-7.070 5.82v-271.168h271.172c-2.496 2.91-4.574 5.406-5.824 7.070l-25.783 27.866c-14.144 15.386-13.726 40.341 1.66 54.899 7.488 7.070 17.886 10.812 27.038 10.812 9.98 0 19.546-4.574 26.615-12.476l74.031-81.933c23.706-26.202 23.706-66.961 0-93.163v-0.418z"],"attrs":[],"isMulticolor":false,"isMulticolor2":false,"colorPermutations":{"1911962061761761561":[],"761761561771761561":[],"2552552551761761561":[],"246155111125525525512936511761761561":[],"2323037125525525512936511761761561":[],"10511915011401421681255255255129365114753651761761561":[],"14014216812552552551293651147536515050501761761561":[]},"tags":["Drag-and-drop"],"grid":24},"attrs":[],"properties":{"order":40,"id":109,"name":"Drag-and-drop","prevSize":24,"code":59669},"setIdx":0,"setId":0,"iconIdx":174},{"icon":{"paths":["M768 522.667c-29.474 0-53.333 23.859-53.333 53.333s23.859 53.333 53.333 53.333h85.333c5.879 0 10.667-4.787 10.667-10.667v-85.333c0-5.879-4.787-10.667-10.667-10.667h-85.333zM650.667 576c0-64.819 52.514-117.333 117.333-117.333h85.333c41.225 0 74.667 33.442 74.667 74.667v85.333c0 41.225-33.442 74.667-74.667 74.667h-85.333c-64.819 0-117.333-52.514-117.333-117.333z","M192 181.333c-17.655 0-32 14.345-32 32s14.345 32 32 32h576c64.819 0 117.333 52.514 117.333 117.333v128c0 17.673-14.327 32-32 32s-32-14.327-32-32v-128c0-29.474-23.859-53.333-53.333-53.333h-576c-53.001 0-96-42.999-96-96s42.999-96 96-96h533.333c17.673 0 32 14.327 32 32s-14.327 32-32 32h-533.333z","M128 181.333c17.673 0 32 14.327 32 32v576c0 29.474 23.86 53.333 53.333 53.333h554.667c29.474 0 53.333-23.859 53.333-53.333v-128c0-17.673 14.327-32 32-32s32 14.327 32 32v128c0 64.819-52.514 117.333-117.333 117.333h-554.667c-64.82 0-117.333-52.514-117.333-117.333v-576c0-17.673 14.327-32 32-32z"],"attrs":[],"tags":["Portfolio"],"grid":24,"isMulticolor":false,"isMulticolor2":false,"colorPermutations":{"246155111125525525512936511761761561":[],"2323037125525525512936511761761561":[],"10511915011401421681255255255129365114753651761761561":[],"14014216812552552551293651147536515050501761761561":[]}},"attrs":[],"properties":{"order":42,"id":111,"name":"Portfolio","prevSize":24,"code":59671},"setIdx":0,"setId":0,"iconIdx":175},{"icon":{"paths":["M621.111 120.82l-356.36 134.558c-37.34 14.115-62.085 49.899-62.085 89.832v162.775c0 17.673-14.327 32-32 32s-32-14.327-32-32v-162.775c0-66.56 41.222-126.18 103.462-149.699l356.404-134.574c76.749-28.906 158.801 27.726 158.801 109.809v142.933c0 17.673-14.327 32-32 32s-32-14.327-32-32v-142.933c0-37.295-37.269-63.081-72.222-49.926z","M138.667 398.97c0-64.82 52.514-117.333 117.333-117.333h512c88.371 0 160 71.628 160 160.002v326.357c0 88.073-71.927 160-160 160h-313.088c-17.673 0-32-14.327-32-32 0-17.677 14.327-32 32-32h313.088c52.727 0 96-43.277 96-96v-326.357c0-53.027-42.974-96.002-96-96.002h-512c-29.474 0-53.333 23.86-53.333 53.333v123.991c0 17.673-14.327 32-32 32s-32-14.327-32-32v-123.991z","M320 501.329c111.945 0 202.667 90.756 202.667 202.667 0 111.906-90.722 202.667-202.667 202.667-111.906 0-202.667-90.765-202.667-202.667 0-111.906 90.761-202.667 202.667-202.667zM320 970.662c147.298 0 266.667-119.42 266.667-266.667 0-147.251-119.369-266.667-266.667-266.667-147.252 0-266.667 119.411-266.667 266.667 0 147.251 119.415 266.667 266.667 266.667z","M320 578.428c17.673 0 32 14.323 32 32v187.179c0 17.673-14.327 32-32 32s-32-14.327-32-32v-187.179c0-17.677 14.327-32 32-32z","M194.432 703.996c0-17.677 14.327-32 32-32h187.136c17.673 0 32 14.323 32 32 0 17.673-14.327 32-32 32h-187.136c-17.673 0-32-14.327-32-32z"],"attrs":[],"isMulticolor":false,"isMulticolor2":false,"colorPermutations":{"246155111125525525512936511761761561":[],"2323037125525525512936511761761561":[],"10511915011401421681255255255129365114753651761761561":[],"14014216812552552551293651147536515050501761761561":[]},"tags":["add-ptf"],"grid":24},"attrs":[],"properties":{"order":293,"id":61,"name":"add-ptf","prevSize":24,"code":59750},"setIdx":0,"setId":0,"iconIdx":176},{"icon":{"paths":["M95.844 298.574c0-17.673 14.327-32 32-32h682.951c64.819 0 117.367 52.548 117.367 117.369v405.501c0 76.608-62.101 138.714-138.709 138.714h-234.765c-17.673 0-32-14.327-32-32s14.327-32 32-32h234.765c41.263 0 74.709-33.451 74.709-74.714v-405.501c0-29.475-23.893-53.369-53.367-53.369h-682.951c-17.673 0-32-14.327-32-32z","M95.844 277.232c0-76.608 62.103-138.711 138.711-138.711h405.501c64.823 0 117.372 52.548 117.372 117.369v42.684c0 17.673-14.327 32-32 32s-32-14.327-32-32v-42.684c0-29.475-23.893-53.369-53.372-53.369h-405.501c-41.262 0-74.711 33.449-74.711 74.711v362.819c0 17.673-14.327 32-32 32s-32-14.327-32-32v-362.819z","M95.844 810.786c0-17.673 14.327-32 32-32h298.791c17.675 0 32.002 14.327 32.002 32s-14.327 32-32.002 32h-298.791c-17.673 0-32-14.327-32-32z","M318.639 702.793c12.497-12.497 32.758-12.497 45.255 0l85.37 85.367c12.497 12.497 12.497 32.759 0 45.257l-85.37 85.367c-12.497 12.497-32.758 12.497-45.255 0s-12.497-32.759 0-45.257l62.741-62.741-62.741-62.741c-12.497-12.497-12.497-32.755 0-45.252z","M608.051 597.363c0-17.673 14.327-32 32-32h85.372c17.673 0 32 14.327 32 32s-14.327 32-32 32h-85.372c-17.673 0-32-14.327-32-32z"],"attrs":[],"tags":["Enhance"],"grid":24,"isMulticolor":false,"isMulticolor2":false,"colorPermutations":{"246155111125525525512936511761761561":[],"2323037125525525512936511761761561":[],"10511915011401421681255255255129365114753651761761561":[],"14014216812552552551293651147536515050501761761561":[]}},"attrs":[],"properties":{"order":44,"id":113,"name":"Enhance","prevSize":24,"code":59673},"setIdx":0,"setId":0,"iconIdx":177},{"icon":{"paths":["M68.358 472.384c4.354-7.398 5.66-16.542 3.048-24.815-16.98-63.565 1.306-131.483 47.891-177.633 55.728-55.293 140.191-69.225 209.85-36.136l-19.156 5.225-4.789 1.742c-14.367 6.966-21.333 23.075-16.98 38.313 3.919 13.932 16.98 23.945 31.347 23.945 3.048 0 6.095 0 8.707-1.306l85.769-24.381 3.483-1.306c2.612-1.306 5.224-3.048 6.095-3.919l3.482-3.048c2.611-3.048 4.791-6.095 6.097-9.143l1.306-3.483c0 0 0.87-3.483 1.306-5.225l10.449-87.075v-4.789c-0.87-15.673-12.625-28.735-29.606-30.476h-4.789l-5.66 0.871c-13.061 3.047-23.075 14.367-24.816 27.864l-3.483 29.605c-97.088-59.211-224.218-43.537-304.762 36.572-62.694 62.694-87.51 154.993-64.871 240.764 3.918 14.366 16.98 24.38 31.347 24.38 2.612 0 5.66 0 8.272-1.306 8.272-2.176 15.674-7.838 20.027-15.241h0.435z","M85.772 672.222c16.544 0 30.476-12.194 32.218-28.736l3.483-29.606c38.749 23.074 83.156 35.264 128.436 35.264 67.048 0 129.741-25.685 176.763-72.704 63.13-62.694 87.945-154.995 64.87-240.764-4.791-17.415-22.639-27.864-40.055-23.075-8.273 2.177-15.671 7.837-20.028 15.238-4.352 7.401-5.659 16.544-3.046 24.816 16.977 63.565-1.306 131.484-47.892 177.632-55.728 55.292-140.19 68.791-209.85 36.139l19.156-5.227 4.789-1.741c14.367-6.967 21.333-23.074 17.415-38.315-4.789-17.412-22.639-26.991-40.054-22.639l-86.204 24.384-2.612 1.306c-2.612 1.306-5.224 2.611-7.837 5.222l-3.048 3.046c-2.177 2.615-3.918 5.227-5.225 8.273l-0.87 3.046c0 0-1.306 3.921-1.742 6.097l-10.449 87.074v4.791c0.871 15.671 12.626 28.732 28.3 30.477h3.483z","M980.894 529.421c-3.482-37.879-33.523-67.921-69.658-70.532v-85.333c-3.921-44.408-40.055-79.238-82.722-80.109v-33.959c-3.917-49.197-44.407-87.945-92.301-87.945h-193.741v69.225h193.306c13.5 0 24.819 12.19 24.819 26.122v26.123h-218.125v69.225h285.606c8.273 1.741 15.236 9.578 15.236 18.721v77.497h-37.005c-57.903 4.352-103.185 54.421-103.185 114.94v18.283c4.356 60.083 52.681 107.106 111.023 107.106h29.167v78.801c-1.741 8.273-8.704 14.366-16.542 14.366h-556.844c-8.272-1.741-15.238-9.579-15.238-18.722v-66.611h-67.483v74.014c3.918 44.843 41.36 80.111 84.898 80.111h561.635c43.537-4.356 77.495-42.667 77.495-87.949v-75.755h1.741c38.75-3.482 68.352-37.005 68.352-77.495v-90.991l-0.435 0.87zM913.847 619.541v2.611c-0.87 3.921-3.917 6.967-7.838 6.967h-96.653c-21.769-2.611-38.31-21.769-38.31-44.843v-15.241c2.611-23.074 20.898-40.051 42.667-40.051h92.297c4.356 0 7.838 3.482 7.838 8.704v81.852z"],"attrs":[],"isMulticolor":false,"isMulticolor2":false,"colorPermutations":{"1911962061761761561":[],"761761561771761561":[],"2552552551761761561":[],"246155111125525525512936511761761561":[],"2323037125525525512936511761761561":[],"10511915011401421681255255255129365114753651761761561":[],"14014216812552552551293651147536515050501761761561":[]},"tags":["Portfolio-update"],"grid":24},"attrs":[],"properties":{"order":41,"id":110,"name":"Portfolio-update","prevSize":24,"code":59670},"setIdx":0,"setId":0,"iconIdx":178},{"icon":{"paths":["M0 389.12c0-143.787 117.333-261.12 261.547-261.12 143.787 0 261.12 116.907 261.12 261.12s-116.907 261.547-261.12 261.547c-144.213 0-261.547-117.76-261.547-261.547zM460.8 389.12c0-42.667-13.227-83.2-38.4-117.333l-278.187 278.613c34.133 25.173 74.667 38.4 117.333 38.4 109.653 0 199.253-89.6 199.253-199.68zM100.267 506.453l278.613-278.187c-34.133-25.173-74.667-38.4-117.333-38.4-110.080 0-199.68 89.6-199.68 199.253 0 42.667 13.227 83.2 38.4 117.333zM916.48 464.213c35.84 2.56 66.133 32.427 69.547 70.4l0.427-0.427v90.027c0 40.533-29.44 74.24-68.267 77.653h-1.707v75.947c0 45.227-34.133 83.627-77.653 87.893h-561.493c-43.52 0-81.067-35.413-84.907-80.213v-73.813h67.413v66.56c0 9.387 7.253 17.067 15.36 18.773h555.946c8.107 0 14.933-6.4 16.64-14.507v-78.933h-29.013c-58.453 0-106.667-46.933-110.933-107.093v-18.347c0-60.16 45.227-110.507 103.253-114.773h37.12v-77.653c0-9.387-7.253-17.066-15.36-18.347h-252.16v-69.547h184.747v-26.027c0-13.653-11.093-26.027-24.747-25.6h-159.573v-69.547h160.427c47.787 0 88.32 38.827 92.16 87.893v34.133c42.667 0.853 78.933 35.84 82.773 80.213v85.333zM918.613 627.2v-2.56h-0.427v-82.347c0-5.12-3.413-8.533-7.68-8.533h-92.16c-21.76 0-40.107 17.067-42.667 40.107v15.36c0 23.040 16.64 42.24 38.4 44.8h96.853c3.84 0 6.827-2.987 7.68-6.827z"],"attrs":[],"isMulticolor":false,"isMulticolor2":false,"colorPermutations":{"1911962061761761561":[],"761761561771761561":[],"2552552551761761561":[],"246155111125525525512936511761761561":[],"2323037125525525512936511761761561":[],"10511915011401421681255255255129365114753651761761561":[],"14014216812552552551293651147536515050501761761561":[]},"tags":["Enhance-Not-available"],"grid":24},"attrs":[],"properties":{"order":43,"id":112,"name":"Enhance-Not-available","prevSize":24,"code":59672},"setIdx":0,"setId":0,"iconIdx":179},{"icon":{"paths":["M818.022 853.333h-612.045c-19.502 0-35.311-15.808-35.311-35.311v-612.045c0-19.502 15.809-35.311 35.311-35.311h258.944c19.499 0 35.307 15.809 35.307 35.311s-15.808 35.31-35.307 35.31h-223.634v541.424h541.424v-223.633c0-19.499 15.812-35.307 35.311-35.307 19.503 0 35.311 15.808 35.311 35.307v258.944c0 19.503-15.808 35.311-35.311 35.311zM759.172 264.828h-49.937l-151.582 151.583c-13.79 13.789-13.79 36.146 0 49.936s36.147 13.79 49.937 0l151.582-151.583v-49.936zM853.333 205.977v188.322c0 19.501-15.808 35.312-35.311 35.312-19.499 0-35.311-15.811-35.311-35.312v-153.012h-153.011c-19.499 0-35.311-15.809-35.311-35.31s15.812-35.311 35.311-35.311h188.322c19.503 0 35.311 15.809 35.311 35.311z"],"attrs":[],"isMulticolor":false,"isMulticolor2":false,"colorPermutations":{"1911962061761761561":[],"761761561771761561":[],"2552552551761761561":[],"246155111125525525512936511761761561":[],"2323037125525525512936511761761561":[],"10511915011401421681255255255129365114753651761761561":[],"14014216812552552551293651147536515050501761761561":[]},"tags":["Expand"],"grid":24},"attrs":[],"properties":{"order":45,"id":114,"name":"Expand","prevSize":24,"code":59674},"setIdx":0,"setId":0,"iconIdx":180},{"icon":{"paths":["M232.69 213.333h558.618c57.399 0 104.286 47.211 104.691 105.004v422.053c0 58.202-46.886 105.412-104.691 105.412h-558.618c-57.802 0.405-104.69-47.211-104.69-105.412v-421.239c0 0 0-0.814 0-1.221 0-57.386 47.293-104.597 104.69-104.597zM197.929 386.306v354.085c0 19.127 15.764 34.999 34.762 34.999h558.618c18.999 0 34.765-15.872 34.765-34.999v-354.085l-294.268 207.158c-12.126 8.55-27.891 8.55-40.017 0l-293.86-207.158zM201.566 303.279l310.434 218.961 310.434-218.961c-5.658-11.396-17.788-19.536-31.125-19.536h-558.618c-13.743 0-25.465 8.14-31.124 19.536z"],"attrs":[],"isMulticolor":false,"isMulticolor2":false,"colorPermutations":{"1911962061761761561":[],"761761561771761561":[],"2552552551761761561":[],"246155111125525525512936511761761561":[],"2323037125525525512936511761761561":[],"10511915011401421681255255255129365114753651761761561":[],"14014216812552552551293651147536515050501761761561":[]},"tags":["Mail"],"grid":24},"attrs":[],"properties":{"order":47,"id":115,"name":"Mail","prevSize":24,"code":59676},"setIdx":0,"setId":0,"iconIdx":181},{"icon":{"paths":["M324.267 503.467c0 42.419-34.382 76.8-76.8 76.8s-76.8-34.381-76.8-76.8c0-42.419 34.382-76.8 76.8-76.8s76.8 34.381 76.8 76.8z","M593.067 503.467c0 42.419-34.381 76.8-76.8 76.8-42.415 0-76.8-34.381-76.8-76.8s34.385-76.8 76.8-76.8c42.419 0 76.8 34.381 76.8 76.8z","M861.871 503.467c0 42.419-34.381 76.8-76.8 76.8s-76.8-34.381-76.8-76.8c0-42.419 34.381-76.8 76.8-76.8s76.8 34.381 76.8 76.8z"],"attrs":[],"isMulticolor":false,"isMulticolor2":false,"colorPermutations":{"1911962061761761561":[],"761761561771761561":[],"2552552551761761561":[],"246155111125525525512936511761761561":[],"2323037125525525512936511761761561":[],"10511915011401421681255255255129365114753651761761561":[],"14014216812552552551293651147536515050501761761561":[]},"tags":["More"],"grid":24},"attrs":[],"properties":{"order":49,"id":116,"name":"More","prevSize":24,"code":59678},"setIdx":0,"setId":0,"iconIdx":182},{"icon":{"paths":["M512 256c18.125 0 32.819 14.694 32.819 32.82v426.665c0 18.129-14.694 32.823-32.819 32.823s-32.819-14.694-32.819-32.823v-426.665c0-18.126 14.694-32.82 32.819-32.82zM101.584 326.131c10.065-5.888 22.498-5.99 32.66-0.276l262.566 147.694c10.332 5.811 16.729 16.747 16.729 28.604 0 11.861-6.397 22.797-16.729 28.608l-262.566 147.691c-10.162 5.717-22.595 5.615-32.66-0.273s-16.251-16.67-16.251-28.331v-295.386c0-11.661 6.186-22.446 16.251-28.331zM922.415 326.131c10.065 5.885 16.252 16.669 16.252 28.331v295.386c0 11.661-6.187 22.443-16.252 28.331s-22.498 5.99-32.661 0.273l-262.562-147.691c-10.334-5.811-16.73-16.747-16.73-28.608 0-11.857 6.396-22.793 16.73-28.604l262.562-147.694c10.163-5.714 22.596-5.612 32.661 0.276zM150.974 410.578v183.15l162.799-91.575-162.799-91.575zM710.225 502.153l162.799 91.575v-183.15l-162.799 91.575z"],"attrs":[],"isMulticolor":false,"isMulticolor2":false,"colorPermutations":{"1911962061761761561":[],"761761561771761561":[],"2552552551761761561":[],"246155111125525525512936511761761561":[],"2323037125525525512936511761761561":[],"10511915011401421681255255255129365114753651761761561":[],"14014216812552552551293651147536515050501761761561":[]},"tags":["News-category-Contraints"],"grid":24},"attrs":[],"properties":{"order":50,"id":117,"name":"News-category-Contraints","prevSize":24,"code":59679},"setIdx":0,"setId":0,"iconIdx":183},{"icon":{"paths":["M512 170.667c-188.199 0-341.333 153.134-341.333 341.333s153.134 341.333 341.333 341.333c188.198 0 341.333-153.135 341.333-341.333s-153.135-341.333-341.333-341.333zM775.215 548.843c-18.645 131.827-129.613 229.922-263.215 229.922-147.364 0-267.208-119.846-267.208-267.209 0-47.936 12.872-94.544 37.285-135.823l206.84 165.118c6.66 5.325 14.647 7.991 23.083 7.991h263.215zM329.127 318.031c76.789-73.238 192.196-95.431 292.953-48.381l-118.959 187.311-173.994-138.929zM579.913 474.714l105.195-164.673c49.715 42.611 81.673 100.314 90.551 164.673h-195.746z"],"attrs":[],"isMulticolor":false,"isMulticolor2":false,"colorPermutations":{"1911962061761761561":[],"761761561771761561":[],"2552552551761761561":[],"246155111125525525512936511761761561":[],"2323037125525525512936511761761561":[],"10511915011401421681255255255129365114753651761761561":[],"14014216812552552551293651147536515050501761761561":[]},"tags":["News-category-exposure"],"grid":24},"attrs":[],"properties":{"order":51,"id":118,"name":"News-category-exposure","prevSize":24,"code":59680},"setIdx":0,"setId":0,"iconIdx":184},{"icon":{"paths":["M573.803 296.598h-361.866c-22.807 0-41.27-18.825-41.27-41.632s18.463-41.632 41.27-41.632h362.591c22.805 0 41.267 18.463 41.267 41.632s-18.462 41.632-41.993 41.632zM211.937 381.932h450.122c22.805 0 41.267 18.463 41.267 41.632s-18.462 41.631-41.993 41.631h-449.396c-22.807 0-41.27-18.825-41.27-41.631s18.463-41.632 41.27-41.632zM595.861 550.528h-383.924c-22.807 0-41.27 18.825-41.27 41.634 0 22.805 18.463 41.63 41.27 41.63h383.199c23.531 0 41.993-18.462 41.993-41.63s-18.462-41.634-41.267-41.634zM211.937 719.125h514.792c22.81 0 41.271 18.466 41.271 41.634s-18.462 41.634-41.993 41.634h-514.071c-22.807 0-41.27-18.829-41.27-41.634s18.463-41.634 41.27-41.634z"],"attrs":[],"isMulticolor":false,"isMulticolor2":false,"colorPermutations":{"1911962061761761561":[],"761761561771761561":[],"2552552551761761561":[],"246155111125525525512936511761761561":[],"2323037125525525512936511761761561":[],"10511915011401421681255255255129365114753651761761561":[],"14014216812552552551293651147536515050501761761561":[]},"tags":["News-category-isntruments"],"grid":24},"attrs":[],"properties":{"order":52,"id":119,"name":"News-category-isntruments","prevSize":24,"code":59681},"setIdx":0,"setId":0,"iconIdx":185},{"icon":{"paths":["M947.857 521.839h-100.429v-122.744c0-55.347-45.082-100.428-100.429-100.428-55.343 0-100.425 45.081-100.425 100.428v122.744h-67.401c-5.355-49.988-48.205-89.267-99.981-89.267s-94.179 39.279-99.982 89.267h-67.398v-78.11c0-55.347-45.081-100.428-100.428-100.428s-100.428 45.081-100.428 100.428v78.11h-34.815c-18.746 0-33.476 14.729-33.476 33.476s14.729 33.476 33.476 33.476h168.719v78.11c0 55.347 45.081 100.429 100.428 100.429s100.428-45.082 100.428-100.429v-78.11h67.401c5.355 49.993 48.205 89.271 99.981 89.271s94.178-39.279 99.981-89.271h67.396v33.476c0 55.347 45.082 100.429 100.429 100.429h22.319c18.748 0 33.476-14.729 33.476-33.476s-14.729-33.476-33.476-33.476h-22.319c-18.3 0-33.476-15.177-33.476-33.476v-33.476h100.429c18.748 0 33.476-14.729 33.476-33.476s-14.729-33.476-33.476-33.476zM244.861 521.839h-66.952v-78.11c0-18.3 15.176-33.476 33.476-33.476s33.476 15.176 33.476 33.476v78.11zM378.766 666.901c0 18.3-15.176 33.476-33.476 33.476s-33.476-15.177-33.476-33.476v-78.11h66.952v78.11zM447.501 521.839c4.467-12.945 16.964-22.315 31.693-22.315s26.782 9.37 31.689 22.315h-63.381zM613.099 611.11c-14.729 0-26.782-9.374-31.693-22.319h62.938c-4.467 12.945-16.964 22.319-31.693 22.319h0.448zM780.476 521.839h-66.948v-122.744c0-18.3 15.172-33.476 33.472-33.476 18.304 0 33.476 15.176 33.476 33.476v122.744z"],"attrs":[],"isMulticolor":false,"isMulticolor2":false,"colorPermutations":{"1911962061761761561":[],"761761561771761561":[],"2552552551761761561":[],"246155111125525525512936511761761561":[],"2323037125525525512936511761761561":[],"10511915011401421681255255255129365114753651761761561":[],"14014216812552552551293651147536515050501761761561":[]},"tags":["News-category-Market-variations"],"grid":24},"attrs":[],"properties":{"order":53,"id":120,"name":"News-category-Market-variations","prevSize":24,"code":59682},"setIdx":0,"setId":0,"iconIdx":186},{"icon":{"paths":["M978.155 237.701c-4.237-9.535-11.652-16.951-20.13-20.659-4.766-2.649-10.065-3.708-15.889-3.708h-105.946c-22.251 0-39.731 17.481-39.731 39.729s17.481 39.729 39.731 39.729h10.065l-168.981 168.981-130.842-130.841c-15.893-15.892-40.789-15.892-56.149 0l-91.113 91.112-91.112-91.112c-15.892-15.892-40.788-15.892-56.151 0l-197.586 194.939c-7.416 7.415-11.654 17.481-11.654 28.075s4.238 20.659 12.183 28.604c15.362 14.302 40.259 14.302 54.561 2.65l170.041-170.042 63.037 63.038-117.598 117.598c-7.416 7.415-11.654 17.481-11.654 28.075s4.238 20.659 12.184 28.604c15.892 14.302 43.437 13.244 55.621-1.058l117.598-117.598 223.014 223.010c6.886 7.949 17.481 12.186 28.604 12.186s21.188-4.237 28.075-11.652l264.862-264.862c7.415-7.415 11.652-17.481 11.652-28.075s-4.237-20.659-11.652-28.075c-15.893-15.893-40.26-15.893-56.149 0l-236.258 236.783-195.465-195.465 63.036-63.039 130.842 130.84c15.889 15.893 40.789 15.893 56.149 0l196.527-197.056v10.065c0 22.248 17.481 39.729 39.727 39.729 22.251 0 39.731-17.481 39.731-39.729v-105.415c0-5.827-1.058-11.124-3.179-15.362z"],"attrs":[],"isMulticolor":false,"isMulticolor2":false,"colorPermutations":{"1911962061761761561":[],"761761561771761561":[],"2552552551761761561":[],"246155111125525525512936511761761561":[],"2323037125525525512936511761761561":[],"10511915011401421681255255255129365114753651761761561":[],"14014216812552552551293651147536515050501761761561":[]},"tags":["News-category-Market-view-aligment"],"grid":24},"attrs":[],"properties":{"order":54,"id":121,"name":"News-category-Market-view-aligment","prevSize":24,"code":59683},"setIdx":0,"setId":0,"iconIdx":187},{"icon":{"paths":["M499.196 643.853c-37.094 0-70.652 22.519-84.341 56.521h-209.746c-18.546 0-34.442 16.341-34.442 34.445s16.338 34.441 34.442 34.441h210.188c13.687 34.001 46.805 56.521 84.339 56.521 51.221 0 90.965-40.179 90.965-90.961s-40.627-90.965-90.965-90.965h-0.439zM520.832 734.818c0 12.365-9.715 21.636-21.636 21.636-11.925 0-21.636-9.715-21.636-21.636s9.711-22.080 21.636-22.080c11.921 0 21.636 9.715 21.636 22.080z","M527.010 484.894c-13.687-33.997-46.805-56.521-84.339-56.521-51.221 0-90.963 40.183-90.963 90.965s40.183 90.961 90.963 90.961c37.094 0 70.652-22.519 84.339-56.521h290.112c18.547 0 34.445-16.337 34.445-34.001 0.883-8.388-1.766-17.22-7.949-23.842-6.626-7.066-15.458-11.482-24.73-11.482h-291.878v0.439zM464.751 519.339c0 12.365-9.276 21.636-21.636 21.636-12.365 0-21.638-9.715-21.638-21.636s9.713-21.636 21.638-21.636c11.921 0 21.636 9.271 21.636 21.636z","M205.109 338.739h279.956c13.687 34.001 46.805 56.521 84.339 56.521 51.221 0 90.965-40.183 90.965-90.964s-39.744-90.963-90.965-90.963c-37.090 0-70.652 22.52-84.339 56.521h-279.956c-18.546 0-34.442 16.338-34.442 34.442s16.338 34.443 34.442 34.443zM547.324 304.297c0-12.364 9.276-21.637 21.641-21.637 12.361 0 21.636 9.714 21.636 21.637s-9.715 21.637-21.636 21.637c-11.925 0-21.641-9.273-21.641-21.637z","M818.897 700.373h-202.24v69.329h202.24c18.543 0 34.441-16.337 34.441-34.445 0-19.426-15.014-34.441-34.441-34.441v-0.444z","M205.109 554.223h118.341v-69.329h-118.341c-18.546 0-34.442 16.341-34.442 34.445s16.338 34.441 34.442 34.441v0.444z","M853.329 304.297c0-18.546-16.337-34.442-34.441-34.442h-130.266v69.327h130.266c18.547 0 34.441-16.338 34.441-34.443v-0.442z"],"attrs":[],"isMulticolor":false,"isMulticolor2":false,"colorPermutations":{"1911962061761761561":[],"761761561771761561":[],"2552552551761761561":[],"246155111125525525512936511761761561":[],"2323037125525525512936511761761561":[],"10511915011401421681255255255129365114753651761761561":[],"14014216812552552551293651147536515050501761761561":[]},"tags":["Optimize"],"grid":24},"attrs":[],"properties":{"order":55,"id":122,"name":"Optimize","prevSize":24,"code":59684},"setIdx":0,"setId":0,"iconIdx":188},{"icon":{"paths":["M341.333 160c-5.879 0-10.667 4.788-10.667 10.667v170.667c0 17.673-14.327 32-32 32s-32-14.327-32-32v-170.667c0-41.225 33.442-74.667 74.667-74.667h341.333c41.225 0 74.667 33.442 74.667 74.667v170.667c0 17.673-14.327 32-32 32s-32-14.327-32-32v-170.667c0-5.879-4.787-10.667-10.667-10.667h-341.333z","M213.333 373.333c-29.474 0-53.333 23.86-53.333 53.333v213.333c0 29.474 23.86 53.333 53.333 53.333h85.333c17.673 0 32 14.327 32 32s-14.327 32-32 32h-85.333c-64.82 0-117.333-52.514-117.333-117.333v-213.333c0-64.82 52.514-117.333 117.333-117.333h597.333c64.819 0 117.333 52.514 117.333 117.333v213.333c0 64.819-52.514 117.333-117.333 117.333h-85.333c-17.673 0-32-14.327-32-32s14.327-32 32-32h85.333c29.474 0 53.333-23.859 53.333-53.333v-213.333c0-29.474-23.859-53.333-53.333-53.333h-597.333z","M266.667 588.8c0-17.673 14.327-32 32-32h426.667c17.673 0 32 14.327 32 32v264.533c0 41.225-33.442 74.667-74.667 74.667h-341.333c-41.225 0-74.667-33.442-74.667-74.667v-264.533zM330.667 620.8v232.533c0 5.879 4.788 10.667 10.667 10.667h341.333c5.879 0 10.667-4.787 10.667-10.667v-232.533h-362.667z","M266.667 469.333c0-17.673 14.327-32 32-32h42.667c17.673 0 32 14.327 32 32s-14.327 32-32 32h-42.667c-17.673 0-32-14.327-32-32z"],"attrs":[],"tags":["Print"],"grid":24,"isMulticolor":false,"isMulticolor2":false,"colorPermutations":{"246155111125525525512936511761761561":[],"2323037125525525512936511761761561":[],"10511915011401421681255255255129365114753651761761561":[],"14014216812552552551293651147536515050501761761561":[]}},"attrs":[],"properties":{"order":56,"id":123,"name":"Print","prevSize":24,"code":59685},"setIdx":0,"setId":0,"iconIdx":189},{"icon":{"paths":["M835.089 223.759c4.075-18.186 11.311-40.627 15.91-45.246 4.638-4.619 27.081-11.893 45.265-15.93l40.661-9.093-40.661-9.093c-18.185-4.073-40.666-11.311-45.282-15.894-4.582-4.619-11.823-27.097-15.893-45.282l-9.092-40.554-9.097 40.554c-4.070 18.185-11.311 40.663-15.927 45.318-4.582 4.547-27.059 11.784-45.227 15.857l-40.61 9.056 40.593 9.129c18.185 4.037 40.623 11.311 45.244 15.93s11.857 27.061 15.932 45.246l9.092 40.518 9.092-40.518zM125.938 288.652c28.097-6.292 76.907-20.477 88.255-31.825s25.569-60.157 31.861-88.273l9.074-40.554 9.075 40.554c6.31 28.114 20.513 76.925 31.879 88.273 11.33 11.348 60.14 25.533 88.237 31.825l40.608 9.056-40.591 9.129c-28.115 6.292-76.925 20.477-88.273 31.825s-25.551 60.194-31.861 88.311l-9.075 40.589-9.075-40.589c-6.292-28.116-20.513-76.963-31.843-88.311-11.348-11.311-60.176-25.533-88.291-31.825l-40.591-9.129 40.609-9.056zM467.409 472.73c47.684-47.611 95.475-259.295 95.949-261.436l9.092-40.627 9.101 40.742c1.357 5.972 48.666 214.121 95.927 261.321 47.663 47.718 259.358 95.509 261.487 95.987l40.627 9.092-40.627 9.092c-2.125 0.474-213.824 48.265-261.487 95.91-46.882 46.903-93.888 252.493-95.889 261.239l-0.064 0.273-9.075 40.627-9.092-40.627c-0.474-2.112-48.265-213.828-95.949-261.513-47.646-47.646-259.359-95.437-261.491-95.91l-40.627-9.092 40.608-9.092c2.146-0.474 213.827-48.265 261.509-95.987z"],"attrs":[],"isMulticolor":false,"isMulticolor2":false,"colorPermutations":{"191196206125525525512936511761761561":[],"174239125525525512936511":[],"255255255129365114248601":[],"246155111125525525512936511761761561":[],"2323037125525525512936511761761561":[],"10511915011401421681255255255129365114753651761761561":[],"14014216812552552551293651147536515050501761761561":[]},"tags":["Ask-ai"],"grid":24},"attrs":[],"properties":{"order":171,"id":125,"name":"Ask-ai","prevSize":24,"code":59761},"setIdx":0,"setId":0,"iconIdx":190},{"icon":{"paths":["M740.958 616.454l-233.075-228.524c-5.38-5.274-14.007-5.235-19.345 0.094l-228.512 228.522c-3.927 3.926-5.105 9.842-2.984 14.973s7.133 8.481 12.695 8.481h461.604c5.589 0 10.615-3.377 12.719-8.547 2.108-5.17 0.892-11.086-3.102-14.999z"],"attrs":[],"isMulticolor":false,"isMulticolor2":false,"colorPermutations":{"191196206125525525512936511761761561":[],"174239125525525512936511":[],"255255255129365114248601":[],"246155111125525525512936511761761561":[],"2323037125525525512936511761761561":[],"10511915011401421681255255255129365114753651761761561":[],"14014216812552552551293651147536515050501761761561":[]},"tags":["Property 1=az"],"grid":24},"attrs":[],"properties":{"order":139,"id":126,"name":"Property-1az","prevSize":24,"code":59726},"setIdx":0,"setId":0,"iconIdx":191},{"icon":{"paths":["M740.958 317.787l-233.075-228.524c-5.38-5.275-14.007-5.236-19.345 0.092l-228.512 228.524c-3.927 3.926-5.105 9.842-2.984 14.973s7.133 8.481 12.695 8.481h461.604c5.589 0 10.615-3.377 12.719-8.547 2.108-5.17 0.892-11.099-3.102-15.013v0.013z","M740.958 706.214l-233.075 228.523c-5.38 5.274-14.007 5.235-19.345-0.094l-228.512-228.523c-3.927-3.925-5.105-9.843-2.984-14.972 2.12-5.133 7.133-8.482 12.695-8.482h461.604c5.589 0 10.615 3.375 12.719 8.546 2.108 5.171 0.892 11.098-3.102 15.014v-0.013z"],"attrs":[],"isMulticolor":false,"isMulticolor2":false,"colorPermutations":{"191196206125525525512936511761761561":[],"174239125525525512936511":[],"255255255129365114248601":[],"246155111125525525512936511761761561":[],"2323037125525525512936511761761561":[],"10511915011401421681255255255129365114753651761761561":[],"14014216812552552551293651147536515050501761761561":[]},"tags":["Property 1=Default"],"grid":24},"attrs":[],"properties":{"order":127,"id":127,"name":"Property-1Default","prevSize":24,"code":59727},"setIdx":0,"setId":0,"iconIdx":192},{"icon":{"paths":["M740.958 407.548l-233.075 228.522c-5.38 5.275-14.007 5.236-19.345-0.092l-228.512-228.524c-3.927-3.925-5.105-9.843-2.984-14.972 2.12-5.133 7.133-8.482 12.695-8.482h461.604c5.589 0 10.615 3.375 12.719 8.546 2.108 5.171 0.892 11.085-3.102 15.002z"],"attrs":[],"isMulticolor":false,"isMulticolor2":false,"colorPermutations":{"191196206125525525512936511761761561":[],"174239125525525512936511":[],"255255255129365114248601":[],"246155111125525525512936511761761561":[],"2323037125525525512936511761761561":[],"10511915011401421681255255255129365114753651761761561":[],"14014216812552552551293651147536515050501761761561":[]},"tags":["Property 1=za"],"grid":24},"attrs":[],"properties":{"order":128,"id":128,"name":"Property-1za","prevSize":24,"code":59728},"setIdx":0,"setId":0,"iconIdx":193},{"icon":{"paths":["M522.667 128c53.019 0 96 42.981 96 96v576c0 53.019-42.981 96-96 96s-96-42.981-96-96v-576c0-53.019 42.981-96 96-96z"],"attrs":[],"isMulticolor":false,"isMulticolor2":false,"colorPermutations":{"174239125525525512936511":[],"191196206125525525512936511761761561":[],"255255255129365114248601":[],"246155111125525525512936511761761561":[],"2323037125525525512936511761761561":[],"10511915011401421681255255255129365114753651761761561":[],"14014216812552552551293651147536515050501761761561":[]},"tags":["Legend/full"],"grid":24},"attrs":[],"properties":{"order":119,"id":129,"name":"legend-full","prevSize":24,"code":59721},"setIdx":0,"setId":0,"iconIdx":194},{"icon":{"paths":["M522.667 608c53.019 0 96 42.981 96 96v96c0 53.019-42.981 96-96 96s-96-42.981-96-96v-96c0-53.019 42.981-96 96-96z","M522.667 128c53.019 0 96 42.981 96 96v96c0 53.019-42.981 96-96 96s-96-42.981-96-96v-96c0-53.019 42.981-96 96-96z"],"attrs":[],"isMulticolor":false,"isMulticolor2":false,"colorPermutations":{"174239125525525512936511":[],"191196206125525525512936511761761561":[],"255255255129365114248601":[],"246155111125525525512936511761761561":[],"2323037125525525512936511761761561":[],"10511915011401421681255255255129365114753651761761561":[],"14014216812552552551293651147536515050501761761561":[]},"tags":["Legend/dashes"],"grid":24},"attrs":[],"properties":{"order":120,"id":130,"name":"Legend-dashed","prevSize":24,"code":59722},"setIdx":0,"setId":0,"iconIdx":195},{"icon":{"paths":["M704 512c0 106.039-85.961 192-192 192s-192-85.961-192-192c0-106.039 85.961-192 192-192s192 85.961 192 192z","M576 512c0 35.345-28.655 64-64 64v0c-35.345 0-64-28.655-64-64v0c0-35.345 28.655-64 64-64v0c35.345 0 64 28.655 64 64v0z"],"attrs":[{"fill":"rgb(29, 36, 51)"},{"fill":"rgb(255, 255, 255)"}],"isMulticolor":true,"isMulticolor2":false,"colorPermutations":{"174239125525525512936511":[{"f":0},{"f":2}],"191196206125525525512936511761761561":[{"f":0},{"f":3}],"255255255129365114248601":[{"f":0},{"f":2}],"246155111125525525512936511761761561":[{"f":0},{"f":3}],"2323037125525525512936511761761561":[{"f":0},{"f":3}],"10511915011401421681255255255129365114753651761761561":[{"f":0},{"f":5}],"14014216812552552551293651147536515050501761761561":[{"f":0},{"f":5}]},"tags":["previous-position"],"grid":24},"attrs":[{"fill":"rgb(29, 36, 51)"},{"fill":"rgb(255, 255, 255)"}],"properties":{"order":110,"id":131,"name":"previous-position","prevSize":24,"code":59712,"codes":[59712,59713]},"setIdx":0,"setId":0,"iconIdx":196},{"icon":{"paths":["M832 512c0 176.731-143.269 320-320 320s-320-143.269-320-320c0-176.731 143.269-320 320-320s320 143.269 320 320z","M704 512c0 106.039-85.961 192-192 192s-192-85.961-192-192c0-106.039 85.961-192 192-192s192 85.961 192 192z","M576 512c0 35.345-28.655 64-64 64v0c-35.345 0-64-28.655-64-64v0c0-35.345 28.655-64 64-64v0c35.345 0 64 28.655 64 64v0z"],"attrs":[{"fill":"rgb(29, 36, 51)","opacity":0.4},{"fill":"rgb(29, 36, 51)"},{"fill":"rgb(255, 255, 255)"}],"isMulticolor":true,"isMulticolor2":true,"colorPermutations":{"174239125525525512936511":[{"f":0},{"f":0},{"f":2}],"191196206125525525512936511761761561":[{"f":0},{"f":0},{"f":3}],"255255255129365114248601":[{"f":0},{"f":0},{"f":2}],"246155111125525525512936511761761561":[{"f":0},{"f":0},{"f":3}],"2323037125525525512936511761761561":[{"f":0},{"f":0},{"f":3}],"10511915011401421681255255255129365114753651761761561":[{"f":0},{"f":0},{"f":5}],"14014216812552552551293651147536515050501761761561":[{"f":0},{"f":0},{"f":5}]},"tags":["previous+current-position"],"grid":24},"attrs":[{"fill":"rgb(29, 36, 51)","opacity":0.4},{"fill":"rgb(29, 36, 51)"},{"fill":"rgb(255, 255, 255)"}],"properties":{"order":111,"id":132,"name":"previouscurrent-position","prevSize":24,"code":59714,"codes":[59714,59715,59716]},"setIdx":0,"setId":0,"iconIdx":197},{"icon":{"paths":["M832 512c0 176.731-143.269 320-320 320s-320-143.269-320-320c0-176.731 143.269-320 320-320s320 143.269 320 320z"],"attrs":[{"opacity":0.4}],"isMulticolor":false,"isMulticolor2":false,"colorPermutations":{"174239125525525512936511":[{}],"191196206125525525512936511761761561":[{}],"255255255129365114248601":[{}],"246155111125525525512936511761761561":[{}],"2323037125525525512936511761761561":[{}],"10511915011401421681255255255129365114753651761761561":[{}],"14014216812552552551293651147536515050501761761561":[{}]},"tags":["current-position"],"grid":24},"attrs":[{"opacity":0.4}],"properties":{"order":112,"id":133,"name":"current-position","prevSize":24,"code":59717},"setIdx":0,"setId":0,"iconIdx":198},{"icon":{"paths":["M103.759 298.667h238.978c-18.13 42.475-17.679 93.205 9.87 139.537l82.213 138.274-83.519 140.467c-23.563 39.629-81.707 39.629-105.27 0l-194.907-327.804c-23.822-40.064 5.505-90.475 52.634-90.475zM435.123 389.141c-23.815-40.054 5.491-90.449 52.599-90.475h389.85c47.13 0 76.459 50.41 52.638 90.475l-194.91 327.804c-23.561 39.629-81.707 39.629-105.267 0l-194.91-327.804z"],"attrs":[],"isMulticolor":false,"isMulticolor2":false,"colorPermutations":{"174239125525525512936511":[],"191196206125525525512936511761761561":[],"255255255129365114248601":[],"246155111125525525512936511761761561":[],"2323037125525525512936511761761561":[],"10511915011401421681255255255129365114753651761761561":[],"14014216812552552551293651147536515050501761761561":[]},"tags":["driver-arrow-doubledown"],"grid":24},"attrs":[],"properties":{"order":103,"id":134,"name":"driver-arrow-doubledown","prevSize":24,"code":59706},"setIdx":0,"setId":0,"iconIdx":199},{"icon":{"paths":["M810.667 512c0 164.949-133.718 298.667-298.667 298.667s-298.667-133.718-298.667-298.667c0-164.949 133.718-298.667 298.667-298.667s298.667 133.718 298.667 298.667z"],"attrs":[],"isMulticolor":false,"isMulticolor2":false,"colorPermutations":{"174239125525525512936511":[],"191196206125525525512936511761761561":[],"255255255129365114248601":[],"246155111125525525512936511761761561":[],"2323037125525525512936511761761561":[],"10511915011401421681255255255129365114753651761761561":[],"14014216812552552551293651147536515050501761761561":[]},"tags":["driver-arrow-center"],"grid":24},"attrs":[],"properties":{"order":104,"id":135,"name":"driver-arrow-center","prevSize":24,"code":59707},"setIdx":0,"setId":0,"iconIdx":200},{"icon":{"paths":["M951.543 613.525c23.821 40.064-5.508 90.475-52.638 90.475h-389.867c-47.1-0.038-76.395-50.423-52.582-90.475l194.91-327.804c23.561-39.629 81.707-39.629 105.267 0l194.91 327.804zM125.093 704h238.978c-18.13-42.475-17.679-93.205 9.87-139.537l82.213-138.272-83.519-140.469c-23.563-39.629-81.707-39.629-105.27 0l-194.907 327.804c-23.822 40.064 5.505 90.475 52.634 90.475z"],"attrs":[],"isMulticolor":false,"isMulticolor2":false,"colorPermutations":{"174239125525525512936511":[],"191196206125525525512936511761761561":[],"255255255129365114248601":[],"246155111125525525512936511761761561":[],"2323037125525525512936511761761561":[],"10511915011401421681255255255129365114753651761761561":[],"14014216812552552551293651147536515050501761761561":[]},"tags":["driver-arrow-doubleup"],"grid":24},"attrs":[],"properties":{"order":157,"id":136,"name":"driver-arrow-doubleup","prevSize":24,"code":59708},"setIdx":0,"setId":0,"iconIdx":201},{"icon":{"paths":["M685.436 298.667c44.885 0 72.815 48.010 50.129 86.166l-185.626 312.195c-22.443 37.739-77.815 37.739-100.258 0l-185.626-312.195c-22.687-38.156 5.243-86.166 50.128-86.166h371.252z"],"attrs":[],"isMulticolor":false,"isMulticolor2":false,"colorPermutations":{"174239125525525512936511":[],"191196206125525525512936511761761561":[],"255255255129365114248601":[],"246155111125525525512936511761761561":[],"2323037125525525512936511761761561":[],"10511915011401421681255255255129365114753651761761561":[],"14014216812552552551293651147536515050501761761561":[]},"tags":["driver-arrow-singledown"],"grid":24},"attrs":[],"properties":{"order":106,"id":137,"name":"driver-arrow-singledown","prevSize":24,"code":59709},"setIdx":0,"setId":0,"iconIdx":202},{"icon":{"paths":["M295.898 725.333c-44.885 0-72.815-48.009-50.128-86.165l185.624-312.195c22.443-37.742 77.815-37.742 100.258 0l185.626 312.195c22.686 38.157-5.244 86.165-50.129 86.165h-371.251z"],"attrs":[],"isMulticolor":false,"isMulticolor2":false,"colorPermutations":{"174239125525525512936511":[],"191196206125525525512936511761761561":[],"255255255129365114248601":[],"246155111125525525512936511761761561":[],"2323037125525525512936511761761561":[],"10511915011401421681255255255129365114753651761761561":[],"14014216812552552551293651147536515050501761761561":[]},"tags":["driver-arrow-singleup"],"grid":24},"attrs":[],"properties":{"order":107,"id":138,"name":"driver-arrow-singleup","prevSize":24,"code":59710},"setIdx":0,"setId":0,"iconIdx":203},{"icon":{"paths":["M752.198 270.525c-19.379-19.395-50.099-19.363-69.517 0.073l-171.251 171.38-170.993-171.123c-19.38-19.395-50.099-19.363-69.519 0.073s-19.453 50.177-0.073 69.572l171.8 171.93-172.060 172.189c-19.421 19.437-19.453 50.176-0.072 69.574 9.69 9.696 22.619 14.534 34.745 13.715 12.934-0.013 25.064-4.070 34.774-13.792l172.060-172.187 171.798 171.931c9.69 9.696 22.624 14.534 34.746 13.715 12.128-0.819 25.062-4.070 34.778-13.786 19.418-19.437 19.45-50.182 0.070-69.574l-171.799-171.932 172.061-172.19c17.805-19.434 17.837-50.175-1.549-69.571z"],"attrs":[],"tags":["Icon-full-error"],"grid":24,"isMulticolor":false,"isMulticolor2":false,"colorPermutations":{"2323037125525525512936511761761561":[],"246155111125525525512936511761761561":[],"10511915011401421681255255255129365114753651761761561":[],"14014216812552552551293651147536515050501761761561":[]}},"attrs":[],"properties":{"order":28,"id":141,"name":"Icon-full-error","prevSize":24,"code":59690},"setIdx":0,"setId":0,"iconIdx":204},{"icon":{"paths":["M411.159 154.403c0-61.812 50.323-111.737 112.134-111.737 62.208 0 112.132 49.925 112.132 111.737s-50.321 111.736-112.132 111.736c-61.811 0-112.134-49.925-112.134-111.736zM248.31 167.083c-56.265 0-101.831 45.566-101.831 101.831s45.566 101.831 101.831 101.831c56.265 0 101.831-45.566 101.831-101.831s-45.566-101.831-101.831-101.831zM134.196 451.972c50.321 0 91.529 41.207 91.529 91.529 0 50.718-40.812 91.529-91.529 91.529-50.321 0-91.529-41.207-91.529-91.529s41.208-91.529 91.529-91.529zM190.459 875.541c-31.698-31.701-31.698-83.209 0-114.906 32.095-31.701 83.604-31.701 115.303 0 31.698 31.697 32.094 83.204 0 114.906-32.095 31.697-83.604 31.697-115.303 0zM523.294 839.087c-39.228 0-71.322 31.697-71.322 71.322s31.697 71.322 71.322 71.322c39.625 0 71.322-31.697 71.322-71.322s-32.094-71.322-71.322-71.322zM861.67 543.104c0-28.134 22.588-50.718 50.718-50.718 28.134 0 51.115 22.583 51.115 50.718 0 28.13-22.98 50.718-51.115 50.718-28.13 0-50.718-22.588-50.718-50.718zM755.085 774.899c-23.77 23.774-23.77 62.605 0 86.379 23.774 23.774 62.605 23.774 86.379 0s23.774-62.605 0-86.379c-23.774-23.774-62.605-23.774-86.379 0zM843.051 264.555c0 22.585-18.227 40.812-40.811 40.812-22.588 0-40.815-18.227-40.815-40.812s18.227-40.812 40.815-40.812c22.583 0 40.811 18.227 40.811 40.812z"],"attrs":[],"isMulticolor":false,"isMulticolor2":false,"colorPermutations":{"174239125525525512936511":[],"191196206125525525512936511761761561":[],"255255255129365114248601":[],"246155111125525525512936511761761561":[],"2323037125525525512936511761761561":[],"10511915011401421681255255255129365114753651761761561":[],"14014216812552552551293651147536515050501761761561":[]},"tags":["calulating"],"grid":24},"attrs":[],"properties":{"order":60,"id":144,"name":"calulating","prevSize":24,"code":59651},"setIdx":0,"setId":0,"iconIdx":205},{"icon":{"paths":["M849.873 211.784l-462.133 462.132-212.096-212.096c-25.421-25.421-67.157-25.421-92.578 0-25.421 25.425-25.421 67.157 0 92.578l256.867 256.87c25.421 25.421 67.157 25.421 92.579 0l508.42-508.044c25.425-25.421 25.425-67.157 0-92.578-25.421-25.421-65.259-24.663-91.439 1.138h0.38z"],"attrs":[],"isMulticolor":false,"isMulticolor2":false,"colorPermutations":{"174239125525525512936511":[],"191196206125525525512936511761761561":[],"255255255129365114248601":[],"246155111125525525512936511761761561":[],"2323037125525525512936511761761561":[],"10511915011401421681255255255129365114753651761761561":[],"14014216812552552551293651147536515050501761761561":[]},"tags":["Icon-Ptf-status-SMALL"],"grid":24},"attrs":[],"properties":{"order":62,"id":142,"name":"Icon-Ptf-status-SMALL","prevSize":24,"code":59649},"setIdx":0,"setId":0,"iconIdx":206},{"icon":{"paths":["M765.44 96.632c-158.078-140.16-399.998-126.080-540.798 32-52.48 59.52-85.76 133.76-94.080 212.48-14.72 126.72 36.48 252.16 135.040 332.802 26.24 21.76 42.24 53.76 42.88 88.32v120.96c0 77.44 62.72 140.16 140.16 140.16h122.88c77.438 0 140.158-62.72 140.158-140.16v-115.84c0-33.92 14.72-65.92 39.68-88.32 164.48-134.402 188.8-376.322 54.4-540.162-12.8-15.36-26.24-29.44-40.96-42.88l0.64 0.64zM618.242 883.194c0 25.6-21.12 46.72-46.72 46.72h-122.88c-25.6 0-46.72-21.12-46.72-46.72v-66.56h216.32v66.56zM691.2 607.992c-34.56 30.080-58.878 70.402-68.478 115.202h-65.92v-229.122h50.56c25.6 0 46.718-21.12 46.718-46.72s-21.118-46.72-46.718-46.72h-194.56c-25.6 0-46.72 21.12-46.72 46.72s21.12 46.72 46.72 46.72h50.56v229.122h-65.28c-9.6-47.36-35.2-89.602-71.68-120.322h-0.64c-74.88-61.44-113.92-156.16-101.76-252.16 16-158.080 157.44-273.92 316.16-257.28 147.838 15.36 260.478 140.16 259.198 289.28 0 87.68-39.68 170.24-107.52 225.28h-0.64z"],"attrs":[],"isMulticolor":false,"isMulticolor2":false,"colorPermutations":{"174239125525525512936511":[],"191196206125525525512936511761761561":[],"255255255129365114248601":[],"246155111125525525512936511761761561":[],"2323037125525525512936511761761561":[],"10511915011401421681255255255129365114753651761761561":[],"14014216812552552551293651147536515050501761761561":[]},"tags":["Icon-full-small"],"grid":24},"attrs":[],"properties":{"order":59,"id":145,"name":"Icon-full-small","prevSize":24,"code":59652},"setIdx":0,"setId":0,"iconIdx":207},{"icon":{"paths":["M512 42.667c-260.266 0-469.333 209.067-469.333 469.333s209.067 469.333 469.333 469.333c260.266 0 469.333-209.067 469.333-469.333s-209.067-469.333-469.333-469.333zM729.75 129.583c0 0 11.592 57.287 23.75 67.667 12.429 10.611 67.167 22.25 67.167 22.25s-45.848 10.972-63 20.417c-15.262 8.404-27 70.167-27 70.167s-11.833-58.158-25.083-69.083c-12.559-10.355-65.917-21.333-65.917-21.333s49.418-10.333 64.667-20.5c16.137-10.76 25.417-69.583 25.417-69.583zM265.333 202.417c0 0 17.17 84.456 35.083 99.75 18.314 15.635 98.917 32.667 98.917 32.667s-67.561 16.167-92.833 30.083c-22.487 12.382-39.75 103.417-39.75 103.417s-17.476-85.736-37-101.833c-18.505-15.257-97.167-31.333-97.167-31.333s72.865-15.269 95.333-30.25c23.776-15.853 37.417-102.5 37.417-102.5zM521.083 232.833c0 0 42.83 210.53 87.5 248.667 45.667 38.988 246.75 81.5 246.75 81.5s-168.481 40.299-231.5 75c-56.074 30.877-99.25 257.833-99.25 257.833s-43.398-213.61-92.083-253.75c-46.144-38.046-242.417-78.333-242.417-78.333s181.64-37.977 237.667-75.333c59.289-39.532 93.333-255.583 93.333-255.583z"],"attrs":[{}],"isMulticolor":false,"isMulticolor2":false,"colorPermutations":{"255255255129365114248601":[{}],"246155111125525525512936511761761561":[{}],"2323037125525525512936511761761561":[{}],"10511915011401421681255255255129365114753651761761561":[{}],"14014216812552552551293651147536515050501761761561":[{}]},"tags":["Solve"],"grid":24},"attrs":[{}],"properties":{"order":177,"id":124,"name":"Solve","prevSize":24,"code":59762},"setIdx":0,"setId":0,"iconIdx":208},{"icon":{"paths":["M746.667 42.667h-469.333c-129.849 0-234.667 104.818-234.667 234.667v469.333c0 129.847 104.818 234.667 234.667 234.667h469.333c129.847 0 234.667-104.819 234.667-234.667v-469.333c0-129.849-104.819-234.667-234.667-234.667zM501.572 225.185c39.108 0 70.4 31.289 70.4 70.4s-31.292 70.4-70.4 70.4c-39.113 0-70.4-31.289-70.4-70.4s31.287-70.4 70.4-70.4v0zM609.519 798.814h-195.036v-93.346h35.983v-190.34h-34.419v-93.344h157.487v283.684h35.985v93.346z"],"attrs":[],"isMulticolor":false,"isMulticolor2":false,"colorPermutations":{"174239125525525512936511":[],"191196206125525525512936511761761561":[],"255255255129365114248601":[],"246155111125525525512936511761761561":[],"2323037125525525512936511761761561":[],"10511915011401421681255255255129365114753651761761561":[],"14014216812552552551293651147536515050501761761561":[]},"tags":["info"],"grid":24},"attrs":[],"properties":{"order":61,"id":143,"name":"info","prevSize":24,"code":59650},"setIdx":0,"setId":0,"iconIdx":209},{"icon":{"paths":["M965.559 737.523l-356.591-596.928c-20.855-34.408-57.348-55.261-96.969-55.261s-76.113 20.853-96.968 54.219l-356.592 597.971c-20.854 34.406-20.854 77.154-1.043 112.606s56.304 57.348 98.011 57.348h713.183c40.666 0 77.158-21.897 98.014-57.348 19.81-35.452 19.81-78.199-1.045-112.606zM469.773 389.271c0-22.939 18.769-42.228 42.227-42.228s42.227 18.768 42.227 42.228v179.86c0 22.938-18.769 42.227-42.227 42.227s-42.227-19.81-42.227-43.268v-178.819zM512 754.726c-28.672 0-52.134-23.462-52.134-52.134s23.462-52.134 52.134-52.134c28.672 0 52.134 23.462 52.134 52.134s-23.462 52.134-52.134 52.134z"],"attrs":[],"isMulticolor":false,"isMulticolor2":false,"colorPermutations":{"174239125525525512936511":[],"191196206125525525512936511761761561":[],"255255255129365114248601":[],"246155111125525525512936511761761561":[],"2323037125525525512936511761761561":[],"10511915011401421681255255255129365114753651761761561":[],"14014216812552552551293651147536515050501761761561":[]},"tags":["Icon-full-alert"],"grid":24},"attrs":[],"properties":{"order":26,"id":146,"name":"Icon-full-alert","prevSize":24,"code":59688},"setIdx":0,"setId":0,"iconIdx":210},{"icon":{"paths":["M512 42.667c-258.655 0-469.333 210.679-469.333 469.333s210.679 469.333 469.333 469.333c258.654 0 469.333-210.679 469.333-469.333s-210.679-469.333-469.333-469.333zM698.167 615.253h-223.714c-26.074 0-46.933-21.38-46.933-46.933v-262.305c0-26.074 21.38-46.933 46.933-46.933s46.933 21.381 46.933 46.933v215.892h176.26c26.594 0 46.933 20.339 46.933 45.892s-21.38 46.933-46.933 46.933l0.521 0.521z"],"attrs":[],"isMulticolor":false,"isMulticolor2":false,"colorPermutations":{"174239125525525512936511":[],"191196206125525525512936511761761561":[],"255255255129365114248601":[],"246155111125525525512936511761761561":[],"2323037125525525512936511761761561":[],"10511915011401421681255255255129365114753651761761561":[],"14014216812552552551293651147536515050501761761561":[]},"tags":["Icon-full-clock"],"grid":24},"attrs":[],"properties":{"order":27,"id":147,"name":"Icon-full-clock","prevSize":24,"code":59689},"setIdx":0,"setId":0,"iconIdx":211},{"icon":{"paths":["M843.661 180.338c-88.649-88.652-206.507-137.671-331.661-137.671-258.655 0-469.333 210.679-469.333 469.333s210.679 469.333 469.333 469.333c258.654 0 469.333-210.679 469.333-469.333 0-125.155-49.020-243.011-137.673-331.662v0zM513.041 251.259c15.125 0 27.639 4.693 37.026 14.080s14.080 22.423 14.080 38.068c1.045 14.080-3.127 26.595-11.994 36.504-9.907 10.429-25.033 16.166-41.719 16.166-32.853-1.043-50.581-21.381-50.581-56.842 0-27.638 21.901-47.455 53.188-47.455v-0.521zM564.147 668.446c0 28.681-23.467 52.147-52.147 52.147s-52.147-23.467-52.147-52.147v-208.593c0-28.681 23.467-52.149 52.147-52.149s52.147 23.468 52.147 52.149v208.593z"],"attrs":[],"isMulticolor":false,"isMulticolor2":false,"colorPermutations":{"174239125525525512936511":[],"191196206125525525512936511761761561":[],"255255255129365114248601":[],"246155111125525525512936511761761561":[],"2323037125525525512936511761761561":[],"10511915011401421681255255255129365114753651761761561":[],"14014216812552552551293651147536515050501761761561":[]},"tags":["Icon-full-info"],"grid":24},"attrs":[],"properties":{"order":29,"id":148,"name":"Icon-full-info","prevSize":24,"code":59691},"setIdx":0,"setId":0,"iconIdx":212},{"icon":{"paths":["M512 42.667c-258.655 0-469.333 210.679-469.333 469.333s210.679 469.333 469.333 469.333c258.654 0 469.333-210.679 469.333-469.333s-210.679-469.333-469.333-469.333zM406.373 618.359l295.622-302.029c16.759-16.862 42.266-17.358 58.539-0.744 16.277 16.614 16.277 43.891 0 60.505l-325.495 332.034c-16.276 16.614-42.996 16.614-59.271 0l-164.449-167.876c-16.275-16.614-16.275-43.891 0-60.506s42.995-16.614 59.27 0l135.786 138.615z"],"attrs":[],"isMulticolor":false,"isMulticolor2":false,"colorPermutations":{"174239125525525512936511":[],"191196206125525525512936511761761561":[],"255255255129365114248601":[],"246155111125525525512936511761761561":[],"2323037125525525512936511761761561":[],"10511915011401421681255255255129365114753651761761561":[],"14014216812552552551293651147536515050501761761561":[]},"tags":["Icon-full-ok"],"grid":24},"attrs":[],"properties":{"order":30,"id":149,"name":"Icon-full-ok","prevSize":24,"code":59692},"setIdx":0,"setId":0,"iconIdx":213},{"icon":{"paths":["M341.333 853.333L341.333 298.667C341.333 275.103 360.436 256 384 256C407.564 256 426.667 275.103 426.667 298.667L426.667 853.333C426.667 876.898 407.564 896 384 896C360.436 896 341.333 876.898 341.333 853.333Z","M469.333 853.333L469.333 170.667C469.333 147.103 488.435 128 512 128C535.565 128 554.667 147.103 554.667 170.667L554.667 853.333C554.667 876.898 535.565 896 512 896C488.435 896 469.333 876.898 469.333 853.333Z","M597.333 853.333L597.333 341.333C597.333 317.769 616.435 298.667 640 298.667C663.565 298.667 682.667 317.769 682.667 341.333L682.667 853.333C682.667 876.898 663.565 896 640 896C616.435 896 597.333 876.898 597.333 853.333Z","M725.333 853.333L725.333 469.333C725.333 445.769 744.435 426.667 768 426.667C791.565 426.667 810.667 445.769 810.667 469.333L810.667 853.333C810.667 876.898 791.565 896 768 896C744.435 896 725.333 876.898 725.333 853.333Z","M853.333 853.333L853.333 341.333C853.333 317.769 872.435 298.667 896 298.667C919.565 298.667 938.667 317.769 938.667 341.333L938.667 853.333C938.667 876.898 919.565 896 896 896C872.435 896 853.333 876.898 853.333 853.333Z","M213.333 853.333L213.333 640C213.333 616.435 232.436 597.333 256 597.333C279.564 597.333 298.667 616.435 298.667 640L298.667 853.333C298.667 876.898 279.564 896 256 896C232.436 896 213.333 876.898 213.333 853.333Z","M85.333 853.333L85.333 554.667C85.333 531.102 104.436 512 128 512C151.564 512 170.667 531.102 170.667 554.667L170.667 853.333C170.667 876.898 151.564 896 128 896C104.436 896 85.333 876.898 85.333 853.333Z"],"attrs":[{},{},{},{},{},{},{}],"isMulticolor":false,"isMulticolor2":false,"colorPermutations":{},"tags":["chart-type-cols-ver"],"grid":24},"attrs":[{},{},{},{},{},{},{}],"properties":{"order":413,"id":222,"name":"chart-type-cols-ver","prevSize":24,"code":61441},"setIdx":0,"setId":0,"iconIdx":214},{"icon":{"paths":["M32 512C32 494.327 46.327 480 64 480L192 480C209.673 480 224 494.327 224 512L224 853.333C224 871.006 209.673 885.333 192 885.333L64 885.333C46.327 885.333 32 871.006 32 853.333L32 512ZM96 544L96 821.333L160 821.333L160 544L96 544Z","M288 256C288 238.327 302.327 224 320 224L448.085 224C465.758 224 480.085 238.327 480.085 256L480.085 853.333C480.085 871.006 465.758 885.333 448.085 885.333L320 885.333C311.513 885.333 303.374 881.963 297.373 875.959C291.372 869.961 288 861.82 288 853.333L288 256ZM352 288L352 821.333L416.085 821.333L416.085 288L352 288Z","M544 384C544 366.327 558.327 352 576 352L704 352C721.673 352 736 366.327 736 384L736 853.333C736 871.006 721.673 885.333 704 885.333L576 885.333C558.327 885.333 544 871.006 544 853.333L544 384ZM608 416L608 821.333L672 821.333L672 416L608 416Z","M800 170.667C800 152.994 814.327 138.667 832 138.667L960 138.667C977.673 138.667 992 152.994 992 170.667L992 853.333C992 871.006 977.673 885.333 960 885.333L832 885.333C814.327 885.333 800 871.006 800 853.333L800 170.667ZM864 202.667L864 821.333L928 821.333L928 202.667L864 202.667Z","M42.667 672C42.667 654.327 56.994 640 74.667 640L181.333 640C199.006 640 213.333 654.327 213.333 672C213.333 689.673 199.006 704 181.333 704L74.667 704C56.994 704 42.667 689.673 42.667 672Z","M298.667 714.667C298.667 696.994 312.994 682.667 330.667 682.667L437.333 682.667C455.006 682.667 469.333 696.994 469.333 714.667C469.333 732.339 455.006 746.667 437.333 746.667L330.667 746.667C312.994 746.667 298.667 732.339 298.667 714.667Z","M298.667 501.333C298.667 483.661 312.994 469.333 330.667 469.333L437.333 469.333C455.006 469.333 469.333 483.661 469.333 501.333C469.333 519.006 455.006 533.333 437.333 533.333L330.667 533.333C312.994 533.333 298.667 519.006 298.667 501.333Z","M810.667 714.667C810.667 696.994 824.994 682.667 842.667 682.667L949.333 682.667C967.006 682.667 981.333 696.994 981.333 714.667C981.333 732.339 967.006 746.667 949.333 746.667L842.667 746.667C824.994 746.667 810.667 732.339 810.667 714.667Z","M810.667 501.333C810.667 483.661 824.994 469.333 842.667 469.333L949.333 469.333C967.006 469.333 981.333 483.661 981.333 501.333C981.333 519.006 967.006 533.333 949.333 533.333L842.667 533.333C824.994 533.333 810.667 519.006 810.667 501.333Z","M810.667 330.667C810.667 312.994 824.994 298.667 842.667 298.667L949.333 298.667C967.006 298.667 981.333 312.994 981.333 330.667C981.333 348.34 967.006 362.667 949.333 362.667L842.667 362.667C824.994 362.667 810.667 348.34 810.667 330.667Z","M554.667 501.333C554.667 483.661 568.994 469.333 586.667 469.333L693.333 469.333C711.006 469.333 725.333 483.661 725.333 501.333C725.333 519.006 711.006 533.333 693.333 533.333L586.667 533.333C568.994 533.333 554.667 519.006 554.667 501.333Z","M554.667 672C554.667 654.327 568.994 640 586.667 640L693.333 640C711.006 640 725.333 654.327 725.333 672C725.333 689.673 711.006 704 693.333 704L586.667 704C568.994 704 554.667 689.673 554.667 672Z"],"attrs":[{"fillRule":"evenodd"},{"fillRule":"evenodd"},{"fillRule":"evenodd"},{"fillRule":"evenodd"},{"fillRule":"evenodd"},{"fillRule":"evenodd"},{"fillRule":"evenodd"},{"fillRule":"evenodd"},{"fillRule":"evenodd"},{"fillRule":"evenodd"},{"fillRule":"evenodd"},{"fillRule":"evenodd"}],"isMulticolor":false,"isMulticolor2":false,"colorPermutations":{},"tags":["chart-type-stacked"],"grid":24},"attrs":[{"fillRule":"evenodd"},{"fillRule":"evenodd"},{"fillRule":"evenodd"},{"fillRule":"evenodd"},{"fillRule":"evenodd"},{"fillRule":"evenodd"},{"fillRule":"evenodd"},{"fillRule":"evenodd"},{"fillRule":"evenodd"},{"fillRule":"evenodd"},{"fillRule":"evenodd"},{"fillRule":"evenodd"}],"properties":{"order":414,"id":223,"name":"chart-type-stacked","prevSize":24,"code":61440},"setIdx":0,"setId":0,"iconIdx":215},{"icon":{"paths":["M32 512C32 494.327 46.327 480 64 480L192 480C209.673 480 224 494.327 224 512L224 853.333C224 871.006 209.673 885.333 192 885.333L64 885.333C46.327 885.333 32 871.006 32 853.333L32 512ZM96 544L96 821.333L160 821.333L160 544L96 544Z","M288 256C288 238.327 302.327 224 320 224L448.085 224C465.758 224 480.085 238.327 480.085 256L480.085 853.333C480.085 871.006 465.758 885.333 448.085 885.333L320 885.333C311.513 885.333 303.374 881.963 297.373 875.959C291.372 869.961 288 861.82 288 853.333L288 256ZM352 288L352 821.333L416.085 821.333L416.085 288L352 288Z","M544 384C544 366.327 558.327 352 576 352L704 352C721.673 352 736 366.327 736 384L736 853.333C736 871.006 721.673 885.333 704 885.333L576 885.333C558.327 885.333 544 871.006 544 853.333L544 384ZM608 416L608 821.333L672 821.333L672 416L608 416Z","M800 170.667C800 152.994 814.327 138.667 832 138.667L960 138.667C977.673 138.667 992 152.994 992 170.667L992 853.333C992 871.006 977.673 885.333 960 885.333L832 885.333C814.327 885.333 800 871.006 800 853.333L800 170.667ZM864 202.667L864 821.333L928 821.333L928 202.667L864 202.667Z"],"attrs":[{"fillRule":"evenodd"},{"fillRule":"evenodd"},{"fillRule":"evenodd"},{"fillRule":"evenodd"}],"isMulticolor":false,"isMulticolor2":false,"colorPermutations":{},"tags":["chart-type-cols-4-frequency"],"grid":24},"attrs":[{"fillRule":"evenodd"},{"fillRule":"evenodd"},{"fillRule":"evenodd"},{"fillRule":"evenodd"}],"properties":{"order":415,"id":224,"name":"chart-type-cols-4-frequency","prevSize":24,"code":61443},"setIdx":0,"setId":0,"iconIdx":216},{"icon":{"paths":["M512.004 160C384.355 160 306.287 262.173 254.588 373.041C202.441 484.877 169.318 622.921 140.13 715.75C130.625 745.963 108.429 773.461 86.38 794.458C75.628 804.698 65.501 812.809 58.13 818.334C54.461 821.082 51.519 823.189 49.546 824.542C48.568 825.212 47.835 825.702 47.38 826.001C47.152 826.15 46.961 826.24 46.88 826.291L44.213 828.207C31.462 838.229 28.1 856.465 36.963 870.46C45.834 884.463 63.784 889.225 78.296 881.958L81.13 880.375L81.213 880.333C81.241 880.316 81.26 880.273 81.296 880.252C81.372 880.201 81.475 880.158 81.588 880.085C81.82 879.936 82.124 879.71 82.505 879.458C83.274 878.955 84.349 878.238 85.671 877.333C88.324 875.516 92.034 872.892 96.505 869.542C105.425 862.857 117.556 853.12 130.505 840.794C155.851 816.657 186.989 780.156 201.213 734.916C232.477 635.486 262.807 506.842 312.588 400.083C362.82 292.36 425.175 224 512.004 224C603.055 224 666.342 293.901 715.84 401.833C765.056 509.163 793.327 637.602 822.711 734.626C834.842 774.66 866.573 811.388 891.422 836.002C904.393 848.845 916.642 859.541 925.67 866.999C930.197 870.741 933.969 873.69 936.631 875.75C937.958 876.779 939.004 877.602 939.755 878.165C940.13 878.451 940.454 878.673 940.672 878.835C940.77 878.908 940.86 878.955 940.919 879.002L941.047 879.125C955.285 889.587 975.33 886.528 985.796 872.29C996.258 858.052 993.199 838.007 978.961 827.541C978.944 827.529 978.889 827.499 978.837 827.46C978.722 827.371 978.513 827.234 978.253 827.042C977.719 826.637 976.883 826.01 975.795 825.165C973.606 823.471 970.381 820.894 966.421 817.626C958.477 811.059 947.691 801.707 936.422 790.541C912.781 767.125 891.174 739.849 883.964 716.041C856.691 625.993 825.621 487.727 774.003 375.167C722.667 263.214 643.614 160 512.004 160Z"],"attrs":[{}],"isMulticolor":false,"isMulticolor2":false,"colorPermutations":{},"tags":["chart-type-bell"],"grid":24},"attrs":[{}],"properties":{"order":416,"id":225,"name":"chart-type-bell","prevSize":24,"code":61444},"setIdx":0,"setId":0,"iconIdx":217},{"icon":{"paths":["M298.671 309.335C315.136 309.335 332.78 314.27 349.379 320.585C366.502 327.099 385.192 336.136 404.462 346.459C442.927 367.067 486.566 394.378 528.96 420.876C571.895 447.71 613.598 473.737 649.796 493.124C667.853 502.801 683.84 510.434 697.378 515.584C711.445 520.934 720.474 522.667 725.338 522.667C734.767 522.667 751.232 515.866 774.17 496.751C795.81 478.716 818.278 453.909 839.006 428.002C859.58 402.281 877.705 376.431 890.714 356.918C897.199 347.188 902.383 339.085 905.92 333.46C907.682 330.659 909.022 328.468 909.922 327.001C910.37 326.267 910.703 325.694 910.921 325.335C911.027 325.158 911.121 325.04 911.172 324.96L911.211 324.876C920.303 309.726 939.977 304.794 955.127 313.876C970.278 322.967 975.211 342.64 966.127 357.793L966.089 357.876C966.067 357.912 965.999 357.941 965.961 358.001C965.888 358.125 965.807 358.319 965.67 358.543C965.402 358.99 965.009 359.635 964.506 360.46C963.49 362.116 961.988 364.521 960.085 367.543C956.288 373.584 950.805 382.156 943.962 392.418C930.304 412.905 911.095 440.388 889.003 468.002C867.063 495.424 841.527 523.951 815.172 545.916C790.114 566.797 758.575 586.667 725.338 586.667C708.873 586.667 691.226 581.73 674.628 575.42C657.506 568.905 638.814 559.868 619.546 549.542C581.077 528.934 537.442 501.623 495.044 475.127C452.113 448.294 410.409 422.267 374.212 402.876C356.156 393.203 340.168 385.569 326.629 380.418C312.562 375.066 303.536 373.335 298.671 373.335C299.783 373.335 295.925 373.072 286.42 381.626C277.565 389.596 267.261 402.136 255.962 419.084C233.47 452.821 210.345 498.88 189.254 546.334C168.289 593.506 149.865 640.832 136.67 676.459C130.086 694.238 124.822 709.039 121.212 719.377C119.409 724.54 118.021 728.593 117.087 731.337C116.62 732.706 116.279 733.769 116.046 734.46C115.931 734.797 115.81 735.04 115.754 735.211C115.726 735.292 115.725 735.381 115.712 735.42C110.124 752.183 91.978 761.297 75.212 755.708C58.446 750.123 49.373 731.977 54.962 715.209L55.004 715.166L55.379 714.001C55.634 713.242 56.017 712.141 56.504 710.711C57.486 707.827 58.935 703.62 60.795 698.291C64.518 687.633 69.925 672.422 76.67 654.208C90.142 617.835 109.054 569.161 130.754 520.333C152.33 471.787 177.204 421.846 202.712 383.584C215.412 364.534 229.11 347.073 243.587 334.043C257.414 321.599 276.224 309.335 298.671 309.335Z","M303.413 554.667C328.885 554.667 363.85 562.466 400.169 572.416C437.414 582.622 479.787 596.181 521.331 609.459C563.217 622.844 604.288 635.955 640.047 645.751C676.727 655.799 704.346 661.333 720.589 661.333C756.723 661.333 809.779 646.955 856.7 630.959C879.531 623.177 899.874 615.398 914.509 609.54C921.813 606.618 927.697 604.186 931.699 602.5C933.696 601.66 935.245 600.981 936.265 600.542C936.747 600.333 937.118 600.188 937.361 600.085C937.485 600.03 937.591 599.983 937.647 599.957L937.69 599.915C953.566 592.956 971.985 600.474 978.795 616.708C985.6 632.947 978.249 651.785 962.377 658.752L950.033 629.333L962.338 658.752L962.295 658.752C962.27 658.761 962.257 658.816 962.214 658.833C962.129 658.871 961.997 658.893 961.847 658.957C961.536 659.093 961.079 659.294 960.503 659.541C959.347 660.041 957.645 660.762 955.494 661.666C951.189 663.479 944.998 666.052 937.323 669.124C921.971 675.268 900.595 683.494 876.497 691.708C829.555 707.712 767.885 725.333 720.589 725.333C695.113 725.333 660.151 717.534 623.829 707.584C586.586 697.378 544.213 683.819 502.669 670.541C460.783 657.156 419.711 644.045 383.955 634.249C347.274 624.201 319.656 618.667 303.413 618.667C267.277 618.667 214.221 633.045 167.302 649.041C144.471 656.823 124.125 664.602 109.492 670.46C102.185 673.382 96.304 675.814 92.3 677.5C90.304 678.34 88.756 679.019 87.737 679.458C87.252 679.667 86.88 679.812 86.637 679.915C86.517 679.97 86.407 680.017 86.352 680.043L86.311 680.085L83.296 681.207C68.166 686.063 51.592 678.515 45.204 663.292C38.4 647.053 45.75 628.215 61.623 621.248L72.297 646.665L61.664 621.248L61.704 621.248C61.729 621.239 61.745 621.184 61.786 621.167C61.87 621.129 62.001 621.107 62.152 621.043C62.463 620.907 62.919 620.706 63.497 620.459C64.655 619.959 66.354 619.238 68.508 618.334C72.812 616.521 79.003 613.948 86.678 610.876C102.028 604.732 123.405 596.506 147.502 588.292C194.447 572.288 256.114 554.667 303.413 554.667Z"],"attrs":[{},{}],"isMulticolor":false,"isMulticolor2":false,"colorPermutations":{},"tags":["chart-type-cols-4-line"],"grid":24},"attrs":[{},{}],"properties":{"order":417,"id":226,"name":"chart-type-cols-4-line","prevSize":24,"code":61442},"setIdx":0,"setId":0,"iconIdx":218},{"icon":{"paths":["M96 768L96 725.333C96 707.661 110.327 693.333 128 693.333L181.333 693.333L181.333 256C181.333 213.565 198.202 172.881 228.208 142.875C258.214 112.869 298.899 96 341.333 96L810.667 96C818.313 96 825.971 96.745 833.54 98.25C856.303 102.777 877.214 113.966 893.623 130.375C910.033 146.784 921.225 167.698 925.751 190.458C930.274 213.214 927.962 236.815 919.083 258.25C910.204 279.687 895.125 297.984 875.831 310.875C856.538 323.765 833.869 330.667 810.667 330.667L757.333 330.667L757.333 810.667C757.333 841.783 744.964 871.62 722.957 893.623C700.954 915.631 671.117 928 640 928L256 928C213.565 928 172.881 911.13 142.875 881.126C112.869 851.119 96 810.436 96 768ZM554.667 437.333C572.339 437.333 586.667 451.661 586.667 469.333C586.667 487.006 572.339 501.333 554.667 501.333L384 501.333C366.327 501.333 352 487.006 352 469.333C352 451.661 366.327 437.333 384 437.333L554.667 437.333ZM554.667 266.667C572.339 266.667 586.667 280.994 586.667 298.667C586.667 316.34 572.339 330.667 554.667 330.667L384 330.667C366.327 330.667 352 316.34 352 298.667C352 280.994 366.327 266.667 384 266.667L554.667 266.667ZM160 768C160 793.459 170.121 817.873 188.125 835.874C206.129 853.879 230.539 864 256 864L535.582 864C527.219 847.625 522.667 829.397 522.667 810.667L522.667 757.333L160 757.333L160 768ZM245.333 693.333L554.667 693.333C572.339 693.333 586.667 707.661 586.667 725.333L586.667 810.667C586.667 824.811 592.29 838.374 602.291 848.375C612.292 858.377 625.856 864 640 864C654.144 864 667.708 858.377 677.709 848.375C687.71 838.374 693.333 824.811 693.333 810.667L693.333 213.333C693.333 194.713 697.839 176.467 706.249 160L341.333 160C315.872 160 291.462 170.121 273.458 188.125C255.455 206.129 245.333 230.539 245.333 256L245.333 693.333ZM757.333 266.667L810.667 266.667C821.214 266.667 831.522 263.527 840.29 257.667C849.062 251.806 855.923 243.495 859.959 233.75C863.996 224.005 865.015 213.262 862.959 202.917C860.898 192.577 855.829 183.08 848.375 175.625C840.922 168.17 831.424 163.101 821.082 161.041C817.638 160.357 814.144 160 810.667 160C803.695 160 796.753 161.349 790.251 164.042C780.506 168.078 772.194 174.938 766.332 183.708C760.474 192.479 757.333 202.785 757.333 213.333L757.333 266.667Z"],"attrs":[{}],"isMulticolor":false,"isMulticolor2":false,"colorPermutations":{},"tags":["term-and-condition"],"grid":24},"attrs":[{}],"properties":{"order":418,"id":227,"name":"term-and-condition","prevSize":24,"code":61445},"setIdx":0,"setId":0,"iconIdx":219}]'), q6 = 1024, Y6 = { name: "icomoon" }, X6 = { showGlyphs: !0, showQuickUse: !0, showQuickUse2: !0, showSVGs: !0, fontPref: { prefix: "icon-", metadata: { fontFamily: "icomoon", majorVersion: 1, minorVersion: 0 }, metrics: { emSize: 1024, baseline: 6.25, whitespace: 50 }, embed: !1, showMetrics: !0, showSelector: !0 }, imagePref: { prefix: "icon-", png: !0, useClassSelector: !0, color: 0, bgColor: 16777215, classSelector: ".icon", name: "icomoon", height: 24, overrideSize: "true" }, historySize: 50, showCodes: !0, gridSize: 16, showLiga: !1 }, A5 = {
  IcoMoonType: U6,
  icons: K6,
  height: q6,
  metadata: Y6,
  preferences: X6
}, J6 = new Set(A5.icons.map((e) => e.properties.name));
function R5(e) {
  return J6.has(e);
}
const Q = G(Q6);
function Q6({
  icon: e,
  style: t,
  className: r,
  color: c = "currentColor",
  size: n = "1em",
  innerRef: l,
  iconSet: s,
  ...a
}) {
  return /* @__PURE__ */ o(
    "span",
    {
      ref: l,
      className: X(r),
      style: {
        width: n,
        height: n,
        minWidth: n,
        minHeight: n,
        maxWidth: n,
        maxHeight: n,
        display: "block",
        ...t
      },
      "data-icon-name": e,
      ...a,
      children: /* @__PURE__ */ o(
        M6,
        {
          style: {
            width: n,
            height: n,
            minWidth: n,
            minHeight: n,
            maxWidth: n,
            maxHeight: n,
            display: "block"
          },
          iconSet: s ?? A5,
          color: c,
          size: n,
          icon: e
        }
      )
    }
  );
}
const D9 = ["info", "warning", "error", "success"], q3 = {
  info: I.MessageSeverity_info,
  success: I.MessageSeverity_success,
  warning: I.MessageSeverity_warning,
  error: I.MessageSeverity_error
};
class E1 {
  static ok(t) {
    return new M3(t);
  }
  static err(t) {
    return new x3(t);
  }
  static fromThrower(t) {
    try {
      return E1.ok(t());
    } catch (r) {
      return E1.err(r);
    }
  }
  static fromNullable(t, r, c) {
    return t != null ? E1.ok(r(t)) : E1.err(c());
  }
  static fromBool(t, r, c) {
    return t ? E1.ok(r()) : E1.err(c());
  }
}
class M3 extends E1 {
  value;
  constructor(t) {
    super(), this.value = t;
  }
  isOk() {
    return !0;
  }
  isErr() {
    return !1;
  }
  unwrap() {
    return this.value;
  }
  unwrapErr() {
    throw new Error("Cannot call unwrapErr on ok result");
  }
  unwrapOr(t) {
    return this.value;
  }
  unwrapOrElse(t) {
    return this.value;
  }
  map(t) {
    return new M3(t(this.value));
  }
  mapErr(t) {
    return this;
  }
  andThen(t) {
    return t(this.value);
  }
  orElse(t) {
    return this;
  }
  and(t) {
    return t;
  }
  or(t) {
    return this;
  }
}
class x3 extends E1 {
  value;
  constructor(t) {
    super(), this.value = t;
  }
  unwrap() {
    throw new Error("Cannot call unwrap on err result");
  }
  unwrapErr() {
    return this.value;
  }
  isOk() {
    return !1;
  }
  isErr() {
    return !0;
  }
  unwrapOr(t) {
    return t;
  }
  unwrapOrElse(t) {
    return t();
  }
  map(t) {
    return this;
  }
  mapErr(t) {
    return new x3(t(this.value));
  }
  andThen(t) {
    return this;
  }
  orElse(t) {
    return t(this.value);
  }
  and(t) {
    return this;
  }
  or(t) {
    return t;
  }
}
class Q2 extends Error {
}
function L2(e) {
  if (e.kind === "success")
    return e.result;
  if (e.kind === "loading" || e.kind === "error")
    return e.previousResult;
}
function A9(e, t = {}) {
  switch (e) {
    case "loading":
      return { kind: e, progress: t.progress ?? "indeterminate", previousResult: t.result ?? void 0 };
    case "success":
      return { kind: e, result: t.result ?? null };
    case "error":
      return { kind: e, err: t.err, previousResult: t.result ?? void 0 };
    case "initial":
      return { kind: e };
  }
}
function I2(e, t) {
  const [r, c] = W({ kind: "initial" }), n = e1(e), l = e1(t);
  return [Z(
    async (...s) => {
      let a = E1.err(void 0);
      try {
        c((d) => ({ kind: "loading", progress: "indeterminate", previousResult: L2(d) })), l.current?.onLoading?.();
        const i = await n.current(...s, {
          progressCb(d) {
            c((v) => ({ kind: "loading", progress: d, previousResult: L2(v) }));
          }
        });
        return c({ kind: "success", result: i }), l.current?.onSuccess?.(i), a = E1.ok(i), i;
      } catch (i) {
        throw console.warn("[useAsync] asyncFn threw an error", i), c((d) => ({ kind: "error", err: i, previousResult: L2(d) })), l.current?.onError?.(i), a = E1.err(i), i;
      } finally {
        l.current?.onSettled?.(a);
      }
    },
    [n, l]
  ), r];
}
function i3(e) {
  const t = !("trigger" in (e ?? {})), r = t ? void 0 : e.trigger, [c, n] = W(!1), l = T5(), s = a1(null), a = e1(e?.duration), i = Z(() => {
    s.current?.abort(new Q2());
    const d = new AbortController();
    s.current = d, n(!1), l().then(() => (d.signal.throwIfAborted(), n(!0), l())).then(() => (d.signal.throwIfAborted(), s3(a.current ?? D2))).then(() => {
      d.signal.throwIfAborted(), n(!1);
    }).finally(() => {
      s.current = null;
    }).catch((v) => {
      v instanceof Q2 || console.warn(v);
    });
  }, [a, l]);
  return l1(() => {
    s.current?.abort(new Q2()), s.current = null, r ? i() : t || n(!1);
  }, [r, i, t]), t ? [c, i] : c;
}
const D2 = 150;
function R9({
  fallback: e,
  overrides: t
}) {
  return {
    ...e,
    ...t ?? {}
  };
}
function e2({
  fallback: e,
  overrides: t
}) {
  return O(
    () => ({
      ...e,
      ...t ?? {}
    }),
    [e, t]
  );
}
const e4 = C2(
  "inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md text-sm font-medium transition-colors focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-ring disabled:pointer-events-none disabled:opacity-50 [&_svg]:pointer-events-none [&_svg]:size-4 [&_svg]:shrink-0",
  {
    variants: {
      variant: {
        default: "bg-primary text-primary-foreground shadow hover:bg-primary/90",
        destructive: "bg-destructive text-destructive-foreground shadow-sm hover:bg-destructive/90",
        outline: "border border-input bg-background shadow-sm hover:bg-accent hover:text-accent-foreground",
        secondary: "bg-secondary text-secondary-foreground shadow-sm hover:bg-secondary/80",
        ghost: "hover:bg-accent hover:text-accent-foreground",
        link: "text-primary underline-offset-4 hover:underline"
      },
      size: {
        default: "h-9 px-4 py-2",
        sm: "h-8 rounded-md px-3 text-xs",
        lg: "h-10 rounded-md px-8",
        icon: "h-9 w-9"
      }
    },
    defaultVariants: {
      variant: "default",
      size: "default"
    }
  }
), z3 = s1.forwardRef(
  ({ className: e, variant: t, size: r, asChild: c = !1, ...n }, l) => /* @__PURE__ */ o(
    c ? M5 : "button",
    {
      className: D(e4({ variant: t, size: r, className: e })),
      ref: l,
      ...n
    }
  )
);
z3.displayName = "Button";
let t4 = class extends Error {
  constructor() {
    super("unreachable code");
  }
};
function r4(e) {
  throw new t4();
}
const _5 = (...e) => {
}, Y3 = 150;
function o4() {
  return typeof globalThis < "u" && globalThis.__MDOTM_INSTANT_TRANSITIONS_FOR_TEST__ === !0;
}
function b2({
  in: e,
  initialIn: t = e,
  duration: r,
  onChange: c
}) {
  const [n, l] = W(t ? "entered" : "exited"), s = e1(c), a = Z(
    (h) => {
      l(h), s.current?.(h);
    },
    [s]
  ), i = e1(n), d = e1(r), v = F6();
  return s2(() => {
    if (d.current === 0) {
      a(e ? "entered" : "exited");
      return;
    }
    if (o4()) {
      const h = e ? "entered" : "exited";
      i.current !== h && a(h);
      return;
    }
    g2(async () => {
      e && (i.current === "exited" || i.current === "exiting" || i.current === "prepare-exit") ? (a("prepare-enter"), await v(), i.current === "prepare-enter" && (a("entering"), await v(), await s3(d.current ?? Y3), i.current === "entering" && a("entered"))) : !e && (i.current === "entered" || i.current === "entering" || i.current === "prepare-enter") && (a("prepare-exit"), await v(), i.current === "prepare-exit" && (a("exiting"), await v(), await s3(d.current ?? Y3), i.current === "exiting" && a("exited")));
    })();
  }, [d, e, a, v, i]), n;
}
function F5(e, t) {
  switch (e) {
    case "prepare-enter":
      return {
        ...m1(t.className),
        ...m1(t.enterClassName),
        ...m1(t.enterFromClassName)
      };
    case "entering":
      return {
        ...m1(t.className),
        ...m1(t.enterClassName),
        ...m1(t.enterToClassName)
      };
    case "entered":
      return {
        ...m1(t.className),
        ...m1(t.enterClassName),
        ...m1(t.enterToClassName),
        ...m1(t.enteredClassName)
      };
    case "prepare-exit":
      return {
        ...m1(t.className),
        ...m1(t.exitClassName),
        ...m1(t.exitFromClassName ?? t.enterToClassName)
      };
    case "exiting":
      return {
        ...m1(t.className),
        ...m1(t.exitClassName),
        ...m1(t.exitToClassName ?? t.enterFromClassName)
      };
    case "exited":
      return {
        ...m1(t.className),
        ...m1(t.exitClassName),
        ...m1(t.exitToClassName ?? t.enterFromClassName),
        ...m1(t.exitedClassName)
      };
  }
}
function O5(e, t) {
  switch (e) {
    case "prepare-enter":
      return {
        ...t.style,
        ...t.enterStyle,
        ...t.enterFromStyle
      };
    case "entering":
      return {
        ...t.style,
        ...t.enterStyle,
        ...t.enterToStyle
      };
    case "entered":
      return {
        ...t.style,
        ...t.enterStyle,
        ...t.enterToStyle,
        ...t.enteredStyle
      };
    case "prepare-exit":
      return {
        ...t.style,
        ...t.exitStyle,
        ...t.exitFromStyle ?? t.enterToStyle
      };
    case "exiting":
      return {
        ...t.style,
        ...t.exitStyle,
        ...t.exitToStyle ?? t.enterFromStyle
      };
    case "exited":
      return {
        ...t.style,
        ...t.exitStyle,
        ...t.exitToStyle ?? t.enterFromStyle,
        ...t.exitedStyle
      };
  }
}
function F9(e) {
  const t = b2({
    in: e.in,
    initialIn: e.initialIn,
    duration: e.duration,
    onChange: e.onChange
  }), r = O(() => F5(t, e), [e, t]), c = O(() => O5(t, e), [e, t]);
  return {
    transitionStatus: t,
    className: r,
    style: c
  };
}
const $5 = F1({
  transitionStatus: "exited"
}), G1 = G(c4);
function c4({
  in: e,
  initialIn: t = e,
  duration: r,
  onChange: c,
  ...n
}) {
  const l = b2({
    in: e,
    initialIn: t,
    duration: r,
    onChange: c
  });
  return /* @__PURE__ */ o($5.Provider, { value: { transitionStatus: l }, children: /* @__PURE__ */ o(d3, { ...n }) });
}
const d3 = G(n4);
function n4({
  children: e,
  unmountOnExit: t,
  ...r
}) {
  const { transitionStatus: c } = V1($5);
  return /* @__PURE__ */ o(n1, { children: (!(t ?? !1) || c !== "exited") && R(e, {
    transitionStatus: c,
    className: F5(c, r),
    style: O5(c, r)
  }) });
}
const H5 = s1.forwardRef(
  ({ className: e, type: t, ...r }, c) => /* @__PURE__ */ o(
    "input",
    {
      type: t,
      className: D(
        "h-9 w-full rounded-md border border-input bg-transparent px-3 text-base shadow-sm transition-colors file:border-0 file:bg-transparent file:text-sm file:font-medium file:text-foreground focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-ring disabled:cursor-not-allowed disabled:opacity-50",
        e
      ),
      ref: c,
      ...r
    }
  )
);
H5.displayName = "Input";
function r2(e) {
  return e;
}
function j5(e, t) {
  const r = {};
  for (const c in e) {
    const n = t(e[c], c, e), l = r[n] || {};
    l[c] = e[c], r[n] = l;
  }
  return r;
}
function A1(e) {
  return Object.fromEntries(Object.entries(e).filter(([t, r]) => t.startsWith("data-")));
}
function O9(e) {
  return Object.fromEntries(Object.entries(e).filter(([t, r]) => !t.startsWith("data-")));
}
function t2(e) {
  const { dataAttrs: t, others: r } = j5(
    e,
    (c, n) => String(n).startsWith("data-") ? "dataAttrs" : "others"
  );
  return [t, r];
}
function l4(e) {
  const { ariaAttrs: t, others: r } = j5(
    e,
    (c, n) => String(n).startsWith("aria-") ? "ariaAttrs" : "others"
  );
  return [t, r];
}
const W5 = [
  "relative w-auto z-0 min-w-0 max-w-none flex-1 rounded-[4px] font-title",
  "border text-[#1d2433] placeholder:text-[var(--palette-N300)] border-[var(--palette-N200)] focus:border-[var(--palette-N500)] focus:outline-hidden",
  "bg-[#ffffff] disabled:border-[var(--palette-N100)] disabled:text-[var(--palette-N400)] disabled:bg-[var(--palette-N100)]",
  "data-[invalid=true]:border-[var(--palette-D500)]"
].join(" "), s4 = "shadow-none focus-visible:ring-0 focus-visible:outline-none disabled:opacity-100 disabled:cursor-auto transition-none", G5 = {
  large: "text-[16px] h-[38px] px-2.5",
  small: "text-[14px] h-[34px] px-2",
  "x-small": "text-[12px] h-[26px] px-1"
};
function Q1(e, t) {
  return D(o1(e, t));
}
const a4 = "flex relative items-center z-0", $9 = { "flex items-center z-0": !1 }, H9 = {
  [W5]: !1,
  "overflow-hidden text-ellipsis": !1,
  // Every size entry, so the token does not need to know which `size` the call site passed; only
  // one is ever present and cancelling the other two is inert.
  [Object.values(G5).join(" ")]: !1,
  // Overrides rather than negations: the primitive's own base (`src/ui/input.tsx`) is prepended, so a
  // negation cannot reach it. `relative` stays — the adornment wrappers are positioned against it.
  "h-auto w-auto rounded-none border-0 px-0 text-[length:inherit]": !0
};
function y2({
  className: e,
  style: t,
  value: r,
  onChange: c,
  onChangeText: n,
  onBlur: l,
  autoTrimOnBlur: s = !0,
  leftContent: a,
  rightContent: i,
  size: d = "small",
  invalid: v = !1,
  id: h,
  innerRef: u,
  inputAppearance: p,
  ...m
}) {
  const [f, b] = W(null), [y, N] = W(null), _ = q1(f), $ = q1(y), [F, P] = t2(m);
  function C(E) {
    c?.(E), n?.(E.currentTarget.value);
  }
  function L(E) {
    if (s) {
      const S = E.currentTarget.value.trim();
      S !== E.currentTarget.value && n?.(S);
    }
    l?.(E);
  }
  return /* @__PURE__ */ x("div", { className: Q1(a4, e), style: t, ...F, children: [
    /* @__PURE__ */ o(
      H5,
      {
        id: h,
        "data-invalid": v,
        ref: u,
        style: {
          // 12 = 8px (left-2/right-2) + a 4px gap. Measured, not fixed: DebouncedSearchInput's
          // search+clear pair and the date-picker adornments are nowhere near icon-width.
          paddingLeft: a ? (_?.width ?? 0) + 12 : 4,
          paddingRight: i ? ($?.width ?? 0) + 12 : 4,
          ...p?.style
        },
        className: Q1(
          D(
            W5,
            "overflow-hidden text-ellipsis",
            s4,
            G5[d],
            // The one place a native attribute feeds styling; read off the rest object before it
            // is spread. Without it every numeric field in the app goes left-aligned.
            m.type === "number" && "text-right"
          ),
          p?.className
        ),
        onChange: C,
        onBlur: L,
        value: r,
        ...P
      }
    ),
    a && /* @__PURE__ */ o(
      "div",
      {
        ref: b,
        className: "absolute z-10 left-2 top-1/2 -translate-y-1/2 flex items-center pointer-events-box-none",
        children: R(a)
      }
    ),
    i && /* @__PURE__ */ o(
      "div",
      {
        ref: N,
        className: "absolute z-10 right-2 top-1/2 -translate-y-1/2 flex items-center pointer-events-box-none",
        children: R(i)
      }
    )
  ] });
}
const i4 = 'data-[error-pulse="true"]:animate-tremble relative z-0 border inline-flex items-center text-ellipsis whitespace-nowrap overflow-hidden font-title font-semibold transition-colors', d4 = "justify-normal gap-[normal] text-[length:inherit] focus-visible:ring-0 focus-visible:[outline-style:auto] disabled:opacity-100 disabled:pointer-events-auto [&_svg]:size-auto [&_svg]:shrink [&_svg]:pointer-events-auto", Z5 = "items-stretch justify-normal gap-[normal] rounded-none whitespace-normal text-[length:inherit] [font-weight:inherit] transition-none focus-visible:ring-0 focus-visible:[outline-style:auto] disabled:opacity-100 disabled:pointer-events-auto [&_svg]:size-auto [&_svg]:shrink [&_svg]:pointer-events-auto", u4 = {
  primary: [
    "border-[color:var(--Button-border-primary)]",
    "hover:border-[color:var(--Button-border-primary-hover)]",
    "active:border-[color:var(--Button-border-primary-active)]",
    "disabled:border-[color:var(--Button-border-primary-disabled)]",
    'disabled:data-[loading="true"]:border-[color:var(--Button-border-primary)]',
    "bg-[color:var(--Button-bg-primary)]",
    "hover:bg-[color:var(--Button-bg-primary-hover)]",
    "active:bg-[color:var(--Button-bg-primary-active)]",
    "disabled:bg-[color:var(--Button-bg-primary-disabled)]",
    'disabled:data-[loading="true"]:bg-[color:var(--Button-bg-primary)]',
    "text-[color:var(--Button-fg-primary)]",
    "disabled:text-[color:var(--Button-fg-primary-disabled)]",
    'disabled:data-[loading="true"]:text-[color:var(--Button-fg-primary)]'
  ].join(" "),
  secondary: [
    "border-[color:var(--Button-border-secondary)]",
    "disabled:border-[color:var(--Button-border-secondary-disabled)]",
    'disabled:data-[loading="true"]:border-[color:var(--Button-border-secondary)]',
    "bg-[color:var(--Button-bg-secondary)]",
    "hover:bg-[color:var(--Button-bg-secondary-hover)]",
    "active:bg-[color:var(--Button-bg-secondary-active)]",
    "disabled:bg-[color:var(--Button-bg-secondary-disabled)]",
    'disabled:data-[loading="true"]:bg-[color:var(--Button-bg-secondary)]',
    "text-[color:var(--Button-fg-secondary)]",
    "active:text-[color:var(--Button-fg-secondary-active)]",
    "disabled:text-[color:var(--Button-fg-secondary-disabled)]",
    'disabled:data-[loading="true"]:text-[color:var(--Button-fg-secondary)]'
  ].join(" "),
  tertiary: [
    "border-transparent",
    'disabled:data-[loading="true"]:animate-pulse',
    "text-[color:var(--Button-bg-primary)]",
    "active:text-[color:var(--Button-bg-primary-active)]",
    "hover:bg-[color:var(--Button-bg-secondary-hover)]",
    "hover:active:bg-transparent",
    "hover:disabled:bg-transparent",
    "disabled:text-[color:var(--palette-N300)]",
    'disabled:data-[loading="true"]:text-[color:var(--Button-bg-primary)]',
    'data-[loading="true"]:bg-[color:var(--Button-bg-secondary-hover)]',
    'hover:data-[loading="true"]:bg-[color:var(--Button-bg-secondary-hover)]'
  ].join(" "),
  neutral: [
    "border-[color:var(--Button-border-neutral)]",
    "hover:border-[color:var(--Button-border-neutral-hover)]",
    "active:border-[color:var(--Button-border-neutral-active)]",
    "disabled:border-[color:var(--Button-border-neutral-disabled)]",
    'disabled:data-[loading="true"]:border-[color:var(--Button-border-neutral)]',
    "bg-[color:var(--Button-bg-neutral)]",
    "hover:bg-[color:var(--Button-bg-neutral-hover)]",
    "active:bg-[color:var(--Button-bg-neutral-active)]",
    "disabled:bg-[color:var(--Button-bg-neutral-disabled)]",
    'disabled:data-[loading="true"]:bg-[color:var(--Button-bg-neutral)]',
    "text-[color:var(--Button-fg-neutral)]",
    "disabled:text-[color:var(--Button-fg-neutral-disabled)]",
    'disabled:data-[loading="true"]:text-[color:var(--Button-fg-neutral)]'
  ].join(" "),
  ghost: [
    "border-transparent",
    "bg-[color:var(--Button-bg-ghost)]",
    "hover:bg-[color:var(--Button-bg-ghost-hover)]",
    "active:bg-[color:var(--Button-bg-ghost-active)]",
    "disabled:bg-[color:var(--Button-bg-ghost-disabled)]",
    'disabled:data-[loading="true"]:bg-[color:var(--Button-bg-ghost)]',
    "text-[color:var(--Button-fg-ghost)]",
    "disabled:text-[color:var(--Button-fg-ghost-disabled)]",
    'disabled:data-[loading="true"]:text-[color:var(--Button-fg-ghost)]'
  ].join(" "),
  neutralOutline: [
    "border-[color:var(--Button-border-neutralOutline)]",
    "hover:border-[color:var(--Button-border-neutralOutline-hover)]",
    "active:border-[color:var(--Button-border-neutralOutline-active)]",
    "disabled:border-[color:var(--Button-border-neutralOutline-disabled)]",
    'disabled:data-[loading="true"]:border-[color:var(--Button-border-neutralOutline)]',
    "bg-[color:var(--Button-bg-neutralOutline)]",
    "hover:bg-[color:var(--Button-bg-neutralOutline-hover)]",
    "active:bg-[color:var(--Button-bg-neutralOutline-active)]",
    "disabled:bg-[color:var(--Button-bg-neutralOutline-disabled)]",
    'disabled:data-[loading="true"]:bg-[color:var(--Button-bg-neutralOutline)]',
    "text-[color:var(--Button-fg-neutralOutline)]",
    "disabled:text-[color:var(--Button-fg-neutralOutline-disabled)]",
    'disabled:data-[loading="true"]:text-[color:var(--Button-fg-neutralOutline)]'
  ].join(" "),
  info: [
    "border-[color:var(--Button-border-info)]",
    "hover:border-[color:var(--Button-border-info-hover)]",
    "active:border-[color:var(--Button-border-info-active)]",
    "disabled:border-[color:var(--Button-border-info-disabled)]",
    'disabled:data-[loading="true"]:border-[color:var(--Button-border-info)]',
    "bg-[color:var(--Button-bg-info)]",
    "hover:bg-[color:var(--Button-bg-info-hover)]",
    "active:bg-[color:var(--Button-bg-info-active)]",
    "disabled:bg-[color:var(--Button-bg-info-disabled)]",
    'disabled:data-[loading="true"]:bg-[color:var(--Button-bg-info)]',
    "text-[color:var(--Button-fg-info)]",
    "disabled:text-[color:var(--Button-fg-info-disabled)]",
    'disabled:data-[loading="true"]:text-[color:var(--Button-fg-info)]'
  ].join(" "),
  infoOutline: [
    "border-[color:var(--Button-border-infoOutline)]",
    "hover:border-[color:var(--Button-border-infoOutline-hover)]",
    "active:border-[color:var(--Button-border-infoOutline-active)]",
    "disabled:border-[color:var(--Button-border-infoOutline-disabled)]",
    'disabled:data-[loading="true"]:border-[color:var(--Button-border-infoOutline)]',
    "bg-[color:var(--Button-bg-infoOutline)]",
    "hover:bg-[color:var(--Button-bg-infoOutline-hover)]",
    "active:bg-[color:var(--Button-bg-infoOutline-active)]",
    "disabled:bg-[color:var(--Button-bg-infoOutline-disabled)]",
    'disabled:data-[loading="true"]:bg-[color:var(--Button-bg-infoOutline)]',
    "text-[color:var(--Button-fg-infoOutline)]",
    "active:text-[color:var(--Button-fg-infoOutline-active)]",
    "disabled:text-[color:var(--Button-fg-infoOutline-disabled)]",
    'disabled:data-[loading="true"]:text-[color:var(--Button-fg-infoOutline)]'
  ].join(" "),
  danger: [
    "border-[color:var(--Button-border-danger)]",
    "hover:border-[color:var(--Button-border-danger-hover)]",
    "active:border-[color:var(--Button-border-danger-active)]",
    "disabled:border-[color:var(--Button-border-danger-disabled)]",
    'disabled:data-[loading="true"]:border-[color:var(--Button-border-danger)]',
    "bg-[color:var(--Button-bg-danger)]",
    "hover:bg-[color:var(--Button-bg-danger-hover)]",
    "active:bg-[color:var(--Button-bg-danger-active)]",
    "disabled:bg-[color:var(--Button-bg-danger-disabled)]",
    'disabled:data-[loading="true"]:bg-[color:var(--Button-bg-danger)]',
    "text-[color:var(--Button-fg-danger)]",
    "disabled:text-[color:var(--Button-fg-danger-disabled)]",
    'disabled:data-[loading="true"]:text-[color:var(--Button-fg-danger)]'
  ].join(" "),
  inverted: [
    "border-[color:var(--Button-border-inverted)]",
    "bg-[color:var(--Button-bg-inverted)]",
    "hover:bg-[color:var(--Button-bg-inverted-hover)]",
    "active:bg-[color:var(--Button-bg-inverted-active)]",
    "disabled:bg-[color:var(--Button-bg-inverted-disabled)]",
    'disabled:data-[loading="true"]:bg-[color:var(--Button-bg-inverted)]',
    "text-[color:var(--Button-fg-inverted)]",
    "disabled:text-[color:var(--Button-fg-inverted-disabled)]",
    'disabled:data-[loading="true"]:text-[color:var(--Button-fg-inverted)]'
  ].join(" "),
  quaternary: [
    "border-transparent",
    "text-[color:var(--palette-N0)]",
    "active:text-[color:var(--palette-N1000)]",
    "hover:bg-[color:var(--palette-N20)]",
    "hover:text-[color:var(--palette-N700)]",
    "hover:disabled:bg-transparent",
    "disabled:text-[color:var(--palette-N100)]",
    'disabled:data-[loading="true"]:text-[color:var(--palette-N700)]',
    'data-[loading="true"]:bg-[color:var(--palette-N0)]',
    'hover:data-[loading="true"]:bg-[color:var(--palette-N0)]'
  ].join(" "),
  "secondary-danger": [
    "border-[color:var(--Button-border-secondary-danger)]",
    "disabled:border-[color:var(--Button-border-secondary-danger-disabled)]",
    'disabled:data-[loading="true"]:border-[color:var(--Button-border-secondary-danger)]',
    "bg-[color:var(--Button-bg-secondary-danger)]",
    "hover:bg-[color:var(--Button-bg-secondary-danger-hover)]",
    "active:bg-[color:var(--Button-bg-secondary-danger-active)]",
    "disabled:bg-[color:var(--Button-bg-secondary-danger-disabled)]",
    'disabled:data-[loading="true"]:bg-[color:var(--Button-bg-secondary-danger)]',
    "text-[color:var(--Button-fg-secondary-danger)]",
    "active:text-[color:var(--Button-fg-secondary-danger-active)]",
    "disabled:text-[color:var(--Button-fg-secondary-danger-disabled)]",
    'disabled:data-[loading="true"]:text-[color:var(--Button-fg-secondary-danger)]'
  ].join(" ")
}, h4 = {
  large: "text-[16px] h-[38px] px-[10px]",
  small: "h-[34px] px-[9px]",
  "x-small": "text-[12px] h-[26px] px-[6px]"
}, f4 = {
  large: 24,
  small: 18,
  "x-small": 14
};
function j9({ onClickAsync: e, ...t }) {
  return e ? /* @__PURE__ */ o(v4, { ...t, onClickAsync: e }) : /* @__PURE__ */ o(V5, { ...t });
}
function v4({ onClickAsync: e, ...t }) {
  const [r, c] = I2(async (n, l) => e(n, l));
  return /* @__PURE__ */ o(
    V5,
    {
      ...t,
      state: c,
      onClick: (n) => {
        r(n).catch(_5);
      }
    }
  );
}
function V5({
  palette: e = "neutral",
  className: t,
  type: r = "button",
  size: c = "large",
  onClick: n,
  children: l,
  innerRef: s,
  disabled: a = !1,
  state: i,
  unstyled: d = !1,
  progressBar: v = !0,
  ...h
}) {
  const u = i?.kind, p = u === "loading", m = i3({ trigger: u === "error", duration: 500 }), f = i3({ trigger: u === "success", duration: 800 }), b = v ? i?.kind === "loading" && typeof i.progress == "number" ? i.progress : f ? 1 : null : null, y = a || p;
  return /* @__PURE__ */ o(
    z3,
    {
      variant: null,
      size: null,
      ref: s,
      type: r,
      onClick: n,
      disabled: y,
      className: Q1(
        d ? (
          // `inline-block` is what a class-less legacy `<button>` rendered; it beats the primitive's `inline-flex`.
          D(Z5, "inline-block")
        ) : D(
          i4,
          u4[m ? "danger" : e],
          d4,
          "rounded-sm",
          y && "disabled:cursor-default",
          h4[c]
        ),
        t
      ),
      ...h,
      ...i !== void 0 && {
        "data-state": u,
        "data-loading": p,
        "data-error-pulse": m
      },
      children: i === void 0 ? (
        // A render prop is called with an explicit initial state — `state` is optional, so
        // `{(s) => s.kind}` type-checks and would otherwise throw. Everything else goes through
        // `renderNodeOrFn` with NO props, as legacy `Button` did: it spreads props into a `memo`
        // child, which would put a stray `kind` attribute on the DOM.
        typeof l == "function" ? l({ kind: "initial" }) : R(l)
      ) : d ? R(l, i) : /* @__PURE__ */ x(n1, { children: [
        /* @__PURE__ */ x(G1, { in: p || f, children: [
          /* @__PURE__ */ o(
            d3,
            {
              unmountOnExit: !0,
              className: "absolute top-1/2 left-1/2 -translate-x-1/2 block transition-[opacity,transform] z-0",
              enterFromClassName: "opacity-0 -translate-y-full",
              enterToClassName: "opacity-100 -translate-y-1/2",
              children: ({ className: N }) => /* @__PURE__ */ o("span", { className: X(N), children: u === "success" ? /* @__PURE__ */ o(Q, { icon: "Outline", size: f4[c] }) : p ? /* @__PURE__ */ o(Q, { icon: "calulating", className: "animate-spin ease-in-out" }) : null })
            }
          ),
          /* @__PURE__ */ o(
            d3,
            {
              className: "relative inline-flex items-center transition-[opacity,transform] z-10 overflow-hidden text-ellipsis whitespace-nowrap",
              enterFromClassName: "opacity-100 translate-y-0",
              enterToClassName: "opacity-0 translate-y-full",
              children: ({ className: N }) => /* @__PURE__ */ o("span", { className: X(N), children: R(l, i) })
            }
          )
        ] }),
        b !== null && /* @__PURE__ */ o(
          "span",
          {
            style: { transform: `scaleX(${b})` },
            className: "absolute inset-y-0 left-0 w-full z-20 bg-black opacity-5 transition-transform origin-left"
          }
        )
      ] })
    }
  );
}
const m4 = Z5;
function A2({ onClickAsync: e, ...t }) {
  return e ? /* @__PURE__ */ o(p4, { ...t, onClickAsync: e }) : /* @__PURE__ */ o(U5, { ...t });
}
function p4({ onClickAsync: e, ...t }) {
  const [r, c] = I2(async (n, l) => {
    await e(n, l);
  });
  return /* @__PURE__ */ o(
    U5,
    {
      ...t,
      state: c,
      onClick: (n) => {
        r(n).catch(_5);
      }
    }
  );
}
function U5({
  className: e,
  style: t,
  color: r,
  hoverBackground: c = I.palette_N100,
  background: n = "transparent",
  size: l = "1rem",
  type: s = "button",
  disabled: a,
  icon: i,
  innerRef: d,
  applyNegativeMargins: v = !1,
  unstyled: h = !1,
  onClick: u,
  state: p,
  ...m
}) {
  const f = p?.kind === "loading", b = a || f, y = !h, N = /* @__PURE__ */ o(Q, { className: { "animate-spin": f }, color: r, size: l, icon: f ? "calulating" : i });
  return /* @__PURE__ */ o(
    z3,
    {
      variant: null,
      size: null,
      className: Q1(
        D(
          m4,
          // `inline-block` is what a class-less legacy `<button>` rendered; it beats the primitive's `inline-flex`.
          y ? "flex p-2" : "inline-block",
          y && v && "-m-2",
          y && !b && "group/icon-button",
          b && "disabled:cursor-default",
          // Legacy wrote a bare `opacity-70` here, which twMerge cannot resolve against the
          // primitive's `disabled:opacity-50` (different modifier, different group) — both would
          // survive and the reset would win on specificity, leaving a disabled button undimmed.
          // Under the `disabled:` modifier it resolves, and legacy only ever showed it while
          // disabled anyway.
          y && !f && b && "disabled:opacity-70"
        ),
        e
      ),
      style: t,
      type: s,
      disabled: b,
      ref: d,
      onClick: u,
      ...m,
      children: y ? /* @__PURE__ */ o(
        "span",
        {
          className: "inline-block group-hover/icon-button:bg-(--hover-background) bg-(--background) rounded-xs p-0.5",
          style: {
            // content-box so the pill grows AROUND the glyph rather than eating into it.
            boxSizing: "content-box",
            "--hover-background": c,
            "--background": n
          },
          children: N
        }
      ) : N
    }
  );
}
const g4 = {
  dismissLabel: ({ title: e }) => e ? `Dismiss: ${e}` : "Dismiss"
}, b4 = "relative z-0 pl-[36px] py-2", M4 = {
  box: {
    info: "bg-[#E5F7FD]",
    success: "bg-[#EDF7F5]",
    warning: "bg-[#FEF0EA]",
    error: "bg-[#FFE8E9]"
  },
  bar: {
    info: "bg-[#00AEEF] text-white",
    success: "bg-[#4CB09C] text-white",
    warning: "bg-[#F26D2D] text-white",
    error: "bg-[#FF3439] text-white"
  }
}, X3 = {
  box: {
    info: { icon: "info", className: "text-[#03A0DC]" },
    success: { icon: "Icon-full-ok", className: "text-[#4CB09C]" },
    warning: { icon: "Icon-full-alert", className: "text-[#F26D2D]" },
    error: { icon: "Icon-full-error", className: "text-[#FF3439]" }
  },
  bar: {
    info: { icon: "info", className: "" },
    success: { icon: "Icon-full-ok", className: "" },
    warning: { icon: "Icon-full-alert", className: "" },
    error: { icon: "Icon-full-error", className: "" }
  }
}, W9 = G(x4);
function x4({
  variant: e = "box",
  title: t,
  children: r,
  severity: c,
  className: n,
  style: l,
  innerRef: s,
  overrides: a,
  dismissible: i = !1,
  onDismiss: d,
  dismissRef: v,
  i18n: h,
  ...u
}) {
  const p = e2({ fallback: g4, overrides: h });
  return /* @__PURE__ */ x(
    "div",
    {
      ref: s,
      className: o1(
        {
          [b4]: !0,
          // Room for the close button, so text never runs under it.
          "pr-2": !i,
          "pr-11": i,
          [M4[e][c]]: !0,
          "rounded-[3px]": e === "box"
        },
        n
      ),
      style: a?.background ? { ...l, background: a.background } : l,
      ...u,
      children: [
        /* @__PURE__ */ o("div", { className: "absolute top-[8px] left-[9px] flex", children: /* @__PURE__ */ o(
          Q,
          {
            size: 18,
            className: X3[e][c].className,
            icon: a?.icon ?? X3[e][c].icon,
            color: a?.iconColor
          }
        ) }),
        t && /* @__PURE__ */ o("div", { className: "font-bold mb-1", style: { color: a?.foreground }, children: R(t) }),
        r && /* @__PURE__ */ o("div", { style: { color: a?.foreground }, children: R(r) }),
        i && /* @__PURE__ */ o(
          A2,
          {
            icon: "Close",
            innerRef: v,
            "aria-label": p.dismissLabel({ title: typeof t == "string" ? t : void 0 }),
            className: "absolute top-1/2 right-1 -translate-y-1/2",
            onClick: d
          }
        )
      ]
    }
  );
}
function z4({
  className: e,
  style: t,
  children: r,
  onChange: c,
  innerRef: n,
  ...l
}) {
  const [s, a] = E2(null, n), i = q1(s, {
    onChange: c
  }), d = i?.width ?? 0, v = i?.height ?? 0;
  return /* @__PURE__ */ o("div", { className: X(e), style: t, ref: a, ...l, children: s && i && R(r, { height: v, width: d, htmlEl: s }) });
}
const K5 = G(z4), q5 = G(y4);
function y4({
  show: e = !0,
  position: t,
  className: r,
  style: c,
  innerRef: n,
  children: l,
  pointerEvents: s = !1,
  ...a
}) {
  return /* @__PURE__ */ o(
    G1,
    {
      in: e,
      unmountOnExit: !0,
      className: I1(
        {
          "absolute transition-opacity": !0,
          "right-0": t === "right",
          "left-0": t === "left",
          "bottom-0": t === "bottom",
          "top-0": t === "top",
          "inset-y-0 w-4": t === "left" || t === "right",
          "inset-x-0 h-4": t === "top" || t === "bottom",
          "opacity-100": e,
          "opacity-0": !e,
          "pointer-events-none": !s
        },
        r
      ),
      children: ({ className: i }) => /* @__PURE__ */ o(
        "div",
        {
          ref: n,
          style: {
            backgroundImage: `linear-gradient(${t === "top" ? "to top" : t === "left" ? "to left" : t === "bottom" ? "to bottom" : "to right"}, ${I.ScrollWrapper_band_gradient_from}, ${I.ScrollWrapper_band_gradient_to})`,
            ...c
          },
          className: X(i),
          ...a,
          children: R(l)
        }
      )
    }
  );
}
const l2 = G(C4);
function C4({
  value: e,
  children: t,
  onChange: r,
  name: c
}) {
  const [n, l] = W(e), [s, a] = W(0), i = a1(!1), d = a1(n), v = Z(
    (m) => {
      i.current = !0, l(m), d.current = m;
    },
    [d]
  );
  l1(() => {
    U1(s), v(e), i.current = !1;
  }, [e, v, s]);
  const h = e1(
    r ? (m) => {
      r(m), a((f) => f + 1);
    } : null
  ), u = Z(
    (m) => {
      m !== void 0 ? (v(m), h.current?.(m)) : i.current && h.current?.(d.current);
    },
    [h, d, v]
  ), p = O(
    () => ({
      value: n,
      onChange: v,
      onCommit: u
    }),
    [v, u, n]
  );
  return /* @__PURE__ */ o(j6, { onCleanup: () => u(), name: c, children: R(t, p) });
}
const Z1 = F1({
  zIndex: 100
}), J3 = F1(null);
function I4({ onClickAway: e, referenceElement: t, disabled: r }) {
  const c = e1(e), n = a1(e), { cancel: l, invoke: s } = G2(() => n.current(), {
    debounceInterval: 10,
    unmountBehavior: "flush"
  });
  _1(
    document.body,
    "mousedown",
    () => {
      n.current = c.current, s();
    },
    { capture: !0, disabled: r }
  ), _1(t, "mousedown", l, { disabled: r }), _1(
    document.body,
    "touchstart",
    () => {
      n.current = c.current, s();
    },
    { capture: !0, disabled: r }
  ), _1(t, "touchstart", l, { disabled: r });
}
const G9 = ["top", "right", "bottom", "left"], Z9 = ["startToStart", "middle", "endToEnd", "startToEnd", "endToStart"], N4 = {
  top: ["bottom", "left", "right"],
  right: ["left", "top", "bottom"],
  bottom: ["top", "left", "right"],
  left: ["right", "top", "bottom"]
}, S4 = {
  startToStart: ["endToEnd", "startToEnd", "endToStart", "middle"],
  middle: ["startToStart", "endToEnd", "startToEnd", "endToStart"],
  endToEnd: ["startToStart", "startToEnd", "endToStart", "middle"],
  startToEnd: ["startToStart", "endToEnd", "endToStart", "middle"],
  endToStart: ["startToStart", "endToEnd", "startToEnd", "middle"]
}, w4 = {
  firstFocusableElementLabel: () => "Floating content begin focus handle",
  captureFocusElementLabel: () => "Floating content capture focus handle",
  lastFocusableElementLabel: () => "Floating content end focus handle",
  nextFocusableElementLabel: () => "Floating content restore focus handle"
}, y3 = G(B4);
function B4({
  open: e,
  strategy: t = "absolute",
  trigger: r,
  children: c,
  position: n = "top",
  align: l = "startToStart",
  forcePosition: s = !1,
  forceAlignment: a = !1,
  relativeAlignmentOffsets: i,
  relativePositionOffsets: d,
  className: v,
  style: h,
  onClickAway: u,
  onScrollOutside: p,
  onTriggerExitViewport: m,
  onEscapeKey: f,
  onMouseEnter: b,
  onMouseLeave: y,
  i18n: N,
  focusOnOpen: _ = !0,
  onAnimationStateChange: $,
  innerRef: F,
  maxWidth: P,
  animated: C = !0,
  triggerLocation: L = "around",
  portalTarget: E,
  contentRef: S,
  ...B
}) {
  const g = e2({
    fallback: w4,
    overrides: N
  }), [z, M] = E2(null, F), [H, q] = E2(null, S), [U, t1] = W(!1), w = e1({
    focusOnOpen: _,
    renderContent: U,
    triggerElement: z,
    contentElement: H,
    preferredPosition: n,
    preferredAlignment: l,
    relativePositionOffsets: d,
    relativeAlignmentOffsets: i,
    strategy: t,
    forcePosition: s,
    forceAlignment: a,
    triggerLocation: L,
    onTriggerExitViewport: m,
    onScrollOutside: p,
    onEscapeKey: f,
    portalTarget: E
  }), j = e1($), k = Z(
    (M1) => {
      M1 === "exited" ? (t1(!1), d1(e3(w.current.triggerElement, w.current.portalTarget))) : M1 === "entered" && w.current.focusOnOpen && N1.current?.focus({ preventScroll: !0 });
      const k1 = j.current;
      if (k1)
        switch (M1) {
          case "exited":
            return k1("hidden");
          case "entered":
            return k1("shown");
          case "entering":
            return k1("showing");
          case "prepare-enter":
          case "prepare-exit":
            break;
          case "exiting":
            return k1("hiding");
        }
    },
    [j, w]
  ), A = b2({
    in: e,
    onChange: k,
    duration: C ? 50 : 0
  }), Y = V1(J3);
  l1(() => {
    Y && (Y.hasOpenFloatingChildrenRef.current = e);
  }, [Y, e]), l1(() => () => {
    Y && (Y.hasOpenFloatingChildrenRef.current = !1);
  }, [Y]);
  const T = a1(!1), [c1] = W({ hasOpenFloatingChildrenRef: T }), i1 = Z(
    (M1) => {
      T.current || u?.(M1);
    },
    [u]
  ), { value: K } = T2(() => A, [A], {
    debounceInterval: 10
  });
  I4({
    referenceElement: [H, z],
    onClickAway: () => {
      i1?.("clickedOutside");
    },
    disabled: K !== "entered"
  }), _1(
    z,
    "blur",
    () => {
      setTimeout(() => {
        !document.activeElement || document.activeElement === document.body || H?.contains(document.activeElement) || i1?.("blurredTrigger");
      });
    },
    { disabled: !e }
  );
  const J = T5(), [V, d1] = W(() => e3(z, E));
  l1(() => {
    (async () => {
      if (e) {
        if (d1(e3(w.current.triggerElement, w.current.portalTarget)), t1(!0), await J(), !w.current.renderContent)
          return;
        d1(
          Q3(
            w.current.triggerElement,
            w.current.contentElement,
            w.current.preferredPosition,
            w.current.preferredAlignment,
            w.current.relativePositionOffsets,
            w.current.relativeAlignmentOffsets,
            w.current.strategy,
            w.current.forcePosition,
            w.current.forceAlignment,
            w.current.triggerLocation,
            w.current.portalTarget
          )
        );
      }
    })().catch(U1);
  }, [e, w, J]), l1(() => {
    if (!e)
      return;
    const M1 = [];
    if (!z) {
      w.current.onTriggerExitViewport?.();
      return;
    }
    let k1 = z?.parentElement;
    for (; k1; )
      M1.push(k1), k1 === document.documentElement ? k1 = window : k1 = k1.parentElement;
    function o6() {
      if (!w.current.triggerElement || !w.current.contentElement)
        return;
      const O1 = w.current.triggerElement.getBoundingClientRect();
      (O1.x + O1.width <= 0 || O1.y + O1.height <= 0 || O1.x > document.documentElement.clientWidth || O1.y > document.documentElement.clientHeight) && (w.current.onScrollOutside?.(), w.current.onTriggerExitViewport?.()), d1(
        Q3(
          w.current.triggerElement,
          w.current.contentElement,
          w.current.preferredPosition,
          w.current.preferredAlignment,
          w.current.relativePositionOffsets,
          w.current.relativeAlignmentOffsets,
          w.current.strategy,
          w.current.forcePosition,
          w.current.forceAlignment,
          w.current.triggerLocation,
          w.current.portalTarget
        )
      );
    }
    let w2 = null;
    function W3() {
      w2 != null && clearTimeout(w2), w2 = setTimeout(() => {
        o6(), w2 = null;
      }, 10);
    }
    for (const O1 of M1)
      O1.addEventListener("scroll", W3, {
        passive: !0
      });
    return () => {
      for (const O1 of M1)
        O1.removeEventListener("scroll", W3);
    };
  }, [e, w, z]);
  const C1 = e1({ onEscapeKey: f, open: e });
  _1(
    document,
    "keydown",
    (M1) => {
      C1.current.open && M1.key === "Escape" && (M1.preventDefault(), M1.stopPropagation(), C1.current.onEscapeKey?.());
    },
    { disabled: !e }
  );
  const r1 = a1(null), h1 = a1(null), N1 = a1(null), R1 = a1(null);
  return /* @__PURE__ */ x(J3.Provider, { value: c1, children: [
    O(() => r({ innerRef: M }), [M, r]),
    /* @__PURE__ */ o(
      "div",
      {
        "aria-label": g.nextFocusableElementLabel(),
        role: "button",
        ref: R1,
        tabIndex: -1,
        className: "block w-0 h-0 absolute pointer-events-none"
      }
    ),
    /* @__PURE__ */ o(Z1.Consumer, { children: ({ zIndex: M1 }) => /* @__PURE__ */ o(n1, { children: (A !== "exited" || U) && j2(
      /* @__PURE__ */ x(
        "div",
        {
          ...B,
          className: o1(
            {
              "flex flex-col min-h-0": !0,
              "ease-in-out transition-opacity": C,
              absolute: t === "absolute",
              fixed: t === "fixed",
              "opacity-0": A !== "entering" && A !== "entered",
              "opacity-100": A === "entering" || A === "entered",
              "origin-top": V.position === "bottom" && V.align === "middle",
              "origin-bottom": V.position === "top" && V.align === "middle",
              "origin-left": V.position === "right" && V.align === "middle",
              "origin-right": V.position === "left" && V.align === "middle",
              "origin-bottom-left": V.position === "top" && (V.align === "startToStart" || V.align === "startToEnd") || V.position === "right" && (V.align === "endToEnd" || V.align === "endToStart"),
              "origin-bottom-right": V.position === "top" && (V.align === "endToEnd" || V.align === "endToStart") || V.position === "left" && (V.align === "endToEnd" || V.align === "endToStart"),
              "origin-top-left": V.position === "right" && (V.align === "startToStart" || V.align === "startToEnd") || V.position === "bottom" && (V.align === "startToStart" || V.align === "startToEnd"),
              "origin-top-right": V.position === "bottom" && (V.align === "endToEnd" || V.align === "endToStart") || V.position === "left" && (V.align === "startToStart" || V.align === "startToEnd")
            },
            v
          ),
          ref: q,
          style: {
            ...V.style,
            transitionDuration: C ? "50ms" : void 0,
            minWidth: "max-content",
            zIndex: M1,
            ...h
          },
          onMouseLeave: A === "entered" ? y : void 0,
          onMouseEnter: A === "entered" ? b : void 0,
          children: [
            /* @__PURE__ */ o(
              "div",
              {
                "aria-label": g.firstFocusableElementLabel(),
                role: "button",
                tabIndex: 0,
                ref: r1,
                onFocus: () => {
                  R1.current?.focus({
                    preventScroll: !0
                  }), i1?.("focusedFirstElement");
                },
                className: "block w-0 h-0 opacity-0 absolute pointer-events-none"
              }
            ),
            /* @__PURE__ */ o(
              "div",
              {
                "aria-label": g.captureFocusElementLabel(),
                role: "button",
                ref: N1,
                tabIndex: -1,
                className: "block w-0 h-0 opacity-0 absolute pointer-events-none"
              }
            ),
            /* @__PURE__ */ o(
              "div",
              {
                style: {
                  display: "flex",
                  flexDirection: "column",
                  maxWidth: Math.min(
                    P ?? 1 / 0,
                    V.portalTargetSize.width - (V.style.left - V.portalTargetScroll.x)
                  ),
                  maxHeight: V.portalTargetSize.height - (V.style.top - V.portalTargetScroll.y)
                },
                children: R(c, {
                  position: V.position,
                  align: V.align,
                  triggerBox: V.triggerBox,
                  viewportSize: V.portalTargetSize,
                  viewportScroll: V.portalTargetScroll,
                  strategy: t,
                  contentSize: V.contentSize
                })
              }
            ),
            /* @__PURE__ */ o(
              "div",
              {
                "aria-label": g.lastFocusableElementLabel(),
                role: "button",
                tabIndex: 0,
                ref: h1,
                onFocus: () => {
                  R1.current?.focus({
                    preventScroll: !0
                  }), i1?.("focusedLastElement");
                },
                className: "block w-0 h-0 opacity-0 absolute pointer-events-none"
              }
            )
          ]
        }
      ),
      E ?? document.body
    ) }) })
  ] });
}
function Q3(e, t, r, c, n, l, s, a, i, d, v) {
  const h = {
    // window.innerWidth/Height doesn't take into account the scrollbar width/height
    width: v?.clientWidth ?? document.documentElement.clientWidth,
    height: v?.clientHeight ?? document.documentElement.clientHeight
  }, u = {
    y: v?.scrollTop ?? window.scrollY,
    x: v?.scrollLeft ?? window.scrollX
  }, p = v?.getBoundingClientRect(), m = e.getBoundingClientRect();
  m.x -= p?.x ?? 0, m.y -= p?.y ?? 0;
  const f = t.getBoundingClientRect(), b = [
    r,
    ...N4[r]
  ], y = [
    c,
    ...S4[c]
  ], N = {
    top: n?.top ?? 0,
    bottom: n?.bottom ?? 0,
    left: n?.left ?? 0,
    right: n?.right ?? 0
  }, _ = {
    middle: l?.middle ?? 0,
    startToStart: l?.startToStart ?? 0,
    endToEnd: l?.endToEnd ?? 0,
    startToEnd: l?.startToEnd ?? 0,
    endToStart: l?.endToStart ?? 0
  }, $ = {
    positions: ["top", "bottom"],
    coordinate: "y",
    size: "height"
  }, F = {
    positions: ["left", "right"],
    coordinate: "x",
    size: "width"
  }, P = (g, z, M, H) => {
    switch (g) {
      case M.positions[0]:
        return (H ? T1 : r2)(
          N[g] + m[M.coordinate] + (d === "around" ? 0 : m[M.size]) + (s === "absolute" ? u[M.coordinate] : 0) - f[M.size],
          0,
          Math.floor(
            h[M.size] - f[M.size] - N[g] + (s === "absolute" ? u[M.coordinate] : 0)
          )
        );
      case M.positions[1]:
        return (H ? T1 : r2)(
          N[g] + m[M.coordinate] + (s === "absolute" ? u[M.coordinate] : 0) + (d === "around" ? m[M.size] : 0),
          0,
          Math.max(
            0,
            Math.floor(
              h[M.size] - f[M.size] - N[g] + (s === "absolute" ? u[M.coordinate] : 0)
            )
          )
        );
      default:
        switch (z) {
          case "middle":
            return (H ? T1 : r2)(
              _[z] + m[M.coordinate] + (s === "absolute" ? u[M.coordinate] : 0) + m[M.size] / 2 - f[M.size] / 2,
              0,
              Math.max(
                0,
                Math.floor(
                  h[M.size] - f[M.size] - _[z] + (s === "absolute" ? u[M.coordinate] : 0)
                )
              )
            );
          case "startToStart":
            return (H ? T1 : r2)(
              _[z] + m[M.coordinate] + (s === "absolute" ? u[M.coordinate] : 0),
              0,
              Math.max(
                0,
                Math.floor(
                  h[M.size] - f[M.size] - _[z] + (s === "absolute" ? u[M.coordinate] : 0)
                )
              )
            );
          case "endToEnd":
            return (H ? T1 : r2)(
              _[z] + (s === "absolute" ? u[M.coordinate] : 0) + m[M.coordinate] + m[M.size] - f[M.size],
              0,
              Math.max(
                0,
                Math.floor(
                  h[M.size] - f[M.size] - _[z] + (s === "absolute" ? u[M.coordinate] : 0)
                )
              )
            );
          case "startToEnd":
            return (H ? T1 : r2)(
              _[z] + m[M.coordinate] + (s === "absolute" ? u[M.coordinate] : 0) + m[M.size],
              0,
              Math.max(
                0,
                Math.floor(
                  h[M.size] - f[M.size] - _[z] + (s === "absolute" ? u[M.coordinate] : 0)
                )
              )
            );
          case "endToStart":
            return (H ? T1 : r2)(
              _[z] + m[M.coordinate] + (s === "absolute" ? u[M.coordinate] : 0) - f[M.size],
              0,
              Math.max(
                0,
                Math.floor(
                  h[M.size] - f[M.size] - _[z] + (s === "absolute" ? u[M.coordinate] : 0)
                )
              )
            );
        }
    }
  }, C = (a ? [r] : b).flatMap(
    (g) => (i ? [c] : y).map((z) => ({
      position: g,
      alignment: z
    }))
  ), L = i6(C, ({ position: g, alignment: z }) => {
    const M = {
      y: P(g, z, $, !1),
      x: P(g, z, F, !1)
    }, H = {
      y: P(g, z, $, !0),
      x: P(g, z, F, !0)
    };
    return 1 / d6.distance(M, H);
  }), E = C[L].position, S = C[L].alignment;
  return {
    style: {
      top: P(E, S, $, !0),
      left: P(E, S, F, !0)
    },
    position: E,
    align: S,
    triggerBox: m,
    portalTargetSize: h,
    portalTargetScroll: u,
    contentSize: f
  };
}
function e3(e, t) {
  return {
    style: {
      top: 0,
      left: 0,
      visibility: "hidden"
    },
    align: "startToStart",
    position: "bottom",
    portalTargetSize: {
      width: t?.clientWidth ?? document.documentElement.clientWidth,
      height: t?.clientHeight ?? document.documentElement.clientHeight
    },
    portalTargetScroll: {
      y: t?.scrollTop ?? window.scrollY,
      x: t?.scrollLeft ?? window.scrollX
    },
    triggerBox: e?.getBoundingClientRect() ?? {
      x: 0,
      y: 0,
      width: 0,
      height: 0
    },
    contentSize: null
  };
}
function k4({
  direction: e = "vertical",
  overflowingEl: t,
  disabled: r = !1
}) {
  const c = W6(t, { passive: !0, disabled: r });
  return O(() => {
    const n = e === "horizontal" ? c?.x : c?.y, l = e === "horizontal" ? c?.scrollWidth : c?.scrollHeight, s = e === "horizontal" ? c?.clientWidth : c?.clientHeight, a = n ?? null, i = l != null && n != null && s != null ? l - (n + s) : null;
    return { scrollFromStart: a, scrollTillEnd: i, scrollInfo: c };
  }, [e, c]);
}
const Y5 = G(P4);
function P4({
  onArrowClick: e,
  direction: t = "vertical",
  scrollFromStart: r,
  style: c,
  className: n,
  scrollInfo: l,
  offset: s,
  ...a
}) {
  const i = l != null ? l.offsetWidth - l.clientWidth : 0, d = l != null ? l.offsetHeight - l.clientHeight : 0;
  return /* @__PURE__ */ o(
    q5,
    {
      style: {
        ...c,
        top: t === "vertical" ? s ?? 0 : 0,
        bottom: t === "horizontal" ? d : void 0,
        left: t === "horizontal" ? s ?? 0 : 0,
        right: t === "vertical" ? i : void 0,
        overflow: "hidden"
      },
      className: n,
      show: r != null && r > 10,
      position: t === "vertical" ? "top" : "left",
      pointerEvents: !!e,
      ...a,
      children: e && /* @__PURE__ */ o(
        "div",
        {
          role: "button",
          tabIndex: -1,
          onClick: e,
          className: X({
            "absolute flex items-center justify-center cursor-pointer inset-0": !0
          }),
          children: /* @__PURE__ */ o(Q, { size: 20, color: I.palette_N500, icon: t === "horizontal" ? "Left" : "Up" })
        }
      )
    }
  );
}
const X5 = G(L4);
function L4({
  onArrowClick: e,
  scrollTillEnd: t,
  direction: r = "vertical",
  className: c,
  style: n,
  scrollInfo: l,
  offset: s,
  ...a
}) {
  const i = l != null ? l.offsetWidth - l.clientWidth : 0, d = l != null ? l.offsetHeight - l.clientHeight : 0;
  return /* @__PURE__ */ o(
    q5,
    {
      style: {
        ...n,
        bottom: r === "vertical" ? (s ?? 0) + d : d,
        top: r === "horizontal" ? 0 : void 0,
        right: r === "horizontal" ? (s ?? 0) + i : i,
        left: r === "vertical" ? 0 : void 0,
        overflow: "hidden"
      },
      className: c,
      show: t != null && t > 10,
      position: r === "vertical" ? "bottom" : "right",
      pointerEvents: !!e,
      ...a,
      children: e && /* @__PURE__ */ o(
        "div",
        {
          role: "button",
          tabIndex: -1,
          onClick: e,
          className: X({
            "absolute flex items-center justify-center cursor-pointer inset-0": !0
          }),
          children: /* @__PURE__ */ o(Q, { size: 20, color: I.palette_N500, icon: r === "horizontal" ? "Right" : "Down" })
        }
      )
    }
  );
}
function J5({
  direction: e = "vertical",
  showScrollingArrows: t = e === "horizontal",
  startShadow: r = !0,
  endShadow: c = !0,
  overflowingEl: n
}) {
  const { scrollFromStart: l, scrollTillEnd: s, scrollInfo: a } = k4({
    direction: e,
    overflowingEl: n,
    disabled: !r && !c
  });
  return /* @__PURE__ */ x(n1, { children: [
    r && (typeof r == "boolean" ? /* @__PURE__ */ o(
      Y5,
      {
        scrollInfo: a,
        style: { zIndex: 10 },
        scrollFromStart: l,
        direction: e,
        onArrowClick: t ? () => {
          n && (e === "horizontal" ? n.scrollLeft -= n.clientWidth : n.scrollTop -= n.clientHeight);
        } : void 0
      }
    ) : R(r, {
      style: { zIndex: 10 },
      scrollFromStart: l,
      direction: e,
      scrollInfo: a
    })),
    c && (typeof c == "boolean" ? /* @__PURE__ */ o(
      X5,
      {
        scrollInfo: a,
        style: { zIndex: 10 },
        scrollTillEnd: s,
        direction: e,
        onArrowClick: t ? () => {
          n && (e === "horizontal" ? n.scrollLeft += n.clientWidth : n.scrollTop += n.clientHeight);
        } : void 0
      }
    ) : R(c, {
      style: { zIndex: 10 },
      scrollTillEnd: s,
      direction: e,
      scrollInfo: a
    }))
  ] });
}
const d2 = G(T4);
function T4({
  children: e,
  direction: t = "vertical",
  className: r,
  style: c,
  innerRef: n,
  startShadow: l = t === "horizontal",
  endShadow: s = t === "horizontal",
  outerContainerAppearance: a,
  innerContainerAppearance: i,
  showScrollingArrows: d = t === "horizontal",
  ...v
}) {
  const [h, u] = E2(null, n);
  return /* @__PURE__ */ x(
    "div",
    {
      style: a?.style,
      className: o1(
        {
          "relative z-0 flex": !0,
          "flex-col min-h-0": t === "vertical",
          "flex-row min-w-0": t === "horizontal"
        },
        a?.className
      ),
      ...v,
      children: [
        /* @__PURE__ */ o(
          J5,
          {
            overflowingEl: h,
            direction: t,
            startShadow: l,
            endShadow: s,
            showScrollingArrows: d
          }
        ),
        /* @__PURE__ */ o(
          "div",
          {
            ref: u,
            style: {
              WebkitOverflowScrolling: "touch",
              scrollBehavior: "smooth",
              ...c
            },
            className: o1(
              {
                "relative z-0": !0,
                "overflow-y-auto": t === "vertical",
                "overflow-x-auto": t === "horizontal",
                "overflow-y-hidden": t === "horizontal",
                "overflow-x-hidden": t === "vertical"
              },
              r
            ),
            children: /* @__PURE__ */ o(
              "div",
              {
                className: o1(
                  {
                    "relative z-0": !0,
                    "h-max": t === "vertical",
                    "w-max": t === "horizontal"
                  },
                  i?.className
                ),
                style: i?.style,
                children: R(e)
              }
            )
          }
        )
      ]
    }
  );
}
const Q5 = F1(null), E4 = {
  closeButtonLabel: () => "Close"
}, c2 = 6, x1 = 10, B2 = 9, D4 = G(A4);
function A4({
  children: e,
  open: t,
  onClose: r,
  trigger: c,
  position: n = "bottom",
  align: l = "middle",
  severity: s = "info",
  strategy: a = "absolute",
  focusOnOpen: i = !1,
  onAnimationStateChange: d,
  forcePosition: v = !1,
  forceAlignment: h = !1,
  i18n: u,
  contentRef: p,
  closeOnScroll: m = !1,
  overrideColor: f,
  innerRef: b,
  maxWidth: y = 320,
  maxHeight: N = 320,
  hideArrow: _ = !1,
  portalTarget: $,
  ...F
}) {
  return /* @__PURE__ */ o(
    y3,
    {
      portalTarget: $,
      maxWidth: y,
      forcePosition: v,
      forceAlignment: h,
      focusOnOpen: i,
      onClickAway: r,
      onTriggerExitViewport: r,
      strategy: a,
      open: t,
      onEscapeKey: r,
      onScrollOutside: m ? r : void 0,
      trigger: c,
      position: n,
      align: l,
      onAnimationStateChange: d,
      relativeAlignmentOffsets: _ ? void 0 : {
        endToStart: c2 + x1,
        startToEnd: -16,
        endToEnd: c2,
        startToStart: -c2
      },
      relativePositionOffsets: {
        top: -B2,
        left: -B2,
        right: B2,
        bottom: B2
      },
      innerRef: b,
      ...F,
      children: ({ contentSize: P, position: C, align: L }) => /* @__PURE__ */ o(
        R4,
        {
          contentRef: p,
          i18n: u,
          severity: s,
          contentSize: P,
          position: C,
          align: L,
          onClose: r,
          overrideColor: f,
          maxHeight: N,
          hideArrow: _,
          children: e
        }
      )
    }
  );
}
function R4({
  contentSize: e,
  position: t,
  align: r,
  children: c,
  severity: n,
  onClose: l,
  i18n: s,
  contentRef: a,
  overrideColor: i,
  maxHeight: d,
  hideArrow: v
}) {
  return /* @__PURE__ */ x(
    "div",
    {
      className: "flex flex-1 shadow-lg relative z-0 min-h-0",
      style: {
        boxShadow: "0px 8px 16px 0px #2A303C1F"
      },
      ref: a,
      children: [
        !v && /* @__PURE__ */ o(
          "svg",
          {
            xmlns: "http://www.w3.org/2000/svg",
            className: "block absolute z-10 pointer-events-none origin-top",
            style: {
              top: t === "top" ? e?.height ?? 0 : t === "bottom" ? -x1 : r === "middle" ? (e?.height ?? 0) / 2 - x1 / 2 : r === "startToStart" || r === "startToEnd" ? c2 : (e?.height ?? 0) - c2 - x1,
              left: t === "left" ? e?.width ?? 0 : t === "right" ? -x1 : r === "middle" ? (e?.width ?? 0) / 2 - x1 / 2 : r === "startToStart" || r === "startToEnd" ? c2 : (e?.width ?? 0) - c2 - x1,
              height: x1,
              width: x1
            },
            height: x1,
            width: x1,
            viewBox: `0 0 ${x1} ${x1}`,
            children: /* @__PURE__ */ o(
              "g",
              {
                transform: `rotate(${t === "top" ? 0 : t === "bottom" ? 180 : t === "left" ? -90 : 90} ${x1 / 2} ${x1 / 2})`,
                children: /* @__PURE__ */ o(
                  "path",
                  {
                    d: `M${x1} 0H0L${x1 / 2} 6L${x1} 0Z`,
                    fill: i ?? q3[n]
                  }
                )
              }
            )
          }
        ),
        /* @__PURE__ */ x(
          "div",
          {
            className: X({
              "bg-white relative z-0 min-h-0 min-w-0 overflow-hidden flex-1 flex shadow-lg rounded-[3px]": !0,
              "pl-1": t === "right" && !v,
              "pr-1": t === "left" && !v,
              "pb-1": t === "top" && !v,
              "pt-1": t === "bottom" && !v
            }),
            children: [
              !v && /* @__PURE__ */ o(
                "div",
                {
                  className: X({
                    "absolute z-10": !0,
                    "inset-y-0 w-1": t === "left" || t === "right",
                    "inset-x-0 h-1": t === "top" || t === "bottom",
                    "left-0": t === "right",
                    "right-0": t === "left",
                    "top-0": t === "bottom",
                    "bottom-0": t === "top"
                  }),
                  style: { backgroundColor: i ?? q3[n] }
                }
              ),
              /* @__PURE__ */ o(Q5.Provider, { value: { onClose: l }, children: /* @__PURE__ */ o(
                W1,
                {
                  wrapper: (h) => /* @__PURE__ */ o(_4, { maxHeight: d, i18n: s, children: h }),
                  children: R(c)
                }
              ) })
            ]
          }
        )
      ]
    }
  );
}
function _4({
  children: e,
  style: t,
  className: r,
  i18n: c,
  maxHeight: n = 320,
  hideCloseButton: l = !1
}) {
  const a = V1(Q5)?.onClose;
  return /* @__PURE__ */ x(n1, { children: [
    !l && a && /* @__PURE__ */ o(F4, { onClose: a, i18n: c }),
    /* @__PURE__ */ o(
      d2,
      {
        direction: "vertical",
        outerContainerAppearance: {
          className: "min-w-0 flex-1",
          style: { maxHeight: n }
        },
        className: "z-0",
        children: /* @__PURE__ */ o(
          "div",
          {
            className: o1(
              {
                "py-2 pl-[10px]": !0,
                "pr-[10px]": l || !a,
                "pr-[28px]": !!(!l && a)
              },
              r
            ),
            style: t,
            children: R(e)
          }
        )
      }
    )
  ] });
}
function F4({
  className: e,
  style: t,
  i18n: r,
  onClose: c
}) {
  const n = e2({ fallback: E4, overrides: r });
  return /* @__PURE__ */ o(
    A2,
    {
      onClick: c,
      icon: "Close",
      size: "1rem",
      color: I.Tooltip_close_icon_fg,
      title: n.closeButtonLabel(),
      className: I1("absolute right-0 top-px z-10", e),
      style: t
    }
  );
}
function O4({
  deactivationDelay: e = 150,
  activationDelay: t = 150,
  disabled: r = !1,
  elements: c
}) {
  const [n, l] = W(() => b6()), s = n.count(), { value: a, forceUpdate: i } = T2(
    () => s > 0,
    [s],
    {
      debounceInterval: t
    }
  ), { value: d, forceUpdate: v } = T2(
    () => s === 0,
    [s],
    {
      debounceInterval: e
    }
  ), h = e1({
    flushOpen: i,
    flushClosed: v
  }), u = Z(() => {
    l((b) => b.clear()), h.current.flushClosed(!0), h.current.flushOpen(!1);
  }, [h]), p = a && !d, [m, f] = W(() => c);
  return (m.length !== c.length || m.some((b, y) => b !== c[y])) && f(c), l1(() => {
    const b = m.filter((N) => N != null);
    if (r || b.length === 0) {
      u();
      return;
    }
    l((N) => N.intersect(b));
    const y = b.map((N) => {
      const _ = () => l((F) => F.add(N)), $ = () => l((F) => F.remove(N));
      return N.addEventListener("mouseenter", _), N.addEventListener("mouseleave", $), () => {
        N.removeEventListener("mouseenter", _), N.removeEventListener("mouseleave", $);
      };
    });
    return () => {
      y.forEach((N) => N());
    };
  }, [r, m, u]), p;
}
const V9 = G($4);
function $4({
  trigger: e,
  mode: t = "hover",
  autoCloseTimeout: r = 150,
  openDelay: c = 150,
  disabled: n = !1,
  innerRef: l,
  ...s
}) {
  const [a, i] = W(null), [d, v] = W(null), [h, u] = W(!1);
  l1(() => {
    if (!a || t === "hover" || n)
      return;
    const f = () => u((b) => !b);
    return a.addEventListener("click", f), () => {
      a.removeEventListener("click", f);
    };
  }, [n, t, a]);
  const p = Z(
    (f) => e({
      innerRef: (b) => {
        i(b), f.innerRef(b), z2(b, l);
      }
    }),
    [l, e]
  ), m = O4({
    elements: [a, d],
    activationDelay: c,
    deactivationDelay: r,
    disabled: n || t === "click"
  });
  return /* @__PURE__ */ o(
    D4,
    {
      open: t === "click" ? h : m,
      onClose: t === "click" ? () => u(!1) : void 0,
      trigger: p,
      contentRef: v,
      ...s
    }
  );
}
class H4 extends Error {
}
function C3({
  asyncFn: e,
  onError: t,
  onPending: r,
  onSuccess: c
}) {
  const [n, l] = W(null), [s, a] = W(null), [i, d] = W("initial"), [v, h] = W(null), u = e1({ asyncFn: e, onError: t, onPending: r, onSuccess: c }), p = a1(null), m = Z(
    async (...f) => {
      p.current?.abort(new H4()), p.current = new AbortController();
      const b = p.current.signal;
      try {
        a(null), l("indeterminate"), d("loading"), u.current.onPending?.();
        const y = await u.current.asyncFn(...f, {
          signal: b,
          progressCb: l
        });
        return b.throwIfAborted(), h(y), l(1), d("success"), u.current.onSuccess?.(y), y;
      } catch (y) {
        throw console.warn("[useAsync] asyncFn threw an error", y), b.aborted || (a(y), d("error")), u.current.onError?.(y), y;
      }
    },
    [u]
  );
  return {
    progress: n,
    run: m,
    result: v,
    error: s,
    state: i
  };
}
function t3(e) {
  return { x: e.clientX, y: e.clientY };
}
function r3(e, t) {
  const r = e.type === "touchstart" ? G3(e.touches, (c) => c.identifier === t) : G3(e.changedTouches, (c) => c.identifier === t);
  if (!r)
    throw new Error("invalid touch identifier");
  return { x: r.clientX, y: r.clientY };
}
function j4(e) {
  const t = e1(e), r = a1({ type: "idle" }), [c, n] = W(!1), l = Z(
    (f, b, y, N) => {
      f1(t.current.preventDefault ?? !0, { initialCoords: b, coords: y, phase: N }) && f.preventDefault(), f1(t.current.stopPropagation ?? !0, { initialCoords: b, coords: y, phase: N }) && f.stopPropagation();
    },
    [t]
  ), s = Z(
    function(f, b) {
      if (t.current.disabled)
        return;
      const y = b(), N = {
        alt: !!f.altKey,
        ctrl: !!f.ctrlKey,
        shift: !!f.shiftKey,
        meta: !!f.metaKey
      };
      t.current.filter && !t.current.filter(y, N) || (l(f, y, y, "begin"), r.current = { type: "dragging", initialCoords: y }, t.current.onDragStart?.(y, N));
    },
    [l, t]
  ), a = Z(
    function(f, b) {
      if (r.current.type !== "dragging")
        return;
      const y = b();
      l(f, r.current.initialCoords, y, "running"), n(!0), t.current.onDragMove?.(
        r.current.initialCoords,
        y
      );
    },
    [l, t]
  ), i = Z(
    function(f, b) {
      if (r.current.type !== "dragging")
        return;
      const y = b();
      l(f, r.current.initialCoords, y, "end"), t.current.onDragMove?.(
        r.current.initialCoords,
        y
      ), t.current.onDragEnd?.(
        r.current.initialCoords,
        y
      ), r.current = { type: "idle" }, n(!1);
    },
    [l, t]
  ), d = Z(
    (f) => {
      s(f, () => t3(f));
    },
    [s]
  ), v = Z(
    (f) => {
      f.touches.length === 1 && (s(f, () => r3(f, f.touches[0].identifier)), r.current.touchId = f.touches[0].identifier);
    },
    [s]
  ), h = Z(
    (f) => {
      i(f, () => t3(f));
    },
    [i]
  ), u = Z(
    (f) => {
      const b = r.current.touchId;
      b !== void 0 && i(f, () => r3(f, b));
    },
    [i]
  ), p = Z(
    (f) => {
      a(f, () => t3(f));
    },
    [a]
  ), m = Z(
    (f) => {
      const b = r.current.touchId;
      b !== void 0 && a(f, () => r3(f, b));
    },
    [a]
  );
  return l1(() => {
    if (e.draggableEl)
      return e.draggableEl.addEventListener("mousedown", d, { passive: !1 }), e.draggableEl.addEventListener("touchstart", v, {
        passive: !1
      }), document.addEventListener("mousemove", p, { passive: !1 }), document.addEventListener("mouseup", h, { passive: !1 }), document.addEventListener("touchmove", m, { passive: !1 }), document.addEventListener("touchend", u, { passive: !1 }), document.addEventListener("touchcancel", u, { passive: !1 }), () => {
        e.draggableEl.removeEventListener("mousedown", d), e.draggableEl.removeEventListener("touchstart", v), document.removeEventListener("mousemove", p), document.removeEventListener("mouseup", h), document.removeEventListener("touchmove", m), document.removeEventListener("touchend", u), document.removeEventListener("touchcancel", u);
      };
  }, [
    p,
    h,
    u,
    m,
    d,
    v,
    e.draggableEl
  ]), {
    dragging: c
  };
}
function W4({
  query: e,
  collection: t,
  extractFn: r
}) {
  const [c, n] = W(e ?? "");
  l1(() => {
    n(e ?? "");
  }, [e]);
  const { value: l } = T2(() => c, [c]), s = O(
    () => H2(t, l, r),
    [t, r, l]
  );
  return {
    query: c,
    filtered: s,
    setQuery: n,
    debouncedQuery: l,
    collection: t
  };
}
const U9 = {
  "Title/XL": "Title/XL",
  "Title/XL/Light": "Title/XL/Light",
  "Title/L": "Title/L",
  "Title/L/Light": "Title/L/Light",
  "Title/M/Bold": "Title/M/Bold",
  "Title/M": "Title/M",
  "Title/M/Light": "Title/M/Light",
  "Title/S": "Title/S",
  "Title/S/Light": "Title/S/Light",
  "Body/XL/Bold": "Body/XL/Bold",
  "Body/XL/Medium": "Body/XL/Medium",
  "Body/XL/Book": "Body/XL/Book",
  "Body/XL/Italic": "Body/XL/Italic",
  "Body/L/Bold": "Body/L/Bold",
  "Body/L/Medium": "Body/L/Medium",
  "Body/L/Book": "Body/L/Book",
  "Body/L/Italic": "Body/L/Italic",
  "Body/L/Link": "Body/L/Link",
  "Body/M/Bold": "Body/M/Bold",
  "Body/M/Book": "Body/M/Book",
  "Body/M/Italic": "Body/M/Italic",
  "Body/M/Medium": "Body/M/Medium",
  "Body/M/Link": "Body/M/Link",
  "Body/S/Bold": "Body/S/Bold",
  "Body/S/Medium": "Body/S/Medium",
  "Body/S/Book": "Body/S/Book",
  "Body/S/Italic": "Body/S/Italic",
  "Body/S/BOLD-UPPERCASE": "Body/S/BOLD-UPPERCASE",
  "Body/S/Light-UPPERCASE": "Body/S/Light-UPPERCASE",
  "Body/S/Link": "Body/S/Link"
};
function b1(e) {
  return { "data-text-type": e };
}
function z1({
  as: e,
  className: t,
  style: r,
  children: c,
  type: n = "Body/L/Book",
  highlight: l = !1,
  color: s = I.categorical_text_primary,
  innerRef: a,
  ...i
}) {
  return /* @__PURE__ */ o(
    e ?? "span",
    {
      className: o1(
        {
          "bg-[var(--global-palette-secondary-100)]": l === !0
        },
        t
      ),
      "data-text-type": n,
      style: {
        ...typeof l == "string" ? { backgroundColor: l } : f5,
        color: s,
        ...r
      },
      ref: a,
      ...i,
      children: R(c)
    }
  );
}
function K9({
  as: e,
  className: t,
  style: r,
  children: c,
  type: n = "Body/M/Link",
  href: l,
  onClick: s,
  onClickAsync: a,
  highlight: i = !1,
  disabled: d = !1,
  color: v = d ? I.palette_N300 : I.categorical_text_primary,
  rel: h,
  target: u,
  innerRef: p,
  ...m
}) {
  const f = C3({
    asyncFn: a ?? U1
  }), b = a ? g2(f.run) : s, y = e ?? (l ? "a" : b ? "button" : "span"), N = d || f.state === "loading";
  return /* @__PURE__ */ o(
    y,
    {
      disabled: N,
      type: y === "button" ? "button" : void 0,
      href: l,
      onClick: N && y === "a" ? (_) => _.preventDefault() : b,
      className: o1(
        {
          "bg-[var(--global-palette-secondary-100)]": i === !0,
          "underline underline-offset-[3px]": !0,
          "cursor-pointer": !N,
          "cursor-default": N && f.state !== "loading",
          "cursor-progress animate-pulse": f.state === "loading"
        },
        t
      ),
      "data-text-type": n,
      style: {
        ...typeof i == "string" ? { backgroundColor: i } : f5,
        color: v,
        ...r
      },
      rel: h,
      target: u,
      ref: p,
      ...m,
      children: R(c, f)
    }
  );
}
const G4 = G(V4);
function Z4(e) {
  const t = e.startOf("day").plus({ hours: 12 }), r = t.startOf("month").startOf("week").plus({ hours: 12 }), c = t.endOf("month").endOf("week").minus({ hours: 12 });
  let n = r;
  const l = [];
  for (; n.toISODate() <= c.toISODate(); )
    l.push(n), n = n.plus({ days: 1 });
  return l;
}
function e5(e, t) {
  const r = typeof e == "number" ? e : typeof e == "string" ? y1.fromISO(e).year : e.year, c = typeof t == "number" ? t : typeof t == "string" ? y1.fromISO(t).year : t.year;
  return Math.floor(r / P1) - Math.floor(c / P1);
}
function M2(e, t) {
  const r = typeof e == "number" ? e : typeof e == "string" ? y1.fromISO(e).year : e.year, c = typeof t == "number" ? t : typeof t == "string" ? y1.fromISO(t).year : t.year;
  return r - c;
}
function u2(e, t) {
  const r = typeof e == "string" ? y1.fromISO(e) : e, c = typeof t == "string" ? y1.fromISO(t) : t;
  return r.year !== c.year ? r.year - c.year : r.month - c.month;
}
function k2(e, t) {
  const r = typeof e == "string" ? y1.fromISO(e) : e, c = typeof t == "string" ? y1.fromISO(t) : t;
  return r.year !== c.year ? r.year - c.year : r.month !== c.month ? r.month - c.month : r.day - c.day;
}
function o3(e, t) {
  return e.year === t.year && e.month === t.month && e.day === t.day;
}
function V4(e) {
  const [t, r] = W(null), [c, n] = W(() => {
    const i = Array.isArray(e.value) ? e.value[0] : e.value;
    if (i) {
      const d = y1.fromISO(i);
      if (d.isValid)
        return d;
    }
    return y1.now();
  }), l = Array.isArray(e.value) ? e.value[0] : e.value;
  l1(() => {
    if (!l)
      return;
    const i = y1.fromISO(l);
    i.isValid && n((d) => i.hasSame(d, "month") ? d : i);
  }, [l]);
  const s = O(() => y1.now(), []), a = O(() => g3(e.value != null ? e.value : []).map((i) => y1.fromISO(i)), [e.value]);
  return /* @__PURE__ */ x(
    "div",
    {
      className: o1("px-4 py-4 bg-white relative flex flex-col items-center", e.className),
      style: e.style,
      children: [
        /* @__PURE__ */ o(
          c3,
          {
            className: "pb-3",
            decrementDisabled: e.min != null && u2(e.min, c.minus({ month: 1 })) > 0,
            incrementDisabled: e.max != null && u2(e.max, c.plus({ month: 1 })) < 0,
            onDecrement: () => n(c.minus({ month: 1 })),
            onIncrement: () => n(c.plus({ month: 1 })),
            children: /* @__PURE__ */ x("div", { className: "min-w-[120px] flex justify-center gap-1", children: [
              /* @__PURE__ */ x(
                "button",
                {
                  type: "button",
                  className: "relative",
                  onClick: () => r((i) => i === "month" ? null : "month"),
                  children: [
                    /* @__PURE__ */ o(z1, { type: "Body/L/Bold", children: U4[c.month - 1] }),
                    t === "month" && /* @__PURE__ */ o(
                      r5,
                      {
                        style: {
                          position: "absolute",
                          pointerEvents: "none",
                          top: 24 - B1,
                          left: "50%",
                          transform: "translateX(-50%)"
                        }
                      }
                    )
                  ]
                }
              ),
              /* @__PURE__ */ x(
                "button",
                {
                  type: "button",
                  className: "relative",
                  onClick: () => r((i) => i === "year" ? null : "year"),
                  children: [
                    /* @__PURE__ */ o(z1, { type: "Body/L/Bold", children: c.year }),
                    t === "year" && /* @__PURE__ */ o(
                      r5,
                      {
                        style: {
                          position: "absolute",
                          pointerEvents: "none",
                          top: 24 - B1,
                          left: "50%",
                          transform: "translateX(-50%)"
                        }
                      }
                    )
                  ]
                }
              )
            ] })
          }
        ),
        /* @__PURE__ */ x("div", { className: "flex flex-col", children: [
          /* @__PURE__ */ o("div", { className: "pb-3 w-full border-t border-t-[color:var(--palette-N300)]" }),
          /* @__PURE__ */ x("div", { className: "grid grid-cols-7 gap-y-1", children: [
            /* @__PURE__ */ o(U3, { times: 7, children: (i) => /* @__PURE__ */ o("div", { className: "relative h-6 w-6", children: /* @__PURE__ */ o("div", { className: "absolute inset-x-0 text-center top-1/2 -translate-y-1/2", children: /* @__PURE__ */ o(z1, { type: "Body/M/Book", color: I.palette_N500, children: Y4[i] }) }) }) }),
            /* @__PURE__ */ o(p1, { collection: Z4(c), children: (i) => {
              const d = e.min != null && k2(e.min, i) > 0 || e.max != null && k2(e.max, i) < 0 || (e.isDateDisabled?.(i.toISODate() ?? "") ?? !1), v = a?.[0] != null && o3(a[0], i), h = a?.[1] != null && o3(a[1], i), u = v || h ? "bound" : a?.[0] != null && k2(a?.[0], i) <= 0 && a?.[1] != null && k2(a?.[1], i) >= 0 ? "inside" : "outside";
              return /* @__PURE__ */ o(
                "div",
                {
                  "data-relation": u,
                  "data-start-bound": v,
                  "data-end-bound": h,
                  className: X({
                    "relative h-6 w-6 data-[relation=inside]:bg-[color:var(--palette-N50)]": !0,
                    "before:absolute before:block before:inset-y-0 before:bg-[color:var(--palette-N50)]": !0,
                    "before:left-1/2 before:right-0": v && a.length === 2,
                    "before:left-0 before:right-1/2": h && a.length === 2
                  }),
                  children: /* @__PURE__ */ o(
                    "button",
                    {
                      type: "button",
                      onClick: () => {
                        Array.isArray(e.value) ? a.length === 1 ? e.onChange?.(
                          [a[0].toISODate(), i.toISODate()].sort(u6)
                        ) : e.onChange?.([i.toISODate()]) : e.onChange?.(i.toISODate());
                      },
                      disabled: d,
                      "data-relation": u,
                      className: "absolute inset-0 rounded-full data-[relation=bound]:bg-[color:var(--palette-P500)] data-[relation=inside]:bg-[color:var(--palette-N50)] enabled:hover:data-[relation=bound]:bg-[color:var(--palette-P500)] enabled:hover:not(data-[relation=bound]):bg-[color:var(--palette-S50)]",
                      children: /* @__PURE__ */ o(
                        z1,
                        {
                          type: u === "bound" ? "Body/M/Bold" : "Body/M/Book",
                          color: d ? I.palette_N200 : u === "bound" ? I.palette_N0 : o3(s, i) || u === "inside" ? I.palette_P600 : u2(i, c) === 0 ? I.palette_N700 : I.palette_N300,
                          children: i.day
                        }
                      )
                    }
                  )
                }
              );
            } })
          ] })
        ] }),
        /* @__PURE__ */ o(
          G1,
          {
            in: t === "month",
            unmountOnExit: !0,
            className: "transition-[opacity,transform,scale] origin-top",
            enterFromClassName: "opacity-0 scale-y-50",
            enterToClassName: "opacity-100 scale-y-100",
            children: ({ className: i }) => /* @__PURE__ */ o(t5, { className: i, children: /* @__PURE__ */ o(
              l2,
              {
                value: c,
                onChange: (d) => {
                  n(d), r(null);
                },
                children: ({ value: d, onChange: v, onCommit: h }) => /* @__PURE__ */ x("div", { className: "flex flex-col gap-3 min-h-0 pb-3 pt-3 px-4", children: [
                  /* @__PURE__ */ o(
                    c3,
                    {
                      className: "pb-2 px-4",
                      decrementDisabled: e.min != null && M2(e.min, d.minus({ year: 1 })) > 0,
                      incrementDisabled: e.max != null && M2(e.max, d.plus({ year: 1 })) < 0,
                      onDecrement: () => v(d.minus({ year: 1 })),
                      onIncrement: () => v(d.plus({ year: 1 })),
                      children: /* @__PURE__ */ o("div", { className: "min-w-[50px] flex justify-center gap-1", children: /* @__PURE__ */ o(z1, { type: "Body/L/Bold", children: d.year }) })
                    }
                  ),
                  /* @__PURE__ */ o("div", { className: "grid grid-cols-3 gap-x-1 gap-y-2", children: /* @__PURE__ */ o(p1, { collection: Object.values(K4), children: (u, p) => {
                    const m = e.min != null && u2(e.min, d.set({ month: u })) > 0 || e.max != null && u2(e.max, d.set({ month: u })) < 0, f = u2(d.set({ month: u }), c) === 0;
                    return /* @__PURE__ */ o(
                      "button",
                      {
                        type: "button",
                        onClick: () => h(d.set({ month: u })),
                        "data-current": f,
                        disabled: m,
                        className: "rounded-full w-16 h-6 data-[current=true]:bg-[color:var(--palette-P500)]",
                        children: /* @__PURE__ */ o(
                          z1,
                          {
                            type: f ? "Body/M/Bold" : "Body/M/Book",
                            color: m ? I.palette_N200 : f ? I.palette_N0 : I.palette_N700,
                            children: q4[p]
                          }
                        )
                      }
                    );
                  } }) })
                ] })
              }
            ) })
          }
        ),
        /* @__PURE__ */ o(
          G1,
          {
            in: t === "year",
            unmountOnExit: !0,
            className: "transition-[opacity,transform,scale] origin-top",
            enterFromClassName: "opacity-0 scale-y-50",
            enterToClassName: "opacity-100 scale-y-100",
            children: ({ className: i }) => /* @__PURE__ */ o(t5, { className: i, children: /* @__PURE__ */ o(
              l2,
              {
                value: Math.floor(c.year / P1) * P1,
                onChange: (d) => {
                  n(c.set({ year: d })), r(null);
                },
                children: ({ value: d, onChange: v, onCommit: h }) => /* @__PURE__ */ x("div", { className: "flex flex-col gap-3 min-h-0 pb-3 pt-3", children: [
                  /* @__PURE__ */ o(
                    c3,
                    {
                      className: "pb-2 px-4",
                      decrementDisabled: e.min != null && e5(e.min, d - P1) > 0,
                      incrementDisabled: e.max != null && e5(e.max, d + P1) < 0,
                      onDecrement: () => v(d - P1),
                      onIncrement: () => v(d + P1),
                      children: /* @__PURE__ */ o("div", { className: "min-w-[50px] flex justify-center gap-1", children: /* @__PURE__ */ x(z1, { type: "Body/L/Bold", children: [
                        d,
                        " - ",
                        d + P1 - 1
                      ] }) })
                    }
                  ),
                  /* @__PURE__ */ o(d2, { className: "px-4", children: /* @__PURE__ */ o("div", { className: "grid grid-cols-3 gap-x-1 gap-y-2", children: /* @__PURE__ */ o(U3, { times: P1, children: (u) => {
                    const p = Math.floor(c.year / P1) * P1, m = e.min != null && M2(e.min, p + u) > 0 || e.max != null && M2(e.max, p + u) < 0, f = M2(c.year, p + u) === 0;
                    return /* @__PURE__ */ o(
                      "button",
                      {
                        type: "button",
                        onClick: () => h(p + u),
                        "data-current": f,
                        disabled: m,
                        className: "rounded-full w-16 h-6 data-[current=true]:bg-[color:var(--palette-P500)]",
                        children: /* @__PURE__ */ o(
                          z1,
                          {
                            type: f ? "Body/M/Bold" : "Body/M/Book",
                            color: m ? I.palette_N200 : f ? I.palette_N0 : I.palette_N700,
                            children: p + u
                          }
                        )
                      }
                    );
                  } }) }) })
                ] })
              }
            ) })
          }
        )
      ]
    }
  );
}
const P1 = 12;
function t5(e) {
  return /* @__PURE__ */ x(
    "div",
    {
      className: o1(
        "absolute top-10 inset-x-4 max-h-[calc(100%-60px)] rounded-b-[4px] flex flex-col shadow-lg",
        e.className
      ),
      style: { backgroundColor: I.palette_N50, ...e.style },
      children: [
        /* @__PURE__ */ o(
          "div",
          {
            className: "absolute inset-x-0 h-1 top-0 rounded-t-[4px]",
            style: {
              backgroundColor: I.palette_N200
            }
          }
        ),
        e.children
      ]
    }
  );
}
const B1 = 10, U4 = [
  "January",
  "February",
  "March",
  "April",
  "May",
  "June",
  "July",
  "August",
  "September",
  "October",
  "November",
  "December"
], K4 = {
  0: 1,
  1: 2,
  2: 3,
  3: 4,
  4: 5,
  5: 6,
  6: 7,
  7: 8,
  8: 9,
  9: 10,
  10: 11,
  11: 12
}, q4 = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"], Y4 = ["M", "T", "W", "T", "F", "S", "S"];
function r5(e) {
  return /* @__PURE__ */ o(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      "aria-hidden": "true",
      className: o1("block pointer-events-none", e.className),
      style: {
        height: B1,
        width: B1,
        ...e.style
      },
      height: B1,
      width: B1,
      viewBox: `0 0 ${B1} ${B1}`,
      children: /* @__PURE__ */ o("g", { transform: `rotate(180 ${B1 / 2} ${B1 / 2})`, children: /* @__PURE__ */ o("path", { d: `M${B1} 0H0L${B1 / 2} 6L${B1} 0Z`, fill: I.palette_N200 }) })
    }
  );
}
function c3(e) {
  return /* @__PURE__ */ x("div", { className: o1("flex items-center justify-center gap-2", e.className), style: e.style, children: [
    /* @__PURE__ */ o(
      A2,
      {
        disabled: e.decrementDisabled,
        applyNegativeMargins: !0,
        icon: "Left",
        size: 16,
        onClick: e.onDecrement,
        color: e.decrementDisabled ? I.palette_N200 : I.palette_N500
      }
    ),
    e.children,
    /* @__PURE__ */ o(
      A2,
      {
        disabled: e.incrementDisabled,
        applyNegativeMargins: !0,
        icon: "Right",
        size: 16,
        onClick: e.onIncrement,
        color: e.incrementDisabled ? I.palette_N200 : I.palette_N500
      }
    )
  ] });
}
const e7 = "min-w-[10rem] rounded-sm border bg-(--palette-N0) py-1 text-(--palette-N800) shadow-md", Z2 = `${e7} overflow-y-auto overflow-x-hidden`, N2 = "data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0 data-[state=closed]:zoom-out-95 data-[state=open]:zoom-in-95 data-[side=bottom]:slide-in-from-top-2 data-[side=left]:slide-in-from-right-2 data-[side=right]:slide-in-from-left-2 data-[side=top]:slide-in-from-bottom-2", I3 = "relative flex select-none items-center px-2 py-2 outline-none data-[disabled=true]:pointer-events-none data-[disabled=true]:opacity-50 disabled:pointer-events-none disabled:opacity-50", N3 = "focus:bg-(--palette-N50) focus:text-(--palette-N900) aria-selected:bg-(--palette-N50) aria-selected:text-(--palette-N900) aria-current:bg-(--palette-N50) aria-current:text-(--palette-N900)", t7 = "flex select-none items-center gap-2 rounded-sm px-2 py-2 outline-none [&_svg]:pointer-events-none [&_svg]:size-4 [&_svg]:shrink-0", r7 = "focus:bg-(--palette-N50) focus:text-(--palette-N900) data-[state=open]:bg-(--palette-N50) data-[state=open]:text-(--palette-N900)", V2 = "relative flex cursor-default select-none items-center rounded-sm py-1.5 pl-8 pr-2 outline-none transition-colors focus:bg-(--palette-N50) focus:text-(--palette-N900) data-[disabled=true]:pointer-events-none data-[disabled=true]:opacity-50 disabled:pointer-events-none disabled:opacity-50", U2 = "absolute left-2 flex h-3.5 w-3.5 items-center justify-center", o7 = "px-2 py-2 text-(--palette-N500) uppercase", S3 = "-mx-1 my-1 h-px bg-(--palette-N200)", c7 = "-mx-1 mt-1 h-px bg-(--palette-N20)", X4 = "ml-auto text-xs tracking-widest text-muted-foreground", w3 = s1.forwardRef(({ className: e, ...t }, r) => /* @__PURE__ */ o(w1, { ref: r, className: D("flex h-full w-full flex-col overflow-hidden", e), ...t }));
w3.displayName = w1.displayName;
const B3 = s1.forwardRef(({ className: e, ...t }, r) => /* @__PURE__ */ x("div", { className: "flex items-center border-b border-(--palette-N200) px-2 gap-2", "cmdk-input-wrapper": "", children: [
  /* @__PURE__ */ o(Q, { icon: "Search", size: 18, color: I.palette_N300 }),
  /* @__PURE__ */ o(
    w1.Input,
    {
      ref: r,
      className: D(
        "flex h-10 w-full bg-transparent py-3 text-sm outline-none placeholder:text-(--palette-N300) disabled:cursor-not-allowed disabled:opacity-50",
        e
      ),
      ...t
    }
  )
] }));
B3.displayName = w1.Input.displayName;
const k3 = s1.forwardRef(({ className: e, ...t }, r) => /* @__PURE__ */ o(
  w1.List,
  {
    ref: r,
    className: D("flex-1 min-h-0 overflow-y-auto overflow-x-hidden", e),
    ...t
  }
));
k3.displayName = w1.List.displayName;
const P3 = s1.forwardRef(({ className: e, ...t }, r) => /* @__PURE__ */ o(
  w1.Empty,
  {
    ref: r,
    className: D("px-2 py-2 text-center text-(--palette-N500)", e),
    ...b1("Body/M/Book"),
    ...t
  }
));
P3.displayName = w1.Empty.displayName;
const L3 = s1.forwardRef(({ className: e, ...t }, r) => /* @__PURE__ */ o(
  w1.Group,
  {
    ref: r,
    className: D(
      "**:[[cmdk-group-heading]]:sticky **:[[cmdk-group-heading]]:top-0 **:[[cmdk-group-heading]]:z-10 **:[[cmdk-group-heading]]:bg-(--palette-N0) **:[[cmdk-group-heading]]:px-2 **:[[cmdk-group-heading]]:py-2 **:[[cmdk-group-heading]]:text-[10px] **:[[cmdk-group-heading]]:font-medium **:[[cmdk-group-heading]]:uppercase **:[[cmdk-group-heading]]:text-(--palette-N700) **:[[cmdk-group-heading]]:border-b **:[[cmdk-group-heading]]:border-(--palette-N20) **:[[cmdk-group-heading]]:mb-1 **:[[cmdk-group-heading]]:truncate",
      e
    ),
    ...t
  }
));
L3.displayName = w1.Group.displayName;
const T3 = s1.forwardRef(({ className: e, ...t }, r) => /* @__PURE__ */ o(w1.Separator, { ref: r, className: D(S3, e), ...t }));
T3.displayName = w1.Separator.displayName;
const R2 = s1.forwardRef(({ className: e, disabled: t, ...r }, c) => /* @__PURE__ */ o(
  w1.Item,
  {
    ref: c,
    disabled: t,
    "data-disabled": t ? "true" : void 0,
    className: D(I3, N3, e),
    ...b1("Body/M/Medium"),
    ...r
  }
));
R2.displayName = w1.Item.displayName;
const E3 = v2.Root, D3 = v2.Trigger, q9 = v2.Anchor, K2 = s1.forwardRef(({ className: e, align: t = "center", sideOffset: r = 4, container: c, ...n }, l) => /* @__PURE__ */ o(v2.Portal, { container: c ?? void 0, children: /* @__PURE__ */ o(Z1.Consumer, { children: ({ zIndex: s }) => /* @__PURE__ */ o(
  v2.Content,
  {
    ref: l,
    align: t,
    sideOffset: r,
    className: D(
      // `flex flex-col overflow-hidden` + the available-height/width caps are mandatory
      // layout: they bound the content to the viewport and let a child scroll region
      // (e.g. a CommandList with `flex-1 min-h-0`) scroll *inside* the popover instead
      // of overflowing past the screen edge.
      "flex max-h-(--radix-popover-content-available-height) max-w-(--radix-popover-content-available-width) flex-col overflow-hidden outline-none",
      e7,
      N2,
      "origin-[--radix-popover-content-transform-origin]",
      e
    ),
    ...n,
    style: { zIndex: s, ...n.style }
  }
) }) }));
K2.displayName = v2.Content.displayName;
const n7 = "flex w-full items-center justify-between gap-2 whitespace-nowrap overflow-hidden rounded-[4px] border bg-(--palette-N0) text-(--palette-N800) ring-offset-background focus:outline-none focus:border-(--palette-N500) disabled:cursor-not-allowed disabled:border-(--palette-N100) disabled:bg-(--palette-N100) disabled:text-(--palette-N400) data-[invalid=true]:border-(--palette-D500) border-(--palette-N200)", l7 = {
  "x-small": "text-xs h-[26px] px-1.5",
  small: "text-sm h-[34px] px-2.5",
  large: "text-base h-[38px] px-4"
};
function s7(e) {
  return `min(${e}px, var(--radix-popover-content-available-height))`;
}
function a7(e) {
  return `min(${e}px, var(--radix-popover-content-available-width))`;
}
function J4(e) {
  return e.length === 0 ? [] : Array.isArray(e[0]) && e[0].length === 2 && Array.isArray(e[0][1]) ? e.filter(([, t]) => t.length > 0) : [["", e]];
}
function i7(e, t) {
  return e ? typeof e == "string" && R5(e) ? /* @__PURE__ */ o(Q, { icon: e, size: t }) : e : null;
}
function Y9(e) {
  const {
    options: t,
    placeholder: r = "Select...",
    disabled: c,
    invalid: n,
    size: l = "small",
    enableSearch: s = !1,
    enableClear: a = !1,
    searchPlaceholder: i = "Search...",
    emptyMessage: d = "No results found",
    align: v = "start",
    className: h,
    style: u,
    multiSelectLabel: p,
    floatingAppearance: m,
    maxHeight: f = 300,
    maxWidth: b = 440,
    triggerDataAttrs: y,
    innerRef: N,
    id: _,
    Trigger: $,
    extraTriggerProps: F,
    ...P
  } = e, [C, L] = W(!1), [E, S] = W(""), B = O(() => J4(t), [t]), g = O(() => B.flatMap(([, T]) => T), [B]), z = O(() => {
    if (!s || E.length === 0) return B;
    const T = H2(g, E, (c1) => c1.label);
    return T.length > 0 ? [["", T]] : [];
  }, [s, E, B, g]), M = e.multi === !0, H = (T) => M ? e.value.some((c1) => S1(c1, T.value)) : e.value != null && S1(e.value, T.value), q = M ? void 0 : g.find((T) => S1(T.value, e.value)), U = M ? e.value.length === 0 : e.value == null, t1 = M ? e.value.length === 0 ? r : (p ?? ((T) => `${T} selected`))(e.value.length) : q?.label ?? r, w = c || g.length === 0 || g.every((T) => T.disabled);
  function j(T) {
    if (!T.disabled)
      if (e.multi) {
        const c1 = e.value, i1 = c1.findIndex((J) => S1(J, T.value)), K = i1 === -1 ? [...c1, T.value] : c1.filter((J, V) => V !== i1);
        e.onChange?.(K);
      } else
        e.onChange?.(T.value), L(!1);
  }
  function k() {
    e.multi ? e.onChange?.([]) : e.onChange?.(null);
  }
  function A(T) {
    if (C || M || g.length === 0) return;
    const c1 = e.value == null ? -1 : g.findIndex((J) => S1(J.value, e.value)), i1 = (J, V) => {
      let d1 = J;
      for (let C1 = 0; C1 < g.length; C1++)
        if (d1 += V, d1 < 0 ? d1 = g.length - 1 : d1 >= g.length && (d1 = 0), !g[d1].disabled) return d1;
      return J;
    };
    let K = null;
    switch (T.key) {
      case "ArrowDown":
        K = i1(c1, 1);
        break;
      case "ArrowUp":
        K = i1(c1 < 0 ? g.length : c1, -1);
        break;
      case "Home":
        K = i1(-1, 1);
        break;
      case "End":
        K = i1(g.length, -1);
        break;
      default:
        return;
    }
    T.preventDefault(), K != null && K !== c1 && e.onChange?.(g[K].value);
  }
  const Y = {
    open: C,
    triggerLabel: t1,
    isEmpty: U,
    isMulti: M,
    disabled: w,
    invalid: n,
    size: l,
    enableClear: a,
    onClear: a && !U ? k : void 0,
    onKeyDown: A
  };
  return /* @__PURE__ */ x(
    E3,
    {
      modal: !1,
      open: C,
      onOpenChange: (T) => {
        L(T), T || S("");
      },
      children: [
        /* @__PURE__ */ o(D3, { asChild: !0, disabled: w, ...y, children: $ ? /* @__PURE__ */ o($, { ...Y, ...F }) : /* @__PURE__ */ o(
          Q4,
          {
            ref: N,
            id: _,
            ...Y,
            icon: q?.icon,
            className: h,
            style: u
          }
        ) }),
        /* @__PURE__ */ o(
          K2,
          {
            align: v,
            className: D("min-w-(--radix-popover-trigger-width)", m?.className),
            style: {
              maxHeight: s7(f),
              maxWidth: a7(b),
              ...m?.style
            },
            ...A1(P),
            children: /* @__PURE__ */ x(w3, { loop: !0, shouldFilter: !1, children: [
              /* @__PURE__ */ o("div", { className: s ? void 0 : "sr-only", children: /* @__PURE__ */ o(
                B3,
                {
                  placeholder: i,
                  value: s ? E : "",
                  onValueChange: s ? S : void 0
                }
              ) }),
              /* @__PURE__ */ x(k3, { children: [
                s && E.length > 0 && z.length === 0 && /* @__PURE__ */ o(P3, { children: d }),
                /* @__PURE__ */ o(p1, { collection: z, children: ([T, c1], i1) => /* @__PURE__ */ x(n1, { children: [
                  i1 > 0 && /* @__PURE__ */ o(T3, {}),
                  /* @__PURE__ */ o(L3, { heading: T || void 0, children: /* @__PURE__ */ o(p1, { collection: c1, children: (K, J) => {
                    const V = H(K);
                    return /* @__PURE__ */ o(
                      R2,
                      {
                        value: `${i1}-${J}-${K.label}`,
                        disabled: K.disabled,
                        "aria-selected": V,
                        className: "gap-2 cursor-pointer group/option",
                        onSelect: () => j(K),
                        ...b1("Body/M/Book"),
                        ...A1(K),
                        children: K.children != null ? R(K.children, { label: K.label, value: K.value }) : /* @__PURE__ */ x(n1, { children: [
                          i7(K.icon, 16),
                          /* @__PURE__ */ o("span", { className: "truncate flex-1", children: K.label }),
                          V && /* @__PURE__ */ o(W2, { className: "h-4 w-4 shrink-0" })
                        ] })
                      },
                      `${i1}-${J}-${K.label}`
                    );
                  } }) })
                ] }) })
              ] })
            ] })
          }
        )
      ]
    }
  );
}
const Q4 = m5(function({
  open: t,
  triggerLabel: r,
  isEmpty: c,
  isMulti: n,
  disabled: l,
  invalid: s,
  size: a = "small",
  enableClear: i,
  onClear: d,
  icon: v,
  className: h,
  style: u,
  ...p
}, m) {
  return /* @__PURE__ */ x(
    "button",
    {
      ref: m,
      type: "button",
      disabled: l,
      "data-invalid": s || void 0,
      className: D(n7, l7[a], h),
      style: u,
      ...p,
      children: [
        /* @__PURE__ */ x("span", { className: D("flex flex-1 items-center gap-2 truncate", c && "text-(--palette-N300)"), children: [
          !c && i7(v, 16),
          /* @__PURE__ */ o("span", { className: "truncate", children: r })
        ] }),
        d && /* @__PURE__ */ o(
          S2,
          {
            title: "Clear",
            className: "inline-flex text-(--palette-N500) hover:text-(--palette-N800)",
            onClick: (f) => {
              f.stopPropagation(), d();
            },
            children: /* @__PURE__ */ o(Q, { icon: "Close", size: 14 })
          }
        ),
        /* @__PURE__ */ o(Q, { icon: "Down", size: 16, className: "shrink-0 opacity-60" })
      ]
    }
  );
}), e0 = s1.forwardRef(({ ...e }, t) => /* @__PURE__ */ o("nav", { ref: t, "aria-label": "breadcrumb", ...e }));
e0.displayName = "Breadcrumb";
const t0 = s1.forwardRef(({ className: e, ...t }, r) => /* @__PURE__ */ o(
  "ol",
  {
    ref: r,
    className: D(
      "flex flex-wrap items-center gap-1.5 break-words text-sm text-neutral-600 sm:gap-2.5",
      e
    ),
    ...t
  }
));
t0.displayName = "BreadcrumbList";
const r0 = s1.forwardRef(({ className: e, ...t }, r) => /* @__PURE__ */ o(
  "li",
  {
    ref: r,
    className: D("inline-flex items-center gap-1.5", e),
    ...t
  }
));
r0.displayName = "BreadcrumbItem";
const o0 = s1.forwardRef(({ asChild: e, className: t, ...r }, c) => /* @__PURE__ */ o(
  e ? M5 : "a",
  {
    ref: c,
    className: D("transition-colors hover:text-neutral-800", t),
    ...r
  }
));
o0.displayName = "BreadcrumbLink";
const c0 = s1.forwardRef(({ className: e, ...t }, r) => /* @__PURE__ */ o(
  "span",
  {
    ref: r,
    role: "link",
    "aria-disabled": "true",
    "aria-current": "page",
    className: D("font-normal text-foreground", e),
    ...t
  }
));
c0.displayName = "BreadcrumbPage";
const n0 = ({
  className: e,
  ...t
}) => /* @__PURE__ */ x(
  "span",
  {
    role: "presentation",
    "aria-hidden": "true",
    className: D("flex h-9 w-9 items-center justify-center", e),
    ...t,
    children: [
      /* @__PURE__ */ o(C6, { className: "h-4 w-4" }),
      /* @__PURE__ */ o("span", { className: "sr-only", children: "More" })
    ]
  }
);
n0.displayName = "BreadcrumbElipssis";
const l0 = v1.Root, s0 = v1.Trigger, a0 = v1.Group, i0 = v1.Sub, d7 = s1.forwardRef(({ className: e, inset: t, children: r, ...c }, n) => /* @__PURE__ */ x(
  v1.SubTrigger,
  {
    ref: n,
    className: D(t7, r7, t && "pl-8", e),
    ...b1("Body/M/Medium"),
    ...c,
    children: [
      r,
      /* @__PURE__ */ o(Q, { icon: "Right", className: "ml-auto", size: 16, color: I.palette_N500 })
    ]
  }
));
d7.displayName = v1.SubTrigger.displayName;
const u7 = s1.forwardRef(({ className: e, ...t }, r) => /* @__PURE__ */ o(
  v1.SubContent,
  {
    ref: r,
    className: D(
      "max-h-(--radix-dropdown-menu-content-available-height) max-w-(--radix-dropdown-menu-content-available-width)",
      Z2,
      N2,
      "origin-[--radix-dropdown-menu-content-transform-origin]",
      e
    ),
    ...t
  }
));
u7.displayName = v1.SubContent.displayName;
const h7 = s1.forwardRef(({ className: e, sideOffset: t = 4, ...r }, c) => /* @__PURE__ */ o(v1.Portal, { children: /* @__PURE__ */ o(Z1.Consumer, { children: ({ zIndex: n }) => /* @__PURE__ */ o(
  v1.Content,
  {
    ref: c,
    sideOffset: t,
    className: D(
      "max-h-(--radix-dropdown-menu-content-available-height) max-w-(--radix-dropdown-menu-content-available-width)",
      Z2,
      N2,
      "origin-[--radix-dropdown-menu-content-transform-origin]",
      e
    ),
    ...r,
    style: { zIndex: n, ...r.style }
  }
) }) }));
h7.displayName = v1.Content.displayName;
const A3 = s1.forwardRef(({ className: e, inset: t, disabled: r, ...c }, n) => /* @__PURE__ */ o(
  v1.Item,
  {
    ref: n,
    disabled: r,
    "data-disabled": r ? "true" : void 0,
    className: D(I3, N3, t && "pl-8", e),
    ...b1("Body/M/Medium"),
    ...c
  }
));
A3.displayName = v1.Item.displayName;
const R3 = s1.forwardRef(({ className: e, children: t, checked: r, disabled: c, ...n }, l) => /* @__PURE__ */ x(
  v1.CheckboxItem,
  {
    ref: l,
    disabled: c,
    "data-disabled": c ? "true" : void 0,
    className: D(V2, "py-2", e),
    checked: r,
    ...b1("Body/M/Medium"),
    ...n,
    children: [
      /* @__PURE__ */ o("span", { className: U2, children: /* @__PURE__ */ o(v1.ItemIndicator, { children: /* @__PURE__ */ o(W2, { className: "h-4 w-4" }) }) }),
      t
    ]
  }
));
R3.displayName = v1.CheckboxItem.displayName;
const d0 = s1.forwardRef(({ className: e, children: t, disabled: r, ...c }, n) => /* @__PURE__ */ x(
  v1.RadioItem,
  {
    ref: n,
    disabled: r,
    "data-disabled": r ? "true" : void 0,
    className: D(V2, e),
    ...c,
    children: [
      /* @__PURE__ */ o("span", { className: U2, children: /* @__PURE__ */ o(v1.ItemIndicator, { children: /* @__PURE__ */ o(z5, { className: "h-2 w-2 fill-current" }) }) }),
      t
    ]
  }
));
d0.displayName = v1.RadioItem.displayName;
const f7 = s1.forwardRef(({ className: e, inset: t, ...r }, c) => /* @__PURE__ */ x(n1, { children: [
  /* @__PURE__ */ o(
    v1.Label,
    {
      ref: c,
      className: D(o7, t && "pl-8", e),
      ...b1("Body/M/Bold"),
      ...r
    }
  ),
  /* @__PURE__ */ o("div", { className: c7 })
] }));
f7.displayName = v1.Label.displayName;
const v7 = s1.forwardRef(({ className: e, ...t }, r) => /* @__PURE__ */ o(v1.Separator, { ref: r, className: D(S3, e), ...t }));
v7.displayName = v1.Separator.displayName;
function u0({ className: e, ...t }) {
  return /* @__PURE__ */ o(
    I6,
    {
      role: "status",
      "aria-label": "Loading",
      className: D("size-4 animate-spin", e),
      ...t
    }
  );
}
const h0 = C2("flex items-center min-w-0", {
  variants: {
    variant: {
      inline: "text-(--palette-N800)",
      floating: "space-x-6 h-11 rounded-md bg-(--palette-N600) text-(--palette-N0) py-2.5 shadow-sm px-4"
    },
    size: {
      inline: ""
      // 	sm: "h-8 px-2 py-1",
      // 	lg: "h-12 px-4 py-3",
    }
  },
  defaultVariants: {
    variant: "inline",
    size: "inline"
  }
}), m7 = C2(
  "flex select-none items-center rounded-sm px-3 py-1 outline-none disabled:opacity-80 disabled:cursor-default whitespace-nowrap",
  {
    variants: {
      variant: {
        inline: "focus-visible:bg-(--palette-N50) enabled:active:bg-(--palette-N100) data-[state=open]:bg-(--palette-N50) focus-visible:text-(--palette-N800) data-[state=open]:text-(--palette-N800)",
        floating: "focus-visible:bg-(--palette-N700) enabled:active:bg-(--palette-N800) focus-visible:text-(--palette-N0) data-[state=open]:bg-(--palette-N800) data-[state=open]:text-(--palette-N0)"
      },
      size: {
        inline: ""
        // 	sm: "h-8 px-2 py-1",
        // 	lg: "h-12 px-4 py-3",
      }
    },
    defaultVariants: {
      variant: "inline",
      size: "inline"
    }
  }
);
function f0({ ...e }) {
  return /* @__PURE__ */ o(u1.Menu, { ...e });
}
function v0({ ...e }) {
  return /* @__PURE__ */ o(u1.Group, { ...e });
}
function X9({ ...e }) {
  return /* @__PURE__ */ o(u1.Portal, { ...e });
}
function J9({ ...e }) {
  return /* @__PURE__ */ o(u1.RadioGroup, { ...e });
}
function m0({ ...e }) {
  return /* @__PURE__ */ o(u1.Sub, { "data-slot": "menubar-sub", ...e });
}
const p7 = s1.forwardRef(
  ({ className: e, variant: t, size: r, ...c }, n) => /* @__PURE__ */ o(u1.Root, { ref: n, className: D(h0({ variant: t, size: r }), e), ...c })
);
p7.displayName = u1.Root.displayName;
const g7 = s1.forwardRef(
  ({ className: e, variant: t, ...r }, c) => /* @__PURE__ */ o(
    u1.Trigger,
    {
      ref: c,
      className: D(m7({ variant: t }), e),
      ...b1("Body/M/Medium"),
      ...r
    }
  )
);
g7.displayName = u1.Trigger.displayName;
const _3 = s1.forwardRef(({ className: e, variant: t, ...r }, c) => /* @__PURE__ */ o(
  "button",
  {
    type: "button",
    ref: c,
    className: D(m7({ variant: t }), e),
    ...b1("Body/M/Medium"),
    ...r
  }
));
_3.displayName = u1.Trigger.displayName;
const b7 = s1.forwardRef(({ className: e, inset: t, children: r, ...c }, n) => /* @__PURE__ */ x(
  u1.SubTrigger,
  {
    ref: n,
    className: D(t7, r7, t && "pl-8", e),
    ...b1("Body/M/Medium"),
    ...c,
    children: [
      r,
      /* @__PURE__ */ o("div", { className: "ml-auto pl-1", children: /* @__PURE__ */ o(Q, { icon: "Right", size: 16, color: I.palette_N500 }) })
    ]
  }
));
b7.displayName = u1.SubTrigger.displayName;
const M7 = s1.forwardRef(({ className: e, ...t }, r) => /* @__PURE__ */ o(Z1.Consumer, { children: ({ zIndex: c }) => /* @__PURE__ */ o(
  u1.SubContent,
  {
    ref: r,
    className: D(
      "max-h-(--radix-popper-available-height) max-w-(--radix-popper-available-width)",
      Z2,
      N2,
      "origin-[--radix-menubar-content-transform-origin]",
      e
    ),
    ...t,
    style: { zIndex: c, ...t.style }
  }
) }));
M7.displayName = u1.SubContent.displayName;
const x7 = s1.forwardRef(({ className: e, align: t = "start", alignOffset: r = -4, sideOffset: c = 8, ...n }, l) => /* @__PURE__ */ o(u1.Portal, { children: /* @__PURE__ */ o(Z1.Consumer, { children: ({ zIndex: s }) => /* @__PURE__ */ o(
  u1.Content,
  {
    ref: l,
    align: t,
    alignOffset: r,
    sideOffset: c,
    className: D(
      "max-h-(--radix-popper-available-height) max-w-(--radix-popper-available-width)",
      Z2,
      N2,
      "origin-[--radix-menubar-content-transform-origin]",
      e
    ),
    ...n,
    style: { zIndex: s, ...n.style }
  }
) }) }));
x7.displayName = u1.Content.displayName;
const F3 = s1.forwardRef(({ className: e, inset: t, disabled: r, ...c }, n) => /* @__PURE__ */ o(
  u1.Item,
  {
    ref: n,
    disabled: r,
    "data-disabled": r ? "true" : void 0,
    className: D(I3, N3, t && "pl-8", e),
    ...b1("Body/M/Medium"),
    ...c
  }
));
F3.displayName = u1.Item.displayName;
const p0 = s1.forwardRef(({ className: e, children: t, checked: r, disabled: c, ...n }, l) => /* @__PURE__ */ x(
  u1.CheckboxItem,
  {
    ref: l,
    disabled: c,
    "data-disabled": c ? "true" : void 0,
    className: D(V2, e),
    checked: r,
    ...b1("Body/M/Medium"),
    ...n,
    children: [
      /* @__PURE__ */ o("span", { className: U2, children: /* @__PURE__ */ o(u1.ItemIndicator, { children: /* @__PURE__ */ o(W2, { className: "h-4 w-4" }) }) }),
      t
    ]
  }
));
p0.displayName = u1.CheckboxItem.displayName;
const g0 = s1.forwardRef(({ className: e, children: t, disabled: r, ...c }, n) => /* @__PURE__ */ x(
  u1.RadioItem,
  {
    ref: n,
    disabled: r,
    "data-disabled": r ? "true" : void 0,
    className: D(V2, e),
    ...b1("Body/M/Medium"),
    ...c,
    children: [
      /* @__PURE__ */ o("span", { className: U2, children: /* @__PURE__ */ o(u1.ItemIndicator, { children: /* @__PURE__ */ o(z5, { className: "h-4 w-4 fill-current" }) }) }),
      t
    ]
  }
));
g0.displayName = u1.RadioItem.displayName;
const z7 = s1.forwardRef(({ className: e, inset: t, ...r }, c) => /* @__PURE__ */ x(n1, { children: [
  /* @__PURE__ */ o(
    u1.Label,
    {
      ref: c,
      className: D(o7, t && "pl-8", e),
      ...b1("Body/M/Bold"),
      ...r
    }
  ),
  /* @__PURE__ */ o("div", { className: c7 })
] }));
z7.displayName = u1.Label.displayName;
const y7 = s1.forwardRef(({ className: e, ...t }, r) => /* @__PURE__ */ o(u1.Separator, { ref: r, className: D(S3, e), ...t }));
y7.displayName = u1.Separator.displayName;
const b0 = ({ className: e, ...t }) => /* @__PURE__ */ o("span", { className: D(X4, e), ...t });
b0.displayname = "MenubarShortcut";
const Q9 = m2.Provider, e8 = m2.Root, t8 = m2.Trigger, M0 = s1.forwardRef(({ className: e, sideOffset: t = 4, ...r }, c) => /* @__PURE__ */ o(m2.Portal, { children: /* @__PURE__ */ o(Z1.Consumer, { children: ({ zIndex: n }) => /* @__PURE__ */ o(
  m2.Content,
  {
    ref: c,
    sideOffset: t,
    className: D(
      "overflow-hidden rounded-md bg-primary px-3 py-1.5 text-xs text-primary-foreground animate-in fade-in-0 zoom-in-95 data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=closed]:zoom-out-95 data-[side=bottom]:slide-in-from-top-2 data-[side=left]:slide-in-from-right-2 data-[side=right]:slide-in-from-left-2 data-[side=top]:slide-in-from-bottom-2 origin-[--radix-tooltip-content-transform-origin]",
      e
    ),
    ...r,
    style: { zIndex: n, ...r.style }
  }
) }) }));
M0.displayName = m2.Content.displayName;
const u3 = s1.forwardRef(
  ({ className: e, orientation: t = "horizontal", decorative: r = !0, ...c }, n) => /* @__PURE__ */ o(
    I5.Root,
    {
      ref: n,
      decorative: r,
      orientation: t,
      className: D(
        "shrink-0 bg-border",
        t === "horizontal" ? "h-[1px] w-full" : "h-full w-[1px]",
        e
      ),
      ...c
    }
  )
);
u3.displayName = I5.Root.displayName;
function O3(e, t) {
  const r = {};
  for (const c of t)
    c in e && (r[c] = e[c]);
  return r;
}
function x0(e, t) {
  const r = { ...e };
  for (const c of t)
    delete r[c];
  return r;
}
const C7 = F1(null);
function r8({ variant: e, ...t }) {
  switch (e ?? "inline") {
    case "floating":
      return /* @__PURE__ */ o(z0, { variant: "floating", ...t });
    case "inline":
      return /* @__PURE__ */ o(I7, { variant: "inline", ...t });
    default:
      return r4();
  }
}
function I7({ actions: e, count: t, onClear: r, style: c, className: n, variant: l = "inline" }) {
  const [s] = S5(() => g5()), a = e?.some((u) => Array.isArray(u)) ? e : [e], [i, d] = W(t), v = e1(t), h = G2(
    (u) => {
      d(v.current);
    },
    { debounceInterval: D2, unmountBehavior: "flush" }
  );
  return l1(() => {
    h.invoke(t);
  }, [t, h]), /* @__PURE__ */ o(C7.Provider, { value: { asyncStates$: s }, children: /* @__PURE__ */ x(p7, { variant: l, className: X(n), style: c, children: [
    t != null && /* @__PURE__ */ x(D1, { flexGrow: 0, gap: 8, alignItems: "center", children: [
      l === "inline" && /* @__PURE__ */ o(z1, { type: "Body/M/Book", children: "Selected: " }),
      /* @__PURE__ */ o(
        G1,
        {
          className: "transition-transform will-change-[scale] inline-block",
          enterFromClassName: "scale-100",
          enterToClassName: "scale-110",
          in: i !== t,
          unmountOnExit: !1,
          children: ({ className: u }) => /* @__PURE__ */ o(
            z1,
            {
              type: "Body/M/Bold",
              className: u,
              color: l === "floating" ? I.palette_N0 : void 0,
              children: t
            }
          )
        }
      ),
      l === "inline" && /* @__PURE__ */ o(u3, { className: "bg-(--palette-N200) my-auto h-4 mx-2", orientation: "vertical" })
    ] }),
    /* @__PURE__ */ o(D1, { minSize: "0", flexGrow: 0, className: "overflow-auto", gap: l === "inline" ? 4 : 24, children: /* @__PURE__ */ o(p1, { collection: a, children: (u, p) => /* @__PURE__ */ x(n1, { children: [
      /* @__PURE__ */ o(p1, { collection: u, children: (m) => {
        const f = m.dropdownItems?.some((b) => Array.isArray(b)) ? m.dropdownItems : [["", m.dropdownItems ?? f2]];
        return /* @__PURE__ */ o(f0, { children: m.dropdownItems ? /* @__PURE__ */ x(n1, { children: [
          /* @__PURE__ */ x(
            g7,
            {
              disabled: m.disabled || t === 0,
              ...A1(m),
              variant: l,
              children: [
                m.icon && /* @__PURE__ */ o(Q, { icon: m.icon ?? "Empty", className: "-ml-1 mr-1", size: 16 }),
                m.label,
                /* @__PURE__ */ o(Q, { icon: "Down", className: "ml-1 -mr-1", size: 12, color: I.palette_N300 })
              ]
            }
          ),
          /* @__PURE__ */ o(x7, { children: /* @__PURE__ */ o(S7, { dropdownItems: f }) })
        ] }) : /* @__PURE__ */ x(
          y0,
          {
            ...O3(m, ["onClick", "onClickAsync"]),
            ...A1(m),
            disabled: m.disabled || t === 0,
            actionId: m.label,
            variant: l,
            children: [
              m.icon && /* @__PURE__ */ o(Q, { icon: m.icon ?? "Empty", className: "-ml-1 mr-1", size: 16 }),
              m.label
            ]
          }
        ) });
      } }),
      p < a.length - 1 && /* @__PURE__ */ o(
        u3,
        {
          className: o1("bg-(--palette-N200) my-auto", {
            "h-5.5": l === "floating",
            "h-4": l === "inline"
          }),
          orientation: "vertical"
        }
      )
    ] }) }) }),
    /* @__PURE__ */ x(D1, { flexGrow: 0, className: X({ "-mr-2": r != null }), alignItems: "center", gap: 8, children: [
      /* @__PURE__ */ o(w5, { atom$: s, children: (u) => u.some((p) => p === "loading") ? /* @__PURE__ */ o(u0, {}) : null }),
      r && /* @__PURE__ */ o(
        "button",
        {
          className: X({
            "h-6 w-6 flex justify-center items-center rounded-sm outline-none": !0,
            "focus:bg-(--palette-N50) active:bg-(--palette-N100) data-[state=open]:bg-(--palette-N50)": l === "inline",
            "focus:bg-(--palette-N700) active:bg-(--palette-N800) focus:text-(--palette-N0) data-[state=open]:bg-(--palette-N800) data-[state=open]:text-(--palette-N0)": l === "floating"
          }),
          type: "button",
          onClick: r,
          children: /* @__PURE__ */ o(Q, { icon: "Close", size: 18 })
        }
      )
    ] })
  ] }) });
}
function z0(e) {
  return /* @__PURE__ */ o(Z1.Consumer, { children: ({ zIndex: t }) => /* @__PURE__ */ o(Z1.Provider, { value: { zIndex: t + 1 }, children: /* @__PURE__ */ o(
    G1,
    {
      initialIn: e.count == null,
      in: e.count == null || e.count > 0,
      className: "transition-[opacity,translate,scale] origin-bottom will-change-[opacity,translate,scale]",
      enterFromClassName: "opacity-0 scale-99 will-change-auto",
      enterToClassName: "opacity-100 scale-100",
      children: ({ className: r, transitionStatus: c }) => (
        // sticky item teleported to the main content as our best guess
        // as to what the lateral margins are supposed to be. Also, height set to
        // zero so that it doesn't occupy space at all.
        j2(
          /* @__PURE__ */ o(
            "div",
            {
              style: { zIndex: t },
              className: o1(
                "sticky bottom-0 inset-x-0 flex justify-center pointer-events-none h-0 overflow-visible",
                r
              ),
              inert: c === "exited",
              children: /* @__PURE__ */ o("div", { className: "absolute flex justify-center inset-x-8 bottom-2 pointer-events-none *:pointer-events-auto", children: /* @__PURE__ */ o(I7, { ...e }) })
            }
          ),
          document.getElementsByTagName("main")[0] ?? document.body
        )
      )
    }
  ) }) });
}
function y0({
  actionId: e,
  ...t
}) {
  return t.onClickAsync ? /* @__PURE__ */ o(C0, { ...t, actionId: e, onClickAsync: t.onClickAsync }) : /* @__PURE__ */ o(_3, { ...t, onClick: t.onClick });
}
function N7(e, t) {
  const r = B5(C7), c = b3(r.asyncStates$), [n] = I2(t, {
    onLoading() {
      X1(r.asyncStates$, (l) => l.set(e, "loading"));
    },
    onSettled(l) {
      X1(r.asyncStates$, (s) => s.set(e, l.isOk() ? "success" : "error"));
    }
  });
  return { onClick: g2(n), disabled: c.get(e) === "loading" };
}
function C0({
  actionId: e,
  onClickAsync: t,
  ...r
}) {
  return /* @__PURE__ */ o(_3, { ...r, ...N7(e, t) });
}
function I0({
  actionId: e,
  ...t
}) {
  return t.onClickAsync ? /* @__PURE__ */ o(N0, { ...t, actionId: e, onClickAsync: t.onClickAsync }) : /* @__PURE__ */ o(F3, { ...t, onClick: t.onClick });
}
function N0({
  actionId: e,
  onClickAsync: t,
  ...r
}) {
  return /* @__PURE__ */ o(F3, { ...r, ...N7(e, t) });
}
function S7({
  dropdownItems: e
}) {
  const t = e?.some((c) => Array.isArray(c)) ? e : [["", e ?? f2]], r = t.some(
    ([, c]) => c.some((n) => n.icon != null)
  );
  return /* @__PURE__ */ o(p1, { collection: t, children: ([c, n], l) => /* @__PURE__ */ x(n1, { children: [
    c && /* @__PURE__ */ o(z7, { children: c }),
    /* @__PURE__ */ o(v0, { children: /* @__PURE__ */ o(p1, { collection: n, children: (s) => s.dropdownItems ? /* @__PURE__ */ x(m0, { children: [
      /* @__PURE__ */ x(b7, { disabled: s.disabled, ...A1(s), children: [
        r && /* @__PURE__ */ o(
          Q,
          {
            color: I.palette_N500,
            icon: s.icon ?? "Empty",
            className: "mr-2",
            size: 16
          }
        ),
        s.label
      ] }),
      /* @__PURE__ */ o(M7, { children: /* @__PURE__ */ o(S7, { dropdownItems: s.dropdownItems }) })
    ] }) : /* @__PURE__ */ x(
      I0,
      {
        ...O3(s, ["onClick", "onClickAsync", "disabled"]),
        ...A1(s),
        disabled: s.disabled,
        actionId: `${c}-${s.label}`,
        children: [
          r && /* @__PURE__ */ o(
            Q,
            {
              color: I.palette_N500,
              icon: s.icon ?? "Empty",
              className: "mr-2",
              size: 16
            }
          ),
          s.label
        ]
      }
    ) }) }),
    l < t.length - 1 && /* @__PURE__ */ o(y7, {})
  ] }) });
}
function S0({ className: e, ...t }) {
  return /* @__PURE__ */ o(
    S6.Root,
    {
      "data-slot": "checkbox",
      className: D(
        "peer border-input dark:bg-input/30 data-[state=checked]:bg-primary data-[state=checked]:text-primary-foreground dark:data-[state=checked]:bg-primary data-[state=checked]:border-primary focus-visible:border-ring focus-visible:ring-ring/50 aria-invalid:ring-destructive/20 dark:aria-invalid:ring-destructive/40 aria-invalid:border-destructive size-4 shrink-0 rounded-[4px] border shadow-xs transition-shadow outline-none focus-visible:ring-[3px] disabled:cursor-not-allowed disabled:opacity-50",
        e
      ),
      ...t
    }
  );
}
const w0 = [
  // `block` is not cosmetic. The Root is a <button>, so the UA gives it `display: inline-block`; it
  // then sits on the text baseline and the line box reserves descender space beneath it, making the
  // whole label row 3px taller than the legacy one (measured: 21px vs 18px). The legacy art was an
  // `svg.block` with no such gap. This is the reverse of MDOT-24849's `flex` deletion in
  // `src/ui/input.tsx`: there legacy asserted no display, here legacy rendered a block, so stating
  // it is the faithful port. A single checkbox looks identical either way — a table row mixing a
  // migrated and an un-migrated one does not.
  "block",
  "p-0 border-0 rounded-none shadow-none transition-none",
  "bg-transparent dark:bg-transparent",
  "data-[state=checked]:bg-transparent dark:data-[state=checked]:bg-transparent",
  "focus-visible:ring-0",
  "disabled:opacity-100 disabled:cursor-auto"
].join(" ");
function w7({ controlId: e, disabled: t, labelPosition: r, label: c, children: n }) {
  return /* @__PURE__ */ x(
    "label",
    {
      "aria-disabled": t,
      className: "aria-disabled:text-(--palette-N300) has-[:focus-visible]:ring-3 transition-[color] inline-flex items-center",
      htmlFor: e,
      children: [
        r === "start" && R(c),
        /* @__PURE__ */ o(
          "span",
          {
            className: X({
              flex: !0,
              "mr-1.5": r === "end" && !!c,
              "ml-1.5": r === "start" && !!c
            }),
            children: n
          }
        ),
        r === "end" && R(c)
      ]
    }
  );
}
function o8({
  // Defaulted, exactly as the legacy `CheckboxBare` defaulted it, and load-bearing despite
  // `checked` being a required prop. Radix decides controlled-ness with `isControlled = prop !==
  // undefined`, so a single `undefined` makes the control UNCONTROLLED: it then runs off its own
  // internal state, reports changes a render late, and — because `CheckboxArt` is driven by the
  // prop while `data-state`/`aria-checked` come from Radix — can advertise `aria-checked="true"`
  // while still drawing an unchecked box, which is precisely what `platform-e2e` reads.
  //
  // The type does not protect against this: the field wrappers in `frontend/src/ui-lib/form`
  // forward react-hook-form's `field.value`, which is `any`, so an unseeded form default arrives
  // here as `undefined` with no type error. MDOT-24854 found exactly that on
  // `spawn-customer-dialog`'s `importData.enabled`.
  checked: e = !1,
  onChange: t,
  onClick: r,
  children: c,
  className: n,
  style: l,
  disabled: s = !1,
  invalid: a = !1,
  labelPosition: i = "end",
  name: d,
  id: v,
  innerRef: h,
  ...u
}) {
  const p = a2(), m = v ?? p;
  return (
    // data-* belong on the WRAPPER, matching legacy and matching what MDOT-24849 documented for
    // TextInput: e2e page objects do getByTestId(q).locator(…) to reach the control inside.
    //
    // The two suppressions below are for the same fact: this `onClick` is not an action target.
    // All five call sites that pass one pass `e.stopPropagation()` and nothing else, keeping a
    // click on the box from reaching the row or dialog behind it. The element that IS activated
    // is the Radix control inside, which is a real button and already keyboard-operable, so there
    // is no keyboard handler to add here and no role that would describe this span honestly.
    //
    // biome-ignore lint/a11y/noStaticElementInteractions: propagation barrier, not an action
    // biome-ignore lint/a11y/useKeyWithClickEvents: propagation barrier, not an action
    /* @__PURE__ */ o(
      "span",
      {
        ref: h,
        className: Q1("inline-flex relative", n),
        style: l,
        onClick: r,
        ...u,
        children: /* @__PURE__ */ o(w7, { controlId: m, disabled: s, labelPosition: i, label: c, children: /* @__PURE__ */ o(
          S0,
          {
            id: m,
            name: d,
            disabled: s,
            checked: e,
            "data-invalid": a,
            onCheckedChange: (f) => t?.(f === !0),
            className: w0,
            children: /* @__PURE__ */ o(B0, { checked: e, disabled: s, invalid: a })
          }
        ) })
      }
    )
  );
}
function B0({
  checked: e,
  disabled: t,
  invalid: r
}) {
  const c = t ? I.palette_N300 : r ? I.palette_D500 : void 0;
  return /* @__PURE__ */ x(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      className: "block",
      height: 16,
      width: 16,
      viewBox: "0 0 16 16",
      "aria-hidden": "true",
      focusable: "false",
      children: [
        /* @__PURE__ */ o("title", { children: "checkbox svg" }),
        e !== "indeterminate" && /* @__PURE__ */ o(
          "rect",
          {
            className: X({ "opacity-100": t, "opacity-0": !t }),
            x: "1.6665",
            y: "2.16663",
            width: "11.6667",
            height: "11.6667",
            fill: I.palette_N50
          }
        ),
        e !== "indeterminate" && /* @__PURE__ */ x(n1, { children: [
          /* @__PURE__ */ o(
            "path",
            {
              className: X({ "transition-[fill]": !0, "opacity-70": !t }),
              d: "M13.3333 2.16667V13.8333H1.66667V2.16667H13.3333ZM13.3333 0.5H1.66667C0.75 0.5 0 1.25 0 2.16667V13.8333C0 14.75 0.75 15.5 1.66667 15.5H13.3333C14.25 15.5 15 14.75 15 13.8333V2.16667C15 1.25 14.25 0.5 13.3333 0.5Z",
              fill: c ?? I.palette_N700
            }
          ),
          /* @__PURE__ */ o(
            "path",
            {
              className: X({
                "transition-[fill,opacity]": !0,
                "opacity-100": e,
                "opacity-0": !e
              }),
              d: "M13.3333 2.16667V13.8333H1.66667V2.16667H13.3333ZM13.3333 0.5H1.66667C0.75 0.5 0 1.25 0 2.16667V13.8333C0 14.75 0.75 15.5 1.66667 15.5H13.3333C14.25 15.5 15 14.75 15 13.8333V2.16667C15 1.25 14.25 0.5 13.3333 0.5Z",
              fill: c ?? I.palette_N500
            }
          )
        ] }),
        e === "indeterminate" && /* @__PURE__ */ o(
          "path",
          {
            className: "transition-[fill,opacity] opacity-100",
            d: "M13.3333 0.5H1.66667C0.75 0.5 0 1.25 0 2.16667V13.8333C0 14.75 0.75 15.5 1.66667 15.5H13.3333C14.25 15.5 15 14.75 15 13.8333V2.16667C15 1.25 14.25 0.5 13.3333 0.5ZM11.6667 8.83333H3.33333V7.16667H11.6667V8.83333Z",
            fill: c ?? I.palette_N500
          }
        ),
        /* @__PURE__ */ o(
          "path",
          {
            className: X({
              "transition-[fill,opacity]": !0,
              "opacity-100": e === !0,
              "opacity-0": e !== !0
            }),
            d: "M2.5 8.83333L5.83333 12.1667L12.5 5.50003L11.325 4.31669L5.83333 9.80835L3.675 7.65833L2.5 8.83333Z",
            fill: c ?? I.palette_N500
          }
        )
      ]
    }
  );
}
const B7 = F1({
  dateLocalizer: {
    /** Convert a ISO string to the localized representation */
    toLocale: (e) => e,
    /** Convert a localized date string to the ISO representation */
    fromLocale: (e) => !e || Number.isNaN(Date.parse(e)) ? null : e,
    placeholder: "yyyy-mm-dd"
  }
}), Y1 = 12, _2 = "relative inline-flex size-5 select-none items-center justify-center rounded-[4px] text-(--palette-N500) after:absolute after:-inset-2 not-aria-disabled:hover:bg-(--palette-N50) aria-disabled:text-(--palette-N200)";
function k7(e, t) {
  const r = new Date(2e3, t, 1);
  return r.setFullYear(e), r;
}
function P2(e) {
  return e.getFullYear() * 12 + e.getMonth();
}
function k0({ calendarMonth: e, displayIndex: t, children: r, ...c }) {
  const { goToMonth: n, dayPickerProps: l } = w6(), [s, a] = W(null), i = e.date, d = new B6({ locale: { ...k6, ...l.locale } }), v = { startMonth: l.startMonth, endMonth: l.endMonth };
  function h(u) {
    n(u), a(null);
  }
  return /* @__PURE__ */ x("div", { ...c, children: [
    /* @__PURE__ */ o("span", { className: "sr-only", children: r }),
    /* @__PURE__ */ x("div", { className: "flex min-w-[120px] items-center justify-center gap-1", children: [
      /* @__PURE__ */ o(o5, { active: s === "month", onClick: () => a((u) => u === "month" ? null : "month"), children: d.format(i, "LLLL") }),
      /* @__PURE__ */ o(o5, { active: s === "year", onClick: () => a((u) => u === "year" ? null : "year"), children: i.getFullYear() })
    ] }),
    /* @__PURE__ */ o(
      G1,
      {
        in: s === "month",
        unmountOnExit: !0,
        className: "origin-top transition-[opacity,scale]",
        enterFromClassName: "scale-y-50 opacity-0",
        enterToClassName: "scale-y-100 opacity-100",
        children: ({ className: u }) => /* @__PURE__ */ o(c5, { className: u, children: /* @__PURE__ */ o(
          P0,
          {
            displayed: i,
            dateLib: d,
            onPick: h,
            ...v
          },
          i.getFullYear()
        ) })
      }
    ),
    /* @__PURE__ */ o(
      G1,
      {
        in: s === "year",
        unmountOnExit: !0,
        className: "origin-top transition-[opacity,scale]",
        enterFromClassName: "scale-y-50 opacity-0",
        enterToClassName: "scale-y-100 opacity-100",
        children: ({ className: u }) => /* @__PURE__ */ o(c5, { className: u, children: /* @__PURE__ */ o(
          L0,
          {
            displayed: i,
            onPick: h,
            ...v
          },
          Math.floor(i.getFullYear() / Y1)
        ) })
      }
    )
  ] });
}
function P0({ displayed: e, dateLib: t, startMonth: r, endMonth: c, onPick: n }) {
  const [l, s] = W(e.getFullYear()), a = r?.getFullYear(), i = c?.getFullYear();
  return /* @__PURE__ */ x("div", { className: "flex min-h-0 flex-col gap-3 py-3", children: [
    /* @__PURE__ */ o(
      P7,
      {
        prevDisabled: a != null && l - 1 < a,
        nextDisabled: i != null && l + 1 > i,
        onPrev: () => s((d) => d - 1),
        onNext: () => s((d) => d + 1),
        children: /* @__PURE__ */ o("span", { ...b1("Body/L/Bold"), className: "min-w-[50px] text-center", children: l })
      }
    ),
    /* @__PURE__ */ o(d2, { className: "px-4", children: /* @__PURE__ */ o("div", { className: "grid grid-cols-3 justify-items-center gap-x-1 gap-y-2", children: Array.from({ length: 12 }, (d, v) => {
      const h = k7(l, v), u = P2(h), p = r != null && u < P2(r) || c != null && u > P2(c);
      return /* @__PURE__ */ o(
        L7,
        {
          current: u === P2(e),
          disabled: p,
          onClick: () => n(h),
          children: t.format(h, "LLL")
        },
        u
      );
    }) }) })
  ] });
}
function L0({ displayed: e, startMonth: t, endMonth: r, onPick: c }) {
  const [n, l] = W(Math.floor(e.getFullYear() / Y1) * Y1), s = t?.getFullYear(), a = r?.getFullYear();
  return /* @__PURE__ */ x("div", { className: "flex min-h-0 flex-col gap-3 py-3", children: [
    /* @__PURE__ */ o(
      P7,
      {
        prevDisabled: s != null && n - 1 < s,
        nextDisabled: a != null && n + Y1 > a,
        onPrev: () => l((i) => i - Y1),
        onNext: () => l((i) => i + Y1),
        children: /* @__PURE__ */ x("span", { ...b1("Body/L/Bold"), className: "min-w-[50px] text-center", children: [
          n,
          " - ",
          n + Y1 - 1
        ] })
      }
    ),
    /* @__PURE__ */ o(d2, { className: "px-4", children: /* @__PURE__ */ o("div", { className: "grid grid-cols-3 justify-items-center gap-x-1 gap-y-2", children: Array.from({ length: Y1 }, (i, d) => {
      const v = n + d, h = s != null && v < s || a != null && v > a;
      return /* @__PURE__ */ o(
        L7,
        {
          current: v === e.getFullYear(),
          disabled: h,
          onClick: () => c(k7(v, e.getMonth())),
          children: v
        },
        v
      );
    }) }) })
  ] });
}
function o5({ active: e, onClick: t, children: r }) {
  return /* @__PURE__ */ x("button", { type: "button", className: "relative", onClick: t, "aria-expanded": e, children: [
    /* @__PURE__ */ o("span", { ...b1("Body/L/Bold"), style: { color: I.categorical_text_primary }, children: r }),
    e && /* @__PURE__ */ o(T0, {})
  ] });
}
function c5({ className: e, children: t }) {
  return /* @__PURE__ */ x(
    "div",
    {
      className: o1(
        "absolute inset-x-0 top-(--cell-size) z-20 flex max-h-[calc(100%-var(--cell-size))] flex-col rounded-b-[4px] bg-(--palette-N50) shadow-lg",
        e
      ),
      children: [
        /* @__PURE__ */ o("div", { className: "absolute inset-x-0 top-0 h-1 rounded-t-[4px] bg-(--palette-N200)" }),
        t
      ]
    }
  );
}
function P7({
  prevDisabled: e,
  nextDisabled: t,
  onPrev: r,
  onNext: c,
  children: n
}) {
  return /* @__PURE__ */ x("div", { className: "flex items-center justify-center gap-2 px-4 pb-2", children: [
    /* @__PURE__ */ o(
      "button",
      {
        type: "button",
        className: _2,
        disabled: e,
        "aria-disabled": e,
        onClick: r,
        children: /* @__PURE__ */ o(y5, { className: "size-4" })
      }
    ),
    n,
    /* @__PURE__ */ o(
      "button",
      {
        type: "button",
        className: _2,
        disabled: t,
        "aria-disabled": t,
        onClick: c,
        children: /* @__PURE__ */ o(C5, { className: "size-4" })
      }
    )
  ] });
}
function L7({
  current: e,
  disabled: t,
  onClick: r,
  children: c
}) {
  const n = t ? I.palette_N200 : e ? I.palette_N0 : I.palette_N700;
  return /* @__PURE__ */ o(
    "button",
    {
      type: "button",
      disabled: t,
      "data-current": e,
      onClick: r,
      className: D("h-6 w-16 rounded-full"),
      style: { color: n, backgroundColor: e && !t ? I.palette_P500 : void 0 },
      ...b1(e ? "Body/M/Bold" : "Body/M/Book"),
      children: c
    }
  );
}
const H1 = 10;
function T0() {
  return /* @__PURE__ */ o(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      "aria-hidden": "true",
      className: "pointer-events-none absolute left-1/2 -translate-x-1/2",
      style: { top: 24 - H1, height: H1, width: H1 },
      viewBox: `0 0 ${H1} ${H1}`,
      children: /* @__PURE__ */ o("g", { transform: `rotate(180 ${H1 / 2} ${H1 / 2})`, children: /* @__PURE__ */ o("path", { d: `M${H1} 0H0L${H1 / 2} 6L${H1} 0Z`, fill: I.palette_N200 }) })
    }
  );
}
function E0({
  className: e,
  classNames: t,
  showOutsideDays: r = !0,
  weekStartsOn: c = 1,
  formatters: n,
  components: l,
  ...s
}) {
  const a = P6();
  return /* @__PURE__ */ o(
    L6,
    {
      showOutsideDays: r,
      className: D("bg-(--palette-N0) p-4 [--cell-size:24px]", e),
      captionLayout: "label",
      weekStartsOn: c,
      formatters: { formatWeekdayName: R0, ...n },
      classNames: {
        root: D("w-fit", a.root),
        months: D("relative flex flex-col gap-4", a.months),
        month: D("flex w-full flex-col items-center gap-3", a.month),
        nav: D("absolute inset-x-0 top-0 flex h-5 w-full items-center justify-between", a.nav),
        button_previous: D(_2, a.button_previous),
        button_next: D(_2, a.button_next),
        month_caption: D(
          // 28px each side = a 20px arrow + legacy's 8px gap; with the 120px label slot inside, the
          // caption is 176px and sets the calendar's width, the day grid (168px) centred under it.
          "flex h-5 w-full items-center justify-center px-7",
          a.month_caption
        ),
        month_grid: D("border-collapse border-t border-t-(--palette-N300)", a.month_grid),
        // The 12px under the rule lives here, not as `pt-3` on the table: a `border-collapse` table
        // ignores its own padding. The row is a flex box, so its margin applies (as `week`'s does).
        weekdays: D("mt-3 flex", a.weekdays),
        weekday: D(
          "size-(--cell-size) select-none font-title text-[12px] font-normal text-(--palette-N500)",
          a.weekday
        ),
        week: D("mt-1 flex w-full", a.week),
        // `group/day` is what the day button's focus variant keys off; without it that variant
        // matches nothing and the focus ring is clipped by the neighbouring cells.
        day: D("group/day relative size-(--cell-size) select-none p-0 text-center", a.day),
        hidden: D("invisible", a.hidden),
        ...t
      },
      components: {
        Root: D0,
        Chevron: A0,
        MonthCaption: k0,
        DayButton: _0,
        ...l
      },
      ...s
    }
  );
}
function D0({
  className: e,
  rootRef: t,
  ...r
}) {
  return /* @__PURE__ */ o("div", { "data-slot": "calendar", ref: t, className: D(e), ...r });
}
function A0({ className: e, orientation: t, disabled: r, ...c }) {
  return /* @__PURE__ */ o(t === "left" ? y5 : t === "right" ? C5 : N6, { className: D("size-4", e), ...c });
}
function R0(...e) {
  return [...T6(...e)][0] ?? "";
}
function _0({
  className: e,
  style: t,
  day: r,
  modifiers: c,
  ...n
}) {
  const l = a1(null);
  l1(() => {
    c.focused && l.current?.focus();
  }, [c.focused]);
  const s = !!c.selected && !c.disabled, a = c.disabled ? I.palette_N200 : s ? I.palette_N0 : c.today ? I.palette_P600 : c.outside ? I.palette_N300 : I.palette_N700;
  return /* @__PURE__ */ o(
    "button",
    {
      ref: l,
      type: "button",
      "data-selected": s,
      className: D(
        "size-(--cell-size) rounded-full font-title text-[12px] leading-none transition-colors",
        "data-[selected=true]:font-bold",
        // Both disabled guards, not either one: react-day-picker splits them by focus state —
        // `disabled: !focused && disabled`, `aria-disabled: focused && disabled` — so `:enabled`
        // alone lets a focused disabled day light up, and `not-aria-disabled` alone lets every
        // other disabled day light up. `data-selected` keeps hover off the selected day.
        "enabled:not-aria-disabled:data-[selected=false]:hover:bg-(--palette-P50)",
        "group-data-[focused=true]/day:relative group-data-[focused=true]/day:z-10",
        e
      ),
      ...n,
      style: { ...t, color: a, backgroundColor: s ? I.palette_P500 : void 0 }
    }
  );
}
const F0 = {
  toggleDropdown: (e) => e ? "Hide calendar" : "Show calendar"
};
function h3(e, t, r) {
  return t && e < t ? t : r && e > r ? r : e;
}
function O0(e, t) {
  const r = t.match(/[A-Za-z]+/g), c = t.replace(/[A-Za-z]/g, "").charAt(0);
  if (!c || r == null || r.length < 2) return e;
  const n = r.reduce((i, d) => i + d.length, 0), l = e.replace(/\D/g, "").slice(0, n);
  let s = "", a = 0;
  for (const [i, d] of r.entries()) {
    if (a >= l.length) break;
    i > 0 && (s += c), s += l.slice(a, a + d.length), a += d.length;
  }
  return s;
}
function $0(e, t) {
  const r = e.trim(), n = t.match(/[A-Za-z]+/g)?.reduce((s, a) => s + a.length, 0) ?? 0, l = r.replace(/\D/g, "");
  return n > 0 && l.length === n ? O0(l, t) : r;
}
function H0(e) {
  if (!e) return;
  const t = y1.fromISO(e);
  return t.isValid ? t.toJSDate() : void 0;
}
function n5(e) {
  return y1.fromJSDate(e).toISODate();
}
function x2(e) {
  if (!e) return null;
  const t = y1.fromISO(e);
  return t.isValid ? t.toISODate() : null;
}
function c8({
  i18n: e,
  value: t,
  onChange: r,
  className: c,
  style: n,
  min: l,
  max: s,
  isDateDisabled: a,
  portalTarget: i,
  enableClear: d,
  invalid: v = !1,
  size: h = "small",
  innerRef: u,
  onBlur: p,
  ...m
}) {
  const f = m.disabled === !0, { dateLocalizer: b } = V1(B7), y = e2({ fallback: F0, overrides: e }), [N, _] = W(!1), $ = a1(null);
  l1(() => {
    const C = $.current;
    if (!N || C == null) return;
    const L = new IntersectionObserver(([E]) => {
      E != null && !E.isIntersecting && _(!1);
    });
    return L.observe(C), () => L.disconnect();
  }, [N]);
  function F(C) {
    const L = x2(l), E = x2(s);
    return L != null && C < L || E != null && C > E ? !0 : a?.(C) === !0;
  }
  const P = H0(t);
  return /* @__PURE__ */ x(E3, { open: N, onOpenChange: (C) => _(C && !f), children: [
    /* @__PURE__ */ o(
      l2,
      {
        value: t ? b.toLocale(t) : "",
        onChange: (C) => {
          if (!C.trim()) {
            r?.(null);
            return;
          }
          const L = b.fromLocale($0(C, b.placeholder)), E = x2(L);
          if (L == null || E == null) return;
          const S = h3(E, x2(l), x2(s));
          F(S) || r?.(S === E ? L : S);
        },
        children: ({ value: C, onChange: L, onCommit: E }) => /* @__PURE__ */ o(
          y2,
          {
            className: c,
            style: n,
            size: h,
            invalid: v,
            innerRef: u,
            placeholder: b.placeholder,
            value: C,
            onChangeText: L,
            onBlur: (S) => {
              E(), p?.(S);
            },
            autoTrimOnBlur: !1,
            rightContent: /* @__PURE__ */ x("div", { className: "flex items-center", children: [
              d && t && /* @__PURE__ */ o(
                "button",
                {
                  title: "Clear DateInput",
                  type: "button",
                  disabled: f,
                  className: "inline-flex mr-2",
                  onClick: () => r?.(null),
                  children: /* @__PURE__ */ o(Q, { icon: "Close", size: 16, color: I.palette_N500 })
                }
              ),
              /* @__PURE__ */ o(
                D3,
                {
                  ref: $,
                  title: y.toggleDropdown(N),
                  type: "button",
                  disabled: f,
                  className: "inline-flex",
                  children: /* @__PURE__ */ o(Q, { icon: "Calendar-Schedule", size: 16, color: I.palette_N500 })
                }
              )
            ] }),
            ...m
          }
        )
      }
    ),
    /* @__PURE__ */ o(
      K2,
      {
        container: i,
        align: "center",
        className: "w-auto p-0",
        onCloseAutoFocus: (C) => {
          C.preventDefault(), $.current?.focus({ preventScroll: !0 });
        },
        children: /* @__PURE__ */ o(
          E0,
          {
            mode: "single",
            selected: P,
            defaultMonth: P,
            disabled: (C) => {
              const L = n5(C);
              return L == null || F(L);
            },
            onSelect: (C) => {
              C && r?.(n5(C)), _(!1);
            }
          }
        )
      }
    )
  ] });
}
function T7(e) {
  return (e?.some((t) => Array.isArray(t)) ? e : [["", e ?? f2]]).filter(([t, r]) => r.length > 0);
}
function n8({
  actions: e,
  Trigger: t,
  extraTriggerProps: r,
  disabled: c
}) {
  const [n] = S5(() => g5()), l = T7(e);
  return /* @__PURE__ */ o(D7.Provider, { value: { asyncStates$: n }, children: /* @__PURE__ */ x(
    l0,
    {
      modal: !1,
      children: [
        /* @__PURE__ */ o(w5, { atom$: n, children: (s) => /* @__PURE__ */ o(s0, { disabled: c || l.length === 0, asChild: !0, children: /* @__PURE__ */ o(
          t,
          {
            ...r,
            state: s.some((a) => a === "loading") ? "loading" : s.some((a) => a === "error") ? "error" : s.some((a) => a === "success") ? "success" : "initial"
          }
        ) }) }),
        /* @__PURE__ */ o(h7, { align: "start", children: /* @__PURE__ */ o(E7, { dropdownItemGroups: l }) })
      ]
    }
  ) });
}
function E7({
  dropdownItemGroups: e
}) {
  const t = e.some(
    ([, r]) => r.some((c) => c.icon != null)
  );
  return /* @__PURE__ */ o(p1, { collection: e, children: ([r, c], n) => /* @__PURE__ */ x(n1, { children: [
    r && /* @__PURE__ */ o(f7, { children: r }),
    /* @__PURE__ */ o(a0, { children: /* @__PURE__ */ o(p1, { collection: c, children: (l) => l.dropdownItems ? /* @__PURE__ */ x(i0, { children: [
      /* @__PURE__ */ x(d7, { disabled: l.disabled, children: [
        t && /* @__PURE__ */ o(
          Q,
          {
            color: (l.icon && typeof l.icon == "object" ? l.icon.color : void 0) ?? I.palette_N500,
            icon: (l.icon && typeof l.icon == "object" ? l.icon.name : l.icon) ?? "Empty",
            className: "mr-2",
            size: 16
          }
        ),
        /* @__PURE__ */ o("span", { className: "truncate", children: l.label })
      ] }),
      /* @__PURE__ */ o(u7, { children: /* @__PURE__ */ o(E7, { dropdownItemGroups: T7(l.dropdownItems) }) })
    ] }) : /* @__PURE__ */ x(
      W0,
      {
        ...O3(l, ["onClick", "onClickAsync", "disabled", "checked"]),
        ...A1(l),
        actionId: `${r}-${l.label}`,
        children: [
          t && l.checked == null && /* @__PURE__ */ o(
            Q,
            {
              color: (l.icon && typeof l.icon == "object" ? l.icon.color : void 0) ?? I.palette_N500,
              icon: (l.icon && typeof l.icon == "object" ? l.icon.name : l.icon) ?? "Empty",
              className: "mr-2 shrink-0",
              size: 16
            }
          ),
          /* @__PURE__ */ o("span", { className: "truncate", children: l.children ?? l.label })
        ]
      }
    ) }) }),
    n < e.length - 1 && /* @__PURE__ */ o(v7, {})
  ] }) });
}
function j0(e, t, r) {
  const c = B5(D7), n = b3(c.asyncStates$), [l] = I2(r, {
    onLoading() {
      X1(c.asyncStates$, (s) => s.set(t, "loading"));
    },
    onSettled(s) {
      X1(c.asyncStates$, (a) => a.set(t, s.isOk() ? "success" : "error"));
    }
  });
  return { onClick: g2(l), disabled: n.get(t) === "loading" || e };
}
function W0({
  actionId: e,
  checked: t,
  ...r
}) {
  return r.onClickAsync ? /* @__PURE__ */ o(G0, { ...r, actionId: e, checked: t, onClickAsync: r.onClickAsync }) : (
    // The checkable item is the radix one, not a tick drawn next to a plain item: it is what carries
    // `role="menuitemcheckbox"` and `aria-checked`. State stays the caller's — it never self-toggles.
    t != null ? /* @__PURE__ */ o(R3, { ...r, checked: t, onClick: r.onClick }) : /* @__PURE__ */ o(A3, { ...r, onClick: r.onClick })
  );
}
function G0({
  disabled: e,
  actionId: t,
  onClickAsync: r,
  checked: c,
  ...n
}) {
  const l = j0(e, t, r);
  return c != null ? /* @__PURE__ */ o(R3, { ...n, ...l, checked: c }) : /* @__PURE__ */ o(A3, { ...n, ...l });
}
const D7 = F1(null), A7 = F1(null);
function l8() {
  const e = V1(A7);
  if (e === null)
    throw new Error("`useFormSubmitState` must be called inside a `Form`.");
  return e;
}
function Z0({
  onSubmitAsync: e,
  children: t,
  style: r,
  className: c,
  onLoading: n,
  onSuccess: l,
  onError: s,
  onSettled: a,
  innerRef: i,
  ...d
}) {
  const [v, h] = I2(
    // Adapting rather than passing `onSubmitAsync` straight through, because the hook's parameter
    // type demands a `Promise<T>` and this prop's contract allows a plain value.
    async (y, N) => await e(y, N),
    { onLoading: n, onSuccess: l, onError: s, onSettled: a }
  ), [u, p] = W(null), m = O(
    () => g2(async (y) => {
      y.preventDefault(), y.stopPropagation(), p(y.nativeEvent.submitter ?? null), await v(y);
    }),
    [v]
  ), f = O(
    () => ({
      state: h.kind,
      error: h.kind === "error" ? h.err : null,
      progress: h.kind === "loading" ? h.progress : h.kind === "success" ? 1 : null,
      result: L2(h) ?? null,
      submitter: u
    }),
    [h, u]
  ), b = /* @__PURE__ */ o(A7.Provider, { value: f, children: R(t, f) });
  return /* @__PURE__ */ o(
    "form",
    {
      ref: i,
      onSubmit: m,
      style: r,
      className: Q1("block", c),
      "data-state": f.state,
      ...d,
      children: b
    }
  );
}
const V0 = C2("group/field flex", {
  variants: {
    orientation: {
      vertical: ["flex-col"],
      horizontal: [
        "w-full gap-3",
        "flex-row items-center",
        "[&>[data-slot=field-label]]:flex-auto",
        "has-[>[data-slot=field-content]]:items-start has-[>[data-slot=field-content]]:[&>[role=checkbox],[role=radio]]:mt-px"
      ],
      responsive: [
        "w-full gap-3",
        "flex-col @md/field-group:flex-row @md/field-group:items-center [&>*]:w-full @md/field-group:[&>*]:w-auto [&>.sr-only]:w-auto",
        "@md/field-group:[&>[data-slot=field-label]]:flex-auto",
        "@md/field-group:has-[>[data-slot=field-content]]:items-start @md/field-group:has-[>[data-slot=field-content]]:[&>[role=checkbox],[role=radio]]:mt-px"
      ]
    }
  },
  defaultVariants: {
    orientation: "vertical"
  }
});
function s8({
  className: e,
  orientation: t = "vertical",
  ...r
}) {
  return /* @__PURE__ */ o(
    "div",
    {
      role: "group",
      "data-slot": "field",
      "data-orientation": t,
      className: D(V0({ orientation: t }), e),
      ...r
    }
  );
}
function $3(e) {
  return e.length === 0 ? [] : Array.isArray(e[0]) && e[0].length === 2 && Array.isArray(e[0][1]) ? e.filter(([, t]) => t.length > 0) : [["", e]];
}
function q2(e) {
  return $3(e).flatMap(([, t]) => t);
}
function F2(e) {
  return e.children != null && q2(e.children).length > 0;
}
function R7(e) {
  const t = [];
  for (const [r, c] of $3(e))
    for (const n of c)
      F2(n) ? t.push(...R7(n.children)) : t.push({ option: n, group: r });
  return t;
}
function _7(e, t, r = []) {
  for (const c of q2(e))
    if (F2(c)) {
      const n = _7(c.children, t, [...r, c]);
      if (n) return n;
    } else if (S1(c.value, t))
      return { ancestors: r, leaf: c };
  return null;
}
function U0(e, { value: t, leafPath: r = [] }) {
  const c = q2(e), n = c.find((l) => S1(l.value, t));
  if (n)
    return r.push(n.value), r;
  for (const l of c)
    if (l.children) {
      const s = U0(l.children, { value: t, leafPath: [...r, l.value] });
      if (s.some((a) => S1(a, t)))
        return s;
    }
  return r;
}
function l5(e) {
  const {
    options: t,
    value: r,
    onChange: c,
    placeholder: n = "Select...",
    searchPlaceholder: l = "Search...",
    emptyMessage: s = "No results found",
    disabled: a,
    invalid: i,
    size: d = "small",
    enableSearch: v = !1,
    enableClear: h = !1,
    align: u = "start",
    className: p,
    style: m,
    floatingAppearance: f,
    maxHeight: b = 300,
    maxWidth: y = 440,
    triggerDataAttrs: N,
    innerRef: _,
    id: $,
    Trigger: F,
    extraTriggerProps: P,
    ...C
  } = e, [L, E] = W(!1), [S, B] = W(""), [g, z] = W([]), M = O(() => r == null ? null : _7(t, r), [t, r]), H = O(() => R7(t), [t]), q = O(() => g.at(-1)?.children ?? t, [g, t]), U = v && S.length > 0, t1 = O(() => {
    if (!U) return $3(q);
    const d1 = H2(H, S, (r1) => r1.option.label), C1 = /* @__PURE__ */ new Map();
    for (const { option: r1, group: h1 } of d1) {
      const N1 = C1.get(h1) ?? [];
      N1.push(r1), C1.set(h1, N1);
    }
    return [...C1.entries()];
  }, [U, q, H, S]), w = M?.ancestors.at(-1), j = M ? `${w?.label ? `${w.label} /` : ""} ${M.leaf.label}`.trim() : n, k = M == null, A = a || q2(t).length === 0;
  function Y(d1) {
    E(d1), d1 ? z(M?.ancestors ?? []) : B("");
  }
  function T(d1) {
    if (!d1.disabled) {
      if (!U && F2(d1)) {
        z((C1) => [...C1, d1]), B("");
        return;
      }
      c?.(d1.value), E(!1);
    }
  }
  function c1() {
    z((d1) => d1.slice(0, -1));
  }
  function i1() {
    c?.(null);
  }
  function K(d1) {
    d1.key === "Backspace" && S.length === 0 && g.length > 0 && (d1.preventDefault(), c1());
  }
  const J = {
    open: L,
    triggerLabel: j,
    isEmpty: k,
    disabled: A,
    invalid: i,
    size: d,
    enableClear: h,
    onClear: h && !k ? i1 : void 0
  }, V = g.at(-1)?.label;
  return /* @__PURE__ */ x(E3, { modal: !1, open: L, onOpenChange: Y, children: [
    /* @__PURE__ */ o(D3, { asChild: !0, disabled: A, ...N, children: F ? /* @__PURE__ */ o(F, { ...J, ...P }) : /* @__PURE__ */ o(K0, { ref: _, id: $, ...J, className: p, style: m }) }),
    /* @__PURE__ */ o(
      K2,
      {
        align: u,
        className: D("min-w-(--radix-popover-trigger-width)", f?.className),
        style: {
          maxHeight: s7(b),
          maxWidth: a7(y),
          ...f?.style
        },
        ...A1(C),
        children: /* @__PURE__ */ x(w3, { loop: !0, shouldFilter: !1, children: [
          /* @__PURE__ */ o("div", { className: v ? void 0 : "sr-only", children: /* @__PURE__ */ o(
            B3,
            {
              placeholder: l,
              value: v ? S : "",
              onValueChange: v ? B : void 0,
              onKeyDown: K
            }
          ) }),
          /* @__PURE__ */ x(k3, { children: [
            U && t1.length === 0 && /* @__PURE__ */ o(P3, { children: s }),
            !U && V != null && /* @__PURE__ */ x(
              R2,
              {
                value: "__hierarchical-back__",
                className: "sticky top-0 z-10 gap-2 cursor-pointer font-medium bg-(--palette-N0)",
                onSelect: c1,
                children: [
                  /* @__PURE__ */ o(Q, { icon: "Left", size: 16, className: "shrink-0" }),
                  /* @__PURE__ */ o("span", { className: "truncate flex-1", children: V })
                ]
              }
            ),
            /* @__PURE__ */ o(p1, { collection: t1, children: ([d1, C1], r1) => /* @__PURE__ */ x(n1, { children: [
              r1 > 0 && /* @__PURE__ */ o(T3, {}),
              /* @__PURE__ */ o(L3, { heading: d1 || void 0, children: /* @__PURE__ */ o(p1, { collection: C1, children: (h1, N1) => {
                const R1 = !U && F2(h1), M1 = !R1 && r != null && S1(r, h1.value);
                return /* @__PURE__ */ x(
                  R2,
                  {
                    value: `${r1}-${N1}-${h1.label}`,
                    disabled: h1.disabled,
                    "aria-selected": M1,
                    className: "gap-2 cursor-pointer group/option",
                    onSelect: () => T(h1),
                    ...b1("Body/M/Book"),
                    ...A1(h1),
                    children: [
                      /* @__PURE__ */ o("span", { className: "truncate flex-1", children: h1.label }),
                      R1 ? /* @__PURE__ */ o(Q, { icon: "Right", size: 16, className: "shrink-0 opacity-60" }) : M1 && /* @__PURE__ */ o(W2, { className: "h-4 w-4 shrink-0" })
                    ]
                  },
                  `${r1}-${N1}-${h1.label}`
                );
              } }) })
            ] }) })
          ] })
        ] })
      }
    )
  ] });
}
const K0 = m5(function({
  open: t,
  triggerLabel: r,
  isEmpty: c,
  disabled: n,
  invalid: l,
  size: s = "small",
  enableClear: a,
  onClear: i,
  id: d,
  className: v,
  style: h,
  ...u
}, p) {
  return /* @__PURE__ */ x(
    "button",
    {
      ref: p,
      id: d,
      type: "button",
      disabled: n,
      "data-invalid": l || void 0,
      className: D(n7, l7[s], v),
      style: h,
      ...u,
      children: [
        /* @__PURE__ */ o("span", { className: D("flex flex-1 items-center gap-2 truncate", c && "text-(--palette-N300)"), children: /* @__PURE__ */ o("span", { className: "truncate", children: r }) }),
        i && /* @__PURE__ */ o(
          S2,
          {
            title: "Clear",
            className: "inline-flex text-(--palette-N500) hover:text-(--palette-N800)",
            onClick: (m) => {
              m.stopPropagation(), i();
            },
            children: /* @__PURE__ */ o(Q, { icon: "Close", size: 14 })
          }
        ),
        /* @__PURE__ */ o(Q, { icon: "Down", size: 16, className: "shrink-0 opacity-60" })
      ]
    }
  );
});
function F7(e) {
  return e.length > 0 && Array.isArray(e[0]) && e[0].length === 2 && Array.isArray(e[0][1]);
}
function f3(e) {
  return F7(e) ? e.flatMap(([, t]) => t) : e;
}
function q0(e, t, r = 1) {
  if (r > t)
    return [];
  const c = (n, l) => n.map((s) => {
    const a = { ...s };
    return s.children && s.children.length > 0 && t > l ? a.children = c(s.children, l + 1) : a.children = void 0, a;
  });
  return F7(e) ? e.map(([n, l]) => [n, c(l, r)]) : c(e, r);
}
function O7(e, t) {
  for (const r of f3(e)) {
    if (S1(r.value, t))
      return r;
    if (r.children && f3(r.children).length > 0) {
      const c = O7(r.children, t);
      if (c)
        return c;
    }
  }
}
function Y0(e) {
  const { depth: t = 0 } = e, r = q0(e.options, e.maxDepth), c = O(() => e.value[t], [e.value, t]), n = Z(
    (s) => {
      const a = e.value.slice(0, t);
      s != null && (a[t] = s), e.onChange(a);
    },
    [t, e]
  ), l = O(() => c != null ? O7(e.options, c) : null, [c, e.options]);
  return /* @__PURE__ */ x(n1, { children: [
    e.hierarchicalSelectClassName ? /* @__PURE__ */ x("div", { className: e.hierarchicalSelectClassName(t), children: [
      /* @__PURE__ */ o(
        l5,
        {
          enableSearch: !0,
          options: r,
          value: c ?? null,
          disabled: e.disabled,
          onChange: n,
          className: "w-full"
        }
      ),
      " "
    ] }) : /* @__PURE__ */ o(
      l5,
      {
        enableSearch: !0,
        options: r,
        value: c ?? null,
        onChange: n,
        className: "w-full"
      }
    ),
    l?.children && f3(l.children).length > 0 && /* @__PURE__ */ o(
      X0,
      {
        options: l.children,
        value: e.value,
        maxDepth: e.maxDepth,
        onChange: e.onChange,
        depth: t + 1
      },
      `${t}-${JSON.stringify(c)}`
    )
  ] });
}
const X0 = G(Y0);
function J0({ className: e, ...t }) {
  return /* @__PURE__ */ o(N5.Root, { "data-slot": "radio-group", className: D(e), ...t });
}
function Q0({ className: e, ...t }) {
  return /* @__PURE__ */ o(
    N5.Item,
    {
      "data-slot": "radio-group-item",
      className: D("block size-[18px] shrink-0 outline-hidden", e),
      ...t
    }
  );
}
const v3 = "boolean:", $7 = "string:";
function H7(e) {
  return typeof e == "boolean" ? `${v3}${e}` : `${$7}${e}`;
}
function ee(e) {
  return e.startsWith(v3) ? e === `${v3}true` : e.slice($7.length);
}
const j7 = F1(null);
function a8({
  value: e,
  onChange: t,
  children: r,
  className: c,
  style: n,
  disabled: l,
  invalid: s = !1,
  labelPosition: a = "end",
  orientation: i,
  innerRef: d,
  ...v
}) {
  const h = e == null ? null : H7(e), u = O(
    () => ({ selectedKey: h, labelPosition: a, disabled: l, invalid: s }),
    [h, a, l, s]
  );
  return /* @__PURE__ */ o(j7.Provider, { value: u, children: /* @__PURE__ */ o(
    J0,
    {
      ref: d,
      orientation: i,
      value: h,
      onValueChange: (p) => {
        p != null && t?.(ee(p));
      },
      className: Q1("", c),
      style: n,
      ...A1(v),
      children: R(r)
    }
  ) });
}
function i8({
  value: e,
  children: t,
  className: r,
  style: c,
  disabled: n = !1,
  id: l,
  innerRef: s,
  ...a
}) {
  const i = V1(j7), d = a2();
  if (i === null)
    throw new Error("`Radio` must be rendered inside a `RadioGroup`.");
  const v = H7(e), h = i.disabled ?? n, u = l ?? d;
  return (
    // data-* on the WRAPPER, as legacy and the rest of the modern family; filtered so a spread
    // react-hook-form `field` cannot put its `ref` on the DOM over `innerRef`.
    /* @__PURE__ */ o(
      "span",
      {
        ref: s,
        className: Q1("inline-flex relative", r),
        style: c,
        ...A1(a),
        children: /* @__PURE__ */ o(
          w7,
          {
            controlId: u,
            disabled: h,
            labelPosition: i.labelPosition,
            label: t,
            children: /* @__PURE__ */ o(Q0, { id: u, value: v, disabled: h, "data-invalid": i.invalid, children: /* @__PURE__ */ o(te, { checked: i.selectedKey === v, disabled: h, invalid: i.invalid }) })
          }
        )
      }
    )
  );
}
function te({ checked: e, disabled: t, invalid: r }) {
  const c = t ? I.palette_N300 : r ? I.palette_D500 : void 0;
  return /* @__PURE__ */ x(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      className: "block",
      height: 18,
      width: 18,
      viewBox: "0 0 18 18",
      "aria-hidden": "true",
      focusable: "false",
      children: [
        /* @__PURE__ */ o("title", { children: "radio svg" }),
        /* @__PURE__ */ o(
          "path",
          {
            className: X({
              "transition-[fill,opacity]": !0,
              "opacity-100 scale-100": !e,
              "opacity-0 scale-0": e
            }),
            d: "M8.50033 0.666748C3.90033 0.666748 0.166992 4.40008 0.166992 9.00008C0.166992 13.6001 3.90033 17.3334 8.50033 17.3334C13.1003 17.3334 16.8337 13.6001 16.8337 9.00008C16.8337 4.40008 13.1003 0.666748 8.50033 0.666748ZM8.50033 15.6667C4.81699 15.6667 1.83366 12.6834 1.83366 9.00008C1.83366 5.31675 4.81699 2.33341 8.50033 2.33341C12.1837 2.33341 15.167 5.31675 15.167 9.00008C15.167 12.6834 12.1837 15.6667 8.50033 15.6667Z",
            fill: c ?? I.palette_N500
          }
        ),
        /* @__PURE__ */ o(
          "path",
          {
            className: X({
              "transition-[fill,opacity,transform,scale] origin-center": !0,
              "opacity-100 scale-100": e,
              "opacity-0 scale-0": !e
            }),
            d: "M8.50033 4.83342C6.20033 4.83342 4.33366 6.70008 4.33366 9.00008C4.33366 11.3001 6.20033 13.1667 8.50033 13.1667C10.8003 13.1667 12.667 11.3001 12.667 9.00008C12.667 6.70008 10.8003 4.83342 8.50033 4.83342ZM8.50033 0.666748C3.90033 0.666748 0.166992 4.40008 0.166992 9.00008C0.166992 13.6001 3.90033 17.3334 8.50033 17.3334C13.1003 17.3334 16.8337 13.6001 16.8337 9.00008C16.8337 4.40008 13.1003 0.666748 8.50033 0.666748ZM8.50033 15.6667C4.81699 15.6667 1.83366 12.6834 1.83366 9.00008C1.83366 5.31675 4.81699 2.33341 8.50033 2.33341C12.1837 2.33341 15.167 5.31675 15.167 9.00008C15.167 12.6834 12.1837 15.6667 8.50033 15.6667Z",
            fill: c ?? I.palette_P500
          }
        )
      ]
    }
  );
}
const re = C2(
  "flex w-fit items-stretch has-[>[data-slot=button-group]]:gap-2 [&>*]:focus-visible:relative [&>*]:focus-visible:z-10 has-[select[aria-hidden=true]:last-child]:[&>[data-slot=select-trigger]:last-of-type]:rounded-r-md [&>[data-slot=select-trigger]:not([class*='w-'])]:w-fit [&>input]:flex-1",
  {
    variants: {
      orientation: {
        horizontal: "[&>*:not(:first-child)]:rounded-l-none [&>*:not(:first-child)]:border-l-0 [&>*:not(:last-child)]:rounded-r-none",
        vertical: "flex-col [&>*:not(:first-child)]:rounded-t-none [&>*:not(:first-child)]:border-t-0 [&>*:not(:last-child)]:rounded-b-none"
      }
    },
    defaultVariants: {
      orientation: "horizontal"
    }
  }
);
function d8({
  className: e,
  orientation: t,
  ...r
}) {
  return /* @__PURE__ */ o(
    "div",
    {
      role: "group",
      "data-slot": "button-group",
      "data-orientation": t,
      className: D(re({ orientation: t }), e),
      ...r
    }
  );
}
const oe = s1.forwardRef(
  ({ className: e, ...t }, r) => /* @__PURE__ */ o(
    "textarea",
    {
      className: D(
        "min-h-[60px] w-full rounded-md border border-input bg-transparent px-3 py-2 text-base shadow-sm placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-ring disabled:cursor-not-allowed disabled:opacity-50",
        e
      ),
      ref: r,
      ...t
    }
  )
);
oe.displayName = "Textarea";
const u8 = G(ne), ce = {
  toggleDropdown: (e) => e ? "Hide calendar" : "Show calendar",
  clear: () => "Clear dates"
};
function ne({
  i18n: e,
  value: t,
  onChange: r,
  className: c,
  style: n,
  min: l,
  max: s,
  isDateDisabled: a,
  invalid: i,
  disabled: d = !1,
  innerRef: v,
  startInputProps: h,
  endInputProps: u,
  inputAppearance: p,
  portalTarget: m
}) {
  const { dateLocalizer: f } = V1(B7), b = e2({ fallback: ce, overrides: e }), [y, N] = W(!1), _ = a1(null), $ = Z(() => N(!1), []), F = Z(() => {
    N(!1), _.current?.focus({ preventScroll: !0 });
  }, []);
  return /* @__PURE__ */ o(
    y3,
    {
      portalTarget: m,
      open: y,
      onClickAway: $,
      position: "bottom",
      align: "middle",
      onTriggerExitViewport: F,
      onEscapeKey: F,
      onScrollOutside: F,
      trigger: ({ innerRef: P }) => /* @__PURE__ */ o(
        l2,
        {
          value: t,
          onChange: ([C, L]) => {
            const E = !C || Number.isNaN(Date.parse(C)), S = !L || Number.isNaN(Date.parse(L));
            r?.(E ? [] : S ? [C] : [C, L]);
          },
          children: ({ value: [C, L], onCommit: E }) => /* @__PURE__ */ x(
            "div",
            {
              ref: v,
              className: o1(
                "inline-flex flex-row items-center gap-2 rounded-[4px] border border-(--palette-N200) focus-within:border-(--palette-N500) data-[disabled=true]:border-(--palette-N100) bg-[#ffffff] data-[disabled=true]:text-(--palette-N400) data-[disabled=true]:bg-(--palette-N100) data-[invalid=true]:border-(--palette-D500)",
                c
              ),
              style: n,
              "data-invalid": i,
              "data-disabled": d,
              children: [
                /* @__PURE__ */ o(
                  l2,
                  {
                    value: C ? f.toLocale(C) : "",
                    onChange: (S) => {
                      const B = f.fromLocale(S), g = B ? h3(B, l, s) : null;
                      g && a?.(g) || E(g && L ? [g, L] : g ? [g] : []);
                    },
                    children: ({ value: S, onChange: B, onCommit: g }) => /* @__PURE__ */ o(
                      y2,
                      {
                        inputAppearance: {
                          ...p,
                          ...h?.inputAppearance,
                          className: o1(
                            p?.className,
                            h?.inputAppearance?.className
                          ),
                          style: {
                            borderWidth: 0,
                            width: "16ch",
                            ...p?.style,
                            ...h?.inputAppearance?.style
                          }
                        },
                        type: "text",
                        placeholder: f.placeholder,
                        value: S,
                        onChangeText: B,
                        onBlur: () => g(),
                        invalid: i,
                        disabled: d,
                        ...h
                      }
                    )
                  }
                ),
                /* @__PURE__ */ o(Q, { icon: "Right1", size: 14 }),
                /* @__PURE__ */ o(
                  l2,
                  {
                    value: L ? f.toLocale(L) : "",
                    onChange: (S) => {
                      const B = f.fromLocale(S), g = B ? h3(B, l, s) : null;
                      g && a?.(g) || E(C && g ? [C, g] : C ? [C] : []);
                    },
                    children: ({ value: S, onChange: B, onCommit: g }) => /* @__PURE__ */ o(
                      y2,
                      {
                        inputAppearance: {
                          ...p,
                          ...u?.inputAppearance,
                          className: o1(
                            p?.className,
                            u?.inputAppearance?.className
                          ),
                          style: {
                            borderWidth: 0,
                            width: "16ch",
                            ...p?.style,
                            ...u?.inputAppearance?.style
                          }
                        },
                        type: "text",
                        placeholder: f.placeholder,
                        value: S,
                        onChangeText: B,
                        onBlur: () => g(),
                        invalid: i,
                        disabled: d,
                        ...u
                      }
                    )
                  }
                ),
                /* @__PURE__ */ o(
                  "button",
                  {
                    className: "inline-flex",
                    style: {
                      visibility: !d && (C || L) ? "visible" : "hidden"
                    },
                    type: "button",
                    title: b.clear(),
                    disabled: d,
                    onClick: () => E([]),
                    children: /* @__PURE__ */ o(Q, { icon: "Cancel", size: 14, color: I.palette_N300 })
                  }
                ),
                /* @__PURE__ */ o(
                  "button",
                  {
                    ref: (S) => {
                      P(S), _.current = S;
                    },
                    title: b.toggleDropdown(y),
                    type: "button",
                    className: "inline-flex mr-1",
                    onClick: () => N(!y),
                    children: /* @__PURE__ */ o(Q, { icon: "Calendar-Schedule", size: 16, color: I.palette_N500 })
                  }
                )
              ]
            }
          )
        }
      ),
      children: /* @__PURE__ */ o(
        G4,
        {
          className: "rounded-lg shadow-xl border",
          style: {
            borderColor: I.palette_N50
          },
          min: l,
          max: s,
          isDateDisabled: a,
          value: t,
          onChange: (P) => {
            r?.(P), P.length === 2 && F();
          }
        }
      )
    }
  );
}
function le({
  disabled: e = !1,
  interceptCharacters: t = !0,
  filteredOptions: r,
  onOutlinedSelected: c,
  onOutlinedItemIndexChange: n,
  onClose: l,
  outlinedItemIndex: s,
  pageSize: a = 1,
  alwaysOutlineFirst: i = !1
}) {
  const d = e1({
    disabled: e,
    onOutlinedSelected: c,
    outlinedItemIndex: s,
    alwaysOutlineFirst: i,
    pageSize: a,
    items: r,
    onOutlinedItemIndexChange: n,
    interceptCharacters: t,
    onClose: l
  }), v = Z(
    (m) => {
      if (m !== d.current.outlinedItemIndex)
        if (typeof m == "number") {
          let f = null;
          if (d.current.outlinedItemIndex === null || m > d.current.outlinedItemIndex) {
            for (let b = m; b < d.current.items.length; b++)
              if (!d.current.items[b].disabled) {
                f = b;
                break;
              }
          } else
            for (let b = m; b >= 0; b--)
              if (!d.current.items[b].disabled) {
                f = b;
                break;
              }
          f !== null && d.current.onOutlinedItemIndexChange(f);
        } else
          d.current.onOutlinedItemIndexChange(m);
    },
    [d]
  );
  l1(() => {
    if (d.current.disabled)
      return;
    const m = r.length === 0 ? null : i ? 0 : d.current.outlinedItemIndex == null ? null : d.current.outlinedItemIndex < r.length ? d.current.outlinedItemIndex : 0;
    d.current.outlinedItemIndex !== m && d.current.onOutlinedItemIndexChange(m);
  }, [r, d, i]);
  const h = Z(
    (m, f) => r.length === 0 ? null : m === null ? 0 : T1(m + f, 0, r.length - 1),
    [r.length]
  ), u = e1(h), p = Z(
    (m) => {
      if (!d.current.disabled)
        if (d.current.interceptCharacters && !m.metaKey && !m.ctrlKey && !m.altKey && !m.shiftKey && m.key.length === 1 && (Z3(m.key.toLowerCase().charCodeAt(0), 97, 122) || Z3(m.key.charCodeAt(0), 48, 57))) {
          m.preventDefault(), m.stopPropagation();
          const f = m.key.toLowerCase(), b = d.current.outlinedItemIndex === null ? 0 : d.current.outlinedItemIndex + 1;
          for (let y = 0; y < d.current.items.length; y++) {
            const N = (y + b) % d.current.items.length;
            if (d.current.items[N].label.charAt(0).toLowerCase() === f) {
              v?.(N);
              return;
            }
          }
        } else m.key === "ArrowUp" ? (m.preventDefault(), m.stopPropagation(), v(
          u.current(d.current.outlinedItemIndex, -1)
        )) : m.key === "ArrowDown" ? (m.preventDefault(), m.stopPropagation(), v(
          u.current(d.current.outlinedItemIndex, 1)
        )) : m.key === "PageUp" ? (m.preventDefault(), m.stopPropagation(), v(
          u.current(d.current.outlinedItemIndex, -d.current.pageSize)
        )) : m.key === "PageDown" ? (m.preventDefault(), m.stopPropagation(), v(
          u.current(d.current.outlinedItemIndex, d.current.pageSize)
        )) : m.key === "Home" ? (m.preventDefault(), m.stopPropagation(), v(d.current.items.length === 0 ? null : 0)) : m.key === "End" ? (m.preventDefault(), m.stopPropagation(), v(
          d.current.items.length === 0 ? null : d.current.items.length - 1
        )) : m.key === "Enter" && d.current.outlinedItemIndex !== null ? (m.preventDefault(), m.stopPropagation(), d.current.onOutlinedSelected(d.current.outlinedItemIndex)) : m.key === "Escape" && (m.preventDefault(), m.stopPropagation(), d.current.onClose());
    },
    [v, u, d]
  );
  return O(() => ({ handleKeyDown: p }), [p]);
}
const se = [
  "flex flex-1 px-4 py-2.5 items-center relative",
  'data-[error-pulse="true"]:animate-tremble',
  'data-[error-pulse="true"]:bg-[color:var(--Button-bg-danger)]',
  'data-[error-pulse="true"]:hover:bg-[color:var(--Button-bg-danger-hover)]',
  'data-[error-pulse="true"]:active:bg-[color:var(--Button-bg-danger-active)]',
  'data-[error-pulse="true"]:disabled:bg-[color:var(--Button-bg-danger-disabled)]',
  'data-[error-pulse="true"]:text-[color:var(--Button-fg-danger)]',
  'data-[error-pulse="true"]:disabled:text-[color:var(--Button-fg-danger-disabled)]',
  'data-[error-pulse="true"]:disabled:data-[loading="true"]:text-[color:var(--Button-fg-danger)]'
].join(" "), m3 = G(
  ae
);
function ae({
  children: e,
  onClick: t,
  onClickAsync: r,
  disabled: c,
  className: n,
  style: l,
  icon: s,
  innerRef: a,
  ...i
}) {
  const { run: d, progress: v, state: h } = C3({
    asyncFn: async (f, b) => {
      t ? t(f) : await r(f, b);
    }
  }), u = i3({ trigger: h === "error", duration: 500 }), p = Z(
    (f) => {
      d(f).catch(console.warn);
    },
    [d]
  ), m = O(() => s ? typeof s == "object" && "name" in s ? { name: s.name, color: s.color } : typeof s == "string" && R5(s) ? { name: s } : { children: R(s) } : { children: null }, [s]);
  return /* @__PURE__ */ x(
    "button",
    {
      ref: a,
      onClick: p,
      disabled: c || h === "loading",
      type: "button",
      "aria-busy": h === "loading",
      className: o1(se, n),
      style: l,
      "data-loading": h === "loading",
      "data-error-pulse": u,
      ...i,
      children: [
        /* @__PURE__ */ x(
          "div",
          {
            "aria-disabled": c || h === "loading",
            className: "flex flex-1 items-center relative z-0 aria-disabled:text-[#80848B] space-x-3",
            children: [
              m && (m.name ? /* @__PURE__ */ o(
                Q,
                {
                  size: 18,
                  icon: m.name ?? "Icon-full-info",
                  color: u ? "white" : m.color ?? (c ? "#A0A7B6" : I.palette_N500)
                }
              ) : R(m.children)),
              /* @__PURE__ */ o(
                W1,
                {
                  wrapper: (f) => /* @__PURE__ */ o(
                    "span",
                    {
                      className: X({
                        "text-start whitespace-nowrap": !0
                      }),
                      children: f
                    }
                  ),
                  children: R(e)
                }
              )
            ]
          }
        ),
        h === "loading" && /* @__PURE__ */ o("div", { className: "absolute inset-x-0 bottom-0 block w-full h-1 z-10", children: /* @__PURE__ */ o(Ae, { value: v }) })
      ]
    }
  );
}
const ie = G(de);
function de({
  externalQuery: e,
  timeout: t,
  onChange: r,
  handleRef: c,
  ...n
}) {
  const [l, s] = J1(e), { invoke: a, cancel: i } = G2((h) => r?.(h), {
    debounceInterval: t ?? 200
  }), d = e1(i);
  l1(() => {
    d.current(), s(e);
  }, [s, d, e]);
  const v = Z(
    (h) => {
      s(h), a(h);
    },
    [s, a]
  );
  return p6(
    c,
    () => ({
      clear() {
        v("");
      },
      setQuery(h) {
        v(h);
      }
    }),
    [v]
  ), /* @__PURE__ */ o(
    y2,
    {
      value: l,
      onChangeText: v,
      leftContent: /* @__PURE__ */ o(Q, { icon: "Search", size: "1.25em", color: I.palette_N300 }),
      rightContent: /* @__PURE__ */ o(
        "button",
        {
          className: "inline-flex",
          style: {
            visibility: l.length === 0 ? "hidden" : "visible"
          },
          type: "button",
          onClick: () => v(""),
          children: /* @__PURE__ */ o(Q, { icon: "Cancel", size: "1.25em", color: I.palette_N300 })
        }
      ),
      ...n
    }
  );
}
const ue = "_FlexBox_txak4_6", he = {
  FlexBox: ue
};
function W7({
  inline: e,
  reverse: t,
  gap: r,
  rowGap: c,
  columnGap: n,
  direction: l,
  alignItems: s,
  justifyContent: a,
  flexBasis: i,
  flexWrap: d,
  flexGrow: v,
  flexShrink: h,
  minSize: u,
  childrenBasis: p,
  childrenGrow: m,
  childrenShrink: f,
  children: b,
  innerRef: y,
  style: N,
  className: _,
  ...$
}) {
  return /* @__PURE__ */ o(
    "div",
    {
      style: {
        display: e ? "inline-flex" : "flex",
        flexDirection: `${l ?? "row"}${t ? "-reverse" : ""}`,
        alignItems: s ?? "stretch",
        justifyContent: a ?? "start",
        flexBasis: i ?? "auto",
        flexWrap: d ?? "nowrap",
        flexGrow: v ?? 1,
        flexShrink: h ?? 1,
        rowGap: n3(c ?? r ?? 0),
        columnGap: n3(n ?? r ?? 0),
        "--FlexBox-childrenBasis": n3(p ?? "auto"),
        "--FlexBox-childrenGrow": m ?? "0",
        "--FlexBox-childrenShrink": f ?? "1",
        ...u === "0" ? { minWidth: 0, minHeight: 0 } : null,
        ...N
      },
      className: o1(he.FlexBox, _),
      ref: y,
      ...$,
      children: R(b)
    }
  );
}
function n3(e) {
  return typeof e == "number" ? `${e}px` : e;
}
function G7(e) {
  return /* @__PURE__ */ o(W7, { ...e, direction: "column" });
}
function D1(e) {
  return /* @__PURE__ */ o(W7, { ...e, direction: "row" });
}
const fe = {
  searchPlaceholder: () => "Search...",
  triggerPlaceholder: () => "Search..."
}, ve = G(me);
function me(e) {
  const [t, r] = W(!1);
  return /* @__PURE__ */ o(pe, { ...e, open: t, setOpen: r });
}
function pe({
  floatingAppearance: e,
  trigger: t,
  triggerDataAttrs: r,
  actions: c,
  align: n = "startToStart",
  position: l = "bottom",
  strategy: s = "absolute",
  relativeAlignmentOffsets: a,
  relativePositionOffsets: i = {
    top: -8,
    bottom: 8,
    left: -8,
    right: 8
  },
  forcePosition: d,
  forceAlignment: v,
  triggerLocation: h,
  closeOnScroll: u = !1,
  innerRef: p,
  open: m,
  setOpen: f,
  onAnimationStateChange: b,
  disabled: y,
  enableSearch: N = !1,
  i18n: _,
  highlightActionId: $,
  children: F,
  portalTarget: P,
  ...C
}) {
  const L = e2({ fallback: fe, overrides: _ }), E = O(
    () => g3(c).filter((k) => k != null && k != !1).map(
      (k) => "children" in k ? {
        id: k.id,
        label: k.label ?? "",
        hasIcon: !1,
        group: typeof k.group == "string" ? { id: k.group, label: k.group } : k.group,
        children: k.children
      } : {
        id: k.id,
        label: k.label ?? "",
        hasIcon: !!k.icon,
        group: typeof k.group == "string" ? { id: k.group, label: k.group } : k.group,
        children: function({ onClose: Y }) {
          return /* @__PURE__ */ o(
            m3,
            {
              ...k.onClickAsync ? {
                onClickAsync: async (T, c1) => {
                  await k.onClickAsync(T, c1), Y();
                }
              } : {
                onClick: (T) => {
                  k.onClick(T), Y();
                }
              },
              icon: k.icon,
              disabled: k.disabled,
              className: k.className,
              style: k.style,
              ...A1(k),
              children: k.label
            }
          );
        }
      }
    ),
    [c]
  ), S = y || E.length === 0, B = Z(() => f((k) => !k), [f]), g = Z(() => {
    f(!1);
  }, [f]), z = Z(() => {
    f(!1), M.current?.focus({ preventScroll: !0 });
  }, [f]), M = a1(null), H = a2(), [q, U] = W(null), t1 = Z(
    (k) => U({ handler: k }),
    []
  ), w = Z(
    (k) => t({
      "aria-controls": H,
      onKeyDown: m ? (A) => A.key === "Escape" ? g() : q?.handler(A) : void 0,
      open: m,
      onClick: B,
      disabled: S,
      innerRef: (A) => {
        M.current = A, z2(A, k.innerRef), z2(A, p);
      },
      ...r
    }),
    [
      t,
      H,
      m,
      B,
      S,
      r,
      g,
      q,
      p
    ]
  );
  l1(() => {
    S && m && z();
  }, [z, S, m]);
  const j = a1(null);
  return /* @__PURE__ */ o(
    y3,
    {
      portalTarget: P,
      align: n,
      position: l,
      strategy: s,
      onAnimationStateChange: Z(
        (k) => {
          b?.(k), k === "shown" && j.current && E5(j.current);
        },
        [b]
      ),
      relativePositionOffsets: i,
      relativeAlignmentOffsets: a,
      forcePosition: d,
      forceAlignment: v,
      triggerLocation: h,
      open: m,
      onClickAway: g,
      onTriggerExitViewport: z,
      onEscapeKey: z,
      onScrollOutside: u ? z : void 0,
      focusOnOpen: !1,
      trigger: w,
      children: (k) => /* @__PURE__ */ x(
        G7,
        {
          alignItems: "stretch",
          justifyContent: "start",
          className: I1(
            "shadow-[0px_8px_32px_rgba(0,0,0,0.16)] rounded-xs bg-white",
            e?.className
          ),
          style: e?.style,
          children: [
            R(F, k),
            /* @__PURE__ */ o(
              ge,
              {
                id: H,
                registerHandleKeyDown: t1,
                onClose: z,
                actions: E,
                open: m,
                enableSearch: N,
                searchBoxRef: j,
                placeholder: L.searchPlaceholder(),
                highlightActionId: $,
                ...C
              }
            )
          ]
        }
      )
    }
  );
}
function ge({
  id: e,
  style: t,
  className: r,
  registerHandleKeyDown: c,
  onClose: n,
  actions: l,
  open: s,
  enableSearch: a,
  searchBoxRef: i,
  placeholder: d,
  highlightActionId: v,
  ...h
}) {
  const [u, p] = W(""), m = O(() => u.length === 0 ? l : H2(l, u, (g) => g.label), [u, l]), [f, b] = W(null), y = Z(
    (g) => {
      const z = f?.querySelector(
        `[data-listbox-index="${g}"]`
      );
      z && z.children[0]?.click();
    },
    [f]
  ), N = O(
    () => A6(m, (g) => g.group?.id ?? ""),
    [m]
  ), _ = O(
    () => c6(N, (g) => g?.length ?? 0),
    [N]
  ), $ = O(
    () => Object.values(N).flatMap((g) => g ?? []),
    [N]
  ), F = n6(N), P = O(() => {
    const g = v != null && u.length === 0 ? $.findIndex((z) => z.id === v) : -1;
    return g === -1 ? null : g;
  }, [u.length, $, v]), [C, L] = W(P), { handleKeyDown: E } = le({
    disabled: !s,
    onOutlinedSelected: y,
    onOutlinedItemIndexChange: L,
    onClose: n,
    outlinedItemIndex: C,
    interceptCharacters: !a,
    filteredOptions: O(
      () => $.map((g) => ({
        disabled: !1,
        // TODO: propagate disabled to allow skipping while pressing arrow keys
        value: g,
        label: g.label
      })),
      [$]
    ),
    pageSize: 3,
    alwaysOutlineFirst: u.length > 0
  });
  l1(() => {
    P != null && L(P);
  }, [P]);
  const S = q1(f);
  l1(() => {
    if (!f || C === null || !S)
      return;
    const g = f.querySelector(
      `[data-listbox-index="${C}"]`
    );
    if (!g)
      return;
    const z = f.style.scrollBehavior;
    f.style.scrollBehavior = "", f.scrollTop = Math.max(0, g.offsetTop - S.height / 2), f.style.scrollBehavior = z;
  }, [S, C, f, u]), l1(() => {
    c(E);
  }, [E, c]);
  const B = O(() => ({ onClose: n }), [n]);
  return /* @__PURE__ */ x(G7, { minSize: "0", ...h, children: [
    a && /* @__PURE__ */ o(
      ie,
      {
        externalQuery: "",
        onChange: p,
        inputAppearance: {
          className: "border-none!"
        },
        className: "py-1 border-b border-b-[#BFC4CE]",
        innerRef: i,
        placeholder: d,
        onKeyDown: E
      }
    ),
    /* @__PURE__ */ o(
      d2,
      {
        innerRef: b,
        direction: "vertical",
        style: t,
        className: o1(
          "min-h-0 max-h-[300px] sm:max-w-[620px] max-w-[90vw]",
          r
        ),
        children: /* @__PURE__ */ o("ul", { id: e, role: "listbox", className: "py-1 overflow-hidden", children: F.map((g, z) => {
          if (!g)
            return null;
          const [M, H] = g, q = Object.values(_).slice(0, z).reduce((w, j) => w + j, 0), t1 = H?.at(0)?.group?.label ?? "";
          return /* @__PURE__ */ x(K1, { children: [
            M !== "" && /* @__PURE__ */ o(
              "li",
              {
                className: X({
                  "z-10 px-4 pt-2 pb-2 top-0 sticky": !!t1,
                  "bg-white border-b border-b-[color:var(--palette-N20)]": !0
                }),
                children: t1 !== "" && /* @__PURE__ */ o(z1, { type: "Body/S/BOLD-UPPERCASE", children: t1 })
              }
            ),
            /* @__PURE__ */ o(p1, { collection: H ?? [], children: ({ children: w }, j) => {
              const k = j === (H?.length ?? 0) - 1 && F[z + 1] && !F[z + 1]?.[1]?.at(0)?.group?.label;
              return /* @__PURE__ */ o(
                "li",
                {
                  "data-listbox-index": q + j,
                  "aria-current": q + j === C,
                  "aria-selected": !1,
                  role: "option",
                  className: X({
                    "border-b flex flex-row grow min-w-0 group/option aria-selected:bg-[#EDF7F5] aria-current:bg-[#EFF0F3] hover:bg-[#EDF7F5] aria-disabled:text-[#80848b] cursor-pointer": !0,
                    "border-b-transparent": !k,
                    "border-b-[var(--palette-N200)]": k
                  }),
                  children: /* @__PURE__ */ o(
                    W1,
                    {
                      wrapper: (A) => /* @__PURE__ */ o("span", { className: "text-start block grow truncate relative z-0 text-[14px]", children: A }),
                      children: R(w, B)
                    }
                  )
                },
                q + j
              );
            } })
          ] }, M);
        }) })
      }
    )
  ] });
}
const be = {
  overlayLabel: () => "Close",
  firstFocusableElementLabel: () => "Modal begin focus handle",
  lastFocusableElementLabel: () => "Modal end focus handle"
}, Me = G(xe);
function xe({
  show: e,
  onAnimationStateChange: t,
  onClose: r,
  children: c,
  className: n,
  style: l,
  i18n: s,
  innerRef: a,
  initialShow: i = e,
  ...d
}) {
  const v = e2({ fallback: be, overrides: s }), h = e1(t), u = Z(
    (C) => {
      const L = h.current;
      if (L)
        switch (C) {
          case "exited":
            return L("hidden");
          case "entered":
            return L("shown");
          case "entering":
            return L("showing");
          case "prepare-enter":
          case "prepare-exit":
            break;
          case "exiting":
            return L("hiding");
        }
    },
    [h]
  ), p = b2({
    in: e,
    initialIn: i,
    onChange: u
  }), m = a1(null), f = Z((C) => {
    m.current = C, E5(C);
  }, []), b = a1(null), y = Z(() => {
    m.current?.focus({ preventScroll: !0 });
  }, []), N = Z(() => {
    b.current?.focus({ preventScroll: !0 });
  }, []);
  l1(() => {
    if (e) {
      const C = document.activeElement;
      return () => {
        C && "focus" in C && setTimeout(() => {
          C.focus({ preventScroll: !0 });
        });
      };
    }
  }, [e]);
  const _ = e1({ onClose: r, show: e });
  _1(
    document,
    "keydown",
    (C) => {
      _.current.show && C.key === "Escape" && (C.preventDefault(), C.stopPropagation(), _.current.onClose?.());
    },
    { disabled: !e }
  );
  const $ = Z(() => {
    const C = Number(
      document.documentElement.getAttribute("data-open-modals-count") ?? 0
    );
    document.documentElement.setAttribute("data-open-modals-count", String(C + 1));
  }, []), F = Z((C) => {
    if (C) {
      const L = Number(
        document.documentElement.getAttribute("data-open-modals-count") ?? 0
      );
      L - 1 > 0 ? document.documentElement.setAttribute(
        "data-open-modals-count",
        String(L - 1)
      ) : document.documentElement.removeAttribute("data-open-modals-count");
    }
  }, []);
  l1(() => {
    e ? $() : F(!0);
  }, [F, $, e]);
  const P = e1(e);
  return l1(() => () => F(P.current), [F, P]), /* @__PURE__ */ o(Z1.Consumer, { children: ({ zIndex: C }) => /* @__PURE__ */ o(n1, { children: p !== "exited" && j2(
    /* @__PURE__ */ o(
      "div",
      {
        ref: a,
        className: X({
          "fixed inset-y-0 left-0 right-0 flex justify-center items-center transition-opacity ease-in-out overflow-hidden": !0,
          "opacity-0": p !== "entering" && p !== "entered",
          "opacity-100": p === "entering" || p === "entered"
        }),
        style: { zIndex: C },
        ...d,
        children: /* @__PURE__ */ x(Z1.Provider, { value: { zIndex: C + 1 }, children: [
          r ? /* @__PURE__ */ o(
            "button",
            {
              "aria-label": v.overlayLabel(),
              type: "button",
              onClick: r,
              tabIndex: -1,
              className: "block absolute z-0 inset-0 w-full h-full bg-[var(--Modal-overlay-bg)] cursor-default"
            }
          ) : /* @__PURE__ */ o(
            "div",
            {
              className: "block absolute z-0 inset-0 w-full h-full bg-[var(--Modal-overlay-bg)] cursor-default"
            }
          ),
          /* @__PURE__ */ x(
            "div",
            {
              className: X({
                "relative z-10 transition-transform ease-in-out": !0,
                "translate-y-1": p !== "entering" && p !== "entered",
                "translate-y-0": p === "entering" || p === "entered"
              }),
              children: [
                /* @__PURE__ */ o(
                  "div",
                  {
                    "aria-label": "-",
                    role: "button",
                    tabIndex: 0,
                    onFocus: N,
                    className: "block w-0 h-0 opacity-0 absolute pointer-events-none"
                  }
                ),
                /* @__PURE__ */ o(
                  "div",
                  {
                    "aria-label": v.firstFocusableElementLabel(),
                    role: "button",
                    ref: f,
                    tabIndex: -1,
                    className: "block w-0 h-0 opacity-0 absolute pointer-events-none"
                  }
                ),
                /* @__PURE__ */ o("div", { className: X(n), style: l, children: R(c) }),
                /* @__PURE__ */ o(
                  "div",
                  {
                    "aria-label": v.lastFocusableElementLabel(),
                    role: "button",
                    ref: b,
                    tabIndex: -1,
                    className: "block w-0 h-0 opacity-0 absolute pointer-events-none"
                  }
                ),
                /* @__PURE__ */ o(
                  "div",
                  {
                    "aria-label": "-",
                    role: "button",
                    tabIndex: 0,
                    onFocus: y,
                    className: "block w-0 h-0 opacity-0 absolute pointer-events-none"
                  }
                )
              ]
            }
          )
        ] })
      }
    ),
    document.body
  ) }) });
}
const h8 = G(ze);
function ze({
  show: e,
  onClose: t,
  onAnimationStateChange: r,
  initialShow: c,
  onSubmitAsync: n,
  ...l
}) {
  const [s, a] = W(!1), i = e1({ onClose: t, submitting: s }), d = O(() => n ? async (...u) => {
    try {
      return a(!0), await n(...u);
    } finally {
      a(!1);
    }
  } : void 0, [n]), v = Z(() => {
    i.current.submitting || i.current.onClose?.();
  }, [i]);
  return /* @__PURE__ */ o(
    Me,
    {
      show: e,
      initialShow: c,
      onClose: v,
      onAnimationStateChange: r,
      children: /* @__PURE__ */ o(
        Ce,
        {
          onSubmitAsync: d,
          onClose: t ? v : void 0,
          ...l
        }
      )
    }
  );
}
const ye = {
  closeButtonLabel: () => "Close"
}, Ce = G(Ie);
function Ie({
  size: e = "medium",
  onSubmitAsync: t,
  className: r,
  style: c,
  noValidate: n,
  innerRef: l,
  children: s,
  ...a
}) {
  const i = a2(), d = a2(), v = t ? Z0 : "div", [h, u] = t2(a);
  return /* @__PURE__ */ o(
    v,
    {
      ref: l,
      role: "dialog",
      "aria-labelledby": i,
      "aria-describedby": d,
      noValidate: n,
      className: o1(
        {
          "bg-[color:var(--DialogBox-bg)] rounded-md overflow-hidden mx-2 my-2 flex flex-col max-h-[calc(100vh-64px)] max-w-[calc(100vw-64px)] w-[calc(100vw-64px)]": !0,
          "lg:w-[1024px]": e === "xxlarge",
          "lg:w-[768px]": e === "xlarge",
          "md:w-[670px]": e === "large",
          "sm:w-[448px]": e === "medium",
          "sm:w-[320px]": e === "small"
        },
        r
      ),
      style: c,
      ...t ? { onSubmitAsync: t } : {},
      ...h,
      children: t ? ((p) => /* @__PURE__ */ o(s5, { titleId: i, contentId: d, ...p, ...u, children: s })) : /* @__PURE__ */ o(
        s5,
        {
          titleId: i,
          contentId: d,
          error: null,
          progress: null,
          result: null,
          state: "initial",
          ...u,
          children: s
        }
      )
    }
  );
}
function s5({
  onClose: e,
  titleId: t,
  children: r,
  header: c,
  error: n,
  footer: l,
  manualContentPadding: s,
  progress: a,
  state: i,
  result: d,
  contentId: v,
  i18n: h,
  startShadow: u,
  endShadow: p
}) {
  const m = e2({ fallback: ye, overrides: h }), f = O(
    () => ({
      onClose: e,
      error: n,
      progress: a,
      state: i,
      result: d
    }),
    [n, e, a, d, i]
  );
  return /* @__PURE__ */ x(n1, { children: [
    (c || e) && /* @__PURE__ */ x(
      "div",
      {
        className: "px-4 pt-4 flex flex-row flex-nowrap items-start justify-between mb-4",
        id: t,
        children: [
          /* @__PURE__ */ o("div", { className: "flex grow min-w-0", children: /* @__PURE__ */ o(W1, { wrapper: (b) => /* @__PURE__ */ o(Se, { children: b }), children: R(c, f) }) }),
          /* @__PURE__ */ o("div", { children: e && /* @__PURE__ */ o(
            "button",
            {
              title: m.closeButtonLabel(),
              className: "block pl-2",
              type: "button",
              disabled: f.state === "loading",
              onClick: e,
              children: /* @__PURE__ */ o(Q, { color: I.DialogBox_close_icon_fg, size: "2rem", icon: "Close" })
            }
          ) })
        ]
      }
    ),
    /* @__PURE__ */ x(
      d2,
      {
        startShadow: u,
        endShadow: p,
        className: {
          "px-4 w-full": !s
        },
        children: [
          /* @__PURE__ */ o("div", { id: v, children: R(r, f) }),
          (c || e || l) && /* @__PURE__ */ o("div", { className: "w-full h-4" })
        ]
      }
    ),
    l && /* @__PURE__ */ o("div", { className: "bg-[color:var(--DialogBox-footer-bg)] p-4", children: R(l, f) })
  ] });
}
const f8 = G(Ne);
function Ne({
  primaryAction: e,
  secondaryAction: t,
  neutralAction: r,
  align: c = "spaced",
  innerRef: n,
  ...l
}) {
  return /* @__PURE__ */ x(
    "div",
    {
      ref: n,
      className: X({
        flex: !0,
        "justify-between": c === "spaced",
        "justify-end": c === "side"
      }),
      ...l,
      children: [
        /* @__PURE__ */ o("div", { className: "mr-2", children: R(r) }),
        /* @__PURE__ */ x("div", { className: "space-x-2", children: [
          R(t),
          R(e)
        ] })
      ]
    }
  );
}
const Se = G(we);
function we({ children: e, icon: t, innerRef: r, ...c }) {
  return /* @__PURE__ */ x(
    "div",
    {
      ref: r,
      className: "flex flex-row flex-nowrap items-start mt-0.5 min-w-0",
      ...c,
      children: [
        t && /* @__PURE__ */ o("div", { className: "mr-2 text-[20px] pt-1", children: R(t) }),
        /* @__PURE__ */ o("div", { className: "text-[20px] font-bold", children: R(e) })
      ]
    }
  );
}
const Be = "_circularProgressbarIndeterminate_1h5x8_16", ke = "_animate_1h5x8_16", a5 = {
  circularProgressbarIndeterminate: Be,
  animate: ke
}, Pe = "http://www.w3.org/2000/svg", Z7 = G(Le);
function Le({
  style: e,
  className: t,
  viewBox: r,
  children: c,
  innerRef: n,
  ...l
}) {
  return /* @__PURE__ */ o(
    "svg",
    {
      ref: n,
      xmlns: Pe,
      style: e,
      className: X(t),
      height: r.height,
      width: r.width,
      viewBox: `${r.x ?? 0} ${r.y ?? 0} ${r.width} ${r.height}`,
      ...l,
      children: R(c, { viewBox: r })
    }
  );
}
const v8 = G(Te);
function Te({
  value: e,
  animationDuration: t = 1300,
  className: r,
  style: c,
  innerRef: n,
  outerDiameter: l = 44,
  innerDiameter: s,
  accentColor: a = I.ProgressBar_fg_color,
  backgroundColor: i = I.ProgressBar_bg_color,
  transition: d = !0,
  ...v
}) {
  const h = s ?? l * 0.8, {
    boxSide: u,
    center: p,
    radius: m,
    strokeWidth: f,
    circumference: b,
    strokeDashArrayAStart: y,
    strokeDashArrayAEnd: N,
    strokeDashArrayAOffset: _,
    strokeDashArrayBStart: $,
    strokeDashArrayBEnd: F,
    strokeDashArrayBOffset: P,
    strokeDashArrayCStart: C,
    strokeDashArrayCEnd: L,
    strokeDashArrayCOffset: E
  } = O(() => {
    const S = l, B = S / 2, g = (l - h) / 2, z = h / 2 + g / 2, M = z * 2 * Math.PI;
    return {
      boxSide: S,
      center: B,
      radius: z,
      strokeWidth: g,
      circumference: M,
      strokeDashArrayAStart: M * 0.0318309886183791,
      strokeDashArrayAEnd: M * 1.59154943091895,
      strokeDashArrayAOffset: 0,
      strokeDashArrayBStart: M * 0.795774715459477,
      strokeDashArrayBEnd: M * 1.59154943091895,
      strokeDashArrayBOffset: M * -0.119366207318922,
      strokeDashArrayCStart: M * 0.795774715459477,
      strokeDashArrayCEnd: M * 1.59154943091895,
      strokeDashArrayCOffset: M * -0.954929658551372
    };
  }, [h, l]);
  return /* @__PURE__ */ x(
    Z7,
    {
      innerRef: n,
      viewBox: { x: p, y: p, width: u, height: u },
      className: I1(
        {
          [a5.circularProgressbarIndeterminate]: e !== null && typeof e != "number"
        },
        r
      ),
      style: {
        "--CircularProgressBar-animation-duration": `${t}ms`,
        "--CircularProgressBar-stroke-dasharray-a-start": `${y}px`,
        "--CircularProgressBar-stroke-dasharray-a-end": `${N}px`,
        "--CircularProgressBar-stroke-dasharray-a-offset": `${_}px`,
        "--CircularProgressBar-stroke-dasharray-b-start": `${$}px`,
        "--CircularProgressBar-stroke-dasharray-b-end": `${F}px`,
        "--CircularProgressBar-stroke-dasharray-b-offset": `${P}px`,
        "--CircularProgressBar-stroke-dasharray-c-start": `${C}px`,
        "--CircularProgressBar-stroke-dasharray-c-end": `${L}px`,
        "--CircularProgressBar-stroke-dasharray-c-offset": `${E}px`,
        ...c
      },
      ...v,
      children: [
        /* @__PURE__ */ o(
          "circle",
          {
            cx: u,
            cy: u,
            r: m,
            fill: "none",
            stroke: i,
            strokeWidth: f
          }
        ),
        e === null ? null : typeof e == "number" ? /* @__PURE__ */ o(
          "circle",
          {
            cx: u,
            cy: u,
            r: m,
            fill: "none",
            className: d ? "transition-[stroke-dasharray,stroke-dashoffset]" : void 0,
            strokeDasharray: `${V3(e, 0, b)} ${V3(
              1 - e,
              0,
              b
            )}`,
            strokeDashoffset: b / 4,
            stroke: a,
            strokeWidth: f
          }
        ) : /* @__PURE__ */ o(
          "circle",
          {
            cx: u,
            cy: u,
            r: m,
            fill: "none",
            className: a5.animate,
            strokeDasharray: `${y} ${N}`,
            stroke: a,
            strokeWidth: f
          }
        )
      ]
    }
  );
}
const Ee = "_progressbarIndeterminate_mjz38_14", De = {
  progressbarIndeterminate: Ee
}, Ae = G(Re);
function Re({
  value: e,
  animationDuration: t = 1300,
  className: r,
  style: c,
  innerRef: n,
  barHeight: l = 4,
  accentColor: s = I.ProgressBar_fg_color,
  backgroundColor: a = I.ProgressBar_bg_color,
  transition: i = !0,
  ...d
}) {
  return /* @__PURE__ */ o(K5, { className: r, style: c, ...d, children: ({ width: h }) => /* @__PURE__ */ x(
    "svg",
    {
      ref: n,
      style: {
        "--ProgressBar-progressbar-width": `${0.2 * h}px`,
        "--ProgressBar-progressbar-container-width": `${h}px`,
        "--ProgressBar-animation-duration": `${t}ms`,
        height: l
      },
      xmlns: "http://www.w3.org/2000/svg",
      className: "block w-full",
      height: l,
      viewBox: `0 0 ${h} ${l}`,
      children: [
        /* @__PURE__ */ o(
          "rect",
          {
            x: 0,
            y: 0,
            width: h,
            height: l,
            fill: a
          }
        ),
        e === null ? null : typeof e == "number" ? /* @__PURE__ */ o(
          "rect",
          {
            className: i ? "transition-[width]" : void 0,
            x: 0,
            y: 0,
            width: h * e,
            height: l,
            fill: s
          }
        ) : /* @__PURE__ */ o(
          "rect",
          {
            className: De.progressbarIndeterminate,
            x: 0,
            y: 0,
            width: h * 0.2,
            height: l,
            fill: s
          }
        )
      ]
    }
  ) });
}
const m8 = G(_e);
function _e({ nodes: e, className: t, style: r, innerRef: c, ...n }) {
  return /* @__PURE__ */ o("div", { ref: c, className: X(t), style: r, ...n, children: /* @__PURE__ */ o(p1, { collection: e, children: (l) => /* @__PURE__ */ o(V7, { node: l, depth: 0 }) }) });
}
const Fe = (e) => ({ paddingLeft: e * 8 });
function V7({ node: e, depth: t }) {
  const [r, c] = J1(e.expand ?? !1);
  return /* @__PURE__ */ x("div", { "aria-expanded": r, children: [
    /* @__PURE__ */ x(
      "div",
      {
        className: o1("flex items-center", f1(e.className, e, t)),
        style: f1(e.style, e, t) ?? Fe(t),
        children: [
          /* @__PURE__ */ o(
            "button",
            {
              type: "button",
              style: {
                transitionDuration: `${D2}ms`
              },
              className: "transition-transform aria-expanded:transform-[rotateX(180deg)] flex pr-2",
              "aria-expanded": r,
              onClick: () => c((n) => !n),
              disabled: !e.nested?.length,
              children: /* @__PURE__ */ o(
                Q,
                {
                  icon: "Down",
                  className: {
                    invisible: !e.nested?.length
                  }
                }
              )
            }
          ),
          R(e.children, {
            disabled: !e.nested?.length,
            expand: r,
            onClick() {
              c((n) => !n);
            }
          })
        ]
      }
    ),
    e.nested && e.nested.length > 0 && /* @__PURE__ */ o(p1, { collection: e.nested, children: (n) => /* @__PURE__ */ o(
      H3,
      {
        transitionDuration: D2,
        expand: r,
        children: /* @__PURE__ */ o(V7, { node: n, depth: t + 1 })
      }
    ) })
  ] });
}
const Oe = G($e);
function $e({
  children: e,
  disabled: t,
  size: r = "large",
  state: c = "initial",
  error: n = null,
  progress: l = null,
  result: s = null,
  ...a
}) {
  const i = b2({
    in: !!n
  });
  return /* @__PURE__ */ o(
    qe,
    {
      ...a,
      size: r,
      disabled: t || c === "loading",
      "data-loading": c === "loading",
      palette: i === "entering" ? "danger" : a.palette,
      children: R(e, { state: c, progress: l, error: n, result: s })
    }
  );
}
const p8 = G(He);
function He({
  onClickAsync: e,
  size: t = "large",
  onError: r,
  onPending: c,
  onSuccess: n,
  ...l
}) {
  const { run: s, progress: a, error: i, result: d, state: v } = C3({
    asyncFn: e,
    onError: r,
    onPending: c,
    onSuccess: n
  }), h = O(
    () => g2(async (u) => {
      await s(u);
    }),
    [s]
  );
  return /* @__PURE__ */ o(
    Oe,
    {
      size: t,
      progress: a,
      error: i,
      result: d,
      state: v,
      onClick: h,
      ...l
    }
  );
}
const i5 = "p-0.5 rounded-[4px] bg-[color:var(--palette-N50)]", je = G(Ze), We = {
  "large-false": "Body/XL/Book",
  "large-true": "Body/XL/Medium",
  "small-false": "Body/L/Book",
  "small-true": "Body/L/Medium",
  "x-small-false": "Body/M/Book",
  "x-small-true": "Body/M/Medium"
}, Ge = {
  large: 16,
  small: 14,
  "x-small": 12
};
function Ze({
  size: e = "small",
  buttons: t,
  cols: r,
  className: c,
  style: n,
  innerRef: l,
  ...s
}) {
  const a = /* @__PURE__ */ o(p1, { collection: t, keyProvider: ({ key: i }, d) => i ?? d, children: ({ selected: i = !1, innerRef: d, children: v, icon: h, disabled: u, ...p }) => /* @__PURE__ */ x(
    "button",
    {
      type: "button",
      ref: d,
      disabled: u,
      "data-selected": i,
      "data-text-type": We[`${e}-${i}`],
      style: { color: I.palette_N700 },
      ...p,
      className: o1(
        {
          "transition-colors flex items-center justify-center\n									rounded-[3px] px-4\n									enabled:hover:bg-[var(--palette-N0)]\n									disabled:opacity-50\n									border border-transparent\n									data-[selected=true]:shadow-xs\n									data-[selected=true]:border-[var(--palette-N200)] data-[selected=true]:bg-[var(--palette-N0)]": !0,
          "h-[38px]": e === "large",
          "h-[28px]": e === "small",
          "h-[26px]": e === "x-small"
        },
        p.className
      ),
      children: [
        h && /* @__PURE__ */ o(Q, { icon: h, size: Ge[e], className: v ? "mr-1.5" : void 0 }),
        R(v)
      ]
    }
  ) });
  return r !== void 0 ? /* @__PURE__ */ o(
    "div",
    {
      ref: l,
      className: o1(i5, c),
      style: {
        display: "grid",
        gridTemplateColumns: `repeat(${r}, minmax(0, 1fr))`,
        gap: 8,
        ...n
      },
      ...s,
      children: a
    }
  ) : /* @__PURE__ */ o(
    D1,
    {
      innerRef: l,
      className: I1(i5, c),
      style: n,
      flexGrow: 0,
      childrenGrow: 1,
      childrenBasis: 0,
      gap: 8,
      ...s,
      children: a
    }
  );
}
const g8 = G(Ve);
function Ve({
  options: e,
  value: t,
  onChange: r,
  disabled: c,
  ...n
}) {
  return /* @__PURE__ */ o(
    je,
    {
      ...n,
      buttons: e.map(({ children: l, value: s, disabled: a, ...i }) => ({
        selected: S1(s, t),
        children: l,
        disabled: c || a,
        onClick: () => r?.(s),
        ...i
      }))
    }
  );
}
function S2({
  onClick: e,
  onDoubleClick: t,
  onMouseEnter: r,
  onMouseLeave: c,
  onMouseDown: n,
  onMouseUp: l,
  onKeyDown: s,
  onKeyUp: a,
  className: i,
  style: d,
  children: v,
  innerRef: h,
  title: u,
  disabled: p = !1,
  ...m
}) {
  const f = P5(null, h), b = O(
    () => p ? void 0 : (P) => {
      P.preventDefault(), f.current?.focus({ preventScroll: !0 }), e?.(P);
    },
    [p, f, e]
  ), y = O(
    () => p ? void 0 : (P) => {
      P.preventDefault(), f.current?.focus({ preventScroll: !0 }), t?.(P);
    },
    [p, f, t]
  ), [N, _] = W(!1), $ = O(
    () => p ? void 0 : (P) => {
      (P.key === "Enter" || P.key === " ") && (P.preventDefault(), P.key === "Enter" ? P.currentTarget.click() : _(!0)), s?.(P);
    },
    [p, s]
  ), F = O(
    () => p ? void 0 : (P) => {
      (P.key === "Enter" || P.key === " ") && (P.preventDefault(), P.key === " " && (P.currentTarget.click(), _(!1))), a?.(P);
    },
    [p, a]
  );
  return /* @__PURE__ */ o(
    "div",
    {
      ref: f,
      className: o1({ active: N, disabled: p }, i),
      style: d,
      role: b ? "button" : void 0,
      tabIndex: b ? 0 : void 0,
      onMouseEnter: r,
      onMouseLeave: c,
      onMouseDown: n,
      onMouseUp: l,
      onDoubleClick: y,
      onKeyUp: F,
      onKeyDown: $,
      onClick: b,
      title: u,
      ...m,
      children: R(v)
    }
  );
}
const Ue = {
  primary: [
    "text-[color:var(--Button-bg-primary)]",
    "hover:text-[color:var(--Button-bg-primary-hover)]",
    "active:text-[color:var(--Button-bg-primary-active)]",
    "disabled:text-[color:var(--Button-bg-primary-disabled)]",
    'disabled:data-[loading="true"]:text-[color:var(--Button-bg-primary)] disabled:data-[loading="true"]:animate-pulse'
  ].join(" "),
  secondary: [
    "text-[color:var(--Button-border-secondary)]",
    "hover:text-[color:var(--Button-bg-primary-hover)]",
    "active:text-[color:var(--Button-bg-primary-active)]",
    "disabled:text-[color:var(--Button-bg-secondary-disabled)]",
    'disabled:data-[loading="true"]:text-[color:var(--Button-bg-secondary)] disabled:data-[loading="true"]:animate-pulse'
  ].join(" "),
  neutral: [
    "text-[color:var(--Button-bg-neutral)]",
    "hover:text-[color:var(--Button-bg-neutral-hover)]",
    "active:text-[color:var(--Button-bg-neutral-active)]",
    "disabled:text-[color:var(--Button-bg-neutral-disabled)]",
    'disabled:data-[loading="true"]:text-[color:var(--Button-bg-neutral)] disabled:data-[loading="true"]:animate-pulse'
  ].join(" "),
  neutralOutline: [
    "text-[color:var(--Button-bg-neutral)]",
    "hover:text-[color:var(--Button-bg-neutral-hover)]",
    "active:text-[color:var(--Button-bg-neutral-active)]",
    "disabled:text-[color:var(--Button-bg-neutral-disabled)]",
    'disabled:data-[loading="true"]:text-[color:var(--Button-bg-neutral)] disabled:data-[loading="true"]:animate-pulse'
  ].join(" "),
  info: [
    "text-[color:var(--Button-fg-infoOutline)]",
    "active:text-[color:var(--Button-fg-infoOutline-active)]",
    "disabled:text-[color:var(--Button-fg-infoOutline-disabled)]",
    'disabled:data-[loading="true"]:text-[color:var(--Button-fg-infoOutline)] disabled:data-[loading="true"]:animate-pulse'
  ].join(" "),
  infoOutline: [
    "text-[color:var(--Button-fg-infoOutline)]",
    "active:text-[color:var(--Button-fg-infoOutline-active)]",
    "disabled:text-[color:var(--Button-fg-infoOutline-disabled)]",
    'disabled:data-[loading="true"]:text-[color:var(--Button-fg-infoOutline)] disabled:data-[loading="true"]:animate-pulse'
  ].join(" "),
  danger: [
    "text-[color:var(--Button-bg-danger)]",
    "hover:text-[color:var(--Button-bg-danger-hover)]",
    "active:text-[color:var(--Button-bg-danger-active)]",
    "disabled:text-[color:var(--Button-bg-danger-disabled)]",
    'disabled:data-[loading="true"]:text-[color:var(--Button-bg-danger)] disabled:data-[loading="true"]:animate-pulse'
  ].join(" "),
  inverted: [
    "text-[color:var(--Button-bg-inverted)]",
    "hover:text-[color:var(--Button-bg-inverted-hover)]",
    "active:text-[color:var(--Button-bg-inverted-active)]",
    "disabled:text-[color:var(--Button-bg-inverted-disabled)]",
    'disabled:data-[loading="true"]:text-[color:var(--Button-bg-inverted)] disabled:data-[loading="true"]:animate-pulse'
  ].join(" ")
}, Ke = "relative z-0 inline-flex items-center overflow-hidden font-title font-semibold transition-colors border-b border-current", qe = G(Ye);
function Ye({
  children: e,
  disabled: t,
  palette: r = "neutral",
  className: c,
  style: n,
  size: l = "large",
  href: s,
  onClick: a,
  type: i,
  innerRef: d,
  ...v
}) {
  return /* @__PURE__ */ o(
    s !== void 0 ? "a" : "button",
    {
      ...v,
      ref: d,
      type: s !== void 0 ? void 0 : i ?? "button",
      onClick: s !== void 0 ? void 0 : a,
      disabled: t,
      href: s !== void 0 ? s : void 0,
      target: s !== void 0 ? s : void 0,
      style: n,
      className: O(
        () => o1(
          {
            [Ke]: !0,
            [Ue[r]]: !0,
            "disabled:cursor-default": t,
            "text-ellipsis whitespace-nowrap overflow-hidden": !0,
            "text-[16px] py-1": l === "large",
            "text-[12px] py-1": l === "small"
          },
          c
        ),
        [c, t, r, l]
      ),
      children: R(e)
    }
  );
}
const H3 = G(Xe);
function Xe({
  children: e,
  expand: t,
  transitionDuration: r = 400,
  innerRef: c,
  style: n,
  className: l,
  unmountOnExit: s,
  ...a
}) {
  const [i, d] = W(null), v = q1(i)?.height ?? 0;
  return /* @__PURE__ */ o(G1, { in: t, duration: r, unmountOnExit: s, children: ({ transitionStatus: h }) => /* @__PURE__ */ o(
    "div",
    {
      ref: c,
      className: o1("transition-[height]", l),
      style: {
        transitionDuration: `${r}ms`,
        overflowY: h === "entered" ? void 0 : "hidden",
        height: h === "prepare-exit" || h === "entering" ? v : h === "exiting" || h === "exited" || h === "prepare-enter" ? 0 : void 0,
        // entered
        ...n
      },
      ...a,
      children: /* @__PURE__ */ o(
        "div",
        {
          className: X({
            "transition-opacity": !0,
            "opacity-0": !t
          }),
          style: { transitionDuration: `${r}ms` },
          ref: d,
          children: R(e, { expand: t, transitionStatus: h })
        }
      )
    }
  ) });
}
const b8 = G(Je);
function Je({
  children: e,
  expand: t,
  header: r,
  transitionDuration: c = 400,
  innerRef: n,
  className: l,
  style: s,
  unmountOnExit: a,
  ...i
}) {
  const [d, v] = W(t ?? !1), h = Z(() => v((u) => !u), []);
  return l1(() => {
    t !== void 0 && v(t);
  }, [t]), /* @__PURE__ */ x(
    "div",
    {
      className: o1("flex flex-col border rounded-xs", l),
      style: { borderColor: I.palette_N100, ...s },
      ref: n,
      ...i,
      children: [
        /* @__PURE__ */ o(G1, { duration: c, in: d, children: ({ transitionStatus: u }) => {
          const p = {
            expand: d,
            transitionStatus: u,
            onClick: h,
            transitionDuration: c
          };
          return /* @__PURE__ */ o(
            W1,
            {
              wrapper: (m) => /* @__PURE__ */ o(tt, { ...p, children: m }),
              children: R(r, p)
            }
          );
        } }),
        /* @__PURE__ */ o(
          H3,
          {
            expand: d,
            transitionDuration: c,
            unmountOnExit: a,
            children: /* @__PURE__ */ o(
              W1,
              {
                wrapper: (u) => /* @__PURE__ */ o(Qe, { expand: d, children: u }),
                children: R(e, { expand: d })
              }
            )
          }
        )
      ]
    }
  );
}
const Qe = G(
  et
);
function et({
  children: e,
  className: t,
  style: r,
  expand: c,
  innerRef: n,
  ...l
}) {
  return /* @__PURE__ */ o(
    "div",
    {
      ref: n,
      className: o1("py-2 px-2", t),
      style: r,
      ...l,
      children: R(e, { expand: c })
    }
  );
}
const tt = G(
  rt
);
function rt({
  children: e,
  expand: t,
  onClick: r,
  transitionDuration: c,
  className: n,
  style: l,
  innerRef: s,
  transitionStatus: a,
  ...i
}) {
  return /* @__PURE__ */ x(
    S2,
    {
      innerRef: s,
      onClick: r,
      className: o1(
        "py-3 transition-[color] flex items-center justify-between flex-1 px-2",
        n
      ),
      style: l,
      ...i,
      children: [
        /* @__PURE__ */ o(
          W1,
          {
            wrapper: (d) => /* @__PURE__ */ o(z1, { as: "div", type: "Body/M/Bold", color: I.palette_N600, children: d }),
            children: R(e, { expand: t })
          }
        ),
        /* @__PURE__ */ o(
          "div",
          {
            style: {
              transitionDuration: `${c}ms`
            },
            className: "transition-transform aria-expanded:transform-[rotateX(180deg)] flex",
            "aria-expanded": t,
            children: /* @__PURE__ */ o(Q, { icon: "Down", size: 20, color: I.palette_N500 })
          }
        )
      ]
    }
  );
}
const M8 = G(ot);
function ot({
  className: e,
  style: t,
  children: r,
  onReorder: c,
  itemKey: n,
  items: l,
  disabled: s,
  ...a
}) {
  const i = e1({ items: l, onReorder: c }), d = Z(
    (h) => {
      h.destination && i.current.onReorder?.(h6(i.current.items.slice(), h.source.index, h.destination.index));
    },
    [i]
  ), v = a2();
  return /* @__PURE__ */ o(x6, { onDragEnd: d, children: /* @__PURE__ */ o(
    z6,
    {
      direction: "vertical",
      droppableId: v,
      isDropDisabled: !1,
      isCombineEnabled: !1,
      ignoreContainerClipping: !1,
      children: (h, u) => /* @__PURE__ */ x(
        "div",
        {
          ...h.droppableProps,
          style: t,
          className: X(e),
          ref: h.innerRef,
          ...a,
          children: [
            l.map((p, m) => /* @__PURE__ */ o(
              y6,
              {
                isDragDisabled: s,
                draggableId: n(p, m),
                index: m,
                children: (f, b) => (
                  // Portal used to prevent clashing between transform and position:fixed
                  // See also https://github.com/atlassian/react-beautiful-dnd/issues/499
                  /* @__PURE__ */ o(O6, { destination: b.isDragging ? document.body : null, children: R(r, {
                    dragHandleProps: f.dragHandleProps,
                    item: p,
                    index: m,
                    isDragging: b.isDragging,
                    innerRef: f.innerRef,
                    // react-beautiful-dnd's DraggingStyle/NotDraggingStyle are closed interfaces, so
                    // they aren't assignable to CSSProperties now that @radix-ui/react-primitive
                    // augments it with a `--radix-${string}` index signature. The runtime value is a
                    // valid inline style object; coerce to the structural prop type.
                    draggableProps: f.draggableProps
                  }) })
                )
              },
              n(p, m)
            )),
            h.placeholder
          ]
        }
      )
    }
  ) });
}
const x8 = G(ct);
function ct({
  children: e,
  query: t,
  collection: r,
  extractFn: c
}) {
  const n = W4({
    query: t,
    collection: r,
    extractFn: c
  });
  return /* @__PURE__ */ o(n1, { children: R(e, n) });
}
const nt = G(lt);
function lt({
  style: e,
  className: t,
  step: r = 0.01,
  ...c
}) {
  const [n, l] = t2(c);
  return /* @__PURE__ */ o(
    "div",
    {
      className: o1("flex min-w-0 flex-row items-center flex-1", t),
      style: e,
      ...n,
      children: /* @__PURE__ */ o("div", { className: "flex-1 min-w-0", children: /* @__PURE__ */ o(K5, { className: "w-full", children: ({ width: s, htmlEl: a }) => /* @__PURE__ */ o(ht, { ...l, step: r, containerWidth: s, containerEl: a }) }) })
    }
  );
}
function st(e) {
  return typeof e == "number" ? {
    value: e
  } : e;
}
const L1 = 48, j1 = 2, at = 4, l3 = L1 / 2 + 4, o2 = L1 - 2, h2 = 14, it = 50, dt = 7, ut = 2;
function ht({
  containerEl: e,
  disabled: t,
  onChange: r,
  onCommit: c,
  values: n,
  step: l = 0.01,
  transitionOnDrag: s = !0,
  invalid: a,
  readonly: i,
  minMaxValueWidth: d = it,
  minMaxValueLocation: v,
  minMaxValueMode: h = "minMax",
  visualMax: u,
  visualMin: p,
  min: m,
  max: f,
  containerWidth: b,
  bandColors: y,
  className: N,
  fillBar: _ = !0,
  markerTextLocation: $ = "alternate",
  markers: F,
  showSteps: P = !1,
  showStepLabels: C = !1,
  stepTextProvider: L = (q) => String(q),
  style: E,
  handleBorderColors: S,
  handleColors: B,
  handleInnerRadius: g = dt,
  handleBorderWidth: z = ut,
  transitionOnDragThreshold: M = 0.05,
  ...H
}) {
  const [q, U] = W(null), [t1, w] = W(!1), j = g + z, k = p ?? m ?? 0, A = u ?? f ?? 100, Y = m ?? k, T = f ?? A, c1 = O(
    () => v ?? $1(h, {
      value: () => "horizontal",
      none: () => "bottom",
      minMax: () => "bottom"
    }),
    [v, h]
  ), i1 = s && (!t1 || l > (T - Y) * M), K = O(
    () => $1(c1, {
      horizontal: () => $1(h, {
        minMax: () => b - d - j,
        value: () => b - j,
        none: () => b - j
      }),
      bottom: () => b - j,
      top: () => b - j
    }),
    [b, j, c1, h, d]
  ), J = O(
    () => $1(c1, {
      horizontal: () => $1(h, {
        minMax: () => d + j,
        value: () => d * n.length + j,
        none: () => j
      }),
      bottom: () => j,
      top: () => j
    }),
    [j, c1, h, d, n.length]
  ), V = O(
    () => /* @__PURE__ */ x(n1, { children: [
      Y !== k && /* @__PURE__ */ o(
        "rect",
        {
          "data-comment": "dead zone left bar",
          className: "pointer-events-none",
          x: J,
          y: L1 / 2 - j1 / 2,
          width: g1(Y, k, A, J, K) - J,
          height: j1,
          fill: I.palette_N100
        }
      ),
      T !== A && /* @__PURE__ */ o(
        "rect",
        {
          "data-comment": "dead zone right bar",
          className: "pointer-events-none",
          x: g1(T, k, A, J, K),
          y: L1 / 2 - j1 / 2,
          width: K - g1(T, k, A, J, K),
          height: j1,
          fill: I.palette_N100
        }
      )
    ] }),
    [K, J, T, Y, A, k]
  ), d1 = O(
    () => (Array.isArray(P) || P) && (P === !0 ? a3(0, Math.floor((T - Y) / l) + 1).map((r1) => g1(r1, 0, Math.floor((T - Y) / l), Y, T)).toArray() : P).map((r1, h1, N1) => /* @__PURE__ */ x(K1, { children: [
      /* @__PURE__ */ o(
        "circle",
        {
          className: "pointer-events-none",
          cx: g1(r1, k, A, J, K),
          cy: L1 / 2,
          r: at / 2,
          fill: I.Slider_bar_step_fill_color
        }
      ),
      !C || h1 === 0 && Y === k || h1 === N1.length - 1 && T === A ? /* @__PURE__ */ o(n1, {}) : /* @__PURE__ */ o(
        "text",
        {
          fill: I.Slider_fg_color,
          x: g1(r1, k, A, J, K),
          y: $1(c1, {
            bottom: () => o2,
            top: () => h2,
            horizontal: () => o2
          }),
          fontSize: "0.8rem",
          textAnchor: "middle",
          children: L(r1)
        }
      )
    ] }, h1)),
    [
      K,
      J,
      T,
      Y,
      c1,
      C,
      P,
      l,
      L,
      A,
      k
    ]
  ), C1 = O(
    () => F?.map(st).map((r1, h1) => {
      const N1 = g1(r1.value, k, A, J, K);
      let R1;
      return !r1.type || r1.type === "bar" ? R1 = /* @__PURE__ */ o(
        "rect",
        {
          className: "pointer-events-none",
          x: N1 - 1,
          y: L1 / 2 - 8,
          width: 2,
          height: 16,
          ry: 1,
          fill: r1.barColor ?? I.palette_N300
        }
      ) : r1.type === "circle" ? R1 = /* @__PURE__ */ o(
        "circle",
        {
          className: X({
            "pointer-events-none": !0
          }),
          cx: N1,
          cy: L1 / 2,
          r: g - z / 2,
          stroke: r1.borderColor ?? I.palette_N300,
          fill: r1.fillColor ?? "white",
          strokeWidth: z
        }
      ) : R1 = /* @__PURE__ */ o(n1, {}), /* @__PURE__ */ x(K1, { children: [
        !r1.hideText && /* @__PURE__ */ o(
          "text",
          {
            fill: r1.textColor ?? I.palette_N500,
            x: N1,
            y: $1(r1.textLocation ?? $, {
              alternate: () => h1 % 2 === 0 ? o2 : h2,
              bottom: () => o2,
              top: () => h2
            }),
            fontSize: "0.8rem",
            textAnchor: "middle",
            children: r1.customText ?? L(r1.value)
          }
        ),
        R1
      ] }, h1);
    }),
    [
      K,
      J,
      z,
      g,
      $,
      F,
      L,
      A,
      k
    ]
  );
  return K < 0 ? /* @__PURE__ */ o(n1, {}) : /* @__PURE__ */ x("div", { className: "relative z-0", style: { height: L1 }, ...H, children: [
    /* @__PURE__ */ o("div", { className: "absolute z-10 inset-0", ref: U }),
    /* @__PURE__ */ x(
      Z7,
      {
        style: {
          ...E,
          position: "absolute",
          zIndex: 0,
          top: 0,
          right: 0,
          bottom: 0,
          left: 0,
          width: b
        },
        className: N,
        viewBox: {
          width: b,
          height: L1
        },
        children: [
          /* @__PURE__ */ o(
            "rect",
            {
              "data-comment": "background",
              className: "pointer-events-none",
              x: J,
              y: L1 / 2 - j1 / 2,
              width: K - J,
              height: j1,
              rx: j1 / 2,
              fill: t ? I.palette_N100 : I.Slider_bar_bg_color
            }
          ),
          /* @__PURE__ */ o(
            _6,
            {
              case: h,
              match: {
                minMax: () => /* @__PURE__ */ x(n1, { children: [
                  /* @__PURE__ */ o(
                    "text",
                    {
                      "data-comment": "min label",
                      fill: I.Slider_fg_color,
                      fontSize: "0.8rem",
                      ...$1(c1, {
                        horizontal: () => ({
                          x: J - j,
                          y: l3,
                          textAnchor: "end"
                        }),
                        bottom: () => ({
                          x: J,
                          y: o2,
                          textAnchor: "start"
                        }),
                        top: () => ({
                          x: J,
                          y: h2,
                          textAnchor: "start"
                        })
                      }),
                      children: L(k)
                    }
                  ),
                  /* @__PURE__ */ o(
                    "text",
                    {
                      "data-comment": "max label",
                      fill: I.Slider_fg_color,
                      fontSize: "0.8rem",
                      ...$1(c1, {
                        horizontal: () => ({
                          x: K + j,
                          y: l3,
                          textAnchor: "start"
                        }),
                        bottom: () => ({
                          x: K,
                          y: o2,
                          textAnchor: "end"
                        }),
                        top: () => ({
                          x: K,
                          y: h2,
                          textAnchor: "end"
                        })
                      }),
                      children: L(A)
                    }
                  )
                ] }),
                value: () => /* @__PURE__ */ o(
                  "text",
                  {
                    "data-comment": "value label",
                    fontSize: "0.8rem",
                    fontWeight: "bold",
                    ...$1(c1, {
                      horizontal: () => ({
                        x: J - j,
                        y: l3,
                        textAnchor: "end"
                      }),
                      bottom: () => ({
                        x: J,
                        y: o2,
                        textAnchor: "end"
                      }),
                      top: () => ({
                        x: J,
                        y: h2,
                        textAnchor: "end"
                      })
                    }),
                    children: n.map((r1, h1) => /* @__PURE__ */ o(K1, { children: /* @__PURE__ */ x("tspan", { fill: y?.[h1] ?? I.Slider_fg_color, children: [
                      L(r1),
                      h1 !== n.length - 1 && ", "
                    ] }) }, h1))
                  }
                ),
                none: () => /* @__PURE__ */ o(n1, {})
              }
            }
          ),
          V,
          d1,
          _ && a3(0, n.length + 1).map((r1) => /* @__PURE__ */ o(
            "rect",
            {
              "data-comment": "value bar",
              className: X({
                "pointer-events-none": !0,
                "transition-[width,x]": i1
              }),
              height: j1,
              rx: j1 / 2,
              x: r1 === 0 ? g1(Y, k, A, J, K) : g1(n[r1 - 1], k, A, J, K),
              y: L1 / 2 - j1 / 2,
              width: r1 === 0 ? g1(n[r1], k, A, J, K) - g1(Y, k, A, J, K) : r1 === n.length ? g1(T, k, A, J, K) - g1(n[r1 - 1], k, A, J, K) : g1(n[r1], k, A, J, K) - g1(n[r1 - 1], k, A, J, K),
              fill: y?.[r1] ?? "transparent"
            },
            r1
          )),
          C1,
          i ? /* @__PURE__ */ o(n1, {}) : /* @__PURE__ */ o(
            ft,
            {
              invalid: a,
              step: l,
              values: n,
              onChange: r,
              onCommit: c,
              onDraggingChange: (r1) => g6(() => w(r1)),
              containerEl: e,
              draggableEl: q,
              barMaxX: K,
              barMinX: J,
              disabled: t,
              max: T,
              min: Y,
              visualMax: A,
              visualMin: k,
              transition: i1,
              handleBorderColors: S,
              handleColors: B,
              handleInnerRadius: g,
              handleBorderWidth: z
            }
          )
        ]
      }
    )
  ] });
}
function ft({
  barMaxX: e,
  barMinX: t,
  max: r,
  min: c,
  visualMin: n,
  visualMax: l,
  step: s,
  onChange: a,
  onCommit: i,
  onDraggingChange: d,
  values: v,
  disabled: h,
  containerEl: u,
  draggableEl: p,
  transition: m,
  invalid: f,
  handleBorderColors: b,
  handleColors: y,
  handleInnerRadius: N,
  handleBorderWidth: _
}) {
  const $ = e1({
    onChange: a,
    onCommit: i,
    onDraggingChange: d
  }), F = e1(v), P = a1(v[0]), C = a1(0), L = Z(
    (S, B) => {
      let g;
      return B === void 0 ? g = "round" : B > S ? g = "ceil" : g = "floor", v5(T1(S, c, r), s, {
        mode: g,
        ceilFloorNudge: s * 0.1
      });
    },
    [r, c, s]
  );
  j4({
    draggableEl: p,
    disabled: h || !u,
    onDragStart: (S) => {
      P.current = L(
        g1(
          S.x - (u?.getBoundingClientRect().left ?? 0),
          t,
          e,
          n,
          l
        )
      );
      const B = f6(
        F.current,
        (z) => 1 / Math.abs(P.current - z)
      );
      B.length === 1 ? C.current = B[0] : F.current[B[B.length - 1]] < P.current ? C.current = B[B.length - 1] : C.current = B[0];
      const g = [...F.current];
      g[C.current] = P.current, $.current.onChange?.(g);
    },
    onDragMove: (S, B) => {
      if (h)
        return;
      $.current.onDraggingChange?.(!0);
      const g = [...F.current];
      g[C.current] = T1(
        L(
          g1(
            g1(P.current, n, l, t, e) + (B.x - S.x),
            t,
            e,
            n,
            l
          ),
          g[C.current]
        ),
        n,
        l
      );
      for (let z = C.current - 1; z >= 0; z--)
        g[z] = Math.min(g[C.current], g[z]);
      for (let z = C.current + 1; z < g.length; z++)
        g[z] = Math.max(g[C.current], g[z]);
      $.current.onChange?.(g);
    },
    onDragEnd: () => {
      $.current.onDraggingChange?.(!1), $.current.onCommit?.(F.current);
    }
  });
  const E = v.map((S) => g1(S, n, l, t, e));
  return /* @__PURE__ */ o(n1, { children: E.map((S, B) => /* @__PURE__ */ o(
    "circle",
    {
      tabIndex: 0,
      xlinkTitle: `handle ${B + 1}, value ${v[B]}, press arrow left or right to adjust`,
      onKeyDown: (g) => {
        if ((g.key === "ArrowLeft" || g.key === "ArrowRight") && !g.altKey && !g.metaKey && !g.shiftKey) {
          g.preventDefault();
          const z = [...F.current];
          z[B] = L(
            z[B] + (g.key === "ArrowLeft" ? -1 : 1) * (g.ctrlKey ? (r - c) / 10 : s)
          );
          for (let M = B - 1; M >= 0; M--)
            z[M] = Math.min(z[B], z[M]);
          for (let M = B + 1; M < z.length; M++)
            z[M] = Math.max(z[B], z[M]);
          $.current.onChange?.(z);
        }
      },
      className: X({
        "pointer-events-none outline-hidden focus:scale-125 focus:peer-first:scale-125 origin-center": !0,
        "transition-[cx]": m
      }),
      style: {
        transformBox: "fill-box"
      },
      cx: S,
      cy: L1 / 2,
      r: N - _ / 2,
      strokeWidth: _,
      stroke: f ? "#E81E25" : b?.[B] ?? I.Slider_handle_border_color,
      fill: y?.[B] ?? I.Slider_handle_fill_color
    },
    B
  )) });
}
const vt = G(mt);
function mt({
  min: e,
  max: t,
  step: r,
  value: c,
  onChange: n,
  icon: l,
  innerRef: s,
  ...a
}) {
  const [i, d] = W(() => c.toFixed(Y2(r)));
  l1(() => {
    d(c.toFixed(Y2(r)));
  }, [r, c]);
  const v = P5(null, s), h = e1(n), u = Z(() => {
    if (!v.current)
      return;
    const p = v.current.value.trim();
    if (p !== "") {
      const m = v5(T1(Number(p), e, t), r);
      d(m.toFixed(Y2(r))), h.current?.(m);
    }
  }, [v, t, e, h, r]);
  return /* @__PURE__ */ o(
    y2,
    {
      innerRef: v,
      step: r,
      type: "number",
      size: "x-small",
      min: e,
      max: t,
      inputAppearance: {
        style: {
          textAlign: "right"
        }
      },
      style: {
        flex: 0,
        minWidth: l ? "10ch" : "7ch"
      },
      rightContent: l ? /* @__PURE__ */ o(Q, { icon: l }) : null,
      value: i,
      onChangeText: d,
      onKeyUp: (p) => {
        p.key === "Enter" && (p.preventDefault(), p.stopPropagation(), u());
      },
      onBlur: u,
      ...a
    }
  );
}
const z8 = G(pt);
function pt({
  value: e,
  onChange: t,
  onCommit: r,
  input: c,
  min: n = 0,
  max: l = 100,
  step: s = 0.01,
  style: a,
  className: i,
  disabled: d = !1,
  invalid: v = !1,
  fillColor: h,
  handleBorderColor: u,
  handleColor: p,
  ...m
}) {
  const [f, b] = t2(m);
  return /* @__PURE__ */ x(
    "div",
    {
      className: o1(
        {
          "flex flex-row items-center flex-1 min-w-0": !0,
          "space-x-2": !!c
        },
        i
      ),
      style: a,
      ...f,
      children: [
        /* @__PURE__ */ o(
          nt,
          {
            ...b,
            disabled: d,
            style: { marginTop: 6 },
            min: n,
            max: l,
            step: s,
            onChange: (y) => t?.(y[0]),
            onCommit: (y) => r?.(y[0]),
            values: [e],
            invalid: v,
            bandColors: [h ?? I.Slider_bar_fg_color],
            handleBorderColors: [u],
            handleColors: [p]
          }
        ),
        c && /* @__PURE__ */ o(
          vt,
          {
            disabled: d,
            value: e,
            max: l,
            min: n,
            step: s,
            onChange: (y) => {
              t?.(y), r?.(y);
            },
            invalid: v,
            ...typeof c == "boolean" ? {} : c
          }
        )
      ]
    }
  );
}
function y8(e) {
  const t = Math.ceil(e.total / e.take) || 1, r = 0, c = (t - 1) * e.take;
  return {
    pageIndex: Math.floor(e.skip / e.take),
    pageCount: t,
    minSkip: r,
    maxSkip: c,
    isFirstPage: e.skip <= 0,
    isLastPage: e.skip >= c,
    skipForPrevPage() {
      return Math.max(r, e.skip - e.take);
    },
    skipForNextPage() {
      return Math.min(c, e.skip + e.take);
    },
    skipForPage(l) {
      return T1(r, l * e.take, c);
    }
  };
}
function p3({
  columnName: e,
  currentOrderBy: t,
  multi: r,
  newDirection: c
}) {
  const n = t.findIndex((l) => l.columnName === e);
  if (c !== void 0) {
    if (r)
      if (c === null) {
        if (n === -1)
          return t;
        {
          const l = [...t];
          return l.splice(n, 1), l;
        }
      } else {
        if (n === -1)
          return [...t, { columnName: e, direction: c }];
        {
          const l = [...t];
          return l[n].direction = c, l;
        }
      }
    return c === null ? [] : [
      {
        columnName: e,
        direction: c
      }
    ];
  } else {
    if (r) {
      if (n === -1)
        return [...t, { columnName: e, direction: "asc" }];
      if (t[n].direction === "asc") {
        const l = [...t];
        return l[n].direction = "desc", l;
      } else {
        const l = [...t];
        return l.splice(n, 1), l;
      }
    }
    return t.length === 0 || t.length !== 1 || t.length === 1 && t[0].columnName !== e ? [
      {
        columnName: e,
        direction: "asc"
      }
    ] : t.length === 1 && t[0].columnName === e && t[0].direction === "asc" ? [
      {
        columnName: e,
        direction: "desc"
      }
    ] : [];
  }
}
function gt() {
  return 0;
}
function C8(e) {
  return O(
    () => i2({
      rows: e.rows,
      columns: e.columns,
      orderByArr: e.orderByArr
    }),
    [e.rows, e.columns, e.orderByArr]
  );
}
function i2({
  rows: e,
  columns: t,
  orderByArr: r
}) {
  if (!r || r.length === 0)
    return e;
  const c = r.map(({ columnName: n, direction: l }) => {
    const s = t.find((a) => a.name === n)?.sortFn || gt;
    return l === "asc" ? s : v6(s);
  });
  return [...e].sort(m6(c));
}
const n2 = 41, d5 = 8, j3 = G(bt);
function bt({
  columns: e,
  className: t,
  style: r,
  children: c,
  cellKey: n,
  onMouseEnter: l,
  onMouseLeave: s,
  onClick: a,
  onContextMenu: i,
  innerRef: d,
  ...v
}) {
  const h = O(
    () => e.map((u, p) => ({ col: u, index: p })).filter(({ col: u }) => !u.hidden),
    [e]
  );
  return /* @__PURE__ */ o(
    "div",
    {
      ref: d,
      onMouseEnter: l,
      onMouseLeave: s,
      onClick: a,
      onContextMenu: i,
      className: o1("flex flex-row", t),
      style: r,
      ...v,
      children: /* @__PURE__ */ o(
        p1,
        {
          collection: h,
          keyProvider: ({ col: u, index: p }) => n?.(u, p) ?? p,
          children: ({ col: u, index: p }) => R(c, {
            column: u,
            columnIndex: p,
            style: {
              width: u.width,
              minWidth: u.minWidth ?? 0,
              maxWidth: u.maxWidth,
              minHeight: n2,
              flexGrow: u.width ? 0 : 1,
              flexBasis: u.minWidth ?? u.width ?? "0px",
              paddingLeft: d5,
              paddingRight: d5
            }
          })
        }
      )
    }
  );
}
const U7 = G(Mt);
function Mt({
  columns: e,
  orderBy: t,
  onOrderByChange: r,
  className: c,
  style: n,
  innerRef: l,
  canMultiSort: s = !0,
  // onResize,
  ...a
}) {
  return /* @__PURE__ */ o(
    j3,
    {
      innerRef: l,
      columns: e,
      className: I1(
        "border-b border-[var(--palette-N200)] bg-[#ffffff] divide-x divide-[var(--palette-N200)]",
        c
      ),
      style: n,
      cellKey: (i) => i.headerKey,
      role: "rowheader",
      "data-role": "TableHead",
      ...a,
      children: ({ column: i, style: d }) => {
        const v = i.name, h = t.find((m) => m.columnName === v)?.direction ?? null, u = {
          canMultiSort: s,
          columnName: v,
          orderBy: t,
          onOrderByChange: r,
          className: f1(i.headerCellClassName, { sortDirection: h }),
          style: { ...d, ...f1(i.headerCellStyle, { sortDirection: h }) },
          align: i.align,
          sortDirection: h,
          orderable: i.orderable ?? i.sortFn != null,
          textType: i.headerTextType
        }, p = R(i.header, u);
        return /* @__PURE__ */ o(
          W1,
          {
            wrapper: (m) => /* @__PURE__ */ o(yt, { ...u, children: m }),
            children: p
          }
        );
      }
    }
  );
}
const K7 = G(xt);
function xt({
  columns: e,
  className: t,
  style: r,
  innerRef: c,
  ...n
}) {
  return /* @__PURE__ */ o(
    j3,
    {
      innerRef: c,
      columns: e,
      cellKey: (l) => l.footerKey,
      className: I1(
        "border-t border-[var(--palette-N200)] bg-[#ffffff] divide-x divide-transparent",
        t
      ),
      style: r,
      role: "row",
      "data-role": "TableFooter",
      ...n,
      children: ({ column: l, style: s }) => {
        const a = {
          align: l.align,
          className: l.footerCellClassList,
          style: { ...s, ...l.footerCellStyle },
          textType: l.footerTextType
        }, i = f1(l.footer, a);
        return /* @__PURE__ */ o(
          W1,
          {
            wrapper: (d) => /* @__PURE__ */ o(wt, { ...a, children: d }),
            children: i
          }
        );
      }
    }
  );
}
const O2 = G(zt);
function zt({
  style: e,
  className: t,
  row: r,
  rowIndex: c,
  columns: n,
  onMouseEnter: l,
  onMouseLeave: s,
  onClick: a,
  onContextMenu: i,
  palette: d = "uniform",
  innerRef: v,
  highlightOnHover: h = !0,
  ...u
}) {
  return /* @__PURE__ */ o(
    j3,
    {
      innerRef: v,
      columns: n,
      className: I1(
        {
          "border-b border-[#eeeef1] divide-x divide-transparent": !0,
          "transition-[background] data-forceHover:bg-[#EFF0F3]! hover:bg-[#EFF0F3]": h,
          "bg-[#ffffff]": c % 2 === 0 || d === "uniform",
          "bg-[#F7F8F9]": c % 2 !== 0 && d === "striped",
          "cursor-pointer": !!a
        },
        t
      ),
      style: e,
      onMouseEnter: l,
      onMouseLeave: s,
      onClick: a,
      onContextMenu: i,
      cellKey: (p, m) => p.contentKey?.(r) ?? m,
      role: "row",
      "data-component": "TableDataRow",
      ...u,
      children: ({ column: p, columnIndex: m, style: f }) => {
        const b = {
          align: p.align,
          textType: p.contentTextType,
          className: f1(p.cellClassName, r, c, m),
          style: { ...f, ...f1(p.cellStyle, r, c, m) }
        }, y = p.content(r, b);
        return /* @__PURE__ */ o(
          W1,
          {
            wrapper: (N) => /* @__PURE__ */ o(It, { ...b, children: N }),
            children: y
          }
        );
      }
    }
  );
}
const yt = G(q7);
function q7(e) {
  const [t] = t2(e), [r] = l4(e), c = R(e.children);
  return /* @__PURE__ */ x(
    S2,
    {
      innerRef: e.innerRef,
      className: I1(
        {
          "flex items-center": !0,
          "justify-start": !e.align || e.align === "start",
          "justify-center": e.align === "middle",
          "justify-end": e.align === "end"
          // 'flex-row-reverse': props.align === 'end',
        },
        e.className
      ),
      style: e.style,
      onClick: e.onClick ?? (e.orderable ? ({ shiftKey: n }) => e.onOrderByChange?.(
        p3({
          currentOrderBy: e.orderBy,
          columnName: e.columnName,
          multi: e.canMultiSort && n
        })
      ) : void 0),
      onKeyDown: e.onKeyDown,
      title: e.title ?? (typeof c == "string" ? c : void 0),
      "data-component": "TableHeadCell",
      ...t,
      ...r,
      children: [
        /* @__PURE__ */ o(
          z1,
          {
            className: {
              "line-clamp-2": !0,
              "text-left": !e.align || e.align === "start",
              "text-right": e.align === "end",
              "text-center": e.align === "middle"
            },
            type: e.textType ?? "Body/S/BOLD-UPPERCASE",
            color: e.sortDirection != null ? I.palette_P500 : I.palette_N500,
            children: c
          }
        ),
        /* @__PURE__ */ o(
          "div",
          {
            "aria-hidden": !e.orderable,
            className: X({
              "flex items-center aria-hidden:hidden": !0,
              "pl-1": !e.align || e.align === "start",
              "pr-1": e.align === "end"
            }),
            children: e.sortDirection == null ? /* @__PURE__ */ o(Q, { icon: "Property-1Default", size: "1.4em", color: I.palette_N100 }) : e.sortDirection === "asc" ? /* @__PURE__ */ o(Q, { icon: "Property-1az", size: "1.4em", color: I.palette_P500 }) : /* @__PURE__ */ o(Q, { icon: "Property-1za", size: "1.4em", color: I.palette_P500 })
          }
        )
      ]
    }
  );
}
const I8 = G(
  Ct
);
function Ct({
  onOrderByChange: e,
  sortDirection: t,
  columnName: r,
  orderBy: c,
  canMultiSort: n,
  actions: l,
  align: s,
  orderable: a,
  ...i
}) {
  const d = !!e, v = e1(e), h = O(
    () => !d || !(a ?? !1) ? [] : [
      {
        group: { id: "sort" },
        id: "sort-ascending",
        // TODO: improve typing of Dropdown icon and migrate?
        children: ({ onClose: u }) => /* @__PURE__ */ o(
          m3,
          {
            icon: "sort-ascending",
            onClick: (p) => {
              p.stopPropagation(), v.current(
                p3({
                  columnName: r,
                  currentOrderBy: c,
                  multi: n && p.shiftKey,
                  // TODO: is there a more intuitive way? do our user even use this feature?
                  newDirection: t === "asc" ? null : "asc"
                })
              ), u();
            },
            children: /* @__PURE__ */ x(D1, { alignItems: "center", justifyContent: "space-between", children: [
              /* @__PURE__ */ o("span", { className: "whitespace-nowrap text-start", children: "Ascending" }),
              /* @__PURE__ */ o(
                Q,
                {
                  icon: "Outline",
                  size: 18,
                  className: {
                    "ml-3": !0,
                    invisible: t !== "asc"
                  }
                }
              )
            ] })
          }
        )
      },
      {
        group: { id: "sort" },
        id: "sort-descending",
        children: ({ onClose: u }) => /* @__PURE__ */ o(
          m3,
          {
            icon: "sort-decending",
            onClick: (p) => {
              p.stopPropagation(), v.current(
                p3({
                  columnName: r,
                  currentOrderBy: c,
                  multi: n && p.shiftKey,
                  // TODO: is there a more intuitive way? do our user even use this feature?
                  newDirection: t === "desc" ? null : "desc"
                })
              ), u();
            },
            children: /* @__PURE__ */ x(D1, { alignItems: "center", justifyContent: "space-between", children: [
              /* @__PURE__ */ o("span", { className: "whitespace-nowrap text-start", children: "Descending" }),
              /* @__PURE__ */ o(
                Q,
                {
                  icon: "Outline",
                  size: 18,
                  className: {
                    "ml-3": !0,
                    invisible: t !== "desc"
                  }
                }
              )
            ] })
          }
        )
      }
    ],
    [
      d,
      a,
      t,
      v,
      r,
      c,
      n
    ]
  );
  return /* @__PURE__ */ o(
    ve,
    {
      actions: l?.(h) ?? h ?? [],
      position: "bottom",
      align: s === "end" ? "endToEnd" : "startToStart",
      relativePositionOffsets: {
        top: -4,
        bottom: 4,
        left: -4,
        right: 4
      },
      trigger: (u) => /* @__PURE__ */ o(
        q7,
        {
          ...i,
          orderable: a,
          align: s,
          onClick: u.onClick,
          onKeyDown: u.onKeyDown,
          "data-open": u.open,
          "aria-controls": u["aria-controls"],
          innerRef: u.innerRef,
          sortDirection: t,
          columnName: r,
          orderBy: c,
          canMultiSort: n
        }
      )
    }
  );
}
const It = G(Nt);
function Nt(e) {
  const [t] = t2(e), r = R(e.children);
  return /* @__PURE__ */ o(
    "div",
    {
      ref: e.innerRef,
      className: o1(
        {
          "flex items-center": !0,
          "justify-start": !e.align || e.align === "start",
          "justify-center": e.align === "middle",
          "justify-end": e.align === "end"
        },
        e.className
      ),
      style: e.style,
      onClick: e.onClick,
      title: e.title ?? (typeof r == "string" ? r : void 0),
      role: "cell",
      "data-component": "TableDataCell",
      ...t,
      children: /* @__PURE__ */ o(
        z1,
        {
          className: {
            "line-clamp-2": !0,
            "text-left": !e.align || e.align === "start",
            "text-right": e.align === "end",
            "text-center": e.align === "middle"
          },
          type: e.textType ?? "Body/M/Book",
          children: r
        }
      )
    }
  );
}
const N8 = G(St);
function St(e) {
  const [t] = t2(e), r = R(e.children);
  return /* @__PURE__ */ x(
    "div",
    {
      ref: e.innerRef,
      className: o1(
        {
          "flex items-stretch": !0,
          "justify-start": !e.align || e.align === "start",
          "justify-center": e.align === "middle",
          "justify-end": e.align === "end"
        },
        e.className
      ),
      style: e.style,
      onClick: e.onClick ?? e.onToggleExpand,
      title: e.title ?? (typeof r == "string" ? r : void 0),
      role: "cell",
      "data-component": "TableGroupDataCell",
      ...t,
      children: [
        /* @__PURE__ */ o(
          S2,
          {
            className: "mr-2 flex items-center",
            onClick: (c) => {
              c.stopPropagation(), e.onToggleExpand?.(c);
            },
            children: /* @__PURE__ */ o(
              "span",
              {
                className: "transition-transform aria-expanded:transform-[rotateX(180deg)] flex",
                "aria-expanded": e.expanded,
                children: /* @__PURE__ */ o(Q, { icon: "Down" })
              }
            )
          }
        ),
        /* @__PURE__ */ o("div", { className: "flex grow items-center", children: /* @__PURE__ */ o(
          z1,
          {
            className: {
              "line-clamp-2": !0,
              "text-left": !e.align || e.align === "start",
              "text-right": e.align === "end",
              "text-center": e.align === "middle"
            },
            type: e.textType ?? "Body/M/Book",
            children: r
          }
        ) })
      ]
    }
  );
}
const wt = G(Bt);
function Bt(e) {
  const [t] = t2(e), r = R(e.children);
  return /* @__PURE__ */ o(
    "div",
    {
      ref: e.innerRef,
      className: o1(
        {
          "flex items-center": !0,
          "justify-start": !e.align || e.align === "start",
          "justify-center": e.align === "middle",
          "justify-end": e.align === "end"
        },
        e.className
      ),
      style: e.style,
      onClick: e.onClick,
      title: e.title ?? (typeof r == "string" ? r : void 0),
      role: "cell",
      "data-component": "TableFooterCell",
      ...t,
      children: /* @__PURE__ */ o(
        z1,
        {
          className: {
            "line-clamp-2": !0,
            "text-left": !e.align || e.align === "start",
            "text-right": e.align === "end",
            "text-center": e.align === "middle"
          },
          type: e.textType ?? "Body/M/Bold",
          children: r
        }
      )
    }
  );
}
const Y7 = G(kt);
function X7(e, t) {
  return t;
}
function kt({
  columns: e,
  rows: t,
  noDataText: r,
  orderBy: c = f2,
  onOrderByChange: n,
  rowStyle: l,
  rowClassName: s,
  rowKey: a,
  className: i,
  headerRowClassName: d,
  headerRowStyle: v,
  footerRowClassName: h,
  footerRowStyle: u,
  style: p,
  palette: m = "uniform",
  highlightRowOnHover: f,
  innerRef: b,
  onRowMouseEnter: y,
  onRowMouseLeave: N,
  onRowClick: _,
  onRowContextMenu: $,
  canMultiSort: F = !0,
  disableVirtualScroll: P = !1,
  TableDataRow: C,
  ...L
}) {
  const E = C ?? O2, S = a1(null), B = a ?? X7, g = x5({
    getScrollElement: () => S.current,
    count: t.length,
    estimateSize: () => n2,
    getItemKey: Z((z) => B(t[z], z), [B, t]),
    enabled: !P
  });
  return /* @__PURE__ */ o(
    "div",
    {
      className: o1(
        "flex flex-col items-stretch min-h-0 relative z-0 grow",
        i
      ),
      style: p,
      ref: b,
      role: "table",
      ...L,
      children: /* @__PURE__ */ x("div", { className: "overflow-y-auto min-h-0 flex-1 flex flex-col", ref: S, children: [
        /* @__PURE__ */ o(
          U7,
          {
            columns: e,
            onOrderByChange: n,
            orderBy: c,
            canMultiSort: F,
            className: I1("top-0 sticky z-10", d),
            style: v
          }
        ),
        t.length === 0 ? r != null && /* @__PURE__ */ o("div", { className: "w-full flex py-2 justify-center italic font-light", children: R(r) }) : /* @__PURE__ */ o(
          "div",
          {
            style: {
              height: P ? void 0 : `${g.getTotalSize()}px`
            },
            className: "flex flex-col items-stretch relative w-full z-0 shrink-0",
            "data-role": "rows-container",
            children: P ? /* @__PURE__ */ o(p1, { collection: t, keyProvider: B, children: (z, M) => R(E, {
              onClick: _ && ((H) => _?.(z, M, H)),
              onContextMenu: $ && ((H) => $?.(z, M, H)),
              onMouseEnter: y && ((H) => y?.(z, M, H)),
              onMouseLeave: N && ((H) => N?.(z, M, H)),
              palette: m,
              highlightOnHover: f,
              row: z,
              rowIndex: M,
              columns: e,
              style: f1(l, z, M),
              className: f1(s, z, M),
              "data-index": M
            }) }) : /* @__PURE__ */ o(p1, { collection: g.getVirtualItems(), keyProvider: (z) => z.key, children: (z) => {
              const M = t[z.index], H = z.index;
              return R(E, {
                onClick: _ && ((q) => _?.(M, H, q)),
                onContextMenu: $ && ((q) => $?.(M, H, q)),
                onMouseEnter: y && ((q) => y?.(M, H, q)),
                onMouseLeave: N && ((q) => N?.(M, H, q)),
                palette: m,
                highlightOnHover: f,
                row: M,
                rowIndex: H,
                columns: e,
                innerRef: g.measureElement,
                style: {
                  position: "absolute",
                  top: 0,
                  left: 0,
                  width: "100%",
                  transform: `translateY(${z.start}px)`,
                  ...f1(l, M, H)
                },
                className: f1(s, M, H),
                "data-index": z.index
              });
            } })
          }
        ),
        e.some((z) => z.footer) && /* @__PURE__ */ o(
          K7,
          {
            columns: e,
            className: I1("mt-auto bottom-0 sticky z-10", h),
            style: u
          }
        )
      ] })
    }
  );
}
function Pt({
  startElement: e,
  endElement: t,
  overflowingEl: r,
  direction: c
}) {
  const n = q1(e ?? null), l = q1(t ?? null);
  return /* @__PURE__ */ o(
    J5,
    {
      startShadow: ({ scrollFromStart: s, className: a, style: i, scrollInfo: d }) => /* @__PURE__ */ o(
        Y5,
        {
          scrollInfo: d,
          scrollFromStart: s,
          offset: c === "vertical" ? n?.height : n?.width,
          style: {
            ...i,
            zIndex: 10
          },
          direction: c,
          className: a
        }
      ),
      endShadow: ({ scrollTillEnd: s, className: a, style: i, scrollInfo: d }) => /* @__PURE__ */ o(
        X5,
        {
          offset: c === "vertical" ? l?.height : l?.width,
          scrollInfo: d,
          scrollTillEnd: s,
          style: {
            ...i,
            zIndex: 10
          },
          direction: c,
          className: a
        }
      ),
      showScrollingArrows: !1,
      direction: c,
      overflowingEl: r
    }
  );
}
function J7({
  columns: e,
  rows: t,
  style: r,
  className: c,
  innerRef: n,
  pinnedColumns: l = f2,
  footerRowClassName: s,
  footerRowStyle: a,
  headerRowClassName: i,
  headerRowStyle: d,
  noDataText: v,
  onOrderByChange: h,
  onRowClick: u,
  onRowContextMenu: p,
  onRowMouseEnter: m,
  onRowMouseLeave: f,
  orderBy: b = f2,
  palette: y,
  highlightRowOnHover: N,
  rowClassName: _,
  rowKey: $,
  rowStyle: F,
  canMultiSort: P = !0,
  disableVirtualScroll: C = !1,
  TableDataRow: L,
  ...E
}) {
  const S = L ?? O2, B = O(() => {
    const w = l.filter((T) => T.side === "left").map((T) => T.name), j = l.filter((T) => T.side === "right").map((T) => T.name), k = e.findLastIndex((T) => w.includes(T.name)), A = e.findIndex((T) => j.includes(T.name));
    return [
      ["left", k !== -1 ? e.slice(0, k + 1) : []],
      [
        "middle",
        e.slice(
          k !== -1 ? k + 1 : 0,
          A !== -1 ? A : void 0
        )
      ],
      ["right", A !== -1 ? e.slice(A) : []]
    ].filter(([T, c1]) => c1.length > 0);
  }, [e, l]), [g, z] = W(null), [M, H] = W({}), q = O(
    () => ({
      left: (w) => H((j) => ({ ...j, left: w })),
      middle: (w) => H((j) => ({ ...j, middle: w })),
      right: (w) => H((j) => ({ ...j, right: w }))
    }),
    []
  ), U = $ ?? X7, t1 = x5({
    getScrollElement: () => g,
    count: t.length,
    estimateSize: () => n2,
    getItemKey: Z((w) => U(t[w], w), [U, t]),
    enabled: !C
  });
  return /* @__PURE__ */ x(
    "div",
    {
      ref: n,
      className: o1("relative z-0 min-h-0 flex flex-col grow", c),
      style: r,
      role: "table",
      ...E,
      children: [
        /* @__PURE__ */ o(
          Pt,
          {
            direction: "horizontal",
            overflowingEl: g,
            startElement: M.left,
            endElement: M.right
          }
        ),
        /* @__PURE__ */ o(
          "div",
          {
            className: X("flex flex-col min-h-0 relative z-0 overflow-auto flex-1"),
            ref: z,
            children: /* @__PURE__ */ o("div", { className: "flex flex-row h-max w-max min-w-full shrink-0", children: /* @__PURE__ */ o(p1, { collection: B, children: ([w, j], k) => /* @__PURE__ */ x(
              "div",
              {
                "data-table-part": w,
                ref: q[w],
                className: X({
                  "flex flex-col min-h-0 w-max bg-white": !0,
                  "relative z-0 flex-1": w === "middle",
                  "sticky z-10": w !== "middle",
                  "left-0": w === "left",
                  "right-0": w === "right"
                }),
                children: [
                  /* @__PURE__ */ o(
                    U7,
                    {
                      columns: j,
                      onOrderByChange: h,
                      orderBy: b,
                      className: I1(
                        {
                          "top-0 sticky z-10": !0,
                          "border-l": !!(w === "middle" && M.left),
                          "border-r": !!(w === "middle" && M.right)
                        },
                        i
                      ),
                      style: d,
                      canMultiSort: P
                    }
                  ),
                  /* @__PURE__ */ o(
                    "div",
                    {
                      style: {
                        height: C || t.length === 0 ? void 0 : `${t1.getTotalSize()}px`
                      },
                      className: "flex flex-col items-stretch relative w-full z-0 shrink-0",
                      "data-role": "rows-container",
                      children: C ? /* @__PURE__ */ o(
                        p1,
                        {
                          fallback: () => w === "middle" ? v != null && /* @__PURE__ */ o("div", { className: "p-2 italic font-light", children: R(v) }) : /* @__PURE__ */ o(n1, {}),
                          collection: t,
                          keyProvider: U,
                          children: (A, Y) => R(S, {
                            onClick: u && ((T) => u?.(A, Y, T)),
                            onContextMenu: p && ((T) => p?.(A, Y, T)),
                            onMouseEnter: (T) => {
                              T.currentTarget.closest('[role="table"]')?.querySelectorAll(
                                `[data-role="rows-container"] [data-index="${Y}"]`
                              ).forEach((c1) => c1.setAttribute("data-forceHover", "1")), m?.(A, Y, T);
                            },
                            onMouseLeave: (T) => {
                              T.currentTarget.closest('[role="table"]')?.querySelectorAll(
                                `[data-role="rows-container"] [data-index="${Y}"]`
                              ).forEach((c1) => c1.removeAttribute("data-forceHover")), f?.(A, Y, T);
                            },
                            palette: y,
                            highlightOnHover: N,
                            row: A,
                            rowIndex: Y,
                            columns: j,
                            style: f1(F, A, Y),
                            className: f1(_, A, Y),
                            "data-index": Y
                          })
                        }
                      ) : /* @__PURE__ */ o(
                        p1,
                        {
                          fallback: () => w === "middle" ? v != null && /* @__PURE__ */ o("div", { className: "p-2 italic font-light", children: R(v) }) : /* @__PURE__ */ o(n1, {}),
                          collection: t1.getVirtualItems(),
                          keyProvider: (A) => A.key,
                          children: (A) => {
                            const Y = t[A.index], T = A.index, c1 = k === 0 ? t1.measureElement : void 0;
                            return R(S, {
                              onClick: u && ((i1) => u?.(Y, T, i1)),
                              onContextMenu: p && ((i1) => p?.(Y, T, i1)),
                              onMouseEnter: (i1) => {
                                i1.currentTarget.closest('[role="table"]')?.querySelectorAll(
                                  `[data-role="rows-container"] [data-index="${T}"]`
                                ).forEach((K) => K.setAttribute("data-forceHover", "1")), m?.(Y, T, i1);
                              },
                              onMouseLeave: (i1) => {
                                i1.currentTarget.closest('[role="table"]')?.querySelectorAll(
                                  `[data-role="rows-container"] [data-index="${T}"]`
                                ).forEach((K) => K.removeAttribute("data-forceHover")), f?.(Y, T, i1);
                              },
                              palette: y,
                              highlightOnHover: N,
                              row: Y,
                              innerRef: c1,
                              rowIndex: T,
                              columns: j,
                              style: {
                                position: "absolute",
                                top: 0,
                                left: 0,
                                width: "100%",
                                transform: `translateY(${A.start}px)`,
                                ...f1(F, Y, T)
                              },
                              className: f1(_, Y, T),
                              "data-index": T
                            });
                          }
                        }
                      )
                    }
                  ),
                  e.some((A) => A.footer) && /* @__PURE__ */ o(
                    K7,
                    {
                      columns: j,
                      className: I1(
                        "mt-auto sticky z-10 bottom-0",
                        s
                      ),
                      style: a
                    }
                  )
                ]
              }
            ) }) })
          }
        )
      ]
    }
  );
}
const S8 = G(Lt);
function Lt({
  rows: e,
  orderBy: t,
  onOrderByChange: r,
  ...c
}) {
  const [n, l] = J1(t, {
    onSet: r
  }), s = O(
    () => i2({
      rows: e,
      columns: c.columns,
      orderByArr: n
    }),
    [c.columns, n, e]
  );
  return /* @__PURE__ */ o(
    J7,
    {
      ...c,
      rows: s,
      orderBy: n,
      onOrderByChange: l
    }
  );
}
const Q7 = "Body/M/Medium", w8 = "Body/M/Book", Tt = G(Et);
function Et({
  columns: e,
  groupedRows: t,
  groupRowKey: r,
  groupRowStyle: c,
  expandGroupByKey: n = $2,
  onExpandGroupByKeyChange: l,
  expandOnRowClick: s = !0,
  groupRowClassName: a,
  palette: i,
  highlightRowOnHover: d,
  rowKey: v,
  onGroupMouseEnter: h,
  onGroupMouseLeave: u,
  onGroupClick: p,
  onGroupContextMenu: m,
  onRowMouseEnter: f,
  onRowMouseLeave: b,
  onRowClick: y,
  onRowContextMenu: N,
  rowClassName: _,
  rowStyle: $,
  groupColor: F,
  rowColor: P,
  ...C
}) {
  const L = e1(l), E = t6({
    groupColor: F,
    rowColor: P,
    groupRowKey: r,
    expandGroupByKey: n,
    onExpandGroupByKeyChange: l
  }), S = O(() => e(E), [e, E]), B = O(
    () => S.map(({ content: z, contentKey: M, contentSortFn: H, contentOrderable: q, ...U }) => ({
      ...U,
      name: U.name,
      orderable: (U.orderable ?? U.sortFn != null) || (q ?? H != null),
      content: (t1, w) => {
        const j = r(t1), k = n.has(j);
        return U.groupContent(t1, {
          ...w,
          expanded: k,
          onToggleExpand: (A) => {
            A.stopPropagation(), L.current?.(
              k ? n.delete(j) : n.add(j)
            );
          }
        });
      },
      contentTextType: U.groupContentTextType ?? Q7,
      contentKey: U.groupContentKey,
      cellClassName: U.groupCellClassName,
      cellStyle: U.groupCellStyle
    })),
    [S, n, r, L]
  ), g = O(
    () => S.map(
      ({
        groupContent: z,
        groupCellClassName: M,
        groupCellStyle: H,
        groupContentKey: q,
        groupContentTextType: U,
        sortFn: t1,
        orderable: w,
        contentSortFn: j,
        contentOrderable: k,
        content: A,
        ...Y
      }) => ({ ...Y, content: A })
    ),
    [S]
  );
  return /* @__PURE__ */ o(
    Y7,
    {
      disableVirtualScroll: !0,
      columns: B,
      rows: t,
      rowKey: r,
      palette: i,
      highlightRowOnHover: d,
      TableDataRow: (z) => /* @__PURE__ */ o(
        e6,
        {
          ...z,
          subColumns: g,
          expandOnRowClick: s,
          onExpandGroupByKeyChange: l,
          expandGroupByKey: n,
          groupRowKey: r,
          groupRowClassName: a,
          groupRowStyle: c,
          rowKey: v,
          onGroupMouseEnter: h,
          onGroupMouseLeave: u,
          onGroupClick: p,
          onGroupContextMenu: m,
          onRowMouseEnter: f,
          onRowMouseLeave: b,
          onRowClick: y,
          onRowContextMenu: N,
          rowClassName: _,
          rowStyle: $,
          palette: i,
          highlightOnHover: d
        }
      ),
      ...C
    }
  );
}
function e6({
  columns: e,
  expandGroupByKey: t = $2,
  expandOnRowClick: r,
  groupRowClassName: c,
  groupRowKey: n,
  groupRowStyle: l,
  onExpandGroupByKeyChange: s,
  row: a,
  rowIndex: i,
  rowKey: d,
  subColumns: v,
  rowStyle: h,
  rowClassName: u,
  onGroupMouseEnter: p,
  onGroupMouseLeave: m,
  onGroupClick: f,
  onGroupContextMenu: b,
  onRowMouseEnter: y,
  onRowMouseLeave: N,
  onRowClick: _,
  onRowContextMenu: $,
  palette: F,
  highlightOnHover: P,
  innerRef: C,
  ...L
}) {
  const E = n(a);
  return /* @__PURE__ */ x("div", { className: "flex flex-col", ref: C, children: [
    /* @__PURE__ */ o(
      O2,
      {
        ...L,
        onClick: f || r ? (S) => {
          f?.(a, i, S), r && s?.(
            t.has(E) ? t.delete(E) : t.add(E)
          );
        } : void 0,
        onContextMenu: b && ((S) => b?.(a, i, S)),
        onMouseEnter: (S) => {
          S.currentTarget.closest('[role="table"]')?.querySelectorAll(`[data-role="rows-container"] [data-index="${i}"]`).forEach((B) => B.setAttribute("data-forceHover", "1")), p?.(a, i, S);
        },
        onMouseLeave: (S) => {
          S.currentTarget.closest('[role="table"]')?.querySelectorAll(`[data-role="rows-container"] [data-index="${i}"]`).forEach((B) => B.removeAttribute("data-forceHover")), m?.(a, i, S);
        },
        row: a,
        rowIndex: i,
        columns: e,
        style: f1(l, a, i),
        className: o1("font-bold", f1(c, a, i)),
        palette: F,
        highlightOnHover: P
      }
    ),
    /* @__PURE__ */ o(H3, { expand: t.has(E) ?? !1, children: a.rows.map((S, B) => /* @__PURE__ */ o(
      O2,
      {
        onClick: _ && ((g) => _?.(S, B, g)),
        onContextMenu: $ && ((g) => $?.(S, B, g)),
        row: S,
        rowIndex: B,
        palette: F,
        highlightOnHover: P,
        columns: v,
        style: f1(h, S, B),
        className: f1(u, S, B),
        "data-parent-index": i,
        "data-sub-index": B,
        onMouseEnter: (g) => {
          g.currentTarget.closest('[role="table"]')?.querySelectorAll(
            `[data-role="rows-container"] [data-parent-index="${i}"][data-sub-index="${B}"]`
          ).forEach((z) => z.setAttribute("data-forceHover", "1")), y?.(a, i, g);
        },
        onMouseLeave: (g) => {
          g.currentTarget.closest('[role="table"]')?.querySelectorAll(
            `[data-role="rows-container"] [data-parent-index="${i}"][data-sub-index="${B}"]`
          ).forEach((z) => z.removeAttribute("data-forceHover")), N?.(a, i, g);
        }
      },
      d?.(S, B) ?? B
    )) })
  ] });
}
function t6({
  groupRowKey: e,
  groupColor: t,
  rowColor: r,
  expandGroupByKey: c = $2,
  onExpandGroupByKeyChange: n
}) {
  const l = e1(n);
  return O(
    () => ({
      expandColumn: {
        name: "expand-25c694c3-8fbe-46f4-888f-f414f00c213d",
        header: (s) => /* @__PURE__ */ o(
          D1,
          {
            justifyContent: "center",
            alignItems: "center",
            style: {
              minHeight: n2,
              ...s.style,
              paddingLeft: 0,
              paddingRight: 0,
              borderColor: "transparent"
            },
            className: s.className,
            innerRef: s.innerRef,
            title: s.title,
            onClick: s.onClick
          }
        ),
        cellClassName: "h-auto w-full",
        groupContent: (s, a) => {
          const i = e(s), d = c.has(i);
          return /* @__PURE__ */ o(
            D1,
            {
              justifyContent: "center",
              alignItems: "center",
              style: { minHeight: n2, ...a.style, paddingLeft: 0, paddingRight: 0 },
              className: a.className,
              innerRef: a.innerRef,
              title: a.title,
              onClick: a.onClick,
              children: /* @__PURE__ */ o(
                "button",
                {
                  type: "button",
                  className: "h-full w-full flex items-center justify-center disabled:invisible",
                  disabled: s.rows.length === 0,
                  onClick: (v) => {
                    v.stopPropagation(), l.current?.(
                      d ? c.delete(i) : c.add(i)
                    );
                  },
                  children: /* @__PURE__ */ o(
                    "span",
                    {
                      className: "transition-transform aria-expanded:transform-[rotateX(180deg)] flex",
                      "aria-expanded": d,
                      children: /* @__PURE__ */ o(Q, { icon: "Down" })
                    }
                  )
                }
              )
            }
          );
        },
        content: (s, a) => /* @__PURE__ */ o(
          D1,
          {
            style: { minHeight: n2, ...a.style, paddingLeft: 0, paddingRight: 0 },
            className: a.className,
            innerRef: a.innerRef,
            title: a.title,
            onClick: a.onClick
          }
        ),
        maxWidth: 32,
        minWidth: 32
      },
      bandColumn: {
        name: "band-25c694c3-8fbe-46f4-888f-f414f00c213d",
        header: (s) => /* @__PURE__ */ o(
          D1,
          {
            justifyContent: "center",
            alignItems: "center",
            style: {
              minHeight: n2,
              ...s.style,
              paddingLeft: 0,
              paddingRight: 0,
              borderColor: "transparent"
            },
            className: s.className,
            innerRef: s.innerRef,
            title: s.title,
            onClick: s.onClick
          }
        ),
        groupContent: (s, a) => {
          const i = t?.(s);
          return /* @__PURE__ */ o(
            D1,
            {
              style: { backgroundColor: i, ...a.style, paddingLeft: 0, paddingRight: 0 },
              className: a.className,
              innerRef: a.innerRef,
              title: a.title,
              onClick: a.onClick
            }
          );
        },
        content: (s, a) => {
          const i = r?.(s);
          return /* @__PURE__ */ o(
            D1,
            {
              style: { backgroundColor: i, ...a.style, paddingLeft: 0, paddingRight: 0 },
              className: a.className,
              innerRef: a.innerRef,
              title: a.title,
              onClick: a.onClick
            }
          );
        },
        maxWidth: 4,
        minWidth: 4
      }
    }),
    [c, t, e, l, r]
  );
}
const Dt = G(
  At
);
function At({
  columns: e,
  groupedRows: t,
  groupRowKey: r,
  groupRowStyle: c,
  expandGroupByKey: n = $2,
  onExpandGroupByKeyChange: l,
  expandOnRowClick: s = !0,
  groupRowClassName: a,
  rowKey: i,
  onGroupMouseEnter: d,
  onGroupMouseLeave: v,
  onGroupClick: h,
  onGroupContextMenu: u,
  onRowMouseEnter: p,
  onRowMouseLeave: m,
  onRowClick: f,
  onRowContextMenu: b,
  rowClassName: y,
  rowStyle: N,
  groupColor: _,
  rowColor: $,
  ...F
}) {
  const P = e1({ onExpandGroupByKeyChange: l }), C = t6({
    groupColor: _,
    rowColor: $,
    groupRowKey: r,
    expandGroupByKey: n,
    onExpandGroupByKeyChange: l
  }), L = O(() => e(C), [e, C]), E = O(
    () => L.map(({ content: B, contentKey: g, contentSortFn: z, contentOrderable: M, ...H }) => ({
      ...H,
      name: H.name,
      orderable: (H.orderable ?? H.sortFn != null) || (M ?? z != null),
      content: (q, U) => {
        const t1 = r(q), w = n.has(t1);
        return H.groupContent(q, {
          ...U,
          expanded: w,
          onToggleExpand: (j) => {
            j.stopPropagation(), P.current.onExpandGroupByKeyChange?.(
              w ? n.delete(t1) : n.add(t1)
            );
          }
        });
      },
      contentTextType: H.groupContentTextType ?? Q7,
      contentKey: H.groupContentKey,
      cellClassName: H.groupCellClassName,
      cellStyle: H.groupCellStyle
    })),
    [L, n, r, P]
  ), S = O(
    () => L.map(
      ({
        groupContent: B,
        groupCellClassName: g,
        groupCellStyle: z,
        groupContentKey: M,
        groupContentTextType: H,
        sortFn: q,
        orderable: U,
        contentSortFn: t1,
        contentOrderable: w,
        content: j,
        ...k
      }) => ({ ...k, content: j })
    ),
    [L]
  );
  return /* @__PURE__ */ o(
    J7,
    {
      disableVirtualScroll: !0,
      columns: E,
      rows: t,
      rowKey: r,
      TableDataRow: (B) => /* @__PURE__ */ o(
        e6,
        {
          ...B,
          subColumns: S.filter(
            (g) => B.columns.some((z) => z.name === g.name)
          ),
          expandOnRowClick: s,
          onExpandGroupByKeyChange: l,
          expandGroupByKey: n,
          groupRowKey: r,
          groupRowClassName: a,
          groupRowStyle: c,
          rowKey: i,
          onGroupMouseEnter: d,
          onGroupMouseLeave: v,
          onGroupClick: h,
          onGroupContextMenu: u,
          onRowMouseEnter: p,
          onRowMouseLeave: m,
          onRowClick: f,
          onRowContextMenu: b,
          rowClassName: y,
          rowStyle: N
        }
      ),
      ...F
    }
  );
}
const B8 = G(
  Rt
);
function Rt({
  groupedRows: e,
  orderBy: t,
  onOrderByChange: r,
  expandGroupByKey: c,
  onExpandGroupByKeyChange: n,
  ...l
}) {
  const [s, a] = J1(t, {
    onSet: r
  }), [i, d] = J1(c, {
    equalityComparator: (h, u) => h?.equals(u) || h === void 0 && u === void 0,
    onSet: n
  }), v = O(() => {
    const h = l.columns({
      bandColumn: u5,
      expandColumn: u5
    }), u = h.map((f) => ({
      name: f.name,
      sortFn: f.orderable ?? f.sortFn != null ? f.sortFn : void 0
    })), p = i2({
      rows: e,
      columns: u,
      orderByArr: s
    }), m = h.map((f) => ({
      name: f.name,
      sortFn: f.contentOrderable ?? f.contentSortFn != null ? f.contentSortFn : void 0
    }));
    return !s?.length || !m.some((f) => f.sortFn) ? p : p.map((f) => ({
      ...f,
      rows: i2({
        rows: f.rows,
        columns: m,
        orderByArr: s
      })
    }));
  }, [e, s, l.columns]);
  return /* @__PURE__ */ o(
    Dt,
    {
      ...l,
      groupedRows: v,
      orderBy: s,
      onOrderByChange: a,
      expandGroupByKey: i,
      onExpandGroupByKeyChange: d
    }
  );
}
const u5 = {
  content: () => null,
  groupContent: () => null,
  header: () => null,
  name: "dummy-column"
}, k8 = G(_t);
function _t({
  rows: e,
  orderBy: t,
  onOrderByChange: r,
  ...c
}) {
  const [n, l] = J1(t, {
    onSet: r
  }), s = O(
    () => i2({
      rows: e,
      columns: c.columns,
      orderByArr: n
    }),
    [c.columns, n, e]
  );
  return /* @__PURE__ */ o(Y7, { ...c, rows: s, orderBy: n, onOrderByChange: l });
}
const P8 = G(
  Ft
);
function Ft({
  groupedRows: e,
  orderBy: t,
  onOrderByChange: r,
  expandGroupByKey: c,
  onExpandGroupByKeyChange: n,
  ...l
}) {
  const [s, a] = J1(t, {
    onSet: r
  }), [i, d] = J1(c, {
    onSet: n
  }), v = O(() => {
    const h = l.columns({
      bandColumn: h5,
      expandColumn: h5
    }), u = h.map((f) => ({
      name: f.name,
      sortFn: f.orderable ?? f.sortFn != null ? f.sortFn : void 0
    })), p = i2({
      rows: e,
      columns: u,
      orderByArr: s
    }), m = h.map((f) => ({
      name: f.name,
      sortFn: f.contentOrderable ?? f.contentSortFn != null ? f.contentSortFn : void 0
    }));
    return !s?.length || !m.some((f) => f.sortFn) ? p : p.map((f) => ({
      ...f,
      rows: i2({
        rows: f.rows,
        columns: m,
        orderByArr: s
      })
    }));
  }, [l, e, s]);
  return /* @__PURE__ */ o(
    Tt,
    {
      ...l,
      groupedRows: v,
      orderBy: s,
      onOrderByChange: a,
      expandGroupByKey: i,
      onExpandGroupByKeyChange: d
    }
  );
}
const h5 = {
  content: () => null,
  groupContent: () => null,
  header: () => null,
  name: "dummy-column"
}, Ot = G(Ht);
function $t({
  children: e,
  onClick: t,
  className: r,
  style: c,
  innerRef: n,
  ...l
}) {
  return /* @__PURE__ */ o(n1, { children: t ? /* @__PURE__ */ o(
    "button",
    {
      ref: n,
      type: "button",
      onClick: t,
      className: X(r),
      style: c,
      ...l,
      children: e
    }
  ) : /* @__PURE__ */ o(
    "span",
    {
      ref: n,
      className: X(r),
      style: c,
      ...l,
      children: e
    }
  ) });
}
function Ht({
  children: e,
  headerPosition: t,
  icon: r,
  iconSize: c,
  onClick: n,
  size: l,
  innerRef: s,
  active: a,
  className: i,
  style: d,
  index: v,
  ...h
}) {
  return /* @__PURE__ */ x(
    $t,
    {
      className: I1(
        {
          "flex items-center": !0,
          "cursor-pointer": !!n,
          "justify-end": t === "left-side",
          "pr-2.5": t === "left-side",
          "pl-2.5": t === "right-side",
          "py-2": l === "small" || l === "large",
          "py-1": l === "x-small"
        },
        i
      ),
      style: d,
      innerRef: s,
      onClick: n,
      ...h,
      children: [
        r && /* @__PURE__ */ o(Q, { size: c, icon: r, className: "mr-1" }),
        /* @__PURE__ */ o(
          z1,
          {
            type: l === "x-small" ? "Body/M/Bold" : "Body/L/Bold",
            className: "transition-colors",
            color: a ? I.palette_N700 : I.palette_N400,
            children: R(e)
          }
        )
      ]
    }
  );
}
const r6 = F1(null), L8 = G(jt);
function jt({
  children: e,
  title: t,
  className: r,
  style: c,
  unstyled: n = !1,
  innerRef: l,
  ...s
}) {
  const a = V1(r6), i = e1(a), d = a2(), v = a1(t);
  return l1(() => {
    const h = i.current;
    if (!h)
      throw new Error("missing TabGroupContext, cannot render Tab");
    return h.onUpsert({ id: d, title: v.current }), () => h.onRemove(d);
  }, [i, d]), l1(() => {
    i.current?.onUpsert({ id: d, title: t });
  }, [i, d, t]), /* @__PURE__ */ o(
    "div",
    {
      ref: l,
      className: o1(
        {
          "mt-4": !n && a?.headerPosition === "top",
          "ml-4": !n && a?.headerPosition === "left-side",
          "mr-4": !n && a?.headerPosition === "right-side"
        },
        r
      ),
      style: c,
      ...s,
      children: R(e)
    }
  );
}
const T8 = G(Gt);
function Wt({
  enableTransitions: e,
  headerPosition: t,
  height: r,
  left: c,
  top: n,
  width: l,
  palette: s = "neutral",
  showDivider: a = !1,
  ...i
}) {
  return /* @__PURE__ */ x(n1, { children: [
    t === "top" && a && /* @__PURE__ */ o(
      "div",
      {
        style: { borderBottom: `1px solid ${I.palette_N200}` },
        className: "absolute left-0 right-0 bottom-0 z-0"
      }
    ),
    /* @__PURE__ */ o(
      "div",
      {
        className: X({
          "absolute z-10": !0,
          "border-[var(--palette-P600)]": s === "primary",
          "border-[var(--palette-N600)]": s === "neutral",
          "transition-[left,width,height,top] duration-200": e,
          "bottom-0 border-b-2": t === "top",
          "right-0 border-r-2": t === "left-side",
          "left-0 border-l-2": t === "right-side"
        }),
        style: { height: r, left: c, top: n, width: l },
        ...i
      }
    )
  ] });
}
function Gt({
  children: e,
  tabIndex: t,
  onTabChange: r,
  size: c = "large",
  headerPosition: n = "top",
  indicator: l,
  enableTransitions: s = !0,
  innerRef: a,
  palette: i = "neutral",
  showTitleDivider: d = !1,
  headerChildren: v,
  minHeightStrategy: h = "auto",
  ...u
}) {
  const p = l ?? ((q) => /* @__PURE__ */ o(Wt, { ...q })), [m, f] = W([]), b = Z(({ id: q, title: U }) => {
    f((t1) => {
      const w = t1.findIndex(({ id: k }) => k === q);
      if (w === -1)
        return [...t1, { id: q, title: U }];
      const j = [...t1];
      return j[w].title = U, j;
    });
  }, []), y = Z((q) => {
    f((U) => {
      const t1 = U.findIndex(({ id: j }) => j === q);
      if (t1 === -1)
        return U;
      const w = [...U];
      return w.splice(t1, 1), w;
    });
  }, []), N = n === "top" ? "width" : "height", _ = n === "top" ? "offsetWidth" : "offsetHeight", $ = n === "top" ? "horizontal" : "vertical", F = n === "top" ? "left" : "top", P = n === "top" ? "offsetLeft" : "offsetTop", [C, L] = W({
    [F]: 0,
    [N]: 0,
    animated: !1
  }), E = e1(t), S = Z(
    (q, U) => {
      if (!B.current)
        return;
      U1(c);
      const t1 = B.current.children[q];
      t1 && L({
        [F]: t1[P],
        // -1 is used to prevent the scrollbar from appearing
        // when we are on the last element but there is enough room to avoid it.
        [N]: t1[_] - 1,
        animated: U
      });
    },
    [F, P, _, N, c]
  ), B = a1(null), g = Z(
    (q) => {
      !q || !B.current || S(E.current, !1);
    },
    [S, E]
  );
  l1(() => {
    S(t, !0);
  }, [S, t]), _1(window, "resize", () => S(t, !1));
  const [z, M] = W(t);
  l1(() => {
    M(t);
  }, [t]);
  const H = b2({
    in: t === z,
    duration: 200
  });
  return /* @__PURE__ */ o(
    r6.Provider,
    {
      value: {
        onUpsert: b,
        onRemove: y,
        headerPosition: n
      },
      children: /* @__PURE__ */ x(
        "div",
        {
          ref: a,
          className: X({
            "flex flex-1 overflow-hidden": !0,
            "flex-col": n === "top",
            "flex-row": n === "left-side",
            "flex-row-reverse": n === "right-side"
          }),
          ...u,
          children: [
            /* @__PURE__ */ o("div", { className: "flex", children: /* @__PURE__ */ o(
              d2,
              {
                direction: $,
                outerContainerAppearance: { className: "grow" },
                className: "grow",
                innerContainerAppearance: { className: "min-w-full" },
                children: /* @__PURE__ */ x("div", { className: "relative z-0", children: [
                  /* @__PURE__ */ x(
                    "div",
                    {
                      ref: B,
                      className: X({
                        "flex relative z-0": !0,
                        "flex-row space-x-4": n === "top",
                        "flex-col": n === "left-side" || n === "right-side"
                      }),
                      children: [
                        m.map(({ id: q, title: U }, t1) => {
                          const w = {
                            active: t === t1,
                            index: t1,
                            headerPosition: n,
                            onClick: r ? () => r(t1) : void 0,
                            size: c,
                            innerRef: g
                          }, j = R(U, w);
                          return typeof j == "string" ? /* @__PURE__ */ o(Ot, { ...w, children: j }, q + U) : /* @__PURE__ */ o(K1, { children: j }, q + U);
                        }),
                        v
                      ]
                    }
                  ),
                  R(p, {
                    enableTransitions: s && C.animated,
                    headerPosition: n,
                    palette: i,
                    showDivider: d,
                    ...x0(C, ["animated"])
                  })
                ] })
              }
            ) }),
            /* @__PURE__ */ o(
              "div",
              {
                className: X({
                  "flex flex-1": !0,
                  "min-h-0": h === "0",
                  "flex-col": n === "top",
                  "flex-row": n === "left-side" || n === "right-side"
                }),
                children: /* @__PURE__ */ o(
                  "div",
                  {
                    className: X({
                      "flex relative flex-1": !0,
                      "min-h-0": h === "0",
                      "transition-transform duration-200": s,
                      "flex-col": n === "top",
                      "flex-row": n === "left-side" || n === "right-side"
                    }),
                    children: e.map((q, U) => /* @__PURE__ */ o(
                      "div",
                      {
                        className: X({
                          "inset-0 w-full flex flex-col transition-[scale,opacity] origin-top duration-200": s,
                          // With the '0' strategy the tab body is height-bounded and meant to be filled by its
                          // content; without `grow` the active (in-flow) tab collapses to content height, so a
                          // short table can't push a trailing footer/pagination to the bottom.
                          "min-h-0 grow": h === "0",
                          absolute: U !== t,
                          relative: U === t,
                          invisible: H === "entered" && U !== t,
                          "opacity-100 scale-100": U === t,
                          "opacity-0 scale-95": U !== t
                        }),
                        children: R(q, { activeTabIndex: t, childTabIndex: U })
                      },
                      U
                    ))
                  }
                )
              }
            )
          ]
        },
        n
      )
    }
  );
}
export {
  E2 as $,
  q1 as A,
  K3 as B,
  W6 as C,
  X as D,
  I1 as E,
  o1 as F,
  m1 as G,
  G6 as H,
  Z6 as I,
  E5 as J,
  D5 as K,
  a2 as L,
  p7 as M,
  N9 as N,
  S9 as O,
  E3 as P,
  B9 as Q,
  M9 as R,
  w9 as S,
  e8 as T,
  x9 as U,
  z9 as V,
  G2 as W,
  T2 as X,
  R as Y,
  z2 as Z,
  P5 as _,
  m7 as a,
  O5 as a$,
  _6 as a0,
  T5 as a1,
  F6 as a2,
  O6 as a3,
  J1 as a4,
  W1 as a5,
  y9 as a6,
  $6 as a7,
  C9 as a8,
  H6 as a9,
  K5 as aA,
  q5 as aB,
  l2 as aC,
  v8 as aD,
  Te as aE,
  Ae as aF,
  Re as aG,
  Y5 as aH,
  P4 as aI,
  X5 as aJ,
  L4 as aK,
  J5 as aL,
  d2 as aM,
  T4 as aN,
  k4 as aO,
  Pe as aP,
  Z7 as aQ,
  Le as aR,
  U9 as aS,
  b1 as aT,
  K9 as aU,
  c4 as aV,
  d3 as aW,
  n4 as aX,
  $5 as aY,
  b2 as aZ,
  F5 as a_,
  I9 as aa,
  k9 as ab,
  P9 as ac,
  L9 as ad,
  T9 as ae,
  E9 as af,
  H4 as ag,
  C3 as ah,
  I4 as ai,
  j4 as aj,
  O4 as ak,
  W4 as al,
  z1 as am,
  V9 as an,
  q3 as ao,
  Q as ap,
  Z1 as aq,
  G1 as ar,
  e2 as as,
  y8 as at,
  A2 as au,
  Y9 as av,
  D1 as aw,
  o8 as ax,
  g4 as ay,
  W9 as az,
  f0 as b,
  P8 as b$,
  F9 as b0,
  m8 as b1,
  p8 as b2,
  i5 as b3,
  je as b4,
  g8 as b5,
  S2 as b6,
  qe as b7,
  Oe as b8,
  b8 as b9,
  Me as bA,
  h8 as bB,
  ye as bC,
  Ce as bD,
  f8 as bE,
  Se as bF,
  J6 as bG,
  R5 as bH,
  ie as bI,
  G7 as bJ,
  W7 as bK,
  D9 as bL,
  i3 as bM,
  D2 as bN,
  R9 as bO,
  nt as bP,
  lt as bQ,
  dt as bR,
  ut as bS,
  ht as bT,
  z8 as bU,
  pt as bV,
  vt as bW,
  mt as bX,
  S8 as bY,
  B8 as bZ,
  k8 as b_,
  H3 as ba,
  Qe as bb,
  tt as bc,
  M8 as bd,
  x8 as be,
  $4 as bf,
  G9 as bg,
  Z9 as bh,
  w4 as bi,
  y3 as bj,
  Q3 as bk,
  e3 as bl,
  Q5 as bm,
  D4 as bn,
  R4 as bo,
  _4 as bp,
  F4 as bq,
  J3 as br,
  G4 as bs,
  u8 as bt,
  ce as bu,
  ve as bv,
  pe as bw,
  m3 as bx,
  le as by,
  be as bz,
  g7 as c,
  d8 as c$,
  J7 as c0,
  Dt as c1,
  Y7 as c2,
  X7 as c3,
  Tt as c4,
  e6 as c5,
  t6 as c6,
  Pt as c7,
  n2 as c8,
  d5 as c9,
  n7 as cA,
  A1 as cB,
  a7 as cC,
  s7 as cD,
  k3 as cE,
  P3 as cF,
  p1 as cG,
  T3 as cH,
  L3 as cI,
  R2 as cJ,
  e0 as cK,
  t0 as cL,
  r0 as cM,
  l0 as cN,
  s0 as cO,
  n0 as cP,
  h7 as cQ,
  A3 as cR,
  o0 as cS,
  c0 as cT,
  I2 as cU,
  r4 as cV,
  u0 as cW,
  B3 as cX,
  Q1 as cY,
  s8 as cZ,
  y2 as c_,
  j3 as ca,
  U7 as cb,
  K7 as cc,
  O2 as cd,
  yt as ce,
  I8 as cf,
  It as cg,
  N8 as ch,
  wt as ci,
  Q7 as cj,
  w8 as ck,
  p3 as cl,
  C8 as cm,
  i2 as cn,
  Ot as co,
  Ht as cp,
  L8 as cq,
  jt as cr,
  T8 as cs,
  Wt as ct,
  Gt as cu,
  r6 as cv,
  z3 as cw,
  n8 as cx,
  w3 as cy,
  l7 as cz,
  _3 as d,
  l8 as d0,
  j9 as d1,
  A9 as d2,
  w7 as d3,
  t2 as d4,
  oe as d5,
  s4 as d6,
  W5 as d7,
  a4 as d8,
  r8 as d9,
  Z5 as da,
  F0 as db,
  h3 as dc,
  $0 as dd,
  c8 as de,
  Z0 as df,
  U0 as dg,
  l5 as dh,
  X0 as di,
  a8 as dj,
  i8 as dk,
  G5 as dl,
  $9 as dm,
  H9 as dn,
  O9 as dp,
  l4 as dq,
  B7 as dr,
  A7 as ds,
  x7 as e,
  F3 as f,
  y7 as g,
  z7 as h,
  p0 as i,
  J9 as j,
  g0 as k,
  X9 as l,
  h0 as m,
  M7 as n,
  b7 as o,
  v0 as p,
  m0 as q,
  b0 as r,
  t8 as s,
  M0 as t,
  Q9 as u,
  D3 as v,
  K2 as w,
  q9 as x,
  j6 as y,
  _1 as z
};
//# sourceMappingURL=TabGroup-B4jOGf3W.js.map
